import { useQuery, useMutation, UseQueryOptions, UseMutationOptions } from 'react-query'
import { fetcher } from '../lib/api-client'
export type Maybe<T> = T | null | undefined
export type InputMaybe<T> = T | null | undefined
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> }
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> }
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string
  String: string
  Boolean: boolean
  Int: number
  Float: number
  AWSDate: string
  AWSDateTime: string
  AWSEmail: string
  AWSIPAddress: string
  AWSJSON: string
  AWSPhone: string
  AWSTime: string
  AWSTimestamp: number
  AWSURL: string
}

export type AccountingChartResponse = {
  __typename?: 'AccountingChartResponse'
  data: Array<AccountingReportOutput>
  status: ChartStatus
}

export enum AccountingCharts {
  BalanceSheet = 'balanceSheet',
  CashBalance = 'cashBalance',
  CashBalanceByMonth = 'cashBalanceByMonth',
  CashFlow = 'cashFlow',
  LiquidCash = 'liquidCash',
  Payments = 'payments',
  ProfitAndLoss = 'profitAndLoss',
}

export type AccountingReport = {
  dateRange?: Maybe<DateRanges>
  endDate?: Maybe<Scalars['String']>
  growth?: Maybe<Scalars['Float']>
  source?: Maybe<Scalars['String']>
  startDate?: Maybe<Scalars['String']>
  userId?: Maybe<Scalars['String']>
}

export type AccountingReportOutput =
  | CashBalanceByMonthReport
  | CashBalanceReport
  | LiquidCashReport
  | ProfitAndLossReport

export type AccountingToolEntry = {
  __typename?: 'AccountingToolEntry'
  amount?: Maybe<Scalars['Float']>
  name?: Maybe<Scalars['String']>
}

export type ActivityLogInput = {
  accessToken?: InputMaybe<Scalars['String']>
  action: Scalars['String']
  logStatus?: InputMaybe<Scalars['String']>
  showClientActivity?: InputMaybe<Scalars['Boolean']>
  tenantId: Scalars['String']
  type?: InputMaybe<Scalars['String']>
}

export type AddInsightInput = {
  category?: InputMaybe<Scalars['String']>
  description?: InputMaybe<Scalars['String']>
  feedback?: InputMaybe<FeedbackType>
  feedbackMessage: Array<FeedbackMessageInput>
  goalsId?: InputMaybe<Array<Scalars['String']>>
  hasBeenViewed?: InputMaybe<Scalars['Boolean']>
  internal_context?: InputMaybe<Scalars['String']>
  metadata?: InputMaybe<Scalars['AWSJSON']>
  metrics?: InputMaybe<Array<InsightMetricInput>>
  name: Scalars['String']
  playsId?: InputMaybe<Array<Scalars['String']>>
  priority?: InputMaybe<InsightPriority>
  suggestedBy?: InputMaybe<Scalars['String']>
  tenantId: Scalars['ID']
  userId?: InputMaybe<Scalars['ID']>
  why?: InputMaybe<Scalars['String']>
}

export type AddTaskCommentInput = {
  content: Scalars['String']
  fileIds?: InputMaybe<Array<Scalars['String']>>
  parentId?: InputMaybe<Scalars['String']>
  tags?: InputMaybe<Array<Scalars['String']>>
  taskId: Scalars['String']
  userId?: InputMaybe<Scalars['String']>
}

export type AddUserNotificationInput = {
  meta?: InputMaybe<Scalars['AWSJSON']>
  notificationType: Scalars['String']
  senderId: Scalars['String']
  status?: InputMaybe<Scalars['String']>
  tenantId: Scalars['String']
  userId: Scalars['String']
}

export type AddUserToGroupInput = {
  remove?: InputMaybe<Scalars['Boolean']>
  role: Scalars['String']
  tenantId: Scalars['String']
  userName: Scalars['String']
}

export type Address = {
  __typename?: 'Address'
  city?: Maybe<Scalars['String']>
  country?: Maybe<Scalars['String']>
  state?: Maybe<Scalars['String']>
  street?: Maybe<Scalars['String']>
  zip?: Maybe<Scalars['String']>
}

export type AddressInput = {
  city?: InputMaybe<Scalars['String']>
  country?: InputMaybe<Scalars['String']>
  state?: InputMaybe<Scalars['String']>
  street?: InputMaybe<Scalars['String']>
  zip?: InputMaybe<Scalars['String']>
}

export type AdvisorProfile = {
  __typename?: 'AdvisorProfile'
  defaultVideoLinkDescription?: Maybe<Scalars['String']>
  firstName?: Maybe<Scalars['String']>
  id?: Maybe<Scalars['String']>
  lastName?: Maybe<Scalars['String']>
}

export type Advisors = {
  __typename?: 'Advisors'
  email?: Maybe<Scalars['String']>
  firstName?: Maybe<Scalars['String']>
  id: Scalars['ID']
  lastName?: Maybe<Scalars['String']>
  schedulingUrl?: Maybe<Scalars['String']>
  tenantId?: Maybe<Scalars['String']>
}

export type ApiResponse = {
  __typename?: 'ApiResponse'
  data?: Maybe<Scalars['AWSJSON']>
  error?: Maybe<Scalars['String']>
  message?: Maybe<Scalars['String']>
  success: Scalars['Boolean']
}

export type Assessment = {
  __typename?: 'Assessment'
  assessmentType?: Maybe<Scalars['String']>
  content?: Maybe<Scalars['AWSJSON']>
  createdAt?: Maybe<Scalars['AWSDateTime']>
  id: Scalars['ID']
  isVisible?: Maybe<Scalars['Boolean']>
  meta?: Maybe<Scalars['AWSJSON']>
  optionType?: Maybe<Scalars['String']>
  options?: Maybe<Scalars['AWSJSON']>
  prerequisites?: Maybe<Scalars['AWSJSON']>
  previous?: Maybe<Scalars['AWSJSON']>
  tenantId?: Maybe<Scalars['Int']>
  updatedAt?: Maybe<Scalars['AWSDateTime']>
}

export type AssessmentResponse = {
  __typename?: 'AssessmentResponse'
  assessmentResponse?: Maybe<Array<AssessmentResponseOutput>>
  completedAt?: Maybe<Scalars['AWSDateTime']>
  createdAt?: Maybe<Scalars['AWSDateTime']>
  currentStage?: Maybe<Scalars['ID']>
  id?: Maybe<Scalars['ID']>
  playStage?: Maybe<Scalars['AWSJSON']>
  totalAttemptedItems?: Maybe<Scalars['Int']>
  totalItems?: Maybe<Scalars['Int']>
  type?: Maybe<Scalars['String']>
  updatedAt?: Maybe<Scalars['AWSDateTime']>
  userId?: Maybe<Scalars['ID']>
}

export type AssessmentResponseInput = {
  EIN?: InputMaybe<Scalars['Boolean']>
  accountingMethod?: InputMaybe<Scalars['Boolean']>
  cageCode?: InputMaybe<Scalars['Boolean']>
  codeCageAndUniqueId?: InputMaybe<Scalars['Boolean']>
  id?: InputMaybe<Scalars['String']>
  industryIcon?: InputMaybe<Scalars['Boolean']>
  isActiveGoal?: InputMaybe<Scalars['Boolean']>
  isBusinessEmail?: InputMaybe<Scalars['Boolean']>
  isCreateAliasesGmail?: InputMaybe<Scalars['Boolean']>
  isCreateBusinessPlan?: InputMaybe<Scalars['Boolean']>
  isCreateLogo?: InputMaybe<Scalars['Boolean']>
  isDevelopBudget?: InputMaybe<Scalars['Boolean']>
  isGoogleDomain?: InputMaybe<Scalars['Boolean']>
  isGoogleProfileImage?: InputMaybe<Scalars['Boolean']>
  isGoogleVoice?: InputMaybe<Scalars['Boolean']>
  isIndustry?: InputMaybe<Scalars['Boolean']>
  isMatrix?: InputMaybe<Scalars['Boolean']>
  isSetupFacebook?: InputMaybe<Scalars['Boolean']>
  isSetupInstagram?: InputMaybe<Scalars['Boolean']>
  isSetupLinkedin?: InputMaybe<Scalars['Boolean']>
  isSubIndustry?: InputMaybe<Scalars['Boolean']>
  isTopGoal?: InputMaybe<Scalars['Boolean']>
  label?: InputMaybe<Scalars['AWSJSON']>
  month?: InputMaybe<Scalars['Boolean']>
  naicsCode?: InputMaybe<Scalars['Boolean']>
  next?: InputMaybe<Scalars['String']>
  nigpCode?: InputMaybe<Scalars['Boolean']>
  optionType?: InputMaybe<Scalars['String']>
  playResponse?: InputMaybe<Scalars['AWSJSON']>
  previous?: InputMaybe<Array<Scalars['String']>>
  productCode?: InputMaybe<Scalars['Boolean']>
  questionLabel?: InputMaybe<Scalars['String']>
  recommendations?: InputMaybe<RecommendationsInput>
  registerBusinessStructure?: InputMaybe<Scalars['Boolean']>
  registrationYear?: InputMaybe<Scalars['Boolean']>
  samRegistration?: InputMaybe<Scalars['Boolean']>
  serviceCode?: InputMaybe<Scalars['Boolean']>
  showInReview?: InputMaybe<Scalars['Boolean']>
  submittedAt?: InputMaybe<Scalars['AWSDateTime']>
  uniqueEntityId?: InputMaybe<Scalars['Boolean']>
  uniqueId?: InputMaybe<Scalars['Boolean']>
  value?: InputMaybe<Scalars['AWSJSON']>
  year?: InputMaybe<Scalars['Boolean']>
}

export type AssessmentResponseOutput = {
  __typename?: 'AssessmentResponseOutput'
  EIN?: Maybe<Scalars['Boolean']>
  accountingMethod?: Maybe<Scalars['Boolean']>
  cageCode?: Maybe<Scalars['Boolean']>
  codeCageAndUniqueId?: Maybe<Scalars['Boolean']>
  id?: Maybe<Scalars['String']>
  industryIcon?: Maybe<Scalars['Boolean']>
  isActiveGoal?: Maybe<Scalars['Boolean']>
  isBusinessEmail?: Maybe<Scalars['Boolean']>
  isCreateAliasesGmail?: Maybe<Scalars['Boolean']>
  isCreateBusinessPlan?: Maybe<Scalars['Boolean']>
  isCreateLogo?: Maybe<Scalars['Boolean']>
  isDevelopBudget?: Maybe<Scalars['Boolean']>
  isGoogleDomain?: Maybe<Scalars['Boolean']>
  isGoogleProfileImage?: Maybe<Scalars['Boolean']>
  isGoogleVoice?: Maybe<Scalars['Boolean']>
  isIndustry?: Maybe<Scalars['Boolean']>
  isMatrix?: Maybe<Scalars['Boolean']>
  isSetupFacebook?: Maybe<Scalars['Boolean']>
  isSetupInstagram?: Maybe<Scalars['Boolean']>
  isSetupLinkedin?: Maybe<Scalars['Boolean']>
  isSubIndustry?: Maybe<Scalars['Boolean']>
  isTopGoal?: Maybe<Scalars['Boolean']>
  label?: Maybe<Scalars['AWSJSON']>
  month?: Maybe<Scalars['Boolean']>
  naicsCode?: Maybe<Scalars['Boolean']>
  next?: Maybe<Scalars['String']>
  nigpCode?: Maybe<Scalars['Boolean']>
  optionType?: Maybe<Scalars['String']>
  playResponse?: Maybe<Scalars['AWSJSON']>
  previous?: Maybe<Array<Scalars['String']>>
  productCode?: Maybe<Scalars['Boolean']>
  questionLabel?: Maybe<Scalars['String']>
  recommendations?: Maybe<Recommendations>
  registerBusinessStructure?: Maybe<Scalars['Boolean']>
  samRegistration?: Maybe<Scalars['Boolean']>
  serviceCode?: Maybe<Scalars['Boolean']>
  showInReview?: Maybe<Scalars['Boolean']>
  submittedAt?: Maybe<Scalars['AWSDateTime']>
  uniqueEntityId?: Maybe<Scalars['Boolean']>
  uniqueId?: Maybe<Scalars['Boolean']>
  value?: Maybe<Scalars['AWSJSON']>
  year?: Maybe<Scalars['Boolean']>
}

export type AttendeesType = {
  __typename?: 'AttendeesType'
  email?: Maybe<Scalars['String']>
  organizer?: Maybe<Scalars['Boolean']>
  responseStatus?: Maybe<Scalars['String']>
  self?: Maybe<Scalars['Boolean']>
}

export type Attestation = {
  __typename?: 'Attestation'
  businessBankAccount?: Maybe<Scalars['String']>
  businessName?: Maybe<Scalars['String']>
  contractors?: Maybe<Scalars['String']>
  createdAt?: Maybe<Scalars['String']>
  debtFinancing?: Maybe<Scalars['String']>
  documentId?: Maybe<Scalars['String']>
  downloadUrl?: Maybe<Scalars['String']>
  education?: Maybe<Scalars['String']>
  error?: Maybe<Scalars['String']>
  fileName?: Maybe<Scalars['String']>
  financialGrowth?: Maybe<Scalars['String']>
  fullTimeEmployees?: Maybe<Scalars['String']>
  gender?: Maybe<Scalars['String']>
  id?: Maybe<Scalars['String']>
  jobsCreated?: Maybe<Scalars['String']>
  month?: Maybe<Scalars['String']>
  name?: Maybe<Scalars['String']>
  newCustomer?: Maybe<Scalars['String']>
  partTimeEmployees?: Maybe<Scalars['String']>
  physicalLocation?: Maybe<Scalars['String']>
  pk?: Maybe<Scalars['String']>
  productSale?: Maybe<Scalars['String']>
  properName?: Maybe<Scalars['String']>
  race?: Maybe<Scalars['String']>
  revenue?: Maybe<Scalars['String']>
  serviceSale?: Maybe<Scalars['String']>
  signedCount?: Maybe<Scalars['String']>
  signedDocumentUrl?: Maybe<Scalars['String']>
  sk?: Maybe<Scalars['String']>
  status?: Maybe<Scalars['String']>
  targetAudience?: Maybe<Scalars['String']>
  tenantAdvisorStatus?: Maybe<Scalars['String']>
  tenantId?: Maybe<Scalars['String']>
  tenantStatus?: Maybe<Scalars['String']>
  unsignedCount?: Maybe<Scalars['String']>
  url?: Maybe<Scalars['String']>
  username?: Maybe<Scalars['String']>
  volunteers?: Maybe<Scalars['String']>
  wages?: Maybe<Scalars['String']>
  year?: Maybe<Scalars['String']>
}

export type AttestationInput = {
  additionalInfo?: InputMaybe<Scalars['String']>
  businessBankAccount?: InputMaybe<Scalars['String']>
  businessName?: InputMaybe<Scalars['String']>
  contractors?: InputMaybe<Scalars['String']>
  debtFinancing?: InputMaybe<Scalars['String']>
  education?: InputMaybe<Scalars['String']>
  financialGrowth?: InputMaybe<Scalars['String']>
  fullTimeEmployees?: InputMaybe<Scalars['String']>
  gender?: InputMaybe<Scalars['String']>
  generateDocuSignUrl?: InputMaybe<Scalars['Boolean']>
  jobsCreated?: InputMaybe<Scalars['String']>
  month?: InputMaybe<Scalars['String']>
  newCustomer?: InputMaybe<Scalars['String']>
  partTimeEmployees?: InputMaybe<Scalars['String']>
  physicalLocation?: InputMaybe<Scalars['String']>
  productSale?: InputMaybe<Scalars['String']>
  race?: InputMaybe<Scalars['String']>
  redirectUrl: Scalars['String']
  registerBusinessStructureOptionId?: InputMaybe<Scalars['String']>
  revenue?: InputMaybe<Scalars['String']>
  serviceSale?: InputMaybe<Scalars['String']>
  targetAudience?: InputMaybe<Scalars['String']>
  tenantId: Scalars['String']
  volunteers?: InputMaybe<Scalars['String']>
  wages?: InputMaybe<Scalars['String']>
  year?: InputMaybe<Scalars['String']>
}

export type AttestationResponse = {
  __typename?: 'AttestationResponse'
  data?: Maybe<Attestation>
  error?: Maybe<Scalars['String']>
}

export enum AttestationStatus {
  Signed = 'SIGNED',
  Suspended = 'SUSPENDED',
  Unsigned = 'UNSIGNED',
}

export type AttestationSummary = {
  __typename?: 'AttestationSummary'
  aggregationReportHistory?: Maybe<Array<Maybe<Attestation>>>
  newAggregatedReport?: Maybe<Attestation>
  signedCount?: Maybe<Scalars['Int']>
  submissionEndDate?: Maybe<Scalars['AWSDateTime']>
  submissionReminderDate?: Maybe<Scalars['AWSDateTime']>
  submissionReportDate?: Maybe<Scalars['AWSDateTime']>
  submissionStartDate?: Maybe<Scalars['AWSDateTime']>
  tenantId?: Maybe<Scalars['ID']>
  unsignedCount?: Maybe<Scalars['Int']>
}

export type AuthValue = {
  __typename?: 'AuthValue'
  AccessToken?: Maybe<Scalars['String']>
  Expires?: Maybe<Scalars['String']>
  RefreshToken?: Maybe<Scalars['String']>
}

export type AvailabilityHoursInput = {
  duration?: InputMaybe<Array<Scalars['String']>>
  timeSlots?: InputMaybe<Array<InputMaybe<TimeSlotsInput>>>
}

export type AvailabilityHoursObj = {
  __typename?: 'AvailabilityHoursObj'
  duration?: Maybe<Array<Scalars['String']>>
  timeSlots?: Maybe<Array<Maybe<TimeSlotsObj>>>
  timezone?: Maybe<Scalars['String']>
}

export type BoAdvisorsResponse = {
  __typename?: 'BOAdvisorsResponse'
  data?: Maybe<Array<Maybe<Advisors>>>
  error?: Maybe<Scalars['String']>
  message?: Maybe<Scalars['String']>
  success: Scalars['Boolean']
}

export type BalanceSheet = {
  __typename?: 'BalanceSheet'
  assets?: Maybe<Array<Maybe<AccountingToolEntry>>>
  endDate?: Maybe<Scalars['String']>
  equity?: Maybe<Array<Maybe<AccountingToolEntry>>>
  liabilities?: Maybe<Array<Maybe<AccountingToolEntry>>>
  startDate?: Maybe<Scalars['String']>
}

export type BaseCondition = {
  __typename?: 'BaseCondition'
  destinationResource: DestinationResource
  isDynamic?: Maybe<Scalars['Boolean']>
  operation: ConditionRuleOperation
  value?: Maybe<Scalars['String']>
}

export enum BaseResource {
  BusinessProfile = 'BUSINESS_PROFILE',
  User = 'USER',
}

export type BookkeepingInfo = {
  __typename?: 'BookkeepingInfo'
  balanceSheet?: Maybe<BalanceSheet>
  cashFlow?: Maybe<CashFlow>
  payments?: Maybe<Array<Maybe<Payment>>>
  profitAndLoss?: Maybe<ProfitAndLoss>
}

export type BookmarkToolInput = {
  isBookmarked: Scalars['Boolean']
  toolId: Scalars['String']
  userId?: InputMaybe<Scalars['String']>
}

export type BookmarkToolResponse = {
  __typename?: 'BookmarkToolResponse'
  data?: Maybe<Tool>
  error?: Maybe<Scalars['String']>
  message?: Maybe<Scalars['String']>
  success?: Maybe<Scalars['Boolean']>
}

export type BusinessAccessInput = {
  businessId: Scalars['ID']
  email: Scalars['String']
  type: BusinessUserType
  userId: Scalars['ID']
}

export type BusinessAddress = {
  __typename?: 'BusinessAddress'
  addressLine1?: Maybe<Scalars['String']>
  addressLine2?: Maybe<Scalars['String']>
  city?: Maybe<Scalars['String']>
  country?: Maybe<Scalars['String']>
  hasBusinessAddress?: Maybe<Scalars['Boolean']>
  postalCode?: Maybe<Scalars['String']>
  state?: Maybe<Scalars['String']>
  zipCode?: Maybe<Scalars['String']>
}

export type BusinessAddressInput = {
  addressLine1?: InputMaybe<Scalars['String']>
  addressLine2?: InputMaybe<Scalars['String']>
  city?: InputMaybe<Scalars['String']>
  country?: InputMaybe<Scalars['String']>
  hasBusinessAddress?: InputMaybe<Scalars['Boolean']>
  postalCode?: InputMaybe<Scalars['String']>
  state?: InputMaybe<Scalars['String']>
  zipCode?: InputMaybe<Scalars['String']>
}

export type BusinessAdvisorsData = {
  __typename?: 'BusinessAdvisorsData'
  label?: Maybe<Scalars['String']>
  value?: Maybe<Scalars['String']>
}

export type BusinessGoal = {
  __typename?: 'BusinessGoal'
  availableExpertise?: Maybe<Scalars['String']>
  availableResources?: Maybe<Scalars['Int']>
  blockOutDates?: Maybe<Array<Maybe<Scalars['String']>>>
  budget?: Maybe<Scalars['Float']>
  businessGoalDescription?: Maybe<Scalars['String']>
  category?: Maybe<BusinessGoalCategory>
  chatSessions?: Maybe<Array<Maybe<GoalChatSessionRef>>>
  createdAt?: Maybe<Scalars['String']>
  createdBy?: Maybe<User>
  createdById?: Maybe<Scalars['String']>
  dedicatedHoursPerWeek?: Maybe<Scalars['Int']>
  description?: Maybe<Scalars['String']>
  expectedEndDate?: Maybe<Scalars['String']>
  experimentalCurrentDay?: Maybe<Scalars['Int']>
  feedbackMessage?: Maybe<Array<Maybe<FeedbackMessage>>>
  filter?: Maybe<UserTasksFilter>
  goalId?: Maybe<Scalars['ID']>
  goalPriority?: Maybe<BusinessGoalPriority>
  goalTimeFrame?: Maybe<BusinessGoalTimeFrame>
  hasBeenViewed?: Maybe<Scalars['Boolean']>
  logo?: Maybe<Scalars['String']>
  metadata?: Maybe<Scalars['AWSJSON']>
  name?: Maybe<Scalars['String']>
  pauseDate?: Maybe<Scalars['String']>
  plan?: Maybe<BusinessGoalPlan>
  progress?: Maybe<Scalars['Int']>
  resourcesAverageDedicatedTimePerWeek?: Maybe<Scalars['Int']>
  sessionId?: Maybe<Scalars['String']>
  startDate?: Maybe<Scalars['String']>
  status?: Maybe<UserTaskItemStatus>
  strategyHistory?: Maybe<Array<StrategyHistory>>
  suggestedBy?: Maybe<Advisors>
  suggestedById?: Maybe<Scalars['String']>
  suggestedStatus?: Maybe<UserTaskSuggestedItemStatus>
  tenantId?: Maybe<Scalars['ID']>
  updatedAt?: Maybe<Scalars['String']>
  userId?: Maybe<Scalars['ID']>
  why?: Maybe<Scalars['String']>
}

export enum BusinessGoalCategory {
  Communications = 'COMMUNICATIONS',
  CustomerService = 'CUSTOMER_SERVICE',
  Finance = 'FINANCE',
  Hr = 'HR',
  InformationTechnology = 'INFORMATION_TECHNOLOGY',
  Legal = 'LEGAL',
  Marketing = 'MARKETING',
  Operations = 'OPERATIONS',
  Production = 'PRODUCTION',
  ResearchAndDevelopment = 'RESEARCH_AND_DEVELOPMENT',
  Sales = 'SALES',
  Strategy = 'STRATEGY',
}

export enum BusinessGoalDateFilter {
  EntireGamePlan = 'ENTIRE_GAME_PLAN',
  NextMonth = 'NEXT_MONTH',
  NextQuarter = 'NEXT_QUARTER',
  NextWeek = 'NEXT_WEEK',
  ThisMonth = 'THIS_MONTH',
  ThisQuarter = 'THIS_QUARTER',
  ThisWeek = 'THIS_WEEK',
  ThisYear = 'THIS_YEAR',
  Today = 'TODAY',
  Tomorrow = 'TOMORROW',
}

export type BusinessGoalMilestone = {
  __typename?: 'BusinessGoalMilestone'
  descriptions?: Maybe<Scalars['String']>
  expectedEndDate?: Maybe<Scalars['String']>
  filter?: Maybe<UserTasksFilter>
  goalStatus?: Maybe<UserTaskItemStatus>
  isFumbled?: Maybe<Scalars['Boolean']>
  milestoneId?: Maybe<Scalars['ID']>
  milestoneSpan?: Maybe<Scalars['String']>
  name?: Maybe<Scalars['String']>
  order?: Maybe<Scalars['Int']>
  planId?: Maybe<Scalars['ID']>
  riskAndChallenges?: Maybe<Scalars['String']>
  startDate?: Maybe<Scalars['String']>
  status?: Maybe<UserTaskItemStatus>
  tasks?: Maybe<Array<UserTask>>
  timeline?: Maybe<Scalars['String']>
}

export type BusinessGoalMilestoneInput = {
  descriptions?: InputMaybe<Scalars['String']>
  expectedEndDate: Scalars['String']
  milestoneId: Scalars['ID']
  name: Scalars['String']
  order: Scalars['Int']
  planId?: InputMaybe<Scalars['ID']>
  riskAndChallenges?: InputMaybe<Scalars['String']>
  startDate: Scalars['String']
  status?: InputMaybe<UserTaskItemStatus>
  tasks?: InputMaybe<Array<UserTaskInput>>
  timeline?: InputMaybe<Scalars['String']>
}

export type BusinessGoalPlan = {
  __typename?: 'BusinessGoalPlan'
  expectedEndDate?: Maybe<Scalars['String']>
  filter?: Maybe<UserTasksFilter>
  goalId?: Maybe<Scalars['ID']>
  goalStatus?: Maybe<UserTaskItemStatus>
  isUndismissedFumbledState?: Maybe<Scalars['Boolean']>
  isUndismissedMicroCelebrationState?: Maybe<Scalars['Boolean']>
  milestones?: Maybe<Array<BusinessGoalMilestone>>
  name?: Maybe<Scalars['String']>
  pauseDate?: Maybe<Scalars['String']>
  pauseDuration?: Maybe<Scalars['Int']>
  planId?: Maybe<Scalars['ID']>
  progress?: Maybe<Scalars['Int']>
  startDate?: Maybe<Scalars['String']>
  state?: Maybe<BusinessGoalPlanState>
  strategy?: Maybe<Scalars['String']>
  tasks?: Maybe<Array<Maybe<UserTask>>>
  timeline?: Maybe<Scalars['String']>
}

export type BusinessGoalPlanInput = {
  category?: InputMaybe<Scalars['String']>
  expectedEndDate: Scalars['String']
  goalId?: InputMaybe<Scalars['ID']>
  milestones?: InputMaybe<Array<BusinessGoalMilestoneInput>>
  name: Scalars['String']
  pauseDate?: InputMaybe<Scalars['String']>
  pauseDuration?: InputMaybe<Scalars['Int']>
  planId: Scalars['ID']
  progress?: InputMaybe<Scalars['Int']>
  startDate: Scalars['String']
  state?: InputMaybe<BusinessGoalPlanState>
  timeline?: InputMaybe<Scalars['String']>
}

export enum BusinessGoalPlanState {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Draft = 'DRAFT',
}

export enum BusinessGoalPriority {
  HighPriority = 'HIGH_PRIORITY',
  LowPriority = 'LOW_PRIORITY',
  MediumPriority = 'MEDIUM_PRIORITY',
}

export enum BusinessGoalTimeFrame {
  LongTerm = 'LONG_TERM',
  MediumTerm = 'Medium_TERM',
  ShortTerm = 'SHORT_TERM',
}

export type BusinessGoalsFilterData = {
  categories?: InputMaybe<Array<BusinessGoalCategory>>
  isArchive?: InputMaybe<Scalars['Boolean']>
  priorities?: InputMaybe<Array<BusinessGoalPriority>>
  statuses?: InputMaybe<Array<UserTaskItemStatus>>
  timeFrames?: InputMaybe<Array<BusinessGoalTimeFrame>>
}

export enum BusinessIndustries {
  ArtsEntertainment = 'ArtsEntertainment',
  EducationSocialServices = 'EducationSocialServices',
  FoodAndRestaurantBar = 'FoodAndRestaurantBar',
  Other = 'Other',
  PersonalServices = 'PersonalServices',
  ProfessionalServices = 'ProfessionalServices',
  Retail = 'Retail',
}

export enum BusinessMetricsViewPermissionState {
  Granted = 'GRANTED',
  NotGranted = 'NOT_GRANTED',
  Requested = 'REQUESTED',
}

export type BusinessPhoneNumber = {
  __typename?: 'BusinessPhoneNumber'
  countryCode?: Maybe<Scalars['Int']>
  phoneNo?: Maybe<Scalars['Int']>
}

export type BusinessProfile = {
  __typename?: 'BusinessProfile'
  EIN?: Maybe<Scalars['String']>
  POS?: Maybe<Scalars['String']>
  POSOptionId?: Maybe<Scalars['String']>
  accountingMethod?: Maybe<Scalars['String']>
  accountingMethodOptionId?: Maybe<Scalars['String']>
  additionalContext?: Maybe<Scalars['AWSJSON']>
  additionalInfo?: Maybe<Scalars['String']>
  address?: Maybe<Address>
  advisors?: Maybe<Array<Advisors>>
  avatar?: Maybe<Scalars['String']>
  bookKeepingTool?: Maybe<Scalars['String']>
  bookKeepingToolOptionId?: Maybe<Scalars['String']>
  bookkeepingInfo?: Maybe<BookkeepingInfo>
  budget?: Maybe<Scalars['String']>
  businessAddress?: Maybe<BusinessAddress>
  businessBankAccount?: Maybe<Scalars['Boolean']>
  businessClassification?: Maybe<Scalars['String']>
  businessClassificationOptionId?: Maybe<Scalars['String']>
  businessDescription?: Maybe<Scalars['String']>
  businessEmail?: Maybe<Scalars['String']>
  businessLocations?: Maybe<Array<Scalars['String']>>
  businessLocationsOptionIds?: Maybe<Array<Scalars['String']>>
  businessMetricsViewPermission?: Maybe<BusinessMetricsViewPermissionState>
  businessName?: Maybe<Scalars['String']>
  businessNature?: Maybe<Scalars['String']>
  businessNatureOptionId?: Maybe<Scalars['String']>
  businessPhoneNumber?: Maybe<BusinessPhoneNumber>
  businessPlan?: Maybe<UserFile>
  businessStage?: Maybe<Scalars['String']>
  businessStageOptionId?: Maybe<Scalars['String']>
  businessVision?: Maybe<Scalars['String']>
  challenges?: Maybe<Scalars['String']>
  companyEmployees?: Maybe<Scalars['String']>
  contractors?: Maybe<Scalars['String']>
  country?: Maybe<Scalars['String']>
  createdAt?: Maybe<Scalars['AWSDateTime']>
  crmToolIds?: Maybe<Array<Scalars['String']>>
  dba?: Maybe<Scalars['String']>
  dbaNames?: Maybe<Array<Scalars['String']>>
  debtFinancing?: Maybe<Scalars['String']>
  domainName?: Maybe<Scalars['String']>
  education?: Maybe<Scalars['String']>
  employeeBenefit?: Maybe<Scalars['String']>
  exitPlan?: Maybe<Scalars['String']>
  exitPlanOptionId?: Maybe<Scalars['String']>
  expenses?: Maybe<Scalars['Float']>
  facebook?: Maybe<Scalars['String']>
  financeTrackingToolIds?: Maybe<Array<Scalars['String']>>
  financialGrowth?: Maybe<Scalars['String']>
  finicityBusinessId?: Maybe<Scalars['String']>
  finicityConsumerId?: Maybe<Scalars['String']>
  finicityCustomerId?: Maybe<Scalars['String']>
  foodSubIndustry?: Maybe<Array<Scalars['String']>>
  foodSubIndustryOptionIds?: Maybe<Array<Scalars['String']>>
  fullTimeEmployees?: Maybe<Scalars['String']>
  gender?: Maybe<Scalars['String']>
  googleBusinessProfilePlays?: Maybe<Array<Scalars['String']>>
  googleBusinessProfilePlaysOptionIds?: Maybe<Array<Scalars['String']>>
  googleWorkspacePlays?: Maybe<Array<Scalars['String']>>
  googleWorkspacePlaysOptionIds?: Maybe<Array<Scalars['String']>>
  grossRevenueGoalForThisYear?: Maybe<Scalars['String']>
  hasAvatar?: Maybe<Scalars['Boolean']>
  hasBookKeepingTool?: Maybe<Scalars['String']>
  hasBookKeepingToolOptionId?: Maybe<Scalars['String']>
  hasBudget?: Maybe<Scalars['String']>
  hasBudgetOptionId?: Maybe<Scalars['String']>
  hasBusinessEmail?: Maybe<Scalars['String']>
  hasBusinessEmailOptionId?: Maybe<Scalars['String']>
  hasBusinessEmployees?: Maybe<Scalars['String']>
  hasBusinessEmployeesOptionId?: Maybe<Scalars['String']>
  hasBusinessPhoneNumber?: Maybe<Scalars['String']>
  hasBusinessPhoneNumberOptionId?: Maybe<Scalars['String']>
  hasDomainName?: Maybe<Scalars['String']>
  hasDomainNameOptionId?: Maybe<Scalars['String']>
  hasEIN?: Maybe<Scalars['Boolean']>
  hasEsignatureTool?: Maybe<Scalars['String']>
  hasEsignatureToolOptionId?: Maybe<Scalars['String']>
  hasFacebook?: Maybe<Scalars['Boolean']>
  hasGoogleBusinessProfile?: Maybe<Scalars['String']>
  hasGoogleBusinessProfileOptionId?: Maybe<Scalars['String']>
  hasGoogleChrome?: Maybe<Scalars['String']>
  hasGoogleChromeOptionId?: Maybe<Scalars['String']>
  hasGoogleWorkspace?: Maybe<Scalars['String']>
  hasGoogleWorkspaceOptionId?: Maybe<Scalars['String']>
  hasInstagram?: Maybe<Scalars['Boolean']>
  hasLinkedin?: Maybe<Scalars['Boolean']>
  hasLogo?: Maybe<Scalars['String']>
  hasLogoOptionId?: Maybe<Scalars['String']>
  hasLogoTrademarked?: Maybe<Scalars['String']>
  hasLogoTrademarkedOptionId?: Maybe<Scalars['String']>
  hasMoreLocations?: Maybe<Scalars['String']>
  hasMoreLocationsOptionId?: Maybe<Scalars['String']>
  hasPOS?: Maybe<Scalars['String']>
  hasPOSOptionId?: Maybe<Scalars['String']>
  hasPaymentProcessor?: Maybe<Scalars['String']>
  hasPaymentProcessorOptionId?: Maybe<Scalars['String']>
  hasPricingStrategies?: Maybe<Scalars['String']>
  hasPricingStrategiesOptionId?: Maybe<Scalars['String']>
  hasQuickBooks?: Maybe<Scalars['String']>
  hasQuickBooksOptionId?: Maybe<Scalars['String']>
  hasRegisterBusinessStructure?: Maybe<Scalars['Boolean']>
  hasTikTok?: Maybe<Scalars['Boolean']>
  hasTwitter?: Maybe<Scalars['Boolean']>
  hasWebsite?: Maybe<Scalars['Boolean']>
  hasYoutube?: Maybe<Scalars['Boolean']>
  haveStartedGeneratingSales?: Maybe<Scalars['Boolean']>
  hoursSpent?: Maybe<Scalars['String']>
  hoursSpentOptionId?: Maybe<Scalars['String']>
  hoursSpentPerMonth?: Maybe<Scalars['Int']>
  hoursSpentPerWeek?: Maybe<Scalars['Int']>
  id?: Maybe<Scalars['ID']>
  instagram?: Maybe<Scalars['String']>
  isProfit?: Maybe<Scalars['Boolean']>
  jobsCreated?: Maybe<Scalars['String']>
  lastUpdatedBusinessPlan?: Maybe<Scalars['AWSDateTime']>
  lastYearRevenue?: Maybe<Scalars['String']>
  launchDate?: Maybe<Scalars['AWSDateTime']>
  learnPricingStrategies?: Maybe<Scalars['String']>
  learnPricingStrategiesOptionId?: Maybe<Scalars['String']>
  linkedin?: Maybe<Scalars['String']>
  loginFrequency?: Maybe<Scalars['String']>
  logo?: Maybe<UserFile>
  metricTimeSeries?: Maybe<MetricTimeSeries>
  metricValue?: Maybe<MetricValue>
  minorityOwned?: Maybe<Scalars['String']>
  month?: Maybe<Scalars['String']>
  monthlyImpactReports?: Maybe<Array<UserFile>>
  motivation?: Maybe<Scalars['String']>
  naicsCode?: Maybe<Scalars['String']>
  newCustomer?: Maybe<Scalars['String']>
  noOfBusinessStarted?: Maybe<Scalars['String']>
  numberOfBusinessBankAccounts?: Maybe<Scalars['String']>
  onboardedAt?: Maybe<Scalars['String']>
  otherExitPlan?: Maybe<Scalars['String']>
  otherGoals?: Maybe<Array<Scalars['String']>>
  otherGoalsOptionIds?: Maybe<Array<Scalars['String']>>
  otherRegisteredBusinessStructure?: Maybe<Scalars['String']>
  otherWhereDoYouDoBusiness?: Maybe<Scalars['String']>
  partTimeEmployees?: Maybe<Scalars['String']>
  paymentAcceptance?: Maybe<Scalars['String']>
  paymentAcceptanceOptionId?: Maybe<Scalars['String']>
  paymentAcceptancePlan?: Maybe<Scalars['String']>
  paymentAcceptancePlanOptionId?: Maybe<Scalars['String']>
  paymentApps?: Maybe<Array<Scalars['String']>>
  paymentAppsOptionIds?: Maybe<Array<Scalars['String']>>
  paymentProcessor?: Maybe<Scalars['String']>
  paymentProcessorOptionId?: Maybe<Scalars['String']>
  paymentTypes?: Maybe<Array<Scalars['String']>>
  paymentTypesOptionIds?: Maybe<Array<Scalars['String']>>
  personalGoals?: Maybe<Scalars['String']>
  phoneNumber?: Maybe<Scalars['String']>
  physicalLocation?: Maybe<Scalars['String']>
  pricingStrategies?: Maybe<Array<Scalars['String']>>
  pricingStrategiesOptionIds?: Maybe<Array<Scalars['String']>>
  productSale?: Maybe<Scalars['String']>
  productsAndServices?: Maybe<Array<Scalars['String']>>
  productsAndServicesOptionIds?: Maybe<Array<Scalars['String']>>
  quickBookPlays?: Maybe<Array<Scalars['String']>>
  quickBookPlaysOptionIds?: Maybe<Array<Scalars['String']>>
  race?: Maybe<Scalars['String']>
  registerBusinessStructure?: Maybe<Scalars['String']>
  registerBusinessStructureOptionId?: Maybe<Scalars['String']>
  revenue?: Maybe<Scalars['String']>
  revenueStatus?: Maybe<Scalars['String']>
  revenueStatusOptionId?: Maybe<Scalars['String']>
  saleGoal?: Maybe<Scalars['String']>
  sbaCertified?: Maybe<Scalars['String']>
  seasonalityDetails?: Maybe<Scalars['String']>
  serviceSale?: Maybe<Scalars['String']>
  servicesSubIndustry?: Maybe<Scalars['String']>
  servicesSubIndustryOptionId?: Maybe<Scalars['String']>
  squarePlays?: Maybe<Array<Scalars['String']>>
  squarePlaysOptionIds?: Maybe<Array<Scalars['String']>>
  stripePlays?: Maybe<Array<Scalars['String']>>
  stripePlaysOptionIds?: Maybe<Array<Scalars['String']>>
  strongBusinessAreas?: Maybe<Array<Scalars['String']>>
  strongBusinessAreasOptionIds?: Maybe<Array<Scalars['String']>>
  supportAndHelp?: Maybe<Array<Scalars['String']>>
  supportAndHelpOptionIds?: Maybe<Array<Scalars['String']>>
  targetAudience?: Maybe<Scalars['String']>
  tenantId?: Maybe<Scalars['String']>
  thisYearRevenue?: Maybe<Scalars['String']>
  tiktok?: Maybe<Scalars['String']>
  topGoal?: Maybe<Scalars['String']>
  topGoalOptionId?: Maybe<Scalars['String']>
  totalEmployees?: Maybe<Scalars['String']>
  twitter?: Maybe<Scalars['String']>
  updatedAt?: Maybe<Scalars['AWSDateTime']>
  usePOS?: Maybe<Scalars['String']>
  usePOSOptionId?: Maybe<Scalars['String']>
  usePaymentProcessor?: Maybe<Scalars['String']>
  usePaymentProcessorOptionId?: Maybe<Scalars['String']>
  userName?: Maybe<Scalars['String']>
  users?: Maybe<Array<BusinessUser>>
  veteranOwned?: Maybe<Scalars['String']>
  volunteers?: Maybe<Scalars['String']>
  wages?: Maybe<Scalars['String']>
  website?: Maybe<Scalars['String']>
  whereDoYouDoBusiness?: Maybe<Array<Scalars['String']>>
  whereDoYouDoBusinessOptionIds?: Maybe<Array<Scalars['String']>>
  year?: Maybe<Scalars['String']>
  yearEstablished?: Maybe<Scalars['String']>
  yearsInBusiness?: Maybe<Scalars['String']>
  youtube?: Maybe<Scalars['String']>
}

export type BusinessProfileMetricTimeSeriesArgs = {
  input: MetricTimeSeriesInput
}

export type BusinessProfileMetricValueArgs = {
  input: MetricValueInput
}

export type BusinessProfileFields = {
  __typename?: 'BusinessProfileFields'
  logo?: Maybe<Scalars['String']>
}

export type BusinessSummaryData = {
  __typename?: 'BusinessSummaryData'
  optionId?: Maybe<Scalars['String']>
  optionName?: Maybe<Scalars['String']>
  optionType?: Maybe<Scalars['String']>
  summary?: Maybe<Scalars['Int']>
  tenantId?: Maybe<Scalars['String']>
}

export type BusinessSummaryItem = {
  __typename?: 'BusinessSummaryItem'
  data: Array<BusinessSummaryData>
  optionType?: Maybe<Scalars['String']>
}

export type BusinessSummaryResponse = {
  __typename?: 'BusinessSummaryResponse'
  data: Array<BusinessSummaryItem>
  status: ChartStatus
}

export type BusinessSupportOrganization = {
  __typename?: 'BusinessSupportOrganization'
  adminCount?: Maybe<Scalars['Int']>
  adminId: Scalars['String']
  advisorCount?: Maybe<Scalars['Int']>
  id: Scalars['ID']
  intakeFormCompleted?: Maybe<Scalars['Boolean']>
  intakeFormCompletedAt?: Maybe<Scalars['AWSDateTime']>
  intakeFormCompletedBy?: Maybe<Scalars['String']>
  licenseCount?: Maybe<Scalars['Int']>
  licensesUsed?: Maybe<Scalars['Int']>
  logoUrl?: Maybe<Scalars['String']>
  mtdHighEngagementCriteria?: Maybe<UserEngagementCriteria>
  mtdMediumEngagementCriteria?: Maybe<UserEngagementCriteria>
  name: Scalars['String']
  status?: Maybe<OrganizationStatus>
  terminology?: Maybe<Array<Term>>
}

export type BusinessUser = {
  __typename?: 'BusinessUser'
  businessId: Scalars['ID']
  createdAt: Scalars['AWSDateTime']
  id: Scalars['ID']
  type: BusinessUserType
  updatedAt: Scalars['AWSDateTime']
  user: UserProfile
  userId: Scalars['ID']
}

export enum BusinessUserType {
  Admin = 'ADMIN',
  CoOwner = 'CO_OWNER',
  Member = 'MEMBER',
  Owner = 'OWNER',
}

export enum Calendar {
  GoogleCalendar = 'GOOGLE_CALENDAR',
  Internal = 'INTERNAL',
  MicrosoftOffice_365 = 'MICROSOFT_OFFICE_365',
}

export type CalendarEvent = {
  __typename?: 'CalendarEvent'
  advisorId?: Maybe<Scalars['String']>
  advisorName?: Maybe<Scalars['String']>
  advisorProfiles?: Maybe<Scalars['AWSJSON']>
  attendees?: Maybe<Array<CalendarEventAttendee>>
  availability?: Maybe<Scalars['String']>
  botId?: Maybe<Scalars['String']>
  businessLogo?: Maybe<Scalars['String']>
  businessName?: Maybe<Scalars['String']>
  comment?: Maybe<Scalars['String']>
  description?: Maybe<Scalars['String']>
  end?: Maybe<CalendarEventDate>
  eventId?: Maybe<Scalars['String']>
  eventTime?: Maybe<Scalars['AWSDateTime']>
  eventType?: Maybe<Scalars['String']>
  externalReferenceIds?: Maybe<Array<CalendarEventExternalReferenceId>>
  generatedByAI?: Maybe<Scalars['Boolean']>
  id?: Maybe<Scalars['String']>
  inviteeId?: Maybe<Scalars['String']>
  isAllDay?: Maybe<Scalars['Boolean']>
  isBusy?: Maybe<Scalars['Boolean']>
  location?: Maybe<Scalars['String']>
  meetingDetailsHTML?: Maybe<Scalars['String']>
  meta?: Maybe<Scalars['AWSJSON']>
  organizerFirstName?: Maybe<Scalars['String']>
  organizerLastName?: Maybe<Scalars['String']>
  organizerName?: Maybe<Scalars['String']>
  originator?: Maybe<Scalars['String']>
  ownerId?: Maybe<Scalars['String']>
  participantFirstName?: Maybe<Scalars['String']>
  participantLastName?: Maybe<Scalars['String']>
  participantName?: Maybe<Scalars['String']>
  privateNotes?: Maybe<Array<Maybe<PrivateNote>>>
  profile?: Maybe<Scalars['AWSJSON']>
  recordingUrl?: Maybe<Scalars['String']>
  requestDetails?: Maybe<Array<Maybe<RequestDetail>>>
  start?: Maybe<CalendarEventDate>
  status?: Maybe<Scalars['String']>
  summary?: Maybe<Scalars['String']>
  summaryEditInfo?: Maybe<SummaryEditInfo>
  teamMemberDetails?: Maybe<Array<Maybe<TeamMemberDetails>>>
  teamMemberList?: Maybe<Array<Maybe<Scalars['String']>>>
  timezone?: Maybe<Scalars['String']>
  transcriptSummary?: Maybe<Scalars['String']>
  transcriptSummaryFile?: Maybe<Scalars['String']>
  transcriptUrl?: Maybe<Scalars['AWSJSON']>
  videoLinkDescription?: Maybe<Scalars['String']>
}

export type CalendarEventAttendee = {
  __typename?: 'CalendarEventAttendee'
  email: Scalars['String']
  optional?: Maybe<Scalars['Boolean']>
  responseStatus?: Maybe<Scalars['String']>
}

export type CalendarEventDate = {
  __typename?: 'CalendarEventDate'
  date?: Maybe<Scalars['String']>
  dateTime?: Maybe<Scalars['String']>
  timeZone?: Maybe<Scalars['String']>
}

export type CalendarEventDateInput = {
  date?: InputMaybe<Scalars['String']>
  dateTime?: InputMaybe<Scalars['String']>
  timeZone?: InputMaybe<Scalars['String']>
}

export type CalendarEventExternalReferenceId = {
  __typename?: 'CalendarEventExternalReferenceId'
  calendarId?: Maybe<Scalars['String']>
  createdAt?: Maybe<Scalars['String']>
  eventId: Scalars['String']
  externalEventId?: Maybe<Scalars['String']>
  meetingLink?: Maybe<Scalars['String']>
  meta?: Maybe<Scalars['AWSJSON']>
  pk?: Maybe<Scalars['String']>
  sk?: Maybe<Scalars['String']>
  startDate?: Maybe<Scalars['String']>
  status?: Maybe<Scalars['String']>
  type: Scalars['String']
  userId: Scalars['String']
}

export type CalendarEventResponse = {
  __typename?: 'CalendarEventResponse'
  data: Array<CalendarEvent>
  error?: Maybe<Scalars['String']>
  message?: Maybe<Scalars['String']>
  success: Scalars['Boolean']
}

export enum CalendarEventViewPreference {
  All = 'ALL',
  Internal = 'INTERNAL',
}

export type CalendlyUser = {
  __typename?: 'CalendlyUser'
  calendlyEventsUrl?: Maybe<Scalars['String']>
  email?: Maybe<Scalars['String']>
  name?: Maybe<Scalars['String']>
  schedulingUrl?: Maybe<Scalars['String']>
  userId?: Maybe<Scalars['String']>
}

export type CalendlyUserResponse = {
  __typename?: 'CalendlyUserResponse'
  data?: Maybe<CalendlyUser>
  error?: Maybe<Scalars['String']>
  message?: Maybe<Scalars['String']>
  success: Scalars['Boolean']
}

export type CancelUserCalendarEvent = {
  __typename?: 'CancelUserCalendarEvent'
  eventId?: Maybe<Scalars['String']>
  eventType?: Maybe<Scalars['String']>
  tackleId?: Maybe<Scalars['String']>
}

export type CancelUserCalendarEventInput = {
  eventId?: InputMaybe<Scalars['String']>
  eventType?: InputMaybe<Scalars['String']>
  tackleId?: InputMaybe<Scalars['String']>
  tenantId: Scalars['String']
}

export type CancelUserCalendarEventResponse = {
  __typename?: 'CancelUserCalendarEventResponse'
  data?: Maybe<CancelUserCalendarEvent>
  error?: Maybe<Scalars['String']>
}

export type CashBalanceByMonthReport = {
  __typename?: 'CashBalanceByMonthReport'
  cashBalance?: Maybe<Scalars['Float']>
  endDate?: Maybe<Scalars['String']>
  source?: Maybe<Scalars['String']>
  startDate?: Maybe<Scalars['String']>
}

export type CashBalanceReport = AccountingReport & {
  __typename?: 'CashBalanceReport'
  cashBalance?: Maybe<Scalars['Float']>
  dateRange?: Maybe<DateRanges>
  endDate?: Maybe<Scalars['String']>
  growth?: Maybe<Scalars['Float']>
  source?: Maybe<Scalars['String']>
  startDate?: Maybe<Scalars['String']>
  userId?: Maybe<Scalars['String']>
}

export type CashFlow = {
  __typename?: 'CashFlow'
  activities?: Maybe<Array<Maybe<AccountingToolEntry>>>
  endDate?: Maybe<Scalars['String']>
  startDate?: Maybe<Scalars['String']>
}

export enum ChartStatus {
  DisconnectedSource = 'DisconnectedSource',
  Error = 'Error',
  Processing = 'Processing',
  Success = 'Success',
}

export type ChatBotMessage = {
  __typename?: 'ChatBotMessage'
  content: Scalars['String']
  createdAt: Scalars['String']
  isEdited?: Maybe<Scalars['Boolean']>
  isVoiceMessage?: Maybe<Scalars['Boolean']>
  messageType: Scalars['String']
  progress?: Maybe<Scalars['Int']>
  role: Scalars['String']
  voiceDuration?: Maybe<Scalars['Int']>
}

export enum ChatBotMessageTypes {
  Audio = 'Audio',
  AudioToForm = 'AudioToForm',
  Form = 'Form',
  FormResponse = 'FormResponse',
  Text = 'Text',
  ToolConnected = 'ToolConnected',
  Tools = 'Tools',
}

export type ChatSession = {
  __typename?: 'ChatSession'
  streamUrl: Scalars['String']
}

export enum ChatSessionStatus {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
}

export type CognitoUser = {
  __typename?: 'CognitoUser'
  email: Scalars['String']
  enabled?: Maybe<Scalars['Boolean']>
  name?: Maybe<Scalars['String']>
  userName: Scalars['String']
  userStatus?: Maybe<Scalars['String']>
}

export enum ConditionRuleOperation {
  Contains = 'CONTAINS',
  Equals = 'EQUALS',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqual = 'GREATER_THAN_OR_EQUAL',
  IsEmpty = 'IS_EMPTY',
  IsNotEmpty = 'IS_NOT_EMPTY',
  LessThan = 'LESS_THAN',
  LessThanOrEqual = 'LESS_THAN_OR_EQUAL',
  NotContains = 'NOT_CONTAINS',
  NotEquals = 'NOT_EQUALS',
}

export type ConditionalField = {
  __typename?: 'ConditionalField'
  dependsOn: Scalars['String']
  excludeValues?: Maybe<Array<Scalars['String']>>
  values: Array<Scalars['String']>
}

export type ConditionalFieldInput = {
  dependsOn: Scalars['String']
  excludeValues?: InputMaybe<Array<Scalars['String']>>
  values: Array<Scalars['String']>
}

export type CounterResponse = {
  __typename?: 'CounterResponse'
  lastUpdatedAt?: Maybe<Scalars['AWSDateTime']>
  refreshInProgress?: Maybe<Scalars['Boolean']>
  value?: Maybe<Scalars['Float']>
}

export type CreateChatSessionInput = {
  assistantId?: InputMaybe<Scalars['String']>
  onboardingFlowType?: InputMaybe<OnboardingFlowType>
  targetOrigin: Scalars['String']
  threadId?: InputMaybe<Scalars['String']>
}

export type CreateFlowChatSessionInput = {
  businessId?: InputMaybe<Scalars['String']>
  flow: Scalars['String']
  metadata?: InputMaybe<Scalars['AWSJSON']>
}

export type CreateTeamMemberInput = {
  businessFunction?: InputMaybe<Scalars['String']>
  businessName?: InputMaybe<Scalars['String']>
  email: Scalars['String']
  firstName: Scalars['String']
  jobTitle?: InputMaybe<Scalars['String']>
  lastName: Scalars['String']
  mobileNumber?: InputMaybe<Scalars['String']>
  type: BusinessUserType
}

export type CreateToolInput = {
  businessId: Scalars['String']
  dataScope?: InputMaybe<ToolDataScope>
  description?: InputMaybe<Scalars['String']>
  featured?: InputMaybe<Scalars['Boolean']>
  imageFile?: InputMaybe<ToolImageFileInput>
  imageUrl?: InputMaybe<Scalars['String']>
  keyWords?: InputMaybe<Array<Scalars['String']>>
  longDescription?: InputMaybe<Scalars['String']>
  pricingPageUrl?: InputMaybe<Scalars['String']>
  supportLevel?: InputMaybe<ToolSupportLevel>
  tags?: InputMaybe<Array<Scalars['String']>>
  toolDisplayName?: InputMaybe<Scalars['String']>
  toolHelpText?: InputMaybe<Scalars['String']>
  toolName: Scalars['String']
  toolType?: InputMaybe<ToolType>
  toolUrl: Scalars['String']
  userToolsImageUrl: Scalars['String']
  visible?: InputMaybe<Scalars['Boolean']>
}

export type CreateUserInput = {
  advisors?: InputMaybe<Scalars['AWSJSON']>
  email: Scalars['String']
  firstName: Scalars['String']
  lastName: Scalars['String']
  mobileContactNumber: Scalars['AWSPhone']
  owners?: InputMaybe<Scalars['AWSJSON']>
  role: Scalars['String']
  suppressEmail?: InputMaybe<Scalars['Boolean']>
  tenantId?: InputMaybe<Scalars['String']>
}

export type CreateUserTaskInput = {
  assigneeId?: InputMaybe<Scalars['ID']>
  category?: InputMaybe<BusinessGoalCategory>
  createdById?: InputMaybe<Scalars['ID']>
  estimatedEffortInMinutes?: InputMaybe<Scalars['Int']>
  expectedEndDate?: InputMaybe<Scalars['String']>
  feedbackMessage?: InputMaybe<Array<InputMaybe<FeedbackMessageInput>>>
  files?: InputMaybe<Array<UserFileInput>>
  goalId?: InputMaybe<Scalars['String']>
  goalName?: InputMaybe<Scalars['String']>
  hasBeenViewed?: InputMaybe<Scalars['Boolean']>
  howToDo?: InputMaybe<Scalars['String']>
  howToLinks?: InputMaybe<Array<InputMaybe<UserTaskHowToInput>>>
  instructionForTask?: InputMaybe<Scalars['String']>
  kpis?: InputMaybe<Scalars['String']>
  meetingId?: InputMaybe<Scalars['String']>
  milestoneId?: InputMaybe<Scalars['ID']>
  name: Scalars['String']
  order?: InputMaybe<Scalars['Int']>
  planId?: InputMaybe<Scalars['ID']>
  playType?: InputMaybe<PlayType>
  resources?: InputMaybe<Scalars['String']>
  role?: InputMaybe<Scalars['String']>
  source: UserTaskSource
  startDate?: InputMaybe<Scalars['String']>
  status?: InputMaybe<UserTaskItemStatus>
  taskPriority?: InputMaybe<BusinessGoalPriority>
  tenantId: Scalars['ID']
  timeline?: InputMaybe<Scalars['String']>
  tool?: InputMaybe<Scalars['String']>
  userId?: InputMaybe<Scalars['ID']>
  why?: InputMaybe<Scalars['String']>
}

export type CyclrConnector = {
  __typename?: 'CyclrConnector'
  authValue?: Maybe<AuthValue>
  authenticated?: Maybe<Scalars['Boolean']>
  connectorId?: Maybe<Scalars['Int']>
  id?: Maybe<Scalars['Int']>
  name?: Maybe<Scalars['String']>
}

export type CyclrConnectorResponse = {
  __typename?: 'CyclrConnectorResponse'
  data?: Maybe<Array<CyclrConnector>>
  error?: Maybe<Scalars['String']>
  message?: Maybe<Scalars['String']>
  success: Scalars['Boolean']
}

export enum DateRanges {
  Last12Months = 'last12Months',
  LastMonth = 'lastMonth',
  LastQuarter = 'lastQuarter',
  LastYear = 'lastYear',
  LastYearToDate = 'lastYearToDate',
  ThisMonth = 'thisMonth',
  ThisQuarter = 'thisQuarter',
  ThisWeek = 'thisWeek',
  ThisYear = 'thisYear',
  ThisYearToDate = 'thisYearToDate',
}

export type DateValidationRule = {
  __typename?: 'DateValidationRule'
  dependsOn?: Maybe<Scalars['String']>
  dependsOnMessage?: Maybe<Scalars['String']>
  message: Scalars['String']
  value?: Maybe<Scalars['String']>
}

export type DateValidationRuleInput = {
  dependsOn?: InputMaybe<Scalars['String']>
  dependsOnMessage?: InputMaybe<Scalars['String']>
  message: Scalars['String']
  value?: InputMaybe<Scalars['String']>
}

export type DeauthenticateConnectorInput = {
  connectorName: Scalars['String']
  tenantId: Scalars['String']
}

export type DeleteCalendarEventInput = {
  meta?: InputMaybe<Scalars['AWSJSON']>
}

export type DeleteCalendarEventResponse = {
  __typename?: 'DeleteCalendarEventResponse'
  data?: Maybe<Scalars['AWSJSON']>
  error?: Maybe<Scalars['String']>
  message?: Maybe<Scalars['String']>
  success: Scalars['Boolean']
}

export type DeleteTaskCommentInput = {
  commentId: Scalars['String']
  taskId: Scalars['String']
}

export type DeleteUserFilesInput = {
  recordIds: Array<Scalars['String']>
}

export type DeleteUserNotificationsInput = {
  deleteAll?: InputMaybe<Scalars['Boolean']>
  id?: InputMaybe<Scalars['String']>
  tenantId: Scalars['String']
}

export type DeleteUserTaskInput = {
  taskId: Scalars['ID']
  tenantId: Scalars['ID']
  userId?: InputMaybe<Scalars['ID']>
}

export type DestinationResource = {
  __typename?: 'DestinationResource'
  baseResource: BaseResource
  field: Scalars['String']
}

export type DestinationResourceInput = {
  baseResource: BaseResource
  field: Scalars['String']
}

export enum DirectNotificationChanel {
  Email = 'EMAIL',
  Sms = 'SMS',
}

export enum ErrorType {
  DisconnectedToolError = 'DisconnectedToolError',
  FailedMeetingEmailInvites = 'FailedMeetingEmailInvites',
  ForceLogoutError = 'ForceLogoutError',
  LicenseLimitReached = 'LicenseLimitReached',
  ValidationError = 'ValidationError',
}

export type FeedbackMessage = {
  __typename?: 'FeedbackMessage'
  client?: Maybe<Scalars['String']>
  coachlogic?: Maybe<Scalars['String']>
}

export type FeedbackMessageInput = {
  client?: InputMaybe<Scalars['String']>
  coachlogic?: InputMaybe<Scalars['String']>
}

export enum FeedbackType {
  Negative = 'NEGATIVE',
  Positive = 'POSITIVE',
}

export enum FieldType {
  Button = 'BUTTON',
  ButtonSelect = 'BUTTON_SELECT',
  Checkbox = 'CHECKBOX',
  Date = 'DATE',
  File = 'FILE',
  GoalTemplate = 'GOAL_TEMPLATE',
  Input = 'INPUT',
  Select = 'SELECT',
}

export type FileDetails = {
  id: Scalars['String']
  name?: InputMaybe<Scalars['String']>
  size?: InputMaybe<Scalars['String']>
  streamMessageId?: InputMaybe<Scalars['String']>
  tag?: InputMaybe<UserFileTag>
  tenantId: Scalars['String']
  type?: InputMaybe<Scalars['String']>
  url?: InputMaybe<Scalars['String']>
  userId?: InputMaybe<Scalars['String']>
}

export type FileStructure = {
  __typename?: 'FileStructure'
  id?: Maybe<Scalars['String']>
  name?: Maybe<Scalars['String']>
  size?: Maybe<Scalars['String']>
  tenantId?: Maybe<Scalars['String']>
  type?: Maybe<Scalars['String']>
  url?: Maybe<Scalars['String']>
  userId?: Maybe<Scalars['String']>
}

export type FileStructureInput = {
  id?: InputMaybe<Scalars['String']>
  name?: InputMaybe<Scalars['String']>
  size?: InputMaybe<Scalars['String']>
  tenantId?: InputMaybe<Scalars['String']>
  type?: InputMaybe<Scalars['String']>
  url?: InputMaybe<Scalars['String']>
  userId?: InputMaybe<Scalars['String']>
}

export type GeneralNotification = {
  __typename?: 'GeneralNotification'
  data?: Maybe<Scalars['AWSJSON']>
  key?: Maybe<Scalars['String']>
  timestamp: Scalars['String']
  topic: Scalars['String']
}

export type GeneralNotificationInput = {
  data?: InputMaybe<Scalars['AWSJSON']>
  key?: InputMaybe<Scalars['String']>
  topic: Scalars['String']
}

export type GetAdvisorAssignedTasksInput = {
  filter?: InputMaybe<UserTasksFilterInput>
  tenantId: Scalars['ID']
  userId?: InputMaybe<Scalars['ID']>
}

export type GetAdvisorProfileInput = {
  advisorId: Scalars['String']
  tenantId?: InputMaybe<Scalars['String']>
}

export type GetAdvisorsInput = {
  advisorId?: InputMaybe<Scalars['String']>
  isPaginated?: InputMaybe<Scalars['Boolean']>
  lastEvaluatedKey?: InputMaybe<Scalars['String']>
  pageSize?: InputMaybe<Scalars['String']>
  searchQuery?: InputMaybe<Scalars['String']>
  status?: InputMaybe<Scalars['String']>
  tenantId?: InputMaybe<Scalars['String']>
}

export type GetAllToolCategoriesResponse = {
  __typename?: 'GetAllToolCategoriesResponse'
  categories: Array<GetAllToolCategoriesResponseItem>
  subCategories: Array<GetAllToolCategoriesResponseItem>
}

export type GetAllToolCategoriesResponseItem = {
  __typename?: 'GetAllToolCategoriesResponseItem'
  clientDescription?: Maybe<Scalars['String']>
  description?: Maybe<Scalars['String']>
  name: Scalars['String']
}

export type GetAllToolsGroupedResponse = {
  __typename?: 'GetAllToolsGroupedResponse'
  data?: Maybe<Array<Maybe<GroupedTools>>>
  error?: Maybe<Scalars['String']>
  message?: Maybe<Scalars['String']>
  success?: Maybe<Scalars['Boolean']>
}

export type GetAllToolsResponse = {
  __typename?: 'GetAllToolsResponse'
  data?: Maybe<Array<Maybe<Tool>>>
  error?: Maybe<Scalars['String']>
  groupedTools?: Maybe<GroupedTools>
  message?: Maybe<Scalars['String']>
  success?: Maybe<Scalars['Boolean']>
}

export type GetAttestationReportsInput = {
  filter: AttestationStatus
  lastEvaluatedKey?: InputMaybe<Scalars['String']>
  month?: InputMaybe<Scalars['String']>
  page: Scalars['Int']
  pageSize: Scalars['Int']
  paginationDirection: PaginationDirection
  sort?: InputMaybe<SortOrder>
  tenantId: Scalars['String']
  year?: InputMaybe<Scalars['String']>
}

export type GetAttestationReportsResponse = {
  __typename?: 'GetAttestationReportsResponse'
  data?: Maybe<GetAttestationReportsResponseObj>
  error?: Maybe<Scalars['String']>
}

export type GetAttestationReportsResponseObj = {
  __typename?: 'GetAttestationReportsResponseObj'
  currentPage?: Maybe<Scalars['Int']>
  items?: Maybe<Array<Maybe<Attestation>>>
  lastEvaluatedKey?: Maybe<Scalars['String']>
  pageSize?: Maybe<Scalars['Int']>
  prevEvaluatedKey?: Maybe<Scalars['String']>
  totalPages?: Maybe<Scalars['Int']>
  totalRecords?: Maybe<Scalars['Int']>
}

export type GetAttestationSummaryInput = {
  advisorId: Scalars['ID']
  includeAggregationDetails?: InputMaybe<Scalars['Boolean']>
  tenantId: Scalars['ID']
  timePeriod: TimePeriod
}

export type GetBusinessGoalInput = {
  filter?: InputMaybe<UserTasksFilterInput>
  goalId: Scalars['ID']
  tenantId: Scalars['ID']
  userId?: InputMaybe<Scalars['ID']>
}

export type GetBusinessGoalsInput = {
  filter?: InputMaybe<BusinessGoalsFilterData>
  tenantId: Scalars['ID']
  userId?: InputMaybe<Scalars['ID']>
}

export type GetBusinessIndustryDetailsInput = {
  foodSubIndustryOptionIds?: InputMaybe<Array<Scalars['String']>>
  userId?: InputMaybe<Scalars['String']>
}

export type GetBusinessIndustryDetailsResponse = {
  __typename?: 'GetBusinessIndustryDetailsResponse'
  isSubIndustryUpdated?: Maybe<Scalars['Boolean']>
}

export type GetBusinessSummaryInput = {
  advisorId?: InputMaybe<Scalars['String']>
  optionType?: InputMaybe<OptionTypes>
  tenantId?: InputMaybe<Scalars['String']>
}

export type GetBusinessSupportOrganizationInput = {
  mtdHighEngagementCriteria?: InputMaybe<UserEngagementCriteriaInput>
  mtdMediumEngagementCriteria?: InputMaybe<UserEngagementCriteriaInput>
  tenantId: Scalars['String']
}

export type GetBusinessesInput = {
  advisor?: InputMaybe<Scalars['String']>
  allStatuses: Scalars['Boolean']
  isPaginated?: InputMaybe<Scalars['Boolean']>
  lastEvaluatedKey?: InputMaybe<Scalars['String']>
  pageSize?: InputMaybe<Scalars['String']>
  searchQuery?: InputMaybe<Scalars['String']>
  status?: InputMaybe<Scalars['String']>
  tenantId?: InputMaybe<Scalars['String']>
}

export type GetChartDataInput = {
  businessId?: InputMaybe<Scalars['String']>
  chartName: Scalars['String']
  endDate?: InputMaybe<Scalars['String']>
  startDate?: InputMaybe<Scalars['String']>
  userId?: InputMaybe<Scalars['String']>
}

export type GetChatSessionsInput = {
  flowType?: InputMaybe<OnboardingFlowType>
  userId?: InputMaybe<Scalars['String']>
}

export type GetClientsInput = {
  advisorId?: InputMaybe<Scalars['String']>
  includeInvitedClients?: InputMaybe<Scalars['Boolean']>
  tenantId?: InputMaybe<Scalars['String']>
}

export type GetClientsResponse = {
  __typename?: 'GetClientsResponse'
  data?: Maybe<Array<Maybe<GetClientsResponseData>>>
  error?: Maybe<Scalars['String']>
  message?: Maybe<Scalars['String']>
  success: Scalars['Boolean']
}

export type GetClientsResponseData = {
  __typename?: 'GetClientsResponseData'
  bio?: Maybe<Scalars['String']>
  businessName?: Maybe<Scalars['String']>
  calendlyEventsUrl?: Maybe<Scalars['String']>
  companyAdvisor?: Maybe<Scalars['String']>
  companyEmployees?: Maybe<Scalars['Int']>
  createdAt: Scalars['AWSDateTime']
  email: Scalars['AWSEmail']
  firstName?: Maybe<Scalars['String']>
  id: Scalars['ID']
  isNewUser?: Maybe<Scalars['Boolean']>
  lastName?: Maybe<Scalars['String']>
  mobileContactNumber?: Maybe<Scalars['String']>
  name?: Maybe<Scalars['String']>
  phone?: Maybe<Scalars['AWSPhone']>
  roles?: Maybe<Array<Maybe<Scalars['String']>>>
  schedulingUrl?: Maybe<Scalars['String']>
  updatedAt: Scalars['AWSDateTime']
  websiteURL?: Maybe<Scalars['String']>
  yearsInBusiness?: Maybe<Scalars['String']>
}

export type GetGoalHistoryInput = {
  goalId: Scalars['ID']
  sectionsPagination?: InputMaybe<Array<SectionPaginationInput>>
  tenantId: Scalars['ID']
}

export type GetMeetingTypeResponse = {
  __typename?: 'GetMeetingTypeResponse'
  data?: Maybe<Array<Maybe<MeetingTypes>>>
  error?: Maybe<Scalars['String']>
  message?: Maybe<Scalars['String']>
  success?: Maybe<Scalars['Boolean']>
}

export type GetOAuthUrlInput = {
  authType?: InputMaybe<ToolAuthType>
  connectorName: Scalars['String']
  oAuthConnectionProperties?: InputMaybe<Array<OAuthConnectionProperty>>
  targetOrigin: Scalars['String']
}

export type GetOnboardingFlowStateInput = {
  flowType: OnboardingFlowType
  sessionId: Scalars['String']
}

export type GetOptionsResponse = {
  __typename?: 'GetOptionsResponse'
  data?: Maybe<Array<Maybe<Options>>>
  error?: Maybe<Scalars['String']>
}

export type GetPlayResponseInput = {
  playId?: InputMaybe<Scalars['String']>
  tabId?: InputMaybe<Scalars['String']>
  tenantId: Scalars['String']
  userId?: InputMaybe<Scalars['String']>
}

export type GetPlaysInput = {
  lastEvaluatedKey?: InputMaybe<Scalars['AWSJSON']>
  pageSize?: InputMaybe<Scalars['Int']>
}

export type GetPlaysResponse = {
  __typename?: 'GetPlaysResponse'
  data?: Maybe<Array<Maybe<Play>>>
  error?: Maybe<Scalars['String']>
  message?: Maybe<Scalars['String']>
  success: Scalars['Boolean']
}

export type GetTackleMeetingResponse = {
  __typename?: 'GetTackleMeetingResponse'
  data?: Maybe<Array<Maybe<CalendarEvent>>>
  error?: Maybe<Scalars['String']>
  message?: Maybe<Scalars['String']>
  pagination?: Maybe<Scalars['AWSJSON']>
  success: Scalars['Boolean']
}

export type GetTackleMeetingsInput = {
  filter?: InputMaybe<Scalars['String']>
  isPaginated?: InputMaybe<Scalars['Boolean']>
  lastEvaluatedKey?: InputMaybe<Scalars['AWSJSON']>
  ownerId?: InputMaybe<Scalars['String']>
  pageSize?: InputMaybe<Scalars['Int']>
  tenantId: Scalars['String']
}

export type GetTaskCommentsInput = {
  taskId: Scalars['String']
}

export type GetTenantsResponse = {
  __typename?: 'GetTenantsResponse'
  data?: Maybe<Array<Maybe<Tenant>>>
  error?: Maybe<Scalars['String']>
  message?: Maybe<Scalars['String']>
  success: Scalars['Boolean']
}

export type GetToolByDataTypesInput = {
  businessId: Scalars['String']
  dataTypes: Array<ToolDataTypes>
  getOpenTools?: InputMaybe<Scalars['Boolean']>
  onboardingFlowType?: InputMaybe<OnboardingFlowType>
  targetOrigin: Scalars['String']
  userId: Scalars['String']
}

export type GetToolsByTypeInput = {
  tenantId: Scalars['String']
  toolType: ToolType
}

export type GetToolsByTypeResponse = {
  __typename?: 'GetToolsByTypeResponse'
  data?: Maybe<Array<Maybe<Tool>>>
  error?: Maybe<Scalars['String']>
}

export type GetToolsResponse = {
  __typename?: 'GetToolsResponse'
  data?: Maybe<Array<Maybe<Tool>>>
  error?: Maybe<Scalars['String']>
  message?: Maybe<Scalars['String']>
  success: Scalars['Boolean']
}

export type GetTopActiveClientsResponse = {
  __typename?: 'GetTopActiveClientsResponse'
  data?: Maybe<Array<Maybe<TopActiveClient>>>
  error?: Maybe<Scalars['String']>
}

export type GetUserAvailability = {
  __typename?: 'GetUserAvailability'
  availability: Array<UserAvailability>
  duration: Scalars['String']
}

export type GetUserAvailabilityHoursResponse = {
  __typename?: 'GetUserAvailabilityHoursResponse'
  data?: Maybe<SetUserAvailabilityObj>
  error?: Maybe<Scalars['String']>
}

export type GetUserAvailabilityInput = {
  duration: Scalars['Int']
  endTime?: InputMaybe<Scalars['String']>
  ignoreConflicts?: InputMaybe<Scalars['Boolean']>
  participantId?: InputMaybe<Scalars['String']>
  role?: InputMaybe<Array<Scalars['String']>>
  startTime?: InputMaybe<Scalars['String']>
  tenantId?: InputMaybe<Scalars['String']>
  timeZone?: InputMaybe<Scalars['String']>
}

export type GetUserAvailabilityResponse = {
  __typename?: 'GetUserAvailabilityResponse'
  data?: Maybe<GetUserAvailability>
  error?: Maybe<Scalars['String']>
  meetingLocation?: Maybe<Array<Maybe<Scalars['String']>>>
}

export type GetUserMeetingByIdInput = {
  businessId: Scalars['String']
  id: Scalars['String']
  tenantId: Scalars['String']
}

export type GetUserMeetingByIdResponse = {
  __typename?: 'GetUserMeetingByIdResponse'
  data?: Maybe<CalendarEvent>
  error?: Maybe<Scalars['String']>
}

export type GetUserMeetingTasksInput = {
  filter?: InputMaybe<UserTasksFilterInput>
  meetingId?: InputMaybe<Scalars['String']>
  tenantId: Scalars['ID']
  userId?: InputMaybe<Scalars['ID']>
}

export type GetUserNotificationsInput = {
  countOnly?: InputMaybe<Scalars['Boolean']>
  filter?: InputMaybe<Scalars['String']>
  isPaginated?: InputMaybe<Scalars['Boolean']>
  lastEvaluatedKey?: InputMaybe<Scalars['String']>
  pageSize?: InputMaybe<Scalars['Int']>
  tenantId: Scalars['String']
}

export type GetUserNotificationsResponse = {
  __typename?: 'GetUserNotificationsResponse'
  data?: Maybe<UserNotificationData>
  error?: Maybe<Scalars['String']>
}

export type GetUserRecommendationsInput = {
  assessmentType?: InputMaybe<Scalars['String']>
  businessId?: InputMaybe<Scalars['String']>
  tenantId: Scalars['String']
}

export type GetUserTaskInput = {
  taskId: Scalars['ID']
  tenantId: Scalars['ID']
  userId?: InputMaybe<Scalars['ID']>
}

export type GetUserTasksInput = {
  filter?: InputMaybe<UserTasksFilterInput>
  tenantId: Scalars['ID']
  userId?: InputMaybe<Scalars['ID']>
}

export type GetUserToolsResponse = {
  __typename?: 'GetUserToolsResponse'
  data?: Maybe<Array<Maybe<Tool>>>
  error?: Maybe<Scalars['String']>
  message?: Maybe<Scalars['String']>
  success?: Maybe<Scalars['Boolean']>
}

export type Goal = {
  __typename?: 'Goal'
  assessments?: Maybe<Scalars['AWSJSON']>
  createdAt?: Maybe<Scalars['AWSDateTime']>
  description?: Maybe<Scalars['String']>
  id: Scalars['ID']
  isActiveGoal?: Maybe<Scalars['Boolean']>
  isTopGoal?: Maybe<Scalars['Boolean']>
  name?: Maybe<Scalars['String']>
  orderOfSequence?: Maybe<Scalars['String']>
  updatedAt?: Maybe<Scalars['AWSDateTime']>
}

export type GoalChatSessionRef = {
  __typename?: 'GoalChatSessionRef'
  createdAt?: Maybe<Scalars['AWSDateTime']>
  executorId?: Maybe<Scalars['String']>
  sessionId: Scalars['String']
  type: OnboardingFlowType
}

export type GoalHistory = {
  __typename?: 'GoalHistory'
  goalId: Scalars['ID']
  sections: Array<GoalHistorySection>
}

export type GoalHistoryMessage = {
  __typename?: 'GoalHistoryMessage'
  avatar?: Maybe<Scalars['String']>
  createdAt: Scalars['String']
  senderName?: Maybe<Scalars['String']>
  senderRole?: Maybe<Scalars['String']>
  text: Scalars['String']
}

export type GoalHistorySection = {
  __typename?: 'GoalHistorySection'
  createdAt?: Maybe<Scalars['String']>
  hasMore: Scalars['Boolean']
  messages: Array<GoalHistoryMessage>
  nextCursor?: Maybe<Scalars['String']>
  sessionId: Scalars['String']
  title: Scalars['String']
  type: OnboardingFlowType
}

export type GoalPlanRegenerationError = {
  __typename?: 'GoalPlanRegenerationError'
  goalId: Scalars['ID']
  isLastAttempt?: Maybe<Scalars['Boolean']>
  message: Scalars['String']
  tenantId: Scalars['ID']
  timestamp: Scalars['String']
  userId: Scalars['ID']
}

export type GoalPlanRegenerationErrorInput = {
  goalId: Scalars['ID']
  isLastAttempt?: InputMaybe<Scalars['Boolean']>
  message: Scalars['String']
  tenantId: Scalars['ID']
  userId: Scalars['ID']
}

export type GoogleCalendarWebhookMetaData = {
  __typename?: 'GoogleCalendarWebhookMetaData'
  expiration?: Maybe<Scalars['String']>
  id?: Maybe<Scalars['String']>
  kind?: Maybe<Scalars['String']>
  resourceId?: Maybe<Scalars['String']>
  resourceUri?: Maybe<Scalars['String']>
  token?: Maybe<Scalars['String']>
}

export type GroupTaskCompletionCondition = {
  __typename?: 'GroupTaskCompletionCondition'
  group?: Maybe<Array<TaskCompletionBaseCondition>>
}

export type GroupedTools = {
  __typename?: 'GroupedTools'
  category?: Maybe<Scalars['String']>
  tools?: Maybe<Array<Maybe<Tool>>>
}

export type IndustryReport = {
  __typename?: 'IndustryReport'
  results?: Maybe<Array<Maybe<IndustryReportResult>>>
  searchedKeyword?: Maybe<Scalars['String']>
  summaryText?: Maybe<Scalars['String']>
}

export type IndustryReportResult = {
  __typename?: 'IndustryReportResult'
  docTitle?: Maybe<Scalars['String']>
  docUrl?: Maybe<Scalars['String']>
  pageNumber?: Maybe<Scalars['Int']>
  summary?: Maybe<Scalars['String']>
}

export type Insight = {
  __typename?: 'Insight'
  category?: Maybe<Scalars['String']>
  createdAt: Scalars['String']
  description?: Maybe<Scalars['String']>
  feedback?: Maybe<FeedbackType>
  feedbackMessage: Array<FeedbackMessage>
  goalsId?: Maybe<Array<Scalars['String']>>
  hasBeenViewed?: Maybe<Scalars['Boolean']>
  insightId: Scalars['ID']
  internal_context?: Maybe<Scalars['String']>
  isApproved?: Maybe<Scalars['Boolean']>
  metadata?: Maybe<Scalars['AWSJSON']>
  metrics?: Maybe<Array<InsightMetric>>
  name: Scalars['String']
  playsId?: Maybe<Array<Scalars['String']>>
  priority?: Maybe<InsightPriority>
  session?: Maybe<Scalars['String']>
  suggestedBy?: Maybe<Scalars['String']>
  updatedAt: Scalars['String']
  why?: Maybe<Scalars['String']>
}

export type InsightMetric = {
  __typename?: 'InsightMetric'
  benchmark: Scalars['Float']
  current_status: Scalars['Float']
  metricTitle: Scalars['String']
  trend: Scalars['String']
}

export type InsightMetricInput = {
  benchmark: Scalars['Float']
  current_status: Scalars['Float']
  metricTitle: Scalars['String']
  trend: Scalars['String']
}

export enum InsightPriority {
  HighPriority = 'HIGH_PRIORITY',
  LowPriority = 'LOW_PRIORITY',
  MediumPriority = 'MEDIUM_PRIORITY',
}

export type InsightsConnection = {
  __typename?: 'InsightsConnection'
  items: Array<Insight>
  nextToken?: Maybe<Scalars['String']>
}

export type InvitedUser = {
  __typename?: 'InvitedUser'
  email?: Maybe<Scalars['String']>
  firstName?: Maybe<Scalars['String']>
  id?: Maybe<Scalars['String']>
  lastName?: Maybe<Scalars['String']>
  roles?: Maybe<Array<Maybe<Scalars['String']>>>
}

export type JobDto = {
  __typename?: 'JobDto'
  createdAt?: Maybe<Scalars['String']>
  id: Scalars['String']
  payload?: Maybe<Scalars['AWSJSON']>
  status: JobStatus
  type: JobTypes
  updatedAt?: Maybe<Scalars['String']>
}

export enum JobStatus {
  Done = 'Done',
  InProgress = 'InProgress',
  NotStarted = 'NotStarted',
}

export enum JobTypes {
  ToolDataProcessing = 'ToolDataProcessing',
}

export type KeyValuePair = {
  __typename?: 'KeyValuePair'
  key: Scalars['String']
  value: Scalars['String']
}

export type KeyValuePairInput = {
  key: Scalars['String']
  value: Scalars['String']
}

export type LastMessage = {
  __typename?: 'LastMessage'
  botResponse?: Maybe<Scalars['String']>
  content: Scalars['String']
  createdAt: Scalars['String']
  isEdited: Scalars['Boolean']
  isVoiceMessage?: Maybe<Scalars['Boolean']>
  messageType: Scalars['String']
  progress?: Maybe<Scalars['Int']>
  role: Scalars['String']
  voiceDuration?: Maybe<Scalars['Int']>
}

export type LineItem = {
  __typename?: 'LineItem'
  amount?: Maybe<Scalars['Float']>
  description?: Maybe<Scalars['String']>
  id?: Maybe<Scalars['ID']>
}

export type LiquidCashReport = AccountingReport & {
  __typename?: 'LiquidCashReport'
  dateRange?: Maybe<DateRanges>
  endDate?: Maybe<Scalars['String']>
  growth?: Maybe<Scalars['Float']>
  liquidCash?: Maybe<Scalars['Float']>
  source?: Maybe<Scalars['String']>
  startDate?: Maybe<Scalars['String']>
  userId?: Maybe<Scalars['String']>
}

export type ListAssessment = {
  __typename?: 'ListAssessment'
  completedAt?: Maybe<Scalars['AWSDateTime']>
  inProgress?: Maybe<Scalars['Boolean']>
  isCompleted?: Maybe<Scalars['Boolean']>
  isLocked?: Maybe<Scalars['Boolean']>
  order?: Maybe<Scalars['String']>
  type?: Maybe<Scalars['String']>
  updatedAt?: Maybe<Scalars['AWSDateTime']>
}

export type ListAssessmentResponse = {
  __typename?: 'ListAssessmentResponse'
  data?: Maybe<Array<Maybe<ListAssessment>>>
  error?: Maybe<Scalars['String']>
  message?: Maybe<Scalars['String']>
  success: Scalars['Boolean']
}

export type ListCognitoUsersInput = {
  role: Scalars['String']
}

export type MakeAnnouncementInput = {
  fileId?: InputMaybe<Scalars['String']>
  receiverIds: Array<Scalars['String']>
  sendToEmail: Scalars['Boolean']
  sendToSms: Scalars['Boolean']
  tenantId: Scalars['String']
  text: Scalars['String']
}

export enum MeetingLocation {
  Custom = 'CUSTOM',
  GoogleMeet = 'GOOGLE_MEET',
  MicrosoftTeams = 'MICROSOFT_TEAMS',
  Zoom = 'ZOOM',
}

export enum MeetingSummaryDateRange {
  MonthToDate = 'MONTH_TO_DATE',
  YearToDate = 'YEAR_TO_DATE',
}

export type MeetingTypes = {
  __typename?: 'MeetingTypes'
  duration?: Maybe<Scalars['String']>
  id?: Maybe<Scalars['String']>
  label?: Maybe<Scalars['String']>
  tenantId?: Maybe<Scalars['String']>
}

export type MessageChatSession = {
  __typename?: 'MessageChatSession'
  createdAt?: Maybe<Scalars['String']>
  executorId?: Maybe<Scalars['String']>
  flow?: Maybe<Scalars['String']>
  id: Scalars['String']
  lastMessage?: Maybe<LastMessage>
  metadata?: Maybe<Scalars['AWSJSON']>
  status?: Maybe<ChatSessionStatus>
  title?: Maybe<Scalars['String']>
}

export type MessageToBotResponse = {
  __typename?: 'MessageToBotResponse'
  hasMore: Scalars['Boolean']
  messages?: Maybe<Array<ChatBotMessage>>
  nextCursor?: Maybe<Scalars['String']>
}

export enum MetricChannel {
  Email = 'EMAIL',
  LandingPage = 'LANDING_PAGE',
  Offline = 'OFFLINE',
  Phone = 'PHONE',
  Website = 'WEBSITE',
}

export enum MetricGranularity {
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK',
  Year = 'YEAR',
}

export type MetricTimeSeries = {
  __typename?: 'MetricTimeSeries'
  timeSeries?: Maybe<TimeSeriesResponse>
}

export type MetricTimeSeriesInput = {
  granularity: MetricGranularity
  metricCode: Scalars['ID']
  timeRange: TimeRangeInput
}

export type MetricValue = {
  __typename?: 'MetricValue'
  counter?: Maybe<CounterResponse>
}

export type MetricValueInput = {
  channel?: InputMaybe<MetricChannel>
  forceSync?: InputMaybe<Scalars['Boolean']>
  metricCode: Scalars['ID']
  source?: InputMaybe<Scalars['String']>
  targetUserId?: InputMaybe<Scalars['ID']>
  timeRange: TimeRangeValueInput
}

export type Mutation = {
  __typename?: 'Mutation'
  addInsight?: Maybe<Insight>
  addPrivateNoteToCalendarEvent: Scalars['Boolean']
  addTaskComment?: Maybe<TaskComment>
  addUserNotification?: Maybe<ApiResponse>
  addUserToGroup: Scalars['Boolean']
  authorizeConnector?: Maybe<ApiResponse>
  bookmarkTool?: Maybe<BookmarkToolResponse>
  cancelUserCalendarEvent?: Maybe<CancelUserCalendarEventResponse>
  connectFinicity: Scalars['String']
  createChatSession?: Maybe<ChatSession>
  createFlowChatSession: MessageChatSession
  createTeamMember?: Maybe<BusinessUser>
  createTool?: Maybe<Tool>
  createUser?: Maybe<UserProfile>
  createUserTask?: Maybe<UserTask>
  deauthenticateConnector?: Maybe<ApiResponse>
  deleteCalendarEvent?: Maybe<DeleteCalendarEventResponse>
  deletePrivateNote: Scalars['Boolean']
  deleteTaskComment?: Maybe<Scalars['Boolean']>
  deleteUserFiles?: Maybe<Scalars['Boolean']>
  deleteUserNotifications?: Maybe<ApiResponse>
  deleteUserTask?: Maybe<Scalars['String']>
  listCognitoUsers: Array<Maybe<CognitoUser>>
  logActivity?: Maybe<ApiResponse>
  makeAnnouncement?: Maybe<Scalars['Boolean']>
  populateTaskInformation: PopulateTaskInformationResponse
  processToolBusinessData: Scalars['String']
  publishGoalPlanRegenerationError?: Maybe<GoalPlanRegenerationError>
  publishRealTimeNotification?: Maybe<RealTimeNotification>
  regeneratePlan?: Maybe<Scalars['Boolean']>
  regeneratePlanAdmin?: Maybe<Scalars['Boolean']>
  requestMeeting: Scalars['Boolean']
  rescheduleUserCalendarEvent?: Maybe<UpdateUserCalendarEventResponse>
  resendUserInvite?: Maybe<Scalars['Boolean']>
  saveAssessmentResponse?: Maybe<AssessmentResponse>
  saveAttestation?: Maybe<AttestationResponse>
  saveBusinessGoal?: Maybe<Scalars['String']>
  savePlayResponse?: Maybe<PlayResponse>
  saveUserFile?: Maybe<ApiResponse>
  searchHowToDoTask: UserTaskHowToResponse
  sendDirectNotification?: Maybe<Scalars['String']>
  sendMessageToBot: SendMessageToBotResponse
  setUserAvailability?: Maybe<SetUserAvailabilityResponse>
  setUserMeeting?: Maybe<UserMeetingData>
  setupFinicityUser?: Maybe<Scalars['Boolean']>
  subscribeGoogleCalendarWebhook?: Maybe<SubscribeGoogleCalendarWebhookResponse>
  summarySessionTitle: MessageChatSession
  toolConnectionSuccess?: Maybe<ApiResponse>
  updateBusinessGoal?: Maybe<Scalars['String']>
  updateBusinessGoalMilestone?: Maybe<Scalars['String']>
  updateBusinessInformation?: Maybe<BusinessProfile>
  updateBusinessProfile?: Maybe<BusinessProfile>
  updateBusinessSupportOrganization?: Maybe<BusinessSupportOrganization>
  updateGoalPlan?: Maybe<Scalars['String']>
  updateInsight?: Maybe<Insight>
  updateInsightsNotificationStatus?: Maybe<UserProfile>
  updateMyProfile?: Maybe<UserProfile>
  updateOwner?: Maybe<ApiResponse>
  updatePrivateNoteInCalendarEvent: Scalars['Boolean']
  updateTaskComment?: Maybe<TaskComment>
  updateTaskProgress?: Maybe<TaskResult>
  updateTaskReaction?: Maybe<Scalars['Boolean']>
  updateTool?: Maybe<Tool>
  updateTranscriptSummary: Scalars['Boolean']
  updateUserAvailability?: Maybe<UpdateUserAvailabilityResponse>
  updateUserCalendarEvent?: Maybe<UpdateUserCalendarEventResponse>
  updateUserNotifications?: Maybe<ApiResponse>
  updateUserPassword?: Maybe<Scalars['Boolean']>
  updateUserTask?: Maybe<UserTask>
}

export type MutationAddInsightArgs = {
  input: AddInsightInput
}

export type MutationAddPrivateNoteToCalendarEventArgs = {
  calendarId: Scalars['String']
  note: PrivateNoteInput
}

export type MutationAddTaskCommentArgs = {
  input: AddTaskCommentInput
}

export type MutationAddUserNotificationArgs = {
  input?: InputMaybe<AddUserNotificationInput>
}

export type MutationAddUserToGroupArgs = {
  input: AddUserToGroupInput
}

export type MutationAuthorizeConnectorArgs = {
  authValue: Scalars['String']
}

export type MutationBookmarkToolArgs = {
  input: BookmarkToolInput
}

export type MutationCancelUserCalendarEventArgs = {
  input: CancelUserCalendarEventInput
}

export type MutationConnectFinicityArgs = {
  institutionId?: InputMaybe<Scalars['Int']>
  redirectUrl: Scalars['String']
  tenantId: Scalars['String']
}

export type MutationCreateChatSessionArgs = {
  input: CreateChatSessionInput
}

export type MutationCreateFlowChatSessionArgs = {
  input: CreateFlowChatSessionInput
}

export type MutationCreateTeamMemberArgs = {
  input: CreateTeamMemberInput
}

export type MutationCreateToolArgs = {
  input: CreateToolInput
}

export type MutationCreateUserArgs = {
  input: CreateUserInput
}

export type MutationCreateUserTaskArgs = {
  input: CreateUserTaskInput
}

export type MutationDeauthenticateConnectorArgs = {
  input?: InputMaybe<DeauthenticateConnectorInput>
}

export type MutationDeleteCalendarEventArgs = {
  input: DeleteCalendarEventInput
}

export type MutationDeletePrivateNoteArgs = {
  calendarId: Scalars['String']
  noteId: Scalars['ID']
}

export type MutationDeleteTaskCommentArgs = {
  input: DeleteTaskCommentInput
}

export type MutationDeleteUserFilesArgs = {
  input: DeleteUserFilesInput
}

export type MutationDeleteUserNotificationsArgs = {
  input?: InputMaybe<DeleteUserNotificationsInput>
}

export type MutationDeleteUserTaskArgs = {
  input: DeleteUserTaskInput
}

export type MutationListCognitoUsersArgs = {
  input: ListCognitoUsersInput
}

export type MutationLogActivityArgs = {
  activityLogInput: ActivityLogInput
}

export type MutationMakeAnnouncementArgs = {
  input: MakeAnnouncementInput
}

export type MutationPopulateTaskInformationArgs = {
  taskName: Scalars['String']
}

export type MutationProcessToolBusinessDataArgs = {
  input: ProcessToolBusinessDataInput
}

export type MutationPublishGoalPlanRegenerationErrorArgs = {
  input: GoalPlanRegenerationErrorInput
}

export type MutationPublishRealTimeNotificationArgs = {
  input: RealTimeNotificationInput
}

export type MutationRegeneratePlanArgs = {
  input: RegeneratePlanInput
}

export type MutationRegeneratePlanAdminArgs = {
  input: RegeneratePlanAdminInput
}

export type MutationRequestMeetingArgs = {
  calendarId: Scalars['ID']
  requestDetail: RequestDetailInput
}

export type MutationRescheduleUserCalendarEventArgs = {
  input: RescheduleUserCalendarEventInput
}

export type MutationResendUserInviteArgs = {
  input: ResendUserInviteInput
}

export type MutationSaveAssessmentResponseArgs = {
  input: SaveAssessmentResponseInput
}

export type MutationSaveAttestationArgs = {
  input: AttestationInput
}

export type MutationSaveBusinessGoalArgs = {
  input: SaveBusinessGoalInput
}

export type MutationSavePlayResponseArgs = {
  input: SavePlayResponseInput
}

export type MutationSaveUserFileArgs = {
  input: SaveUserFileInput
}

export type MutationSearchHowToDoTaskArgs = {
  input: SearchHowToDoTaskInput
}

export type MutationSendDirectNotificationArgs = {
  input: SendDirectNotificationInput
}

export type MutationSendMessageToBotArgs = {
  input: SendMessageToBotInput
}

export type MutationSetUserAvailabilityArgs = {
  input?: InputMaybe<SetUserAvailabilityInput>
}

export type MutationSetUserMeetingArgs = {
  input: SetUserMeetingInput
}

export type MutationSubscribeGoogleCalendarWebhookArgs = {
  tenantId?: InputMaybe<Scalars['String']>
}

export type MutationSummarySessionTitleArgs = {
  id: Scalars['String']
}

export type MutationToolConnectionSuccessArgs = {
  input?: InputMaybe<ToolConnectionSuccessInput>
}

export type MutationUpdateBusinessGoalArgs = {
  input: UpdateBusinessGoalInput
}

export type MutationUpdateBusinessGoalMilestoneArgs = {
  input: UpdateBusinessGoalMilestoneInput
}

export type MutationUpdateBusinessInformationArgs = {
  profile: UpdateBusinessProfileInput
}

export type MutationUpdateBusinessProfileArgs = {
  input: UpdateBusinessProfileInput
}

export type MutationUpdateBusinessSupportOrganizationArgs = {
  input: UpdateBusinessSupportOrganizationInput
}

export type MutationUpdateGoalPlanArgs = {
  input: UpdateGoalPlanInput
}

export type MutationUpdateInsightArgs = {
  input: UpdateInsightInput
}

export type MutationUpdateInsightsNotificationStatusArgs = {
  input: UpdateInsightsNotificationInput
}

export type MutationUpdateMyProfileArgs = {
  input: UpdateMyProfileInput
}

export type MutationUpdateOwnerArgs = {
  input?: InputMaybe<UpdateOwnerInput>
}

export type MutationUpdatePrivateNoteInCalendarEventArgs = {
  calendarId: Scalars['String']
  note: PrivateNoteInput
}

export type MutationUpdateTaskCommentArgs = {
  input: UpdateTaskCommentInput
}

export type MutationUpdateTaskProgressArgs = {
  businessId: Scalars['String']
  id: Scalars['ID']
  output?: InputMaybe<Scalars['AWSJSON']>
  status?: InputMaybe<TaskResultStatus>
}

export type MutationUpdateTaskReactionArgs = {
  input: UpdateTaskReactionInput
}

export type MutationUpdateToolArgs = {
  input: UpdateToolInput
}

export type MutationUpdateTranscriptSummaryArgs = {
  calendarId: Scalars['String']
  summaryDetails: TranscriptSummaryInput
}

export type MutationUpdateUserAvailabilityArgs = {
  input?: InputMaybe<UpdateUserAvailabilityInput>
}

export type MutationUpdateUserCalendarEventArgs = {
  input: UpdateUserCalendarEventInput
}

export type MutationUpdateUserNotificationsArgs = {
  input?: InputMaybe<UpdateUserNotificationsInput>
}

export type MutationUpdateUserPasswordArgs = {
  input: UpdateUserPasswordInput
}

export type MutationUpdateUserTaskArgs = {
  input: UpdateUserTaskInput
}

export type NewInsightsCheckResponse = {
  __typename?: 'NewInsightsCheckResponse'
  hasNewInsights: Scalars['Boolean']
  insightsCount?: Maybe<Scalars['Int']>
  lastInsightGeneratedAt?: Maybe<Scalars['String']>
  shouldShowPopup: Scalars['Boolean']
}

export type OAuthConnectionProperty = {
  name: Scalars['String']
  value: Scalars['String']
}

export type OAuthUrlResponse = {
  __typename?: 'OAuthUrlResponse'
  data?: Maybe<Scalars['String']>
  error?: Maybe<Scalars['String']>
  message?: Maybe<Scalars['String']>
  success: Scalars['Boolean']
}

export type OnboardingFlowState = {
  __typename?: 'OnboardingFlowState'
  currentStepType: OnboardingFlowStepTypes
  executorId?: Maybe<Scalars['String']>
  flowType?: Maybe<OnboardingFlowType>
  metadata: Scalars['AWSJSON']
  previousStep?: Maybe<Scalars['String']>
  previousStepType?: Maybe<OnboardingFlowStepTypes>
  sessionId: Scalars['String']
  status: OnboardingFlowStepStatus
  step: Scalars['String']
  tenantId?: Maybe<Scalars['String']>
  toolProcessingData?: Maybe<Array<Scalars['AWSJSON']>>
  userId: Scalars['String']
}

export enum OnboardingFlowStepStatus {
  Done = 'Done',
  InProgress = 'InProgress',
  Pending = 'Pending',
}

export enum OnboardingFlowStepTypes {
  End = 'End',
  Form = 'Form',
  GoalTemplate = 'GoalTemplate',
  Message = 'Message',
  Question = 'Question',
  Review = 'Review',
  ToolConnection = 'ToolConnection',
}

export enum OnboardingFlowType {
  AcceptGoal = 'AcceptGoal',
  AddGoal = 'AddGoal',
  AdminEdoGetToKnowYou = 'AdminEdoGetToKnowYou',
  AdvisorGetToKnowYou = 'AdvisorGetToKnowYou',
  EdoTeamMemberGetToKnowYou = 'EdoTeamMemberGetToKnowYou',
  GeneralChat = 'GeneralChat',
  GetToKnowYou = 'GetToKnowYou',
  GoalSetting = 'GoalSetting',
  RegeneratePlan = 'RegeneratePlan',
  SuggestGoal = 'SuggestGoal',
}

export enum OnboardingStatus {
  AdminEdoGetToKnowYou = 'ADMIN_EDO_GET_TO_KNOW_YOU',
  AdvisorGetToKnowYou = 'ADVISOR_GET_TO_KNOW_YOU',
  Complete = 'COMPLETE',
  EdoTeamMemberGetToKnowYou = 'EDO_TEAM_MEMBER_GET_TO_KNOW_YOU',
  Intake = 'INTAKE',
  Onboarding = 'ONBOARDING',
  TeamMemberIntake = 'TEAM_MEMBER_INTAKE',
}

export type Option = {
  __typename?: 'Option'
  label: Scalars['String']
  value: Scalars['String']
}

export type OptionInput = {
  label: Scalars['String']
  value: Scalars['String']
}

export enum OptionTypes {
  BusinessClassification = 'businessClassification',
  StrongBusinessAreas = 'strongBusinessAreas',
  SupportAndHelp = 'supportAndHelp',
  TopGoal = 'topGoal',
}

export type Options = {
  __typename?: 'Options'
  category?: Maybe<Scalars['String']>
  categoryType?: Maybe<Scalars['String']>
  dependencies?: Maybe<Scalars['String']>
  id?: Maybe<Scalars['String']>
  infoText?: Maybe<Scalars['String']>
  isNew?: Maybe<Scalars['Boolean']>
  label?: Maybe<Scalars['String']>
  name?: Maybe<Scalars['String']>
  order?: Maybe<Scalars['String']>
  toolTipText?: Maybe<Scalars['String']>
  type?: Maybe<Scalars['String']>
  version?: Maybe<Scalars['String']>
}

export enum OrganizationStatus {
  Live = 'LIVE',
  Test = 'TEST',
}

export type OwnerActivitySummary = {
  __typename?: 'OwnerActivitySummary'
  avgMinsPerSession?: Maybe<Scalars['Float']>
  chats?: Maybe<Scalars['Int']>
  meetingsReScheduled?: Maybe<Scalars['Int']>
  meetingsScheduled?: Maybe<Scalars['Int']>
  signInPerWeek?: Maybe<Scalars['Float']>
  timeOnPlatform?: Maybe<Scalars['String']>
  timesSignedIn?: Maybe<Scalars['Int']>
  toolsIntegrated?: Maybe<Scalars['Int']>
}

export enum PaginationDirection {
  Backward = 'BACKWARD',
  Forward = 'FORWARD',
}

export type Payment = {
  __typename?: 'Payment'
  customerId?: Maybe<Scalars['ID']>
  id?: Maybe<Scalars['ID']>
  lineItems?: Maybe<Array<Maybe<LineItem>>>
  totalAmt?: Maybe<Scalars['Float']>
  txnDate?: Maybe<Scalars['String']>
}

export type Play = {
  __typename?: 'Play'
  content?: Maybe<Scalars['AWSJSON']>
  description?: Maybe<Scalars['String']>
  guide?: Maybe<Scalars['AWSJSON']>
  guide1?: Maybe<Scalars['AWSJSON']>
  id: Scalars['ID']
  meta?: Maybe<Scalars['AWSJSON']>
  playTabs?: Maybe<Scalars['AWSJSON']>
  recommendedBy?: Maybe<Scalars['String']>
  setup?: Maybe<Scalars['AWSJSON']>
  title?: Maybe<Scalars['String']>
  type?: Maybe<Scalars['String']>
  use?: Maybe<Scalars['AWSJSON']>
}

export type PlayBusinessProfileFields = {
  logo?: InputMaybe<Scalars['String']>
}

export type PlayResponse = {
  __typename?: 'PlayResponse'
  businessProfileFields?: Maybe<BusinessProfileFields>
  completedAt?: Maybe<Scalars['AWSDateTime']>
  completedBy?: Maybe<Scalars['String']>
  isCompleted?: Maybe<Scalars['Boolean']>
  playId?: Maybe<Scalars['String']>
  playTabResponse?: Maybe<Array<TabResponse>>
  playType?: Maybe<Scalars['String']>
  recommendations?: Maybe<Array<Scalars['String']>>
  tenantId?: Maybe<Scalars['String']>
}

export enum PlayType {
  ChangeStop = 'CHANGE_STOP',
  DoMore = 'DO_MORE',
  Start = 'START',
}

export type PopulateTaskInformationResponse = {
  __typename?: 'PopulateTaskInformationResponse'
  category: BusinessGoalCategory
  estimatedMinutes: Scalars['Int']
}

export type PrivateNote = {
  __typename?: 'PrivateNote'
  advisorId?: Maybe<Scalars['String']>
  clientId?: Maybe<Scalars['String']>
  content?: Maybe<Scalars['String']>
  createdAt?: Maybe<Scalars['AWSDateTime']>
  createdBy?: Maybe<Scalars['String']>
  files?: Maybe<Array<UserFile>>
  noteId?: Maybe<Scalars['ID']>
  tags?: Maybe<Array<Scalars['String']>>
}

export type PrivateNoteInput = {
  advisorId?: InputMaybe<Scalars['String']>
  clientId?: InputMaybe<Scalars['String']>
  content?: InputMaybe<Scalars['String']>
  createdAt?: InputMaybe<Scalars['AWSDateTime']>
  createdBy?: InputMaybe<Scalars['String']>
  files?: InputMaybe<Array<UserFileInput>>
  noteId?: InputMaybe<Scalars['ID']>
  tags?: InputMaybe<Array<Scalars['String']>>
}

export type ProcessToolBusinessDataInput = {
  businessId: Scalars['String']
  dataType: ToolDataTypes
  toolId: Scalars['String']
  userId?: InputMaybe<Scalars['String']>
}

export type ProfitAndLoss = {
  __typename?: 'ProfitAndLoss'
  endDate?: Maybe<Scalars['String']>
  expenses?: Maybe<Array<Maybe<AccountingToolEntry>>>
  income?: Maybe<Array<Maybe<AccountingToolEntry>>>
  profit?: Maybe<Array<Maybe<AccountingToolEntry>>>
  startDate?: Maybe<Scalars['String']>
}

export type ProfitAndLossReport = AccountingReport & {
  __typename?: 'ProfitAndLossReport'
  dateRange?: Maybe<DateRanges>
  endDate?: Maybe<Scalars['String']>
  growth?: Maybe<Scalars['Float']>
  profitAndLossNetIncome?: Maybe<Scalars['Float']>
  source?: Maybe<Scalars['String']>
  startDate?: Maybe<Scalars['String']>
  userId?: Maybe<Scalars['String']>
}

export type Query = {
  __typename?: 'Query'
  cancelOutlookEvent?: Maybe<ApiResponse>
  checkNewInsightsAvailable: NewInsightsCheckResponse
  deleteGoogleCalendarEvent?: Maybe<ApiResponse>
  getAccountingCharts?: Maybe<AccountingChartResponse>
  getActivityLogs?: Maybe<ApiResponse>
  getAdvisorAssignedTasks?: Maybe<Array<UserTask>>
  getAdvisorDashboard?: Maybe<ApiResponse>
  getAdvisorProfile?: Maybe<AdvisorProfile>
  getAdvisors?: Maybe<ApiResponse>
  getAllInvitedUsers: Array<InvitedUser>
  getAllTagUsers: Array<InvitedUser>
  getAllToolCategories: GetAllToolCategoriesResponse
  getAllTools?: Maybe<GetAllToolsResponse>
  getAssessmentPlayListing?: Maybe<ApiResponse>
  getAssessmentResponseByQuestion?: Maybe<UserResponse>
  getAssessments?: Maybe<Array<Maybe<Assessment>>>
  getAttestationReports?: Maybe<GetAttestationReportsResponse>
  getAttestationSummary?: Maybe<AttestationSummary>
  getBoAdvisors?: Maybe<BoAdvisorsResponse>
  getBusinessGoal?: Maybe<BusinessGoal>
  getBusinessGoals?: Maybe<Array<BusinessGoal>>
  getBusinessIndustryDetails?: Maybe<GetBusinessIndustryDetailsResponse>
  getBusinessProfile?: Maybe<BusinessProfile>
  getBusinessSummary?: Maybe<BusinessSummaryResponse>
  getBusinessSupportOrganization?: Maybe<BusinessSupportOrganization>
  getBusinessUsers: Array<BusinessUser>
  getBusinesses?: Maybe<ApiResponse>
  getCalendlyUser?: Maybe<CalendlyUserResponse>
  getChartData?: Maybe<ApiResponse>
  getChatSessions?: Maybe<Array<MessageChatSession>>
  getClients?: Maybe<GetClientsResponse>
  getClientsSummary?: Maybe<ApiResponse>
  getDashboardListing?: Maybe<ApiResponse>
  getFile?: Maybe<ApiResponse>
  getGoalDetails?: Maybe<Goal>
  getGoalHistory?: Maybe<GoalHistory>
  getInsight?: Maybe<Insight>
  getInsights: InsightsConnection
  getMeetingTypes?: Maybe<GetMeetingTypeResponse>
  getMessagesFromBot: MessageToBotResponse
  getMyProfile: UserProfile
  getOAuthUrl?: Maybe<OAuthUrlResponse>
  getOnboardingFlowState?: Maybe<OnboardingFlowState>
  getOptions?: Maybe<GetOptionsResponse>
  getOwnerActivityDetails?: Maybe<OwnerActivitySummary>
  getOwnerBusinessData?: Maybe<ApiResponse>
  getPendingJobs: Array<JobDto>
  getPlay?: Maybe<ApiResponse>
  getPlayResponse?: Maybe<Array<PlayResponse>>
  getPlays?: Maybe<GetPlaysResponse>
  getQuote: QuoteResponse
  getSignedUrl?: Maybe<SignedUrlResponse>
  getTackleMeetings?: Maybe<GetTackleMeetingResponse>
  getTaskComments: Array<TaskComment>
  getTenants?: Maybe<GetTenantsResponse>
  getToolById?: Maybe<Tool>
  getTools?: Maybe<GetToolsResponse>
  getToolsByDataTypes: Array<Tool>
  getToolsByType?: Maybe<GetToolsByTypeResponse>
  getTopActiveClients?: Maybe<GetTopActiveClientsResponse>
  getUserAssessmentResponse?: Maybe<UserAssessmentResponse>
  getUserAvailability?: Maybe<GetUserAvailabilityResponse>
  getUserAvailabilityHours?: Maybe<GetUserAvailabilityHoursResponse>
  getUserCalendarEvents?: Maybe<CalendarEventResponse>
  getUserCalendarEventsByUserId?: Maybe<CalendarEventResponse>
  getUserConnectors?: Maybe<CyclrConnectorResponse>
  getUserFiles?: Maybe<ApiResponse>
  getUserGoals?: Maybe<Array<Maybe<Goal>>>
  getUserIntegrations?: Maybe<ApiResponse>
  getUserMeeting?: Maybe<ApiResponse>
  getUserMeetingById?: Maybe<GetUserMeetingByIdResponse>
  getUserMeetingTasks?: Maybe<Array<UserTask>>
  getUserNotifications?: Maybe<GetUserNotificationsResponse>
  getUserRecommendations?: Maybe<UserRecommendationsResponse>
  getUserSummaries?: Maybe<UserSummaryResponse>
  getUserTask?: Maybe<UserTask>
  getUserTasks?: Maybe<Array<UserTask>>
  getUserTools?: Maybe<GetUserToolsResponse>
  healthCheck?: Maybe<Scalars['String']>
  listAssessments?: Maybe<ListAssessmentResponse>
  metricValue?: Maybe<MetricValue>
  retrieveBusinessInformation?: Maybe<BusinessProfile>
  searchBusinessInformation?: Maybe<BusinessProfile>
  searchIndustryReport?: Maybe<IndustryReport>
  searchMeetingList?: Maybe<GetTackleMeetingResponse>
  searchTools?: Maybe<SearchToolsResponse>
  searchUserSummaries?: Maybe<UserSummaryResponse>
  searchUserTasks?: Maybe<Array<UserTask>>
  subscribeCalendlyWebhook?: Maybe<ApiResponse>
  updateGoogleCalendarEvent?: Maybe<ApiResponse>
}

export type QueryCancelOutlookEventArgs = {
  input?: InputMaybe<CancelOutlookEventInput>
}

export type QueryCheckNewInsightsAvailableArgs = {
  tenantId: Scalars['String']
  userId: Scalars['String']
}

export type QueryDeleteGoogleCalendarEventArgs = {
  input?: InputMaybe<DeleteGoogleCalendarEventInput>
}

export type QueryGetAccountingChartsArgs = {
  input: QueryAccountingReportInput
}

export type QueryGetActivityLogsArgs = {
  tenantId: Scalars['String']
  userId?: InputMaybe<Scalars['String']>
}

export type QueryGetAdvisorAssignedTasksArgs = {
  input: GetAdvisorAssignedTasksInput
}

export type QueryGetAdvisorDashboardArgs = {
  filterType?: InputMaybe<Scalars['String']>
  tenantId?: InputMaybe<Scalars['String']>
  userId?: InputMaybe<Scalars['String']>
}

export type QueryGetAdvisorProfileArgs = {
  input: GetAdvisorProfileInput
}

export type QueryGetAdvisorsArgs = {
  getAdvisorsInput?: InputMaybe<GetAdvisorsInput>
}

export type QueryGetAllInvitedUsersArgs = {
  input: GetAllInvitedUsersInput
}

export type QueryGetAllTagUsersArgs = {
  input: GetAllTagUsersInput
}

export type QueryGetAllToolsArgs = {
  tenantId?: InputMaybe<Scalars['String']>
}

export type QueryGetAssessmentPlayListingArgs = {
  tenantId: Scalars['String']
}

export type QueryGetAssessmentResponseByQuestionArgs = {
  question?: InputMaybe<Scalars['String']>
  type?: InputMaybe<Scalars['String']>
  userId?: InputMaybe<Scalars['String']>
}

export type QueryGetAssessmentsArgs = {
  type?: InputMaybe<Scalars['String']>
}

export type QueryGetAttestationReportsArgs = {
  input: GetAttestationReportsInput
}

export type QueryGetAttestationSummaryArgs = {
  input?: InputMaybe<GetAttestationSummaryInput>
}

export type QueryGetBoAdvisorsArgs = {
  tenantId?: InputMaybe<Scalars['String']>
  userId?: InputMaybe<Scalars['String']>
}

export type QueryGetBusinessGoalArgs = {
  input: GetBusinessGoalInput
}

export type QueryGetBusinessGoalsArgs = {
  input: GetBusinessGoalsInput
}

export type QueryGetBusinessIndustryDetailsArgs = {
  input: GetBusinessIndustryDetailsInput
}

export type QueryGetBusinessProfileArgs = {
  id?: InputMaybe<Scalars['ID']>
}

export type QueryGetBusinessSummaryArgs = {
  input: GetBusinessSummaryInput
}

export type QueryGetBusinessSupportOrganizationArgs = {
  input: GetBusinessSupportOrganizationInput
}

export type QueryGetBusinessUsersArgs = {
  businessId: Scalars['ID']
}

export type QueryGetBusinessesArgs = {
  getBusinessesInput: GetBusinessesInput
}

export type QueryGetChartDataArgs = {
  input: GetChartDataInput
}

export type QueryGetChatSessionsArgs = {
  input: GetChatSessionsInput
}

export type QueryGetClientsArgs = {
  input?: InputMaybe<GetClientsInput>
}

export type QueryGetClientsSummaryArgs = {
  tenantId?: InputMaybe<Scalars['String']>
}

export type QueryGetDashboardListingArgs = {
  category?: InputMaybe<Scalars['String']>
  tenantId: Scalars['String']
}

export type QueryGetFileArgs = {
  businessId: Scalars['String']
  id?: InputMaybe<Scalars['String']>
}

export type QueryGetGoalDetailsArgs = {
  businessId: Scalars['String']
  id?: InputMaybe<Scalars['String']>
}

export type QueryGetGoalHistoryArgs = {
  input: GetGoalHistoryInput
}

export type QueryGetInsightArgs = {
  insightId: Scalars['ID']
  tenantId: Scalars['ID']
  userId?: InputMaybe<Scalars['ID']>
}

export type QueryGetInsightsArgs = {
  hasBeenViewed?: InputMaybe<Scalars['Boolean']>
  limit?: InputMaybe<Scalars['Int']>
  nextToken?: InputMaybe<Scalars['String']>
  priority?: InputMaybe<InsightPriority>
  tenantId: Scalars['ID']
  userId?: InputMaybe<Scalars['ID']>
}

export type QueryGetMeetingTypesArgs = {
  tenantId: Scalars['String']
}

export type QueryGetMessagesFromBotArgs = {
  cursor?: InputMaybe<Scalars['String']>
  limit?: InputMaybe<Scalars['Int']>
  sessionId: Scalars['String']
}

export type QueryGetMyProfileArgs = {
  tenantId?: InputMaybe<Scalars['String']>
  userId?: InputMaybe<Scalars['String']>
}

export type QueryGetOAuthUrlArgs = {
  input: GetOAuthUrlInput
}

export type QueryGetOnboardingFlowStateArgs = {
  input: GetOnboardingFlowStateInput
}

export type QueryGetOptionsArgs = {
  optionTypes: Array<Scalars['String']>
}

export type QueryGetOwnerActivityDetailsArgs = {
  ownerId?: InputMaybe<Scalars['String']>
  tenantId: Scalars['String']
}

export type QueryGetOwnerBusinessDataArgs = {
  input?: InputMaybe<GetOwnerBusinessDataInput>
}

export type QueryGetPlayArgs = {
  id?: InputMaybe<Scalars['String']>
}

export type QueryGetPlayResponseArgs = {
  input: GetPlayResponseInput
}

export type QueryGetPlaysArgs = {
  input?: InputMaybe<GetPlaysInput>
}

export type QueryGetSignedUrlArgs = {
  contentType?: InputMaybe<Scalars['String']>
  fileName?: InputMaybe<Scalars['String']>
}

export type QueryGetTackleMeetingsArgs = {
  input?: InputMaybe<GetTackleMeetingsInput>
}

export type QueryGetTaskCommentsArgs = {
  input: GetTaskCommentsInput
}

export type QueryGetToolByIdArgs = {
  toolId: Scalars['String']
}

export type QueryGetToolsByDataTypesArgs = {
  input: GetToolByDataTypesInput
}

export type QueryGetToolsByTypeArgs = {
  input: GetToolsByTypeInput
}

export type QueryGetTopActiveClientsArgs = {
  tenantId?: InputMaybe<Scalars['String']>
}

export type QueryGetUserAssessmentResponseArgs = {
  type?: InputMaybe<Scalars['String']>
  userId?: InputMaybe<Scalars['String']>
}

export type QueryGetUserAvailabilityArgs = {
  input: GetUserAvailabilityInput
}

export type QueryGetUserAvailabilityHoursArgs = {
  userId?: InputMaybe<Scalars['String']>
}

export type QueryGetUserCalendarEventsArgs = {
  calendarName?: InputMaybe<Scalars['String']>
  tenantId?: InputMaybe<Scalars['String']>
  timeMax?: InputMaybe<Scalars['String']>
  timeMin?: InputMaybe<Scalars['String']>
}

export type QueryGetUserCalendarEventsByUserIdArgs = {
  calendarName?: InputMaybe<Scalars['String']>
  tenantId?: InputMaybe<Scalars['String']>
  timeMax?: InputMaybe<Scalars['String']>
  timeMin?: InputMaybe<Scalars['String']>
  userId?: InputMaybe<Scalars['String']>
}

export type QueryGetUserConnectorsArgs = {
  connectorName?: InputMaybe<Scalars['String']>
}

export type QueryGetUserFilesArgs = {
  tenantId?: InputMaybe<Scalars['String']>
  userId?: InputMaybe<Scalars['String']>
}

export type QueryGetUserGoalsArgs = {
  tenantId?: InputMaybe<Scalars['String']>
  userId?: InputMaybe<Scalars['String']>
}

export type QueryGetUserIntegrationsArgs = {
  tenantId: Scalars['String']
  userId?: InputMaybe<Scalars['String']>
}

export type QueryGetUserMeetingArgs = {
  advisorId?: InputMaybe<Scalars['String']>
}

export type QueryGetUserMeetingByIdArgs = {
  input: GetUserMeetingByIdInput
}

export type QueryGetUserMeetingTasksArgs = {
  input: GetUserMeetingTasksInput
}

export type QueryGetUserNotificationsArgs = {
  input?: InputMaybe<GetUserNotificationsInput>
}

export type QueryGetUserRecommendationsArgs = {
  input: GetUserRecommendationsInput
}

export type QueryGetUserSummariesArgs = {
  input: UserSummariesInput
}

export type QueryGetUserTaskArgs = {
  input: GetUserTaskInput
}

export type QueryGetUserTasksArgs = {
  input: GetUserTasksInput
}

export type QueryGetUserToolsArgs = {
  tenantId: Scalars['String']
  userId?: InputMaybe<Scalars['String']>
}

export type QueryListAssessmentsArgs = {
  tenantId?: InputMaybe<Scalars['String']>
  userId?: InputMaybe<Scalars['String']>
}

export type QueryMetricValueArgs = {
  input: MetricValueInput
}

export type QueryRetrieveBusinessInformationArgs = {
  businessId: Scalars['String']
}

export type QuerySearchBusinessInformationArgs = {
  businessId: Scalars['String']
}

export type QuerySearchIndustryReportArgs = {
  input: SearchIndustryReportInput
}

export type QuerySearchMeetingListArgs = {
  input: SearchMeetingListInput
}

export type QuerySearchToolsArgs = {
  input: SearchToolsInput
}

export type QuerySearchUserSummariesArgs = {
  input: SearchUserSummariesInput
}

export type QuerySearchUserTasksArgs = {
  input: SearchUserTasksInput
}

export type QuerySubscribeCalendlyWebhookArgs = {
  email?: InputMaybe<Scalars['String']>
  tenantId?: InputMaybe<Scalars['String']>
}

export type QueryUpdateGoogleCalendarEventArgs = {
  input?: InputMaybe<UpdateGoogleCalendarEventInput>
}

export type QueryAccountingReportInput = {
  chartType: AccountingCharts
  dateRange?: InputMaybe<DateRanges>
  endDate?: InputMaybe<Scalars['String']>
  source?: InputMaybe<Scalars['String']>
  startDate?: InputMaybe<Scalars['String']>
  userId?: InputMaybe<Scalars['String']>
  year?: InputMaybe<Scalars['Int']>
}

export type QuoteResponse = {
  __typename?: 'QuoteResponse'
  author?: Maybe<Scalars['String']>
  date?: Maybe<Scalars['String']>
  quote?: Maybe<Scalars['String']>
}

export type Reaction = {
  __typename?: 'Reaction'
  commentId: Scalars['String']
  createdAt: Scalars['AWSDateTime']
  id: Scalars['String']
  taskId: Scalars['String']
  type: Scalars['String']
  updatedAt: Scalars['AWSDateTime']
  userId: Scalars['String']
}

export enum ReactionAction {
  Add = 'ADD',
  Remove = 'REMOVE',
}

export type RealTimeNotification = {
  __typename?: 'RealTimeNotification'
  data?: Maybe<Scalars['AWSJSON']>
  key?: Maybe<Scalars['String']>
  topic: RealTimeNotificationTopic
}

export type RealTimeNotificationInput = {
  data?: InputMaybe<Scalars['AWSJSON']>
  key?: InputMaybe<Scalars['String']>
  topic: RealTimeNotificationTopic
}

export enum RealTimeNotificationTopic {
  TutorialTask = 'TUTORIAL_TASK',
}

export type Recommendations = {
  __typename?: 'Recommendations'
  assessmentRecommendedAt?: Maybe<Scalars['AWSDateTime']>
  assessments?: Maybe<Array<Scalars['String']>>
  playRecommendedAt?: Maybe<Scalars['AWSDateTime']>
  plays?: Maybe<Array<Scalars['String']>>
}

export type RecommendationsInput = {
  assessmentRecommendedAt?: InputMaybe<Scalars['AWSDateTime']>
  assessments?: InputMaybe<Array<Scalars['String']>>
  playRecommendedAt?: InputMaybe<Scalars['AWSDateTime']>
  plays?: InputMaybe<Array<Scalars['String']>>
}

export type RegeneratePlanAdminInput = {
  businessId: Scalars['String']
  feedback: Scalars['String']
  sessionId?: InputMaybe<Scalars['String']>
  userId: Scalars['String']
}

export type RegeneratePlanInput = {
  feedback: Scalars['String']
  goalId: Scalars['String']
  sessionId?: InputMaybe<Scalars['String']>
}

export enum RelativeTimeRange {
  LastNDays = 'LAST_N_DAYS',
  LastNHours = 'LAST_N_HOURS',
  LastNMonths = 'LAST_N_MONTHS',
  LastNYears = 'LAST_N_YEARS',
}

export type Report = {
  __typename?: 'Report'
  columns?: Maybe<Array<Maybe<ReportColumn>>>
  endDate?: Maybe<Scalars['String']>
  id?: Maybe<Scalars['ID']>
  name?: Maybe<Scalars['String']>
  rows?: Maybe<Array<Maybe<ReportRow>>>
  startDate?: Maybe<Scalars['String']>
  title?: Maybe<Scalars['String']>
}

export type ReportCell = {
  __typename?: 'ReportCell'
  id?: Maybe<Scalars['ID']>
  value?: Maybe<Scalars['String']>
}

export type ReportColumn = {
  __typename?: 'ReportColumn'
  id?: Maybe<Scalars['ID']>
  label?: Maybe<Scalars['String']>
}

export type ReportRow = {
  __typename?: 'ReportRow'
  cells?: Maybe<Array<Maybe<ReportCell>>>
  id?: Maybe<Scalars['ID']>
}

export type RequestDetail = {
  __typename?: 'RequestDetail'
  end?: Maybe<CalendarEventDate>
  reason?: Maybe<Scalars['String']>
  start?: Maybe<CalendarEventDate>
}

export type RequestDetailInput = {
  end?: InputMaybe<CalendarEventDateInput>
  reason: Scalars['String']
  start?: InputMaybe<CalendarEventDateInput>
}

export type RescheduleUserCalendarEventInput = {
  attendees?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  comment?: InputMaybe<Scalars['String']>
  description?: InputMaybe<Scalars['String']>
  endTime: Scalars['String']
  eventId?: InputMaybe<Scalars['String']>
  eventType?: InputMaybe<Scalars['String']>
  location?: InputMaybe<Scalars['String']>
  startTime: Scalars['String']
  tackleId: Scalars['String']
  title?: InputMaybe<Scalars['String']>
  videoLinkDescription?: InputMaybe<Scalars['String']>
}

export type ResendUserInviteInput = {
  email: Scalars['String']
  userId: Scalars['String']
}

export type SaveAssessmentResponseInput = {
  assessmentResponse: AssessmentResponseInput
  category?: InputMaybe<Scalars['String']>
  createdAt?: InputMaybe<Scalars['AWSDateTime']>
  currentStage?: InputMaybe<Scalars['ID']>
  isCompleted?: InputMaybe<Scalars['Boolean']>
  playStage?: InputMaybe<Scalars['AWSJSON']>
  tenantId: Scalars['String']
  type: Scalars['String']
  updatedAt?: InputMaybe<Scalars['AWSDateTime']>
  userId: Scalars['ID']
}

export type SaveBusinessGoalInput = {
  category?: InputMaybe<BusinessGoalCategory>
  description?: InputMaybe<Scalars['String']>
  expectedEndDate: Scalars['String']
  feedbackMessage?: InputMaybe<Array<InputMaybe<FeedbackMessageInput>>>
  flow?: InputMaybe<OnboardingFlowType>
  goalId: Scalars['ID']
  goalPriority?: InputMaybe<BusinessGoalPriority>
  goalTimeFrame?: InputMaybe<BusinessGoalTimeFrame>
  hasBeenViewed?: InputMaybe<Scalars['Boolean']>
  logo?: InputMaybe<Scalars['String']>
  metrics?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  name: Scalars['String']
  plan?: InputMaybe<BusinessGoalPlanInput>
  progress?: InputMaybe<Scalars['Int']>
  sessionId?: InputMaybe<Scalars['String']>
  startDate: Scalars['String']
  status?: InputMaybe<UserTaskItemStatus>
  tenantId: Scalars['ID']
  userId: Scalars['ID']
  why?: InputMaybe<Scalars['String']>
}

export type SavePlayResponseInput = {
  businessProfileFields?: InputMaybe<PlayBusinessProfileFields>
  isCompleted?: InputMaybe<Scalars['Boolean']>
  playId: Scalars['String']
  playType?: InputMaybe<Scalars['String']>
  recommendations?: InputMaybe<Array<Scalars['String']>>
  stepData?: InputMaybe<StepDataInput>
  stepDataIndex: Scalars['Int']
  stepIndex: Scalars['Int']
  tabId: Scalars['String']
  tenantId: Scalars['String']
}

export type SaveUserFileInput = {
  files: Array<FileDetails>
  sendNotification?: InputMaybe<Scalars['Boolean']>
}

export type SearchBusinessInformationInput = {
  EIN?: InputMaybe<Scalars['String']>
  businessId?: InputMaybe<Scalars['String']>
  businessName: Scalars['String']
  city: Scalars['String']
  state: Scalars['String']
}

export type SearchHowToDoTaskInput = {
  /**
   * The goal ID where the user was viewing the task from.
   * Can be 'all-plays', 'other-tasks', or a specific goal ID.
   * This is used to navigate back to the correct section after tutorial generation.
   */
  sourceGoalId?: InputMaybe<Scalars['ID']>
  taskId: Scalars['ID']
  userId?: InputMaybe<Scalars['ID']>
}

export type SearchIndustryReportInput = {
  keyword: Scalars['String']
}

export type SearchMeetingListInput = {
  dateRange?: InputMaybe<MeetingSummaryDateRange>
  limit?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  searchTerm?: InputMaybe<Scalars['String']>
}

export type SearchToolsInput = {
  categories?: InputMaybe<Array<Scalars['String']>>
  featured?: InputMaybe<Scalars['Boolean']>
  freeFormSearchQuery?: InputMaybe<Scalars['String']>
  inUserToolKit?: InputMaybe<Scalars['Boolean']>
  limit?: InputMaybe<Scalars['Int']>
  page?: InputMaybe<Scalars['Int']>
  userId?: InputMaybe<Scalars['ID']>
}

export type SearchToolsResponse = {
  __typename?: 'SearchToolsResponse'
  data: Array<Tool>
  numberOfPages?: Maybe<Scalars['Int']>
}

export type SearchUserSummariesInput = {
  dateRange?: InputMaybe<UserSummaryDateRange>
  limit?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  searchTerm?: InputMaybe<Scalars['String']>
}

export type SearchUserTasksInput = {
  goalId?: InputMaybe<Scalars['ID']>
  searchTerm?: InputMaybe<Scalars['String']>
  searchType: SearchUserTasksType
  tenantId: Scalars['ID']
  userId?: InputMaybe<Scalars['ID']>
}

export enum SearchUserTasksType {
  AllTasks = 'ALL_TASKS',
  GoalTasks = 'GOAL_TASKS',
  MiscTasks = 'MISC_TASKS',
}

export type SectionPaginationInput = {
  cursor?: InputMaybe<Scalars['String']>
  limit?: InputMaybe<Scalars['Int']>
  sessionId: Scalars['String']
}

export type SendDirectNotificationInput = {
  channel: DirectNotificationChanel
  message: Scalars['String']
  userId: Scalars['String']
}

export type SendMessageToBotInput = {
  audioTranscript?: InputMaybe<Scalars['String']>
  isEditingLastMessage?: InputMaybe<Scalars['Boolean']>
  isVoiceMessage?: InputMaybe<Scalars['Boolean']>
  sessionId?: InputMaybe<Scalars['String']>
  skip?: InputMaybe<Scalars['Boolean']>
  userMessage: Scalars['String']
  userMessageType?: InputMaybe<ChatBotMessageTypes>
  voiceDuration?: InputMaybe<Scalars['Int']>
}

export type SendMessageToBotResponse = {
  __typename?: 'SendMessageToBotResponse'
  flowType?: Maybe<Scalars['String']>
  isFinished?: Maybe<Scalars['Boolean']>
  nextFlow?: Maybe<Scalars['String']>
  progress?: Maybe<Scalars['Int']>
  responses?: Maybe<Array<Scalars['String']>>
  transcript?: Maybe<Scalars['String']>
}

export type SetUserAvailabilityInput = {
  availabilityHours?: InputMaybe<AvailabilityHoursInput>
  tenantId?: InputMaybe<Scalars['String']>
}

export type SetUserAvailabilityObj = {
  __typename?: 'SetUserAvailabilityObj'
  availabilityHours?: Maybe<AvailabilityHoursObj>
  createdAt?: Maybe<Scalars['String']>
  id?: Maybe<Scalars['String']>
  tenantId?: Maybe<Scalars['String']>
  updatedAt?: Maybe<Scalars['String']>
  userId?: Maybe<Scalars['String']>
}

export type SetUserAvailabilityResponse = {
  __typename?: 'SetUserAvailabilityResponse'
  data?: Maybe<SetUserAvailabilityObj>
  error?: Maybe<Scalars['String']>
}

export type SetUserMeetingInput = {
  advisorName?: InputMaybe<Scalars['String']>
  attendees?: InputMaybe<Array<Scalars['String']>>
  description?: InputMaybe<Scalars['String']>
  endTime: Scalars['String']
  ignoreConflicts?: InputMaybe<Scalars['Boolean']>
  location?: InputMaybe<Scalars['String']>
  meetingLocationTool: Scalars['String']
  organizerName?: InputMaybe<Scalars['String']>
  participantId?: InputMaybe<Scalars['String']>
  participantName?: InputMaybe<Scalars['String']>
  role: Array<Scalars['String']>
  startTime: Scalars['String']
  teamMemberList?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  tenantId: Scalars['String']
  timezone: Scalars['String']
  title: Scalars['String']
  videoLinkDescription?: InputMaybe<Scalars['String']>
}

export type SignedUrlResponse = {
  __typename?: 'SignedUrlResponse'
  data?: Maybe<Scalars['AWSJSON']>
  error?: Maybe<Scalars['String']>
  message?: Maybe<Scalars['String']>
  success: Scalars['Boolean']
}

export type SlotInput = {
  endTime?: InputMaybe<Scalars['String']>
  startTime?: InputMaybe<Scalars['String']>
}

export type SlotObj = {
  __typename?: 'SlotObj'
  isAvailable?: Maybe<Scalars['Boolean']>
  slotEndTime?: Maybe<Scalars['String']>
  slotStartTime?: Maybe<Scalars['String']>
}

export type SlotOutput = {
  __typename?: 'SlotOutput'
  endTime?: Maybe<Scalars['String']>
  startTime?: Maybe<Scalars['String']>
}

export enum SortOrder {
  Ascending = 'ASCENDING',
  Descending = 'DESCENDING',
}

export type StepBusinessProfileFields = {
  __typename?: 'StepBusinessProfileFields'
  logo?: Maybe<FileStructure>
}

export type StepBusinessProfileFieldsInput = {
  logo?: InputMaybe<FileStructureInput>
}

export type StepData = {
  __typename?: 'StepData'
  businessProfileFields?: Maybe<StepBusinessProfileFields>
  completedAt?: Maybe<Scalars['AWSDateTime']>
  id?: Maybe<Scalars['String']>
  isCompleted?: Maybe<Scalars['Boolean']>
  isMeetingScheduled?: Maybe<Scalars['Boolean']>
  label?: Maybe<Array<Scalars['String']>>
  recommendations?: Maybe<Array<Scalars['String']>>
  value?: Maybe<Array<Scalars['String']>>
}

export type StepDataInput = {
  businessProfileFields?: InputMaybe<StepBusinessProfileFieldsInput>
  completedAt?: InputMaybe<Scalars['AWSDateTime']>
  id?: InputMaybe<Scalars['String']>
  isCompleted?: InputMaybe<Scalars['Boolean']>
  isMeetingScheduled?: InputMaybe<Scalars['Boolean']>
  label?: InputMaybe<Array<Scalars['String']>>
  recommendations?: InputMaybe<Array<Scalars['String']>>
  value?: InputMaybe<Array<Scalars['String']>>
}

export type StepResponse = {
  __typename?: 'StepResponse'
  completedAt?: Maybe<Scalars['AWSDateTime']>
  id?: Maybe<Scalars['String']>
  isCompleted?: Maybe<Scalars['Boolean']>
  stepData?: Maybe<Array<StepData>>
  stepTitle?: Maybe<Scalars['String']>
}

export type StrategyHistory = {
  __typename?: 'StrategyHistory'
  createdAt: Scalars['AWSDateTime']
  feedback?: Maybe<Scalars['String']>
  status: StrategyStatus
  strategy: Scalars['String']
  updatedAt: Scalars['AWSDateTime']
}

export type StrategyHistoryInput = {
  createdAt: Scalars['AWSDateTime']
  status: StrategyStatus
  strategy: Scalars['String']
  updatedAt: Scalars['AWSDateTime']
}

export enum StrategyStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
}

export type SubscribeGoogleCalendarWebhookResponse = {
  __typename?: 'SubscribeGoogleCalendarWebhookResponse'
  data?: Maybe<Scalars['String']>
  error?: Maybe<Scalars['String']>
}

export type Subscription = {
  __typename?: 'Subscription'
  onGoalPlanRegenerationError?: Maybe<GoalPlanRegenerationError>
  onRealTimeNotification?: Maybe<RealTimeNotification>
  onTaskProgressUpdated?: Maybe<TaskResult>
}

export type SubscriptionOnGoalPlanRegenerationErrorArgs = {
  userId?: InputMaybe<Scalars['ID']>
}

export type SubscriptionOnRealTimeNotificationArgs = {
  key?: InputMaybe<Scalars['String']>
  topic: Scalars['String']
}

export type SubscriptionOnTaskProgressUpdatedArgs = {
  id: Scalars['ID']
}

export type SummaryEditInfo = {
  __typename?: 'SummaryEditInfo'
  editedByName?: Maybe<Scalars['String']>
  isSummaryEdited?: Maybe<Scalars['Boolean']>
  lastEditedTime?: Maybe<Scalars['AWSDateTime']>
}

export type SystemSetting = {
  __typename?: 'SystemSetting'
  category?: Maybe<Scalars['String']>
  key?: Maybe<Scalars['String']>
  value?: Maybe<Scalars['String']>
}

export type TabResponse = {
  __typename?: 'TabResponse'
  completedAt?: Maybe<Scalars['AWSDateTime']>
  id?: Maybe<Scalars['String']>
  isCompleted?: Maybe<Scalars['Boolean']>
  stepResponse?: Maybe<Array<StepResponse>>
  tabName?: Maybe<Scalars['String']>
}

export type Task = {
  __typename?: 'Task'
  assignedByUserId?: Maybe<Scalars['String']>
  assignedToUserId?: Maybe<Scalars['String']>
  category?: Maybe<Scalars['String']>
  completedAt?: Maybe<Scalars['String']>
  description?: Maybe<Scalars['String']>
  id?: Maybe<Scalars['String']>
  playType?: Maybe<Scalars['String']>
  prerequisites?: Maybe<TaskPrerequisites>
  rank?: Maybe<Scalars['String']>
  recommendedBy?: Maybe<Scalars['String']>
  startedAt?: Maybe<Scalars['String']>
  status?: Maybe<Scalars['String']>
  title?: Maybe<Scalars['String']>
  type?: Maybe<Scalars['String']>
}

export type TaskComment = {
  __typename?: 'TaskComment'
  content: Scalars['String']
  createdAt: Scalars['AWSDateTime']
  createdBy: UserProfile
  createdById: Scalars['String']
  files?: Maybe<Array<UserFile>>
  id: Scalars['String']
  parentId?: Maybe<Scalars['String']>
  reactions?: Maybe<Array<Reaction>>
  replies?: Maybe<Array<TaskComment>>
  tags?: Maybe<Array<Scalars['String']>>
  taskId: Scalars['String']
  updatedAt: Scalars['AWSDateTime']
}

export type TaskCompletionBaseCondition = {
  __typename?: 'TaskCompletionBaseCondition'
  conditions?: Maybe<Array<BaseCondition>>
  conjunction?: Maybe<TaskCompletionConjunction>
}

export enum TaskCompletionConjunction {
  And = 'AND',
  Or = 'OR',
}

export type TaskCompletionSchema = GroupTaskCompletionCondition | TaskCompletionBaseCondition

export type TaskResult = {
  __typename?: 'TaskResult'
  id?: Maybe<Scalars['ID']>
  payload?: Maybe<Scalars['AWSJSON']>
  status?: Maybe<Scalars['ID']>
}

export enum TaskResultStatus {
  Complete = 'COMPLETE',
  Error = 'ERROR',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING',
}

export enum TaskStatus {
  Completed = 'COMPLETED',
  NotStarted = 'NOT_STARTED',
  Started = 'STARTED',
}

export enum TaskType {
  Assessment = 'ASSESSMENT',
  Play = 'PLAY',
}

export type TeamMemberDetails = {
  __typename?: 'TeamMemberDetails'
  email?: Maybe<Scalars['String']>
  firstName?: Maybe<Scalars['String']>
  id?: Maybe<Scalars['String']>
  lastName?: Maybe<Scalars['String']>
}

export type Tenant = {
  __typename?: 'Tenant'
  adminId?: Maybe<Scalars['String']>
  createdAt?: Maybe<Scalars['AWSDateTime']>
  id?: Maybe<Scalars['String']>
  name?: Maybe<Scalars['String']>
  updatedAt?: Maybe<Scalars['AWSDateTime']>
}

export type Term = {
  __typename?: 'Term'
  replacement: Scalars['String']
  term: Scalars['String']
}

export type TimePeriod = {
  day?: InputMaybe<Scalars['Int']>
  month: Scalars['Int']
  year: Scalars['Int']
}

export type TimeRangeInput = {
  endDate?: InputMaybe<Scalars['AWSDateTime']>
  n?: InputMaybe<Scalars['Int']>
  rangeType?: InputMaybe<TimeRangeType>
  relative?: InputMaybe<RelativeTimeRange>
  startDate?: InputMaybe<Scalars['AWSDateTime']>
}

export enum TimeRangeType {
  Absolute = 'ABSOLUTE',
  Relative = 'RELATIVE',
}

export type TimeRangeValueInput = {
  asOfDate: Scalars['AWSDate']
  granularity?: InputMaybe<MetricGranularity>
}

export type TimeSeriesResponse = {
  __typename?: 'TimeSeriesResponse'
  labels?: Maybe<Array<Scalars['String']>>
  values?: Maybe<Array<Scalars['Float']>>
}

export type TimeSlotsInput = {
  label?: InputMaybe<Scalars['String']>
  slots?: InputMaybe<Array<InputMaybe<SlotInput>>>
  value?: InputMaybe<Scalars['String']>
}

export type TimeSlotsObj = {
  __typename?: 'TimeSlotsObj'
  label?: Maybe<Scalars['String']>
  slots?: Maybe<Array<Maybe<SlotOutput>>>
  value?: Maybe<Scalars['String']>
}

export type Tool = {
  __typename?: 'Tool'
  authType?: Maybe<ToolAuthType>
  authorizationQueryParameters?: Maybe<Array<KeyValuePair>>
  authorizationUri?: Maybe<Scalars['String']>
  categories?: Maybe<Array<ToolCategory>>
  category?: Maybe<Scalars['String']>
  clientId?: Maybe<Scalars['String']>
  clientSecret?: Maybe<Scalars['String']>
  connectionFormImageUrl?: Maybe<Scalars['String']>
  connectionStatus?: Maybe<Scalars['String']>
  connectorName?: Maybe<Scalars['String']>
  cyclrToolId?: Maybe<Scalars['String']>
  dataScope?: Maybe<ToolDataScope>
  dataTypes?: Maybe<Array<ToolDataTypes>>
  description?: Maybe<Scalars['String']>
  diagnosticSupported?: Maybe<Scalars['Boolean']>
  featured?: Maybe<Scalars['Boolean']>
  group?: Maybe<Scalars['String']>
  id?: Maybe<Scalars['ID']>
  imageUrl?: Maybe<Scalars['String']>
  isBookmarked?: Maybe<Scalars['Boolean']>
  isConnected?: Maybe<Scalars['Boolean']>
  isRecommended?: Maybe<Scalars['Boolean']>
  isSelected?: Maybe<Scalars['Boolean']>
  keyWords?: Maybe<Array<Scalars['String']>>
  longDescription?: Maybe<Scalars['String']>
  oAuthUrl?: Maybe<Scalars['String']>
  options?: Maybe<ToolConnectionOptions>
  pricingPageUrl?: Maybe<Scalars['String']>
  recommendedBy?: Maybe<Scalars['String']>
  relatedPlays?: Maybe<Array<Maybe<Scalars['String']>>>
  scopes?: Maybe<Array<Scalars['String']>>
  subCategory?: Maybe<Scalars['String']>
  supportLevel?: Maybe<ToolSupportLevel>
  tags?: Maybe<Array<Scalars['String']>>
  tokenUrl?: Maybe<Scalars['String']>
  toolDisplayName?: Maybe<Scalars['String']>
  toolHelpText?: Maybe<Scalars['String']>
  toolName?: Maybe<Scalars['String']>
  toolType?: Maybe<ToolType>
  toolUrl?: Maybe<Scalars['String']>
  userToolsImageUrl?: Maybe<Scalars['String']>
  visible?: Maybe<Scalars['Boolean']>
}

export enum ToolAuthType {
  ApiKey = 'API_KEY',
  Oauth = 'OAUTH',
  UsernameAndPassword = 'USERNAME_AND_PASSWORD',
}

export type ToolCategory = {
  __typename?: 'ToolCategory'
  category: Scalars['String']
  subCategory: Scalars['String']
}

export type ToolCategoryInput = {
  category: Scalars['String']
  subCategory: Scalars['String']
}

export type ToolConnectionForm = {
  __typename?: 'ToolConnectionForm'
  description: Scalars['String']
  inputProperties: Array<ToolConnectionFormInputProperty>
}

export type ToolConnectionFormInput = {
  description: Scalars['String']
  inputProperties: Array<ToolConnectionFormInputPropertyInput>
}

export type ToolConnectionFormInputProperty = {
  __typename?: 'ToolConnectionFormInputProperty'
  displayName: Scalars['String']
  name: Scalars['String']
  placeholder?: Maybe<Scalars['String']>
  type: Scalars['String']
  validationRules: Array<Scalars['String']>
}

export type ToolConnectionFormInputPropertyInput = {
  displayName: Scalars['String']
  name: Scalars['String']
  placeholder?: InputMaybe<Scalars['String']>
  type: Scalars['String']
  validationRules: Array<Scalars['String']>
}

export type ToolConnectionOptions = {
  __typename?: 'ToolConnectionOptions'
  connectionForm?: Maybe<ToolConnectionForm>
}

export type ToolConnectionOptionsInput = {
  connectionForm?: InputMaybe<ToolConnectionFormInput>
}

export enum ToolConnectionStatus {
  Connected = 'CONNECTED',
  ConnectionError = 'CONNECTION_ERROR',
  Disconnected = 'DISCONNECTED',
  Reconnected = 'RECONNECTED',
}

export type ToolConnectionSuccessInput = {
  connectorName: Scalars['String']
  playId?: InputMaybe<Scalars['String']>
  tenantId: Scalars['String']
}

export enum ToolDataScope {
  Individual = 'INDIVIDUAL',
  Organization = 'ORGANIZATION',
}

export enum ToolDataTypes {
  Bookkeeping = 'Bookkeeping',
  CustomerRelationshipManagement = 'CustomerRelationshipManagement',
  Marketing = 'Marketing',
  Sales = 'Sales',
}

export type ToolImageFileInput = {
  base64Data: Scalars['String']
  name?: InputMaybe<Scalars['String']>
  type: Scalars['String']
}

export enum ToolSupportLevel {
  Connect = 'CONNECT',
  DataRetrieval = 'DATA_RETRIEVAL',
  Open = 'OPEN',
}

export enum ToolType {
  Calendar = 'CALENDAR',
}

export type TopActiveClient = {
  __typename?: 'TopActiveClient'
  businessName?: Maybe<Scalars['String']>
  email?: Maybe<Scalars['String']>
  firstName?: Maybe<Scalars['String']>
  id?: Maybe<Scalars['String']>
  industry?: Maybe<Scalars['String']>
  lastName?: Maybe<Scalars['String']>
  logo?: Maybe<UserFile>
  score?: Maybe<Scalars['Float']>
  tenantId?: Maybe<Scalars['String']>
  topGoal?: Maybe<Scalars['String']>
  totalTime?: Maybe<Scalars['Float']>
}

export type TranscriptSummaryInput = {
  files?: InputMaybe<Array<UserFileInput>>
  summaryDetails?: InputMaybe<Scalars['String']>
}

export enum TutorialGenerationStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Generating = 'GENERATING',
  NotStarted = 'NOT_STARTED',
}

export type UpdateBusinessGoalInput = {
  expectedEndDate?: InputMaybe<Scalars['String']>
  feedbackMessage?: InputMaybe<Array<InputMaybe<FeedbackMessageInput>>>
  goalId: Scalars['ID']
  goalPriority?: InputMaybe<BusinessGoalPriority>
  hasBeenViewed?: InputMaybe<Scalars['Boolean']>
  name?: InputMaybe<Scalars['String']>
  progress?: InputMaybe<Scalars['Int']>
  startDate?: InputMaybe<Scalars['String']>
  status?: InputMaybe<UserTaskItemStatus>
  strategyHistory?: InputMaybe<Array<StrategyHistoryInput>>
  suggestedStatus?: InputMaybe<UserTaskSuggestedItemStatus>
  tenantId: Scalars['ID']
  userId?: InputMaybe<Scalars['ID']>
  why?: InputMaybe<Scalars['String']>
}

export type UpdateBusinessGoalMilestoneInput = {
  descriptions?: InputMaybe<Scalars['String']>
  expectedEndDate?: InputMaybe<Scalars['String']>
  feedbackMessage?: InputMaybe<Array<InputMaybe<FeedbackMessageInput>>>
  isFumbled?: InputMaybe<Scalars['Boolean']>
  milestoneId: Scalars['ID']
  name?: InputMaybe<Scalars['String']>
  planId: Scalars['ID']
  riskAndChallenges?: InputMaybe<Scalars['String']>
  startDate?: InputMaybe<Scalars['String']>
  status?: InputMaybe<UserTaskItemStatus>
  timeline?: InputMaybe<Scalars['String']>
  why?: InputMaybe<Scalars['String']>
}

export type UpdateBusinessProfileInput = {
  EIN?: InputMaybe<Scalars['String']>
  POS?: InputMaybe<Scalars['String']>
  POSOptionId?: InputMaybe<Scalars['String']>
  accountingMethod?: InputMaybe<Scalars['String']>
  accountingMethodOptionId?: InputMaybe<Scalars['String']>
  additionalContext?: InputMaybe<Scalars['AWSJSON']>
  additionalInfo?: InputMaybe<Scalars['String']>
  address?: InputMaybe<AddressInput>
  avatar?: InputMaybe<Scalars['String']>
  bookKeepingTool?: InputMaybe<Scalars['String']>
  bookKeepingToolOptionId?: InputMaybe<Scalars['String']>
  budget?: InputMaybe<Scalars['Float']>
  businessAddress?: InputMaybe<BusinessAddressInput>
  businessBankAccount?: InputMaybe<Scalars['Boolean']>
  businessClassification?: InputMaybe<Scalars['String']>
  businessClassificationOptionId?: InputMaybe<Scalars['String']>
  businessDescription?: InputMaybe<Scalars['String']>
  businessEmail?: InputMaybe<Scalars['String']>
  businessLocations?: InputMaybe<Array<Scalars['String']>>
  businessLocationsOptionIds?: InputMaybe<Array<Scalars['String']>>
  businessMetricsViewPermission?: InputMaybe<BusinessMetricsViewPermissionState>
  businessName?: InputMaybe<Scalars['String']>
  businessNature?: InputMaybe<Scalars['String']>
  businessNatureOptionId?: InputMaybe<Scalars['String']>
  businessPlan?: InputMaybe<Scalars['String']>
  businessStage?: InputMaybe<Scalars['String']>
  businessStageOptionId?: InputMaybe<Scalars['String']>
  businessVision?: InputMaybe<Scalars['String']>
  challenges?: InputMaybe<Scalars['String']>
  companyEmployees?: InputMaybe<Scalars['String']>
  contractors?: InputMaybe<Scalars['String']>
  country?: InputMaybe<Scalars['String']>
  createdAt?: InputMaybe<Scalars['AWSDateTime']>
  crmToolIds?: InputMaybe<Array<Scalars['String']>>
  dba?: InputMaybe<Scalars['String']>
  dbaNames?: InputMaybe<Array<Scalars['String']>>
  debtFinancing?: InputMaybe<Scalars['String']>
  domainName?: InputMaybe<Scalars['String']>
  education?: InputMaybe<Scalars['String']>
  employeeBenefit?: InputMaybe<Scalars['String']>
  exitPlan?: InputMaybe<Scalars['String']>
  exitPlanOptionId?: InputMaybe<Scalars['String']>
  expenses?: InputMaybe<Scalars['Float']>
  facebook?: InputMaybe<Scalars['String']>
  financeTrackingToolIds?: InputMaybe<Array<Scalars['String']>>
  financialGrowth?: InputMaybe<Scalars['String']>
  foodSubIndustry?: InputMaybe<Array<Scalars['String']>>
  foodSubIndustryOptionIds?: InputMaybe<Array<Scalars['String']>>
  fullTimeEmployees?: InputMaybe<Scalars['String']>
  gender?: InputMaybe<Scalars['String']>
  googleBusinessProfilePlays?: InputMaybe<Array<Scalars['String']>>
  googleBusinessProfilePlaysOptionIds?: InputMaybe<Array<Scalars['String']>>
  googleWorkspacePlays?: InputMaybe<Array<Scalars['String']>>
  googleWorkspacePlaysOptionIds?: InputMaybe<Array<Scalars['String']>>
  grossRevenueGoalForThisYear?: InputMaybe<Scalars['String']>
  hasAvatar?: InputMaybe<Scalars['Boolean']>
  hasBookKeepingTool?: InputMaybe<Scalars['String']>
  hasBookKeepingToolOptionId?: InputMaybe<Scalars['String']>
  hasBudget?: InputMaybe<Scalars['String']>
  hasBudgetOptionId?: InputMaybe<Scalars['String']>
  hasBusinessEmail?: InputMaybe<Scalars['String']>
  hasBusinessEmailOptionId?: InputMaybe<Scalars['String']>
  hasBusinessEmployees?: InputMaybe<Scalars['String']>
  hasBusinessEmployeesOptionId?: InputMaybe<Scalars['String']>
  hasBusinessPhoneNumber?: InputMaybe<Scalars['String']>
  hasBusinessPhoneNumberOptionId?: InputMaybe<Scalars['String']>
  hasDomainName?: InputMaybe<Scalars['String']>
  hasDomainNameOptionId?: InputMaybe<Scalars['String']>
  hasEIN?: InputMaybe<Scalars['Boolean']>
  hasEsignatureTool?: InputMaybe<Scalars['String']>
  hasEsignatureToolOptionId?: InputMaybe<Scalars['String']>
  hasFacebook?: InputMaybe<Scalars['Boolean']>
  hasGoogleBusinessProfile?: InputMaybe<Scalars['String']>
  hasGoogleBusinessProfileOptionId?: InputMaybe<Scalars['String']>
  hasGoogleChrome?: InputMaybe<Scalars['String']>
  hasGoogleChromeOptionId?: InputMaybe<Scalars['String']>
  hasGoogleWorkspace?: InputMaybe<Scalars['String']>
  hasGoogleWorkspaceOptionId?: InputMaybe<Scalars['String']>
  hasInstagram?: InputMaybe<Scalars['Boolean']>
  hasLinkedin?: InputMaybe<Scalars['Boolean']>
  hasLogo?: InputMaybe<Scalars['String']>
  hasLogoOptionId?: InputMaybe<Scalars['String']>
  hasLogoTrademarked?: InputMaybe<Scalars['String']>
  hasLogoTrademarkedOptionId?: InputMaybe<Scalars['String']>
  hasMoreLocations?: InputMaybe<Scalars['String']>
  hasMoreLocationsOptionId?: InputMaybe<Scalars['String']>
  hasPOS?: InputMaybe<Scalars['String']>
  hasPOSOptionId?: InputMaybe<Scalars['String']>
  hasPaymentProcessor?: InputMaybe<Scalars['String']>
  hasPaymentProcessorOptionId?: InputMaybe<Scalars['String']>
  hasPricingStrategies?: InputMaybe<Scalars['String']>
  hasPricingStrategiesOptionId?: InputMaybe<Scalars['String']>
  hasQuickBooks?: InputMaybe<Scalars['String']>
  hasQuickBooksOptionId?: InputMaybe<Scalars['String']>
  hasRegisterBusinessStructure?: InputMaybe<Scalars['Boolean']>
  hasTikTok?: InputMaybe<Scalars['Boolean']>
  hasTwitter?: InputMaybe<Scalars['Boolean']>
  hasWebsite?: InputMaybe<Scalars['Boolean']>
  hasYoutube?: InputMaybe<Scalars['Boolean']>
  haveStartedGeneratingSales?: InputMaybe<Scalars['Boolean']>
  hoursSpent?: InputMaybe<Scalars['String']>
  hoursSpentOptionId?: InputMaybe<Scalars['String']>
  hoursSpentPerMonth?: InputMaybe<Scalars['Int']>
  hoursSpentPerWeek?: InputMaybe<Scalars['Int']>
  id: Scalars['ID']
  instagram?: InputMaybe<Scalars['String']>
  isOnboarded?: InputMaybe<Scalars['Boolean']>
  isProfit?: InputMaybe<Scalars['Boolean']>
  isUserCreation?: InputMaybe<Scalars['Boolean']>
  jobsCreated?: InputMaybe<Scalars['String']>
  lastUpdatedBusinessPlan?: InputMaybe<Scalars['AWSDateTime']>
  lastYearRevenue?: InputMaybe<Scalars['String']>
  launchDate?: InputMaybe<Scalars['AWSDateTime']>
  learnPricingStrategies?: InputMaybe<Scalars['String']>
  learnPricingStrategiesOptionId?: InputMaybe<Scalars['String']>
  linkedin?: InputMaybe<Scalars['String']>
  loginFrequency?: InputMaybe<Scalars['String']>
  logo?: InputMaybe<Scalars['String']>
  minorityOwned?: InputMaybe<Scalars['String']>
  month?: InputMaybe<Scalars['String']>
  motivation?: InputMaybe<Scalars['String']>
  naicsCode?: InputMaybe<Scalars['String']>
  newCustomer?: InputMaybe<Scalars['String']>
  noOfBusinessStarted?: InputMaybe<Scalars['String']>
  numberOfBusinessBankAccounts?: InputMaybe<Scalars['String']>
  onboardedAt?: InputMaybe<Scalars['String']>
  otherExitPlan?: InputMaybe<Scalars['String']>
  otherGoals?: InputMaybe<Array<Scalars['String']>>
  otherGoalsOptionIds?: InputMaybe<Array<Scalars['String']>>
  otherRegisteredBusinessStructure?: InputMaybe<Scalars['String']>
  otherWhereDoYouDoBusiness?: InputMaybe<Scalars['String']>
  partTimeEmployees?: InputMaybe<Scalars['String']>
  paymentAcceptance?: InputMaybe<Scalars['String']>
  paymentAcceptanceOptionId?: InputMaybe<Scalars['String']>
  paymentAcceptancePlan?: InputMaybe<Scalars['String']>
  paymentAcceptancePlanOptionId?: InputMaybe<Scalars['String']>
  paymentApps?: InputMaybe<Array<Scalars['String']>>
  paymentAppsOptionIds?: InputMaybe<Array<Scalars['String']>>
  paymentProcessor?: InputMaybe<Scalars['String']>
  paymentProcessorOptionId?: InputMaybe<Scalars['String']>
  paymentTypes?: InputMaybe<Array<Scalars['String']>>
  paymentTypesOptionIds?: InputMaybe<Array<Scalars['String']>>
  personalGoals?: InputMaybe<Scalars['String']>
  phoneNumber?: InputMaybe<Scalars['String']>
  physicalLocation?: InputMaybe<Scalars['String']>
  pricingStrategies?: InputMaybe<Array<Scalars['String']>>
  pricingStrategiesOptionIds?: InputMaybe<Array<Scalars['String']>>
  productSale?: InputMaybe<Scalars['String']>
  productsAndServices?: InputMaybe<Array<Scalars['String']>>
  productsAndServicesOptionIds?: InputMaybe<Array<Scalars['String']>>
  quickBookPlays?: InputMaybe<Array<Scalars['String']>>
  quickBookPlaysOptionIds?: InputMaybe<Array<Scalars['String']>>
  race?: InputMaybe<Scalars['String']>
  registerBusinessStructure?: InputMaybe<Scalars['String']>
  registerBusinessStructureOptionId?: InputMaybe<Scalars['String']>
  revenue?: InputMaybe<Scalars['String']>
  revenueStatus?: InputMaybe<Scalars['String']>
  revenueStatusOptionId?: InputMaybe<Scalars['String']>
  saleGoal?: InputMaybe<Scalars['String']>
  sbaCertified?: InputMaybe<Scalars['String']>
  seasonalityDetails?: InputMaybe<Scalars['String']>
  serviceSale?: InputMaybe<Scalars['String']>
  servicesSubIndustry?: InputMaybe<Scalars['String']>
  servicesSubIndustryOptionId?: InputMaybe<Scalars['String']>
  squarePlays?: InputMaybe<Array<Scalars['String']>>
  squarePlaysOptionIds?: InputMaybe<Array<Scalars['String']>>
  stripePlays?: InputMaybe<Array<Scalars['String']>>
  stripePlaysOptionIds?: InputMaybe<Array<Scalars['String']>>
  strongBusinessAreas?: InputMaybe<Array<Scalars['String']>>
  strongBusinessAreasOptionIds?: InputMaybe<Array<Scalars['String']>>
  supportAndHelp?: InputMaybe<Array<Scalars['String']>>
  supportAndHelpOptionIds?: InputMaybe<Array<Scalars['String']>>
  targetAudience?: InputMaybe<Scalars['String']>
  tenantId: Scalars['String']
  thisYearRevenue?: InputMaybe<Scalars['String']>
  tiktok?: InputMaybe<Scalars['String']>
  topGoal?: InputMaybe<Scalars['String']>
  topGoalOptionId?: InputMaybe<Scalars['String']>
  totalEmployees?: InputMaybe<Scalars['String']>
  twitter?: InputMaybe<Scalars['String']>
  updatedAt?: InputMaybe<Scalars['AWSDateTime']>
  usePOS?: InputMaybe<Scalars['String']>
  usePOSOptionId?: InputMaybe<Scalars['String']>
  usePaymentProcessor?: InputMaybe<Scalars['String']>
  usePaymentProcessorOptionId?: InputMaybe<Scalars['String']>
  userName?: InputMaybe<Scalars['String']>
  veteranOwned?: InputMaybe<Scalars['String']>
  volunteers?: InputMaybe<Scalars['String']>
  wages?: InputMaybe<Scalars['String']>
  website?: InputMaybe<Scalars['String']>
  whereDoYouDoBusiness?: InputMaybe<Array<Scalars['String']>>
  whereDoYouDoBusinessOptionIds?: InputMaybe<Array<Scalars['String']>>
  year?: InputMaybe<Scalars['String']>
  yearEstablished?: InputMaybe<Scalars['String']>
  yearsInBusiness?: InputMaybe<Scalars['String']>
  youtube?: InputMaybe<Scalars['String']>
}

export type UpdateBusinessSupportOrganizationInput = {
  id: Scalars['ID']
  intakeFormCompleted?: InputMaybe<Scalars['Boolean']>
  intakeFormCompletedAt?: InputMaybe<Scalars['AWSDateTime']>
  intakeFormCompletedBy?: InputMaybe<Scalars['String']>
  logoUrl?: InputMaybe<Scalars['String']>
}

export type UpdateGoalPlanInput = {
  expectedEndDate?: InputMaybe<Scalars['String']>
  goalId: Scalars['ID']
  isUndismissedFumbledState?: InputMaybe<Scalars['Boolean']>
  isUndismissedMicroCelebrationState?: InputMaybe<Scalars['Boolean']>
  name?: InputMaybe<Scalars['String']>
  pauseDate?: InputMaybe<Scalars['String']>
  pauseDuration?: InputMaybe<Scalars['Int']>
  planId: Scalars['ID']
  progress?: InputMaybe<Scalars['Int']>
  startDate?: InputMaybe<Scalars['String']>
  state?: InputMaybe<BusinessGoalPlanState>
  timeline?: InputMaybe<Scalars['String']>
}

export type UpdateInsightInput = {
  category?: InputMaybe<Scalars['String']>
  description?: InputMaybe<Scalars['String']>
  feedback?: InputMaybe<FeedbackType>
  feedbackMessage?: InputMaybe<Array<FeedbackMessageInput>>
  goalsId?: InputMaybe<Array<Scalars['String']>>
  hasBeenViewed?: InputMaybe<Scalars['Boolean']>
  insightId: Scalars['ID']
  internal_context?: InputMaybe<Scalars['String']>
  isApproved?: InputMaybe<Scalars['Boolean']>
  metadata?: InputMaybe<Scalars['AWSJSON']>
  metrics?: InputMaybe<Array<InsightMetricInput>>
  name?: InputMaybe<Scalars['String']>
  playsId?: InputMaybe<Array<Scalars['String']>>
  priority?: InputMaybe<InsightPriority>
  session?: InputMaybe<Scalars['String']>
  suggestedBy?: InputMaybe<Scalars['String']>
  tenantId: Scalars['ID']
  userId?: InputMaybe<Scalars['ID']>
  why?: InputMaybe<Scalars['String']>
}

export type UpdateInsightsNotificationInput = {
  lastNewInsightsPopupShownAt?: InputMaybe<Scalars['String']>
  lastNewInsightsViewedAt?: InputMaybe<Scalars['String']>
  tenantId: Scalars['String']
  userId: Scalars['String']
}

export type UpdateMyProfileInput = {
  advisors?: InputMaybe<Array<Scalars['String']>>
  attestationStatus?: InputMaybe<Scalars['String']>
  avatar?: InputMaybe<Scalars['String']>
  bio?: InputMaybe<Scalars['String']>
  calendarEventViewPreference?: InputMaybe<CalendarEventViewPreference>
  calendlyEventsUrl?: InputMaybe<Scalars['String']>
  companyAdvisor?: InputMaybe<Scalars['String']>
  companyEmployees?: InputMaybe<Scalars['Int']>
  country?: InputMaybe<Scalars['String']>
  defaultVideoLinkDescription?: InputMaybe<Scalars['String']>
  education?: InputMaybe<Scalars['String']>
  email?: InputMaybe<Scalars['AWSEmail']>
  employmentType?: InputMaybe<Scalars['String']>
  expertise?: InputMaybe<Scalars['String']>
  firstName?: InputMaybe<Scalars['String']>
  hasLinkedin?: InputMaybe<Scalars['Boolean']>
  interimTimezone?: InputMaybe<Scalars['String']>
  isConsentGivenToAdvisor?: InputMaybe<Scalars['Boolean']>
  isJoinedBetaProgram?: InputMaybe<Scalars['Boolean']>
  isNewUser?: InputMaybe<Scalars['Boolean']>
  isSmsEnabled?: InputMaybe<Scalars['Boolean']>
  jobTitle?: InputMaybe<Scalars['String']>
  lastName?: InputMaybe<Scalars['String']>
  linkedinProfile?: InputMaybe<Scalars['String']>
  mobileContactNumber?: InputMaybe<Scalars['AWSPhone']>
  name?: InputMaybe<Scalars['String']>
  onboardingStatus?: InputMaybe<OnboardingStatus>
  owners?: InputMaybe<Array<Scalars['String']>>
  quoteViewDate?: InputMaybe<Scalars['String']>
  schedulingUrl?: InputMaybe<Scalars['String']>
  status?: InputMaybe<Scalars['String']>
  streamAccessToken?: InputMaybe<Scalars['String']>
  tenantId: Scalars['String']
  timezone?: InputMaybe<Scalars['String']>
  userId?: InputMaybe<Scalars['String']>
  websiteURL?: InputMaybe<Scalars['String']>
  workAddress?: InputMaybe<Scalars['String']>
  workExperience?: InputMaybe<Scalars['String']>
  workLocation?: InputMaybe<Scalars['String']>
  workPhoneNumber?: InputMaybe<Scalars['String']>
  yearsInBusiness?: InputMaybe<Scalars['String']>
}

export type UpdateOwnerInput = {
  ownerExperience?: InputMaybe<Scalars['String']>
  selectedTools?: InputMaybe<Scalars['AWSJSON']>
  tenantId: Scalars['String']
}

export type UpdateTaskCommentInput = {
  commentId: Scalars['String']
  content: Scalars['String']
  fileIds?: InputMaybe<Array<Scalars['String']>>
  tags?: InputMaybe<Array<Scalars['String']>>
  taskId: Scalars['String']
}

export type UpdateTaskReactionInput = {
  action: ReactionAction
  commentId: Scalars['String']
  reactionType: Scalars['String']
  taskId: Scalars['String']
}

export type UpdateToolInput = {
  authType?: InputMaybe<ToolAuthType>
  authorizationQueryParameters?: InputMaybe<Array<KeyValuePairInput>>
  authorizationUri?: InputMaybe<Scalars['String']>
  categories?: InputMaybe<Array<ToolCategoryInput>>
  category?: InputMaybe<Scalars['String']>
  clientId?: InputMaybe<Scalars['String']>
  clientSecret?: InputMaybe<Scalars['String']>
  connectionFormImageUrl?: InputMaybe<Scalars['String']>
  connectionStatus?: InputMaybe<Scalars['String']>
  connectorName?: InputMaybe<Scalars['String']>
  cyclrToolId?: InputMaybe<Scalars['String']>
  description?: InputMaybe<Scalars['String']>
  diagnosticSupported?: InputMaybe<Scalars['Boolean']>
  featured?: InputMaybe<Scalars['Boolean']>
  group?: InputMaybe<Scalars['String']>
  id?: InputMaybe<Scalars['ID']>
  imageFile?: InputMaybe<ToolImageFileInput>
  imageUrl?: InputMaybe<Scalars['String']>
  isBookmarked?: InputMaybe<Scalars['Boolean']>
  isConnected?: InputMaybe<Scalars['Boolean']>
  isRecommended?: InputMaybe<Scalars['Boolean']>
  isSelected?: InputMaybe<Scalars['Boolean']>
  keyWords?: InputMaybe<Array<Scalars['String']>>
  longDescription?: InputMaybe<Scalars['String']>
  options?: InputMaybe<ToolConnectionOptionsInput>
  pricingPageUrl?: InputMaybe<Scalars['String']>
  recommendedBy?: InputMaybe<Scalars['String']>
  relatedPlays?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  scopes?: InputMaybe<Array<Scalars['String']>>
  supportLevel?: InputMaybe<ToolSupportLevel>
  tags?: InputMaybe<Array<Scalars['String']>>
  tokenUrl?: InputMaybe<Scalars['String']>
  toolDisplayName?: InputMaybe<Scalars['String']>
  toolHelpText?: InputMaybe<Scalars['String']>
  toolName?: InputMaybe<Scalars['String']>
  toolType?: InputMaybe<ToolType>
  toolUrl?: InputMaybe<Scalars['String']>
  userToolsImageUrl?: InputMaybe<Scalars['String']>
  visible?: InputMaybe<Scalars['Boolean']>
}

export type UpdateUserAvailabilityInput = {
  availabilityHours?: InputMaybe<AvailabilityHoursInput>
  tenantId?: InputMaybe<Scalars['String']>
}

export type UpdateUserAvailabilityResponse = {
  __typename?: 'UpdateUserAvailabilityResponse'
  data?: Maybe<SetUserAvailabilityObj>
  error?: Maybe<Scalars['String']>
}

export type UpdateUserCalendarEvent = {
  __typename?: 'UpdateUserCalendarEvent'
  attendees?: Maybe<Array<Maybe<AttendeesType>>>
  comment?: Maybe<Scalars['String']>
  description?: Maybe<Scalars['String']>
  eventId?: Maybe<Scalars['String']>
  eventType?: Maybe<Scalars['String']>
  location?: Maybe<Scalars['String']>
  tackleId?: Maybe<Scalars['String']>
  teamMemberList?: Maybe<Array<Maybe<Scalars['String']>>>
  title?: Maybe<Scalars['String']>
  videoLinkDescription?: Maybe<Scalars['String']>
}

export type UpdateUserCalendarEventInput = {
  attendees?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  comment?: InputMaybe<Scalars['String']>
  description?: InputMaybe<Scalars['String']>
  eventId?: InputMaybe<Scalars['String']>
  eventType?: InputMaybe<Scalars['String']>
  location?: InputMaybe<Scalars['String']>
  tackleId: Scalars['String']
  teamMemberList?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  title?: InputMaybe<Scalars['String']>
  videoLinkDescription?: InputMaybe<Scalars['String']>
}

export type UpdateUserCalendarEventResponse = {
  __typename?: 'UpdateUserCalendarEventResponse'
  data?: Maybe<UpdateUserCalendarEvent>
  error?: Maybe<Scalars['String']>
}

export type UpdateUserNotificationsInput = {
  id?: InputMaybe<Scalars['String']>
  status?: InputMaybe<Scalars['String']>
  tenantId: Scalars['String']
  updateAll?: InputMaybe<Scalars['Boolean']>
}

export type UpdateUserPasswordInput = {
  password?: InputMaybe<Scalars['String']>
}

export type UpdateUserTaskInput = {
  assigneeId?: InputMaybe<Scalars['ID']>
  category?: InputMaybe<BusinessGoalCategory>
  estimatedEffortInMinutes?: InputMaybe<Scalars['Int']>
  expectedEndDate?: InputMaybe<Scalars['String']>
  feedbackMessage?: InputMaybe<Array<InputMaybe<FeedbackMessageInput>>>
  files?: InputMaybe<Array<UserFileInput>>
  goalId?: InputMaybe<Scalars['String']>
  hasBeenViewed?: InputMaybe<Scalars['Boolean']>
  howToDo?: InputMaybe<Scalars['String']>
  howToLinks?: InputMaybe<Array<InputMaybe<UserTaskHowToInput>>>
  instructionForTask?: InputMaybe<Scalars['String']>
  isCarryOver?: InputMaybe<Scalars['Boolean']>
  meetingId?: InputMaybe<Scalars['String']>
  name?: InputMaybe<Scalars['String']>
  order?: InputMaybe<Scalars['Int']>
  planId?: InputMaybe<Scalars['String']>
  playType?: InputMaybe<PlayType>
  session?: InputMaybe<Scalars['String']>
  startDate?: InputMaybe<Scalars['String']>
  status?: InputMaybe<UserTaskItemStatus>
  structuredSteps?: InputMaybe<Array<InputMaybe<UserTaskHowToStepInput>>>
  suggestedStatus?: InputMaybe<UserTaskSuggestedItemStatus>
  taskId: Scalars['ID']
  taskPriority?: InputMaybe<BusinessGoalPriority>
  tenantId: Scalars['ID']
  tutorialGenerationError?: InputMaybe<Scalars['String']>
  tutorialGenerationStartedAt?: InputMaybe<Scalars['AWSDateTime']>
  tutorialGenerationStatus?: InputMaybe<TutorialGenerationStatus>
  userId?: InputMaybe<Scalars['ID']>
  userInputFields?: InputMaybe<Array<UserInputFieldInput>>
}

export type User = {
  __typename?: 'User'
  avatar?: Maybe<Scalars['String']>
  email?: Maybe<Scalars['String']>
  firstName?: Maybe<Scalars['String']>
  id: Scalars['ID']
  jobTitle?: Maybe<Scalars['String']>
  lastName?: Maybe<Scalars['String']>
}

export type UserAnswer = {
  __typename?: 'UserAnswer'
  id?: Maybe<Scalars['String']>
  meta?: Maybe<Scalars['AWSJSON']>
  optionId?: Maybe<Scalars['String']>
  question?: Maybe<Scalars['AWSJSON']>
  value?: Maybe<Scalars['String']>
}

export type UserAssessmentResponse = {
  __typename?: 'UserAssessmentResponse'
  data?: Maybe<AssessmentResponse>
  error?: Maybe<Scalars['String']>
  message?: Maybe<Scalars['String']>
  success: Scalars['Boolean']
}

export type UserAvailability = {
  __typename?: 'UserAvailability'
  date: Scalars['String']
  slots: Array<SlotObj>
}

export type UserEngagementCriteria = {
  __typename?: 'UserEngagementCriteria'
  /**
   * Threshold for comment/chat frequency (in days ago).
   * e.g., 2 for "Adds a comment or chats within 2 days or fewer".
   * Lower value means higher engagement.
   */
  commentChatDaysThreshold?: Maybe<Scalars['Int']>
  /**
   * The minimum number of the above criteria that must be met to achieve this engagement level.
   * e.g., 2 for "achieves at least 2 of the following".
   */
  criteriaMetCount?: Maybe<Scalars['Int']>
  /**
   * Threshold for fumble count within the period.
   * e.g., 1 for "User achieves 1 fumble or less".
   * Lower value means higher engagement.
   */
  fumbleCountThreshold?: Maybe<Scalars['Int']>
  /**
   * Threshold for the last meeting date (in days ago).
   * e.g., 30 for "Last meeting in the past 30 days".
   */
  lastMeetingDaysThreshold?: Maybe<Scalars['Int']>
  /**
   * Threshold for the next meeting date (in days out).
   * e.g., 30 for "next meeting within the next 30 days".
   */
  nextMeetingDaysThreshold?: Maybe<Scalars['Int']>
  /**
   * Threshold for weekly task completion percentage.
   * e.g., 70 for "Completes 70+% of their tasks each week".
   */
  taskCompletionPercentageThreshold?: Maybe<Scalars['Int']>
  /**
   * Threshold for touchdown count within the period.
   * e.g., 2 for "User achieves 2+ TDs".
   */
  touchdownCountThreshold?: Maybe<Scalars['Int']>
}

export type UserEngagementCriteriaInput = {
  /**
   * Threshold for comment/chat frequency (in days ago).
   * e.g., 2 for "Adds a comment or chats within 2 days or fewer".
   * Lower value means higher engagement.
   */
  commentChatDaysThreshold?: InputMaybe<Scalars['Int']>
  /**
   * The minimum number of the above criteria that must be met to achieve this engagement level.
   * e.g., 2 for "achieves at least 2 of the following".
   */
  criteriaMetCount?: InputMaybe<Scalars['Int']>
  /**
   * Threshold for fumble count within the period.
   * e.g., 1 for "User achieves 1 fumble or less".
   * Lower value means higher engagement.
   */
  fumbleCountThreshold?: InputMaybe<Scalars['Int']>
  /**
   * Threshold for the last meeting date (in days ago).
   * e.g., 30 for "Last meeting in the past 30 days".
   */
  lastMeetingDaysThreshold?: InputMaybe<Scalars['Int']>
  /**
   * Threshold for the next meeting date (in days out).
   * e.g., 30 for "next meeting within the next 30 days".
   */
  nextMeetingDaysThreshold?: InputMaybe<Scalars['Int']>
  /**
   * Threshold for weekly task completion percentage.
   * e.g., 70 for "Completes 70+% of their tasks each week".
   */
  taskCompletionPercentageThreshold?: InputMaybe<Scalars['Int']>
  /**
   * Threshold for touchdown count within the period.
   * e.g., 2 for "User achieves 2+ TDs".
   */
  touchdownCountThreshold?: InputMaybe<Scalars['Int']>
}

export type UserFile = {
  __typename?: 'UserFile'
  createdAt?: Maybe<Scalars['String']>
  id?: Maybe<Scalars['ID']>
  name?: Maybe<Scalars['String']>
  size?: Maybe<Scalars['String']>
  tag?: Maybe<UserFileTag>
  tenantId?: Maybe<Scalars['String']>
  type?: Maybe<Scalars['String']>
  url?: Maybe<Scalars['String']>
  userId?: Maybe<Scalars['String']>
}

export type UserFileInput = {
  createdAt?: InputMaybe<Scalars['String']>
  id?: InputMaybe<Scalars['ID']>
  name?: InputMaybe<Scalars['String']>
  size?: InputMaybe<Scalars['String']>
  tag?: InputMaybe<UserFileTag>
  tenantId?: InputMaybe<Scalars['String']>
  type?: InputMaybe<Scalars['String']>
  url?: InputMaybe<Scalars['String']>
  userId?: InputMaybe<Scalars['String']>
}

export enum UserFileTag {
  BusinessPlan = 'BUSINESS_PLAN',
  Logo = 'LOGO',
}

export type UserInputField = {
  __typename?: 'UserInputField'
  conditionalField?: Maybe<ConditionalField>
  destinationResource?: Maybe<DestinationResource>
  fieldType: FieldType
  label: Scalars['String']
  multiple?: Maybe<Scalars['Boolean']>
  name: Scalars['String']
  options?: Maybe<Array<Option>>
  optionsSource?: Maybe<Scalars['String']>
  placeholder?: Maybe<Scalars['String']>
  validation?: Maybe<Validation>
  value?: Maybe<Scalars['String']>
}

export type UserInputFieldInput = {
  conditionalField?: InputMaybe<ConditionalFieldInput>
  destinationResource?: InputMaybe<DestinationResourceInput>
  fieldType: FieldType
  label: Scalars['String']
  multiple?: InputMaybe<Scalars['Boolean']>
  name: Scalars['String']
  options?: InputMaybe<Array<OptionInput>>
  optionsSource?: InputMaybe<Scalars['String']>
  placeholder?: InputMaybe<Scalars['String']>
  validation?: InputMaybe<ValidationInput>
  value?: InputMaybe<Scalars['String']>
}

export type UserIntegrations = {
  __typename?: 'UserIntegrations'
  cyclrToolId?: Maybe<Scalars['String']>
  group?: Maybe<Scalars['String']>
  id?: Maybe<Scalars['String']>
  imageUrl?: Maybe<Scalars['String']>
  isConnected?: Maybe<Scalars['Boolean']>
  isRecommended?: Maybe<Scalars['Boolean']>
  isSelected?: Maybe<Scalars['Boolean']>
  lastConnectedAt?: Maybe<Scalars['AWSDateTime']>
  name?: Maybe<Scalars['String']>
  recommendedBy?: Maybe<Scalars['String']>
  toolUrl?: Maybe<Scalars['String']>
  userToolsImageUrl?: Maybe<Scalars['String']>
}

export type UserIntegrationsResponse = {
  __typename?: 'UserIntegrationsResponse'
  data?: Maybe<Array<Maybe<ListAssessment>>>
  error?: Maybe<Scalars['String']>
  message?: Maybe<Scalars['String']>
  success: Scalars['Boolean']
}

export type UserMeetingData = {
  __typename?: 'UserMeetingData'
  advisorName?: Maybe<Scalars['String']>
  attendees?: Maybe<Array<CalendarEventAttendee>>
  createdAt?: Maybe<Scalars['String']>
  description?: Maybe<Scalars['String']>
  endTime?: Maybe<Scalars['String']>
  eventId?: Maybe<Scalars['String']>
  id?: Maybe<Scalars['String']>
  inviteeId?: Maybe<Scalars['String']>
  location?: Maybe<Scalars['String']>
  organizerName?: Maybe<Scalars['String']>
  ownerId?: Maybe<Scalars['String']>
  participantId?: Maybe<Scalars['String']>
  participantName?: Maybe<Scalars['String']>
  privateNotes?: Maybe<Array<Maybe<PrivateNote>>>
  role?: Maybe<Array<Maybe<Scalars['String']>>>
  startTime?: Maybe<Scalars['String']>
  status?: Maybe<Scalars['String']>
  tenantId?: Maybe<Scalars['String']>
  timezone?: Maybe<Scalars['String']>
  title?: Maybe<Scalars['String']>
  updatedAt?: Maybe<Scalars['String']>
  videoLinkDescription?: Maybe<Scalars['String']>
}

export type UserNotification = {
  __typename?: 'UserNotification'
  businessName?: Maybe<Scalars['String']>
  createdAt?: Maybe<Scalars['AWSDateTime']>
  firstName?: Maybe<Scalars['String']>
  id: Scalars['String']
  lastName?: Maybe<Scalars['String']>
  meta?: Maybe<Scalars['AWSJSON']>
  notificationType: Scalars['String']
  sender?: Maybe<Scalars['AWSJSON']>
  senderId?: Maybe<Scalars['String']>
  status?: Maybe<Scalars['String']>
  updatedAt?: Maybe<Scalars['AWSDateTime']>
}

export type UserNotificationData = {
  __typename?: 'UserNotificationData'
  lastEvaluatedKey?: Maybe<Scalars['String']>
  notifications?: Maybe<Array<Maybe<UserNotification>>>
  totalCount?: Maybe<Scalars['Int']>
}

export type UserProfile = {
  __typename?: 'UserProfile'
  activatedAt?: Maybe<Scalars['String']>
  algoliaSearchKey?: Maybe<Scalars['String']>
  attestationStatus?: Maybe<Scalars['String']>
  avatar?: Maybe<Scalars['String']>
  bio?: Maybe<Scalars['String']>
  calendarEventViewPreference?: Maybe<CalendarEventViewPreference>
  calendlyEventsUrl?: Maybe<Scalars['String']>
  companyAdvisor?: Maybe<Scalars['String']>
  companyEmployees?: Maybe<Scalars['Int']>
  country?: Maybe<Scalars['String']>
  createdAt: Scalars['AWSDateTime']
  defaultVideoLinkDescription?: Maybe<Scalars['String']>
  education?: Maybe<Scalars['String']>
  email: Scalars['AWSEmail']
  employmentType?: Maybe<Scalars['String']>
  expertise?: Maybe<Scalars['String']>
  firstName?: Maybe<Scalars['String']>
  firstSigninDate?: Maybe<Scalars['String']>
  googleCalendarWebhookMetaData?: Maybe<GoogleCalendarWebhookMetaData>
  id: Scalars['ID']
  interimTimezone?: Maybe<Scalars['String']>
  isConsentGivenToAdvisor?: Maybe<Scalars['Boolean']>
  isJoinedBetaProgram?: Maybe<Scalars['Boolean']>
  isNewUser?: Maybe<Scalars['Boolean']>
  isSmsEnabled?: Maybe<Scalars['Boolean']>
  jobTitle?: Maybe<Scalars['String']>
  lastName?: Maybe<Scalars['String']>
  lastNewInsightsPopupShownAt?: Maybe<Scalars['String']>
  lastNewInsightsViewedAt?: Maybe<Scalars['String']>
  linkedinProfile?: Maybe<Scalars['String']>
  mobileContactNumber?: Maybe<Scalars['AWSPhone']>
  name?: Maybe<Scalars['String']>
  onboardingStatus?: Maybe<OnboardingStatus>
  organizationName?: Maybe<Scalars['String']>
  ownerExperience?: Maybe<Scalars['String']>
  quoteViewDate?: Maybe<Scalars['String']>
  roles?: Maybe<Array<Maybe<Scalars['String']>>>
  schedulingUrl?: Maybe<Scalars['String']>
  status?: Maybe<Scalars['String']>
  streamAccessToken?: Maybe<Scalars['String']>
  submissionEndDay?: Maybe<Scalars['Int']>
  submissionReminderDay?: Maybe<Scalars['Int']>
  submissionReportDay?: Maybe<Scalars['Int']>
  submissionStartDay?: Maybe<Scalars['Int']>
  tempPassword?: Maybe<Scalars['String']>
  tenantId?: Maybe<Array<Scalars['String']>>
  timezone?: Maybe<Scalars['String']>
  updatedAt: Scalars['AWSDateTime']
  websiteURL?: Maybe<Scalars['String']>
  workAddress?: Maybe<Scalars['String']>
  workExperience?: Maybe<Scalars['String']>
  workLocation?: Maybe<Scalars['String']>
  workPhoneNumber?: Maybe<Scalars['String']>
  yearsInBusiness?: Maybe<Scalars['String']>
}

export type UserRecommendationsResponse = {
  __typename?: 'UserRecommendationsResponse'
  data?: Maybe<Scalars['AWSJSON']>
  error?: Maybe<Scalars['String']>
  message?: Maybe<Scalars['String']>
  success: Scalars['Boolean']
}

export type UserResponse = {
  __typename?: 'UserResponse'
  data?: Maybe<UserAnswer>
  error?: Maybe<Scalars['String']>
  message?: Maybe<Scalars['String']>
  success: Scalars['Boolean']
}

export type UserSummariesInput = {
  dateRange: UserSummaryDateRange
  lastEvaluatedKey?: InputMaybe<Scalars['ID']>
  refreshUserSummaries?: InputMaybe<Scalars['Boolean']>
  sortField?: InputMaybe<UserSummarySortField>
  sortOrder?: InputMaybe<SortOrder>
  tenantId?: InputMaybe<Scalars['ID']>
}

export type UserSummary = {
  __typename?: 'UserSummary'
  email?: Maybe<Scalars['String']>
  firstName?: Maybe<Scalars['String']>
  fumbleCount?: Maybe<Scalars['Int']>
  lastLoginDate?: Maybe<Scalars['String']>
  lastName?: Maybe<Scalars['String']>
  nextMeetingDate?: Maybe<Scalars['String']>
  phoneNumber?: Maybe<Scalars['String']>
  status?: Maybe<Scalars['String']>
  touchdownCount?: Maybe<Scalars['Int']>
  userId?: Maybe<Scalars['ID']>
}

export enum UserSummaryDateRange {
  MonthToDate = 'MONTH_TO_DATE',
  YearToDate = 'YEAR_TO_DATE',
}

export type UserSummaryResponse = {
  __typename?: 'UserSummaryResponse'
  items?: Maybe<Array<UserSummary>>
  lastEvaluatedKey?: Maybe<Scalars['ID']>
  totalRecordsCount?: Maybe<Scalars['Int']>
}

export enum UserSummarySortField {
  FirstName = 'FIRST_NAME',
  FumbleCount = 'FUMBLE_COUNT',
  LastLoginDate = 'LAST_LOGIN_DATE',
  LastName = 'LAST_NAME',
  NextMeetingDate = 'NEXT_MEETING_DATE',
  Status = 'STATUS',
  TouchdownCount = 'TOUCHDOWN_COUNT',
}

export type UserTask = {
  __typename?: 'UserTask'
  assigneeId?: Maybe<Scalars['ID']>
  businessAdvisorsData?: Maybe<Array<Maybe<BusinessAdvisorsData>>>
  businessAvatar?: Maybe<Scalars['String']>
  businessHoursSpentPerDay?: Maybe<Scalars['Int']>
  businessLogo?: Maybe<Scalars['String']>
  businessName?: Maybe<Scalars['String']>
  category?: Maybe<BusinessGoalCategory>
  comments?: Maybe<Array<TaskComment>>
  createdBy?: Maybe<Scalars['String']>
  createdById?: Maybe<Scalars['ID']>
  description?: Maybe<Scalars['String']>
  estimatedEffortInMinutes?: Maybe<Scalars['Int']>
  expectedEndDate?: Maybe<Scalars['String']>
  feedbackMessage?: Maybe<Array<Maybe<FeedbackMessage>>>
  files?: Maybe<Array<UserFile>>
  filter?: Maybe<UserTasksFilter>
  goalEndDate?: Maybe<Scalars['String']>
  goalId?: Maybe<Scalars['String']>
  goalName?: Maybe<Scalars['String']>
  hasBeenViewed?: Maybe<Scalars['Boolean']>
  howToDo?: Maybe<Scalars['String']>
  howToLinks?: Maybe<Array<Maybe<UserTaskHowTo>>>
  instructionForTask?: Maybe<Scalars['String']>
  isCarryOver?: Maybe<Scalars['Boolean']>
  isOverDue?: Maybe<Scalars['Boolean']>
  kpis?: Maybe<Scalars['String']>
  meetingId?: Maybe<Scalars['String']>
  milestoneId?: Maybe<Scalars['ID']>
  name?: Maybe<Scalars['String']>
  order?: Maybe<Scalars['Int']>
  planExpectedEndDate?: Maybe<Scalars['String']>
  planId?: Maybe<Scalars['ID']>
  planName?: Maybe<Scalars['String']>
  planStartDate?: Maybe<Scalars['String']>
  playType?: Maybe<PlayType>
  resources?: Maybe<Scalars['String']>
  role?: Maybe<Scalars['String']>
  session?: Maybe<Scalars['String']>
  source?: Maybe<UserTaskSource>
  startDate?: Maybe<Scalars['String']>
  status?: Maybe<UserTaskItemStatus>
  structuredSteps?: Maybe<Array<Maybe<UserTaskHowToStep>>>
  suggestedStatus?: Maybe<UserTaskSuggestedItemStatus>
  taskCompletion?: Maybe<TaskCompletionSchema>
  taskId?: Maybe<Scalars['ID']>
  taskPriority?: Maybe<BusinessGoalPriority>
  tenantId?: Maybe<Scalars['ID']>
  timeline?: Maybe<Scalars['String']>
  tool?: Maybe<Scalars['String']>
  tutorialGenerationError?: Maybe<Scalars['String']>
  tutorialGenerationStartedAt?: Maybe<Scalars['AWSDateTime']>
  tutorialGenerationStatus?: Maybe<TutorialGenerationStatus>
  userId?: Maybe<Scalars['ID']>
  userInputFields?: Maybe<Array<UserInputField>>
  why?: Maybe<Scalars['String']>
}

export type UserTaskHowTo = {
  __typename?: 'UserTaskHowTo'
  howToId: Scalars['ID']
  steps?: Maybe<Scalars['String']>
  title?: Maybe<Scalars['String']>
  url?: Maybe<Scalars['String']>
}

export type UserTaskHowToInput = {
  howToId: Scalars['ID']
  steps?: InputMaybe<Scalars['String']>
  title?: InputMaybe<Scalars['String']>
  url?: InputMaybe<Scalars['String']>
}

export type UserTaskHowToResponse = {
  __typename?: 'UserTaskHowToResponse'
  steps?: Maybe<Scalars['String']>
  structuredSteps?: Maybe<Array<Maybe<UserTaskHowToStep>>>
  text: Scalars['String']
  videoLinks: Array<Maybe<Scalars['String']>>
}

export type UserTaskHowToStep = {
  __typename?: 'UserTaskHowToStep'
  description: Scalars['String']
  stepNumber: Scalars['Int']
  title: Scalars['String']
  videos?: Maybe<Array<Maybe<UserTaskHowToVideo>>>
}

export type UserTaskHowToStepInput = {
  description: Scalars['String']
  stepNumber: Scalars['Int']
  title: Scalars['String']
  videos?: InputMaybe<Array<InputMaybe<UserTaskHowToVideoInput>>>
}

export type UserTaskHowToVideo = {
  __typename?: 'UserTaskHowToVideo'
  relevance?: Maybe<Scalars['String']>
  stepsCovered?: Maybe<Array<Maybe<Scalars['Int']>>>
  title: Scalars['String']
  url: Scalars['String']
}

export type UserTaskHowToVideoInput = {
  relevance?: InputMaybe<Scalars['String']>
  stepsCovered?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>
  title: Scalars['String']
  url: Scalars['String']
}

export type UserTaskInput = {
  estimatedEffortInMinutes: Scalars['Int']
  expectedEndDate: Scalars['String']
  howToDo?: InputMaybe<Scalars['String']>
  howToLinks?: InputMaybe<Array<InputMaybe<UserTaskHowToInput>>>
  instructionForTask?: InputMaybe<Scalars['String']>
  kpis?: InputMaybe<Scalars['String']>
  milestoneId?: InputMaybe<Scalars['ID']>
  name: Scalars['String']
  order?: InputMaybe<Scalars['Int']>
  planId?: InputMaybe<Scalars['ID']>
  resources?: InputMaybe<Scalars['String']>
  role?: InputMaybe<Scalars['String']>
  source?: InputMaybe<UserTaskSource>
  startDate: Scalars['String']
  status?: InputMaybe<UserTaskItemStatus>
  taskId: Scalars['ID']
  tenantId?: InputMaybe<Scalars['ID']>
  timeline?: InputMaybe<Scalars['String']>
  tool?: InputMaybe<Scalars['String']>
  userId?: InputMaybe<Scalars['ID']>
  why?: InputMaybe<Scalars['String']>
}

export enum UserTaskItemFilterDateRange {
  OneMonth = 'ONE_MONTH',
  OneWeek = 'ONE_WEEK',
  Today = 'TODAY',
}

export enum UserTaskItemStatus {
  Archived = 'ARCHIVED',
  Blocked = 'BLOCKED',
  Creating = 'CREATING',
  Deleted = 'DELETED',
  Done = 'DONE',
  Draft = 'DRAFT',
  InProgress = 'IN_PROGRESS',
  Paused = 'PAUSED',
  Pending = 'PENDING',
  Todo = 'TODO',
}

export enum UserTaskQuickFilter {
  AllGoalsTasks = 'ALL_GOALS_TASKS',
  AllTasks = 'ALL_TASKS',
  NoProjectAssigned = 'NO_PROJECT_ASSIGNED',
}

export enum UserTaskSource {
  Assessment = 'ASSESSMENT',
  General = 'GENERAL',
  Goal = 'GOAL',
  Insight = 'INSIGHT',
  Meeting = 'MEETING',
  Play = 'PLAY',
}

export enum UserTaskSuggestedItemStatus {
  Accepted = 'ACCEPTED',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
}

export type UserTasksFilter = {
  __typename?: 'UserTasksFilter'
  assigneeId?: Maybe<Array<Maybe<Scalars['String']>>>
  category?: Maybe<Array<Maybe<BusinessGoalCategory>>>
  dateRange?: Maybe<BusinessGoalDateFilter>
  milestoneId?: Maybe<Scalars['String']>
  planId?: Maybe<Scalars['String']>
  quickFilter?: Maybe<UserTaskQuickFilter>
  source?: Maybe<UserTaskSource>
  status?: Maybe<UserTaskItemStatus>
  taskPriority?: Maybe<Array<Maybe<BusinessGoalPriority>>>
}

export type UserTasksFilterInput = {
  assigneeId?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  businessName?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  category?: InputMaybe<Array<InputMaybe<BusinessGoalCategory>>>
  dateRange?: InputMaybe<BusinessGoalDateFilter>
  goalId?: InputMaybe<Array<InputMaybe<Scalars['String']>>>
  milestoneId?: InputMaybe<Scalars['String']>
  planId?: InputMaybe<Scalars['String']>
  quickFilter?: InputMaybe<UserTaskQuickFilter>
  source?: InputMaybe<UserTaskSource>
  status?: InputMaybe<UserTaskItemStatus>
  taskPriority?: InputMaybe<Array<InputMaybe<BusinessGoalPriority>>>
}

export type Validation = {
  __typename?: 'Validation'
  dateMax?: Maybe<DateValidationRule>
  dateMin?: Maybe<DateValidationRule>
  max?: Maybe<ValidationRule>
  min?: Maybe<ValidationRule>
  pattern?: Maybe<ValidationRule>
  required?: Maybe<ValidationRequired>
  type?: Maybe<ValidationTypes>
}

export type ValidationInput = {
  dateMax?: InputMaybe<DateValidationRuleInput>
  dateMin?: InputMaybe<DateValidationRuleInput>
  max?: InputMaybe<ValidationRuleInput>
  min?: InputMaybe<ValidationRuleInput>
  pattern?: InputMaybe<ValidationRuleInput>
  required?: InputMaybe<ValidationRequiredInput>
  type?: InputMaybe<ValidationTypes>
}

export type ValidationRequired = {
  __typename?: 'ValidationRequired'
  message?: Maybe<Scalars['String']>
  value?: Maybe<Scalars['Boolean']>
}

export type ValidationRequiredInput = {
  message?: InputMaybe<Scalars['String']>
  value?: InputMaybe<Scalars['Boolean']>
}

export type ValidationRule = {
  __typename?: 'ValidationRule'
  message: Scalars['String']
  value?: Maybe<Scalars['String']>
}

export type ValidationRuleInput = {
  message: Scalars['String']
  value?: InputMaybe<Scalars['String']>
}

export enum ValidationTypes {
  Date = 'DATE',
  Float = 'FLOAT',
  Number = 'NUMBER',
  String = 'STRING',
}

export type Attendee = {
  __typename?: 'attendee'
  email: Scalars['String']
  responseStatus?: Maybe<Scalars['String']>
}

export type AttendeesInterface = {
  email: Scalars['String']
  organizer?: InputMaybe<Scalars['Boolean']>
  responseStatus?: InputMaybe<Scalars['String']>
  self?: InputMaybe<Scalars['Boolean']>
}

export type BusinessAdvisor = {
  __typename?: 'businessAdvisor'
  advisor?: Maybe<Scalars['String']>
  businessId?: Maybe<Scalars['String']>
  createdAt?: Maybe<Scalars['String']>
  id?: Maybe<Scalars['String']>
  tenantId?: Maybe<Scalars['String']>
  updatedAt?: Maybe<Scalars['String']>
  userId?: Maybe<Scalars['String']>
}

export type CancelOutlookEventInput = {
  eventId: Scalars['String']
}

export type DeleteGoogleCalendarEventInput = {
  eventId?: InputMaybe<Scalars['String']>
  id: Scalars['String']
  tenantId?: InputMaybe<Scalars['String']>
}

export type GetAllInvitedUsersInput = {
  tenantId: Scalars['String']
  userId: Scalars['String']
}

export type GetAllTagUsersInput = {
  tenantId: Scalars['String']
  userId: Scalars['String']
}

export type GetOwnerBusinessDataInput = {
  endTime: Scalars['String']
  startTime: Scalars['String']
}

export type TaskPrerequisites = {
  __typename?: 'taskPrerequisites'
  assessments?: Maybe<Array<Scalars['String']>>
  plays?: Maybe<Array<Scalars['String']>>
}

export type TimeObjInterface = {
  dateTime?: InputMaybe<Scalars['String']>
  timeZone?: InputMaybe<Scalars['String']>
}

export type UpdateGoogleCalendarEventInput = {
  attendees: Array<InputMaybe<AttendeesInterface>>
  description?: InputMaybe<Scalars['String']>
  end: TimeObjInterface
  eventId?: InputMaybe<Scalars['String']>
  id: Scalars['String']
  start: TimeObjInterface
  tenantId?: InputMaybe<Scalars['String']>
}

export type UserMeeting = {
  __typename?: 'userMeeting'
  advisorId: Scalars['String']
  attendees: Array<Maybe<Attendee>>
  createdAt?: Maybe<Scalars['String']>
  endTime: Scalars['String']
  eventId: Scalars['String']
  id: Scalars['String']
  inviteeId?: Maybe<Scalars['String']>
  ownerId: Scalars['String']
  role?: Maybe<Array<Maybe<Scalars['String']>>>
  startTime: Scalars['String']
  status?: Maybe<Scalars['String']>
  tenantId: Scalars['String']
  timezone?: Maybe<Scalars['String']>
  title?: Maybe<Scalars['String']>
  updatedAt?: Maybe<Scalars['String']>
}

export type AssessmentResponseFieldsFragment = {
  __typename?: 'AssessmentResponse'
  id?: string | null | undefined
  currentStage?: string | null | undefined
  playStage?: string | null | undefined
  type?: string | null | undefined
  userId?: string | null | undefined
  createdAt?: string | null | undefined
  updatedAt?: string | null | undefined
  assessmentResponse?:
    | Array<{
        __typename?: 'AssessmentResponseOutput'
        next?: string | null | undefined
        previous?: Array<string> | null | undefined
        id?: string | null | undefined
        value?: string | null | undefined
        label?: string | null | undefined
        playResponse?: string | null | undefined
        isIndustry?: boolean | null | undefined
        isSubIndustry?: boolean | null | undefined
        isTopGoal?: boolean | null | undefined
        optionType?: string | null | undefined
        submittedAt?: string | null | undefined
        showInReview?: boolean | null | undefined
        questionLabel?: string | null | undefined
        recommendations?:
          | {
              __typename?: 'Recommendations'
              assessments?: Array<string> | null | undefined
              plays?: Array<string> | null | undefined
              assessmentRecommendedAt?: string | null | undefined
              playRecommendedAt?: string | null | undefined
            }
          | null
          | undefined
      }>
    | null
    | undefined
}

export type AssessmentQuestionFieldsFragment = {
  __typename?: 'Assessment'
  id: string
  tenantId?: number | null | undefined
  previous?: string | null | undefined
  assessmentType?: string | null | undefined
  meta?: string | null | undefined
  content?: string | null | undefined
  optionType?: string | null | undefined
  options?: string | null | undefined
  createdAt?: string | null | undefined
  updatedAt?: string | null | undefined
  isVisible?: boolean | null | undefined
}

export type GetAssessmentResponseByQuestionFieldsFragment = {
  __typename?: 'UserResponse'
  success: boolean
  message?: string | null | undefined
  error?: string | null | undefined
  data?:
    | {
        __typename?: 'UserAnswer'
        id?: string | null | undefined
        value?: string | null | undefined
        question?: string | null | undefined
        meta?: string | null | undefined
      }
    | null
    | undefined
}

export type UserAssessmentResponseFieldsFragment = {
  __typename?: 'UserAssessmentResponse'
  success: boolean
  message?: string | null | undefined
  error?: string | null | undefined
  data?:
    | {
        __typename?: 'AssessmentResponse'
        id?: string | null | undefined
        currentStage?: string | null | undefined
        playStage?: string | null | undefined
        type?: string | null | undefined
        userId?: string | null | undefined
        totalItems?: number | null | undefined
        totalAttemptedItems?: number | null | undefined
        createdAt?: string | null | undefined
        updatedAt?: string | null | undefined
        completedAt?: string | null | undefined
        assessmentResponse?:
          | Array<{
              __typename?: 'AssessmentResponseOutput'
              next?: string | null | undefined
              previous?: Array<string> | null | undefined
              id?: string | null | undefined
              value?: string | null | undefined
              label?: string | null | undefined
              playResponse?: string | null | undefined
              isIndustry?: boolean | null | undefined
              isSubIndustry?: boolean | null | undefined
              isTopGoal?: boolean | null | undefined
              optionType?: string | null | undefined
              submittedAt?: string | null | undefined
              showInReview?: boolean | null | undefined
              questionLabel?: string | null | undefined
              recommendations?:
                | {
                    __typename?: 'Recommendations'
                    assessments?: Array<string> | null | undefined
                    plays?: Array<string> | null | undefined
                    assessmentRecommendedAt?: string | null | undefined
                    playRecommendedAt?: string | null | undefined
                  }
                | null
                | undefined
            }>
          | null
          | undefined
      }
    | null
    | undefined
}

export type GetUserRecommendationsFieldsFragment = {
  __typename?: 'UserRecommendationsResponse'
  success: boolean
  message?: string | null | undefined
  data?: string | null | undefined
  error?: string | null | undefined
}

export type GetUserAssessmentResponseQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['String']>
  type?: InputMaybe<Scalars['String']>
}>

export type GetUserAssessmentResponseQuery = {
  __typename?: 'Query'
  getUserAssessmentResponse?:
    | {
        __typename?: 'UserAssessmentResponse'
        success: boolean
        message?: string | null | undefined
        error?: string | null | undefined
        data?:
          | {
              __typename?: 'AssessmentResponse'
              id?: string | null | undefined
              currentStage?: string | null | undefined
              playStage?: string | null | undefined
              type?: string | null | undefined
              userId?: string | null | undefined
              totalItems?: number | null | undefined
              totalAttemptedItems?: number | null | undefined
              createdAt?: string | null | undefined
              updatedAt?: string | null | undefined
              completedAt?: string | null | undefined
              assessmentResponse?:
                | Array<{
                    __typename?: 'AssessmentResponseOutput'
                    next?: string | null | undefined
                    previous?: Array<string> | null | undefined
                    id?: string | null | undefined
                    value?: string | null | undefined
                    label?: string | null | undefined
                    playResponse?: string | null | undefined
                    isIndustry?: boolean | null | undefined
                    isSubIndustry?: boolean | null | undefined
                    isTopGoal?: boolean | null | undefined
                    optionType?: string | null | undefined
                    submittedAt?: string | null | undefined
                    showInReview?: boolean | null | undefined
                    questionLabel?: string | null | undefined
                    recommendations?:
                      | {
                          __typename?: 'Recommendations'
                          assessments?: Array<string> | null | undefined
                          plays?: Array<string> | null | undefined
                          assessmentRecommendedAt?: string | null | undefined
                          playRecommendedAt?: string | null | undefined
                        }
                      | null
                      | undefined
                  }>
                | null
                | undefined
            }
          | null
          | undefined
      }
    | null
    | undefined
}

export type GetAssessmentsQueryVariables = Exact<{
  type?: InputMaybe<Scalars['String']>
}>

export type GetAssessmentsQuery = {
  __typename?: 'Query'
  getAssessments?:
    | Array<
        | {
            __typename?: 'Assessment'
            id: string
            tenantId?: number | null | undefined
            previous?: string | null | undefined
            assessmentType?: string | null | undefined
            meta?: string | null | undefined
            content?: string | null | undefined
            optionType?: string | null | undefined
            options?: string | null | undefined
            createdAt?: string | null | undefined
            updatedAt?: string | null | undefined
            isVisible?: boolean | null | undefined
          }
        | null
        | undefined
      >
    | null
    | undefined
}

export type SaveAssessmentResponseMutationVariables = Exact<{
  input: SaveAssessmentResponseInput
}>

export type SaveAssessmentResponseMutation = {
  __typename?: 'Mutation'
  saveAssessmentResponse?:
    | {
        __typename?: 'AssessmentResponse'
        id?: string | null | undefined
        currentStage?: string | null | undefined
        playStage?: string | null | undefined
        type?: string | null | undefined
        userId?: string | null | undefined
        createdAt?: string | null | undefined
        updatedAt?: string | null | undefined
        assessmentResponse?:
          | Array<{
              __typename?: 'AssessmentResponseOutput'
              next?: string | null | undefined
              previous?: Array<string> | null | undefined
              id?: string | null | undefined
              value?: string | null | undefined
              label?: string | null | undefined
              playResponse?: string | null | undefined
              isIndustry?: boolean | null | undefined
              isSubIndustry?: boolean | null | undefined
              isTopGoal?: boolean | null | undefined
              optionType?: string | null | undefined
              submittedAt?: string | null | undefined
              showInReview?: boolean | null | undefined
              questionLabel?: string | null | undefined
              recommendations?:
                | {
                    __typename?: 'Recommendations'
                    assessments?: Array<string> | null | undefined
                    plays?: Array<string> | null | undefined
                    assessmentRecommendedAt?: string | null | undefined
                    playRecommendedAt?: string | null | undefined
                  }
                | null
                | undefined
            }>
          | null
          | undefined
      }
    | null
    | undefined
}

export type GetAssessmentResponseByQuestionQueryVariables = Exact<{
  type?: InputMaybe<Scalars['String']>
  question?: InputMaybe<Scalars['String']>
  userId?: InputMaybe<Scalars['String']>
}>

export type GetAssessmentResponseByQuestionQuery = {
  __typename?: 'Query'
  getAssessmentResponseByQuestion?:
    | {
        __typename?: 'UserResponse'
        success: boolean
        message?: string | null | undefined
        error?: string | null | undefined
        data?:
          | {
              __typename?: 'UserAnswer'
              id?: string | null | undefined
              value?: string | null | undefined
              question?: string | null | undefined
              meta?: string | null | undefined
            }
          | null
          | undefined
      }
    | null
    | undefined
}

export type GetUserRecommendationsQueryVariables = Exact<{
  input: GetUserRecommendationsInput
}>

export type GetUserRecommendationsQuery = {
  __typename?: 'Query'
  getUserRecommendations?:
    | {
        __typename?: 'UserRecommendationsResponse'
        success: boolean
        message?: string | null | undefined
        data?: string | null | undefined
        error?: string | null | undefined
      }
    | null
    | undefined
}

export type ListAssessmentsFieldsFragment = {
  __typename?: 'ListAssessmentResponse'
  success: boolean
  message?: string | null | undefined
  error?: string | null | undefined
  data?:
    | Array<
        | {
            __typename?: 'ListAssessment'
            type?: string | null | undefined
            order?: string | null | undefined
            isCompleted?: boolean | null | undefined
            isLocked?: boolean | null | undefined
            inProgress?: boolean | null | undefined
          }
        | null
        | undefined
      >
    | null
    | undefined
}

export type OptionsFieldsFragment = {
  __typename?: 'GetOptionsResponse'
  error?: string | null | undefined
  data?:
    | Array<
        | {
            __typename?: 'Options'
            id?: string | null | undefined
            type?: string | null | undefined
            name?: string | null | undefined
            order?: string | null | undefined
            dependencies?: string | null | undefined
            toolTipText?: string | null | undefined
            label?: string | null | undefined
            infoText?: string | null | undefined
            category?: string | null | undefined
            categoryType?: string | null | undefined
            isNew?: boolean | null | undefined
          }
        | null
        | undefined
      >
    | null
    | undefined
}

export type ListAssessmentsQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['String']>
  tenantId: Scalars['String']
}>

export type ListAssessmentsQuery = {
  __typename?: 'Query'
  listAssessments?:
    | {
        __typename?: 'ListAssessmentResponse'
        success: boolean
        message?: string | null | undefined
        error?: string | null | undefined
        data?:
          | Array<
              | {
                  __typename?: 'ListAssessment'
                  type?: string | null | undefined
                  order?: string | null | undefined
                  isCompleted?: boolean | null | undefined
                  isLocked?: boolean | null | undefined
                  inProgress?: boolean | null | undefined
                }
              | null
              | undefined
            >
          | null
          | undefined
      }
    | null
    | undefined
}

export type GetOptionsQueryVariables = Exact<{
  optionTypes: Array<Scalars['String']> | Scalars['String']
}>

export type GetOptionsQuery = {
  __typename?: 'Query'
  getOptions?:
    | {
        __typename?: 'GetOptionsResponse'
        error?: string | null | undefined
        data?:
          | Array<
              | {
                  __typename?: 'Options'
                  id?: string | null | undefined
                  type?: string | null | undefined
                  name?: string | null | undefined
                  order?: string | null | undefined
                  dependencies?: string | null | undefined
                  toolTipText?: string | null | undefined
                  label?: string | null | undefined
                  infoText?: string | null | undefined
                  category?: string | null | undefined
                  categoryType?: string | null | undefined
                  isNew?: boolean | null | undefined
                }
              | null
              | undefined
            >
          | null
          | undefined
      }
    | null
    | undefined
}

export type GetAttestationSummaryFieldsFragment = {
  __typename?: 'AttestationSummary'
  tenantId?: string | null | undefined
  unsignedCount?: number | null | undefined
  signedCount?: number | null | undefined
  submissionStartDate?: string | null | undefined
  submissionEndDate?: string | null | undefined
  submissionReminderDate?: string | null | undefined
  submissionReportDate?: string | null | undefined
  newAggregatedReport?:
    | {
        __typename?: 'Attestation'
        month?: string | null | undefined
        year?: string | null | undefined
        contractors?: string | null | undefined
        businessBankAccount?: string | null | undefined
        jobsCreated?: string | null | undefined
        volunteers?: string | null | undefined
        partTimeEmployees?: string | null | undefined
        fullTimeEmployees?: string | null | undefined
        gender?: string | null | undefined
        race?: string | null | undefined
        education?: string | null | undefined
        wages?: string | null | undefined
        revenue?: string | null | undefined
        debtFinancing?: string | null | undefined
        financialGrowth?: string | null | undefined
        newCustomer?: string | null | undefined
        productSale?: string | null | undefined
        serviceSale?: string | null | undefined
        targetAudience?: string | null | undefined
        physicalLocation?: string | null | undefined
        businessName?: string | null | undefined
        name?: string | null | undefined
        signedDocumentUrl?: string | null | undefined
        error?: string | null | undefined
        createdAt?: string | null | undefined
        downloadUrl?: string | null | undefined
        fileName?: string | null | undefined
      }
    | null
    | undefined
  aggregationReportHistory?:
    | Array<
        | {
            __typename?: 'Attestation'
            month?: string | null | undefined
            year?: string | null | undefined
            contractors?: string | null | undefined
            businessBankAccount?: string | null | undefined
            jobsCreated?: string | null | undefined
            volunteers?: string | null | undefined
            partTimeEmployees?: string | null | undefined
            fullTimeEmployees?: string | null | undefined
            gender?: string | null | undefined
            race?: string | null | undefined
            education?: string | null | undefined
            wages?: string | null | undefined
            revenue?: string | null | undefined
            debtFinancing?: string | null | undefined
            financialGrowth?: string | null | undefined
            newCustomer?: string | null | undefined
            productSale?: string | null | undefined
            serviceSale?: string | null | undefined
            targetAudience?: string | null | undefined
            physicalLocation?: string | null | undefined
            businessName?: string | null | undefined
            name?: string | null | undefined
            signedDocumentUrl?: string | null | undefined
            error?: string | null | undefined
            createdAt?: string | null | undefined
            downloadUrl?: string | null | undefined
            fileName?: string | null | undefined
          }
        | null
        | undefined
      >
    | null
    | undefined
}

export type GetAttestationSummaryQueryVariables = Exact<{
  input?: InputMaybe<GetAttestationSummaryInput>
}>

export type GetAttestationSummaryQuery = {
  __typename?: 'Query'
  getAttestationSummary?:
    | {
        __typename?: 'AttestationSummary'
        tenantId?: string | null | undefined
        unsignedCount?: number | null | undefined
        signedCount?: number | null | undefined
        submissionStartDate?: string | null | undefined
        submissionEndDate?: string | null | undefined
        submissionReminderDate?: string | null | undefined
        submissionReportDate?: string | null | undefined
        newAggregatedReport?:
          | {
              __typename?: 'Attestation'
              month?: string | null | undefined
              year?: string | null | undefined
              contractors?: string | null | undefined
              businessBankAccount?: string | null | undefined
              jobsCreated?: string | null | undefined
              volunteers?: string | null | undefined
              partTimeEmployees?: string | null | undefined
              fullTimeEmployees?: string | null | undefined
              gender?: string | null | undefined
              race?: string | null | undefined
              education?: string | null | undefined
              wages?: string | null | undefined
              revenue?: string | null | undefined
              debtFinancing?: string | null | undefined
              financialGrowth?: string | null | undefined
              newCustomer?: string | null | undefined
              productSale?: string | null | undefined
              serviceSale?: string | null | undefined
              targetAudience?: string | null | undefined
              physicalLocation?: string | null | undefined
              businessName?: string | null | undefined
              name?: string | null | undefined
              signedDocumentUrl?: string | null | undefined
              error?: string | null | undefined
              createdAt?: string | null | undefined
              downloadUrl?: string | null | undefined
              fileName?: string | null | undefined
            }
          | null
          | undefined
        aggregationReportHistory?:
          | Array<
              | {
                  __typename?: 'Attestation'
                  month?: string | null | undefined
                  year?: string | null | undefined
                  contractors?: string | null | undefined
                  businessBankAccount?: string | null | undefined
                  jobsCreated?: string | null | undefined
                  volunteers?: string | null | undefined
                  partTimeEmployees?: string | null | undefined
                  fullTimeEmployees?: string | null | undefined
                  gender?: string | null | undefined
                  race?: string | null | undefined
                  education?: string | null | undefined
                  wages?: string | null | undefined
                  revenue?: string | null | undefined
                  debtFinancing?: string | null | undefined
                  financialGrowth?: string | null | undefined
                  newCustomer?: string | null | undefined
                  productSale?: string | null | undefined
                  serviceSale?: string | null | undefined
                  targetAudience?: string | null | undefined
                  physicalLocation?: string | null | undefined
                  businessName?: string | null | undefined
                  name?: string | null | undefined
                  signedDocumentUrl?: string | null | undefined
                  error?: string | null | undefined
                  createdAt?: string | null | undefined
                  downloadUrl?: string | null | undefined
                  fileName?: string | null | undefined
                }
              | null
              | undefined
            >
          | null
          | undefined
      }
    | null
    | undefined
}

export type BusinessSupportOrganizationFieldsFragment = {
  __typename?: 'BusinessSupportOrganization'
  id: string
  adminId: string
  name: string
  logoUrl?: string | null | undefined
  licenseCount?: number | null | undefined
  licensesUsed?: number | null | undefined
  adminCount?: number | null | undefined
  advisorCount?: number | null | undefined
  intakeFormCompleted?: boolean | null | undefined
  terminology?: Array<{ __typename?: 'Term'; term: string; replacement: string }> | null | undefined
  mtdHighEngagementCriteria?:
    | {
        __typename?: 'UserEngagementCriteria'
        lastMeetingDaysThreshold?: number | null | undefined
        nextMeetingDaysThreshold?: number | null | undefined
        commentChatDaysThreshold?: number | null | undefined
        taskCompletionPercentageThreshold?: number | null | undefined
        touchdownCountThreshold?: number | null | undefined
        fumbleCountThreshold?: number | null | undefined
        criteriaMetCount?: number | null | undefined
      }
    | null
    | undefined
  mtdMediumEngagementCriteria?:
    | {
        __typename?: 'UserEngagementCriteria'
        lastMeetingDaysThreshold?: number | null | undefined
        nextMeetingDaysThreshold?: number | null | undefined
        commentChatDaysThreshold?: number | null | undefined
        taskCompletionPercentageThreshold?: number | null | undefined
        touchdownCountThreshold?: number | null | undefined
        fumbleCountThreshold?: number | null | undefined
        criteriaMetCount?: number | null | undefined
      }
    | null
    | undefined
}

export type SearchIndustryReportFieldsFragment = {
  __typename?: 'IndustryReport'
  summaryText?: string | null | undefined
  searchedKeyword?: string | null | undefined
  results?:
    | Array<
        | {
            __typename?: 'IndustryReportResult'
            summary?: string | null | undefined
            docUrl?: string | null | undefined
            docTitle?: string | null | undefined
            pageNumber?: number | null | undefined
          }
        | null
        | undefined
      >
    | null
    | undefined
}

export type GetBusinessSupportOrganizationQueryVariables = Exact<{
  input: GetBusinessSupportOrganizationInput
}>

export type GetBusinessSupportOrganizationQuery = {
  __typename?: 'Query'
  getBusinessSupportOrganization?:
    | {
        __typename?: 'BusinessSupportOrganization'
        id: string
        adminId: string
        name: string
        logoUrl?: string | null | undefined
        licenseCount?: number | null | undefined
        licensesUsed?: number | null | undefined
        adminCount?: number | null | undefined
        advisorCount?: number | null | undefined
        intakeFormCompleted?: boolean | null | undefined
        terminology?:
          | Array<{ __typename?: 'Term'; term: string; replacement: string }>
          | null
          | undefined
        mtdHighEngagementCriteria?:
          | {
              __typename?: 'UserEngagementCriteria'
              lastMeetingDaysThreshold?: number | null | undefined
              nextMeetingDaysThreshold?: number | null | undefined
              commentChatDaysThreshold?: number | null | undefined
              taskCompletionPercentageThreshold?: number | null | undefined
              touchdownCountThreshold?: number | null | undefined
              fumbleCountThreshold?: number | null | undefined
              criteriaMetCount?: number | null | undefined
            }
          | null
          | undefined
        mtdMediumEngagementCriteria?:
          | {
              __typename?: 'UserEngagementCriteria'
              lastMeetingDaysThreshold?: number | null | undefined
              nextMeetingDaysThreshold?: number | null | undefined
              commentChatDaysThreshold?: number | null | undefined
              taskCompletionPercentageThreshold?: number | null | undefined
              touchdownCountThreshold?: number | null | undefined
              fumbleCountThreshold?: number | null | undefined
              criteriaMetCount?: number | null | undefined
            }
          | null
          | undefined
      }
    | null
    | undefined
}

export type SearchIndustryReportQueryVariables = Exact<{
  input: SearchIndustryReportInput
}>

export type SearchIndustryReportQuery = {
  __typename?: 'Query'
  searchIndustryReport?:
    | {
        __typename?: 'IndustryReport'
        summaryText?: string | null | undefined
        searchedKeyword?: string | null | undefined
        results?:
          | Array<
              | {
                  __typename?: 'IndustryReportResult'
                  summary?: string | null | undefined
                  docUrl?: string | null | undefined
                  docTitle?: string | null | undefined
                  pageNumber?: number | null | undefined
                }
              | null
              | undefined
            >
          | null
          | undefined
      }
    | null
    | undefined
}

export type UpdateBusinessSupportOrganizationMutationVariables = Exact<{
  input: UpdateBusinessSupportOrganizationInput
}>

export type UpdateBusinessSupportOrganizationMutation = {
  __typename?: 'Mutation'
  updateBusinessSupportOrganization?:
    | {
        __typename?: 'BusinessSupportOrganization'
        id: string
        adminId: string
        name: string
        logoUrl?: string | null | undefined
        licenseCount?: number | null | undefined
        licensesUsed?: number | null | undefined
        adminCount?: number | null | undefined
        advisorCount?: number | null | undefined
        intakeFormCompleted?: boolean | null | undefined
        terminology?:
          | Array<{ __typename?: 'Term'; term: string; replacement: string }>
          | null
          | undefined
        mtdHighEngagementCriteria?:
          | {
              __typename?: 'UserEngagementCriteria'
              lastMeetingDaysThreshold?: number | null | undefined
              nextMeetingDaysThreshold?: number | null | undefined
              commentChatDaysThreshold?: number | null | undefined
              taskCompletionPercentageThreshold?: number | null | undefined
              touchdownCountThreshold?: number | null | undefined
              fumbleCountThreshold?: number | null | undefined
              criteriaMetCount?: number | null | undefined
            }
          | null
          | undefined
        mtdMediumEngagementCriteria?:
          | {
              __typename?: 'UserEngagementCriteria'
              lastMeetingDaysThreshold?: number | null | undefined
              nextMeetingDaysThreshold?: number | null | undefined
              commentChatDaysThreshold?: number | null | undefined
              taskCompletionPercentageThreshold?: number | null | undefined
              touchdownCountThreshold?: number | null | undefined
              fumbleCountThreshold?: number | null | undefined
              criteriaMetCount?: number | null | undefined
            }
          | null
          | undefined
      }
    | null
    | undefined
}

export type BusinessProfileFieldsFragment = {
  __typename?: 'BusinessProfile'
  id?: string | null | undefined
  userName?: string | null | undefined
  businessName?: string | null | undefined
  yearsInBusiness?: string | null | undefined
  companyEmployees?: string | null | undefined
  createdAt?: string | null | undefined
  updatedAt?: string | null | undefined
  tenantId?: string | null | undefined
  businessVision?: string | null | undefined
  challenges?: string | null | undefined
  otherGoalsOptionIds?: Array<string> | null | undefined
  registerBusinessStructureOptionId?: string | null | undefined
  otherRegisteredBusinessStructure?: string | null | undefined
  month?: string | null | undefined
  year?: string | null | undefined
  contractors?: string | null | undefined
  businessBankAccount?: boolean | null | undefined
  jobsCreated?: string | null | undefined
  volunteers?: string | null | undefined
  partTimeEmployees?: string | null | undefined
  fullTimeEmployees?: string | null | undefined
  gender?: string | null | undefined
  race?: string | null | undefined
  education?: string | null | undefined
  wages?: string | null | undefined
  revenue?: string | null | undefined
  debtFinancing?: string | null | undefined
  financialGrowth?: string | null | undefined
  newCustomer?: string | null | undefined
  productSale?: string | null | undefined
  serviceSale?: string | null | undefined
  targetAudience?: string | null | undefined
  physicalLocation?: string | null | undefined
  additionalInfo?: string | null | undefined
  businessClassificationOptionId?: string | null | undefined
  foodSubIndustryOptionIds?: Array<string> | null | undefined
  servicesSubIndustryOptionId?: string | null | undefined
  strongBusinessAreasOptionIds?: Array<string> | null | undefined
  supportAndHelpOptionIds?: Array<string> | null | undefined
  businessLocationsOptionIds?: Array<string> | null | undefined
  topGoalOptionId?: string | null | undefined
  businessStageOptionId?: string | null | undefined
  isProfit?: boolean | null | undefined
  domainName?: string | null | undefined
  website?: string | null | undefined
  country?: string | null | undefined
  businessEmail?: string | null | undefined
  naicsCode?: string | null | undefined
  EIN?: string | null | undefined
  hasAvatar?: boolean | null | undefined
  avatar?: string | null | undefined
  yearEstablished?: string | null | undefined
  dba?: string | null | undefined
  totalEmployees?: string | null | undefined
  minorityOwned?: string | null | undefined
  sbaCertified?: string | null | undefined
  veteranOwned?: string | null | undefined
  whereDoYouDoBusinessOptionIds?: Array<string> | null | undefined
  revenueStatusOptionId?: string | null | undefined
  otherWhereDoYouDoBusiness?: string | null | undefined
  hoursSpentOptionId?: string | null | undefined
  hoursSpentPerWeek?: number | null | undefined
  hoursSpentPerMonth?: number | null | undefined
  exitPlanOptionId?: string | null | undefined
  otherExitPlan?: string | null | undefined
  productsAndServicesOptionIds?: Array<string> | null | undefined
  haveStartedGeneratingSales?: boolean | null | undefined
  motivation?: string | null | undefined
  personalGoals?: string | null | undefined
  launchDate?: string | null | undefined
  businessDescription?: string | null | undefined
  lastYearRevenue?: string | null | undefined
  thisYearRevenue?: string | null | undefined
  grossRevenueGoalForThisYear?: string | null | undefined
  facebook?: string | null | undefined
  instagram?: string | null | undefined
  linkedin?: string | null | undefined
  tiktok?: string | null | undefined
  twitter?: string | null | undefined
  youtube?: string | null | undefined
  hasRegisterBusinessStructure?: boolean | null | undefined
  hasEIN?: boolean | null | undefined
  hasWebsite?: boolean | null | undefined
  hasFacebook?: boolean | null | undefined
  hasInstagram?: boolean | null | undefined
  hasLinkedin?: boolean | null | undefined
  hasTikTok?: boolean | null | undefined
  hasTwitter?: boolean | null | undefined
  hasYoutube?: boolean | null | undefined
  businessMetricsViewPermission?: BusinessMetricsViewPermissionState | null | undefined
  businessAddress?:
    | {
        __typename?: 'BusinessAddress'
        addressLine1?: string | null | undefined
        addressLine2?: string | null | undefined
        city?: string | null | undefined
        state?: string | null | undefined
        zipCode?: string | null | undefined
        hasBusinessAddress?: boolean | null | undefined
      }
    | null
    | undefined
  logo?:
    | {
        __typename?: 'UserFile'
        id?: string | null | undefined
        name?: string | null | undefined
        size?: string | null | undefined
        url?: string | null | undefined
      }
    | null
    | undefined
  users?:
    | Array<{
        __typename?: 'BusinessUser'
        id: string
        userId: string
        type: BusinessUserType
        createdAt: string
        updatedAt: string
        user: {
          __typename?: 'UserProfile'
          id: string
          firstName?: string | null | undefined
          lastName?: string | null | undefined
          email: string
        }
      }>
    | null
    | undefined
}

export type BusinessProfileFragment = {
  __typename?: 'BusinessProfile'
  id?: string | null | undefined
  userName?: string | null | undefined
  businessName?: string | null | undefined
  yearsInBusiness?: string | null | undefined
  companyEmployees?: string | null | undefined
  createdAt?: string | null | undefined
  updatedAt?: string | null | undefined
  tenantId?: string | null | undefined
  businessVision?: string | null | undefined
  challenges?: string | null | undefined
  otherGoals?: Array<string> | null | undefined
  otherGoalsOptionIds?: Array<string> | null | undefined
  registerBusinessStructure?: string | null | undefined
  registerBusinessStructureOptionId?: string | null | undefined
  otherRegisteredBusinessStructure?: string | null | undefined
  month?: string | null | undefined
  year?: string | null | undefined
  contractors?: string | null | undefined
  businessBankAccount?: boolean | null | undefined
  jobsCreated?: string | null | undefined
  volunteers?: string | null | undefined
  partTimeEmployees?: string | null | undefined
  fullTimeEmployees?: string | null | undefined
  gender?: string | null | undefined
  race?: string | null | undefined
  education?: string | null | undefined
  wages?: string | null | undefined
  revenue?: string | null | undefined
  debtFinancing?: string | null | undefined
  financialGrowth?: string | null | undefined
  newCustomer?: string | null | undefined
  productSale?: string | null | undefined
  serviceSale?: string | null | undefined
  targetAudience?: string | null | undefined
  physicalLocation?: string | null | undefined
  additionalInfo?: string | null | undefined
  businessClassification?: string | null | undefined
  businessClassificationOptionId?: string | null | undefined
  foodSubIndustry?: Array<string> | null | undefined
  foodSubIndustryOptionIds?: Array<string> | null | undefined
  servicesSubIndustry?: string | null | undefined
  servicesSubIndustryOptionId?: string | null | undefined
  strongBusinessAreas?: Array<string> | null | undefined
  strongBusinessAreasOptionIds?: Array<string> | null | undefined
  supportAndHelp?: Array<string> | null | undefined
  supportAndHelpOptionIds?: Array<string> | null | undefined
  businessLocations?: Array<string> | null | undefined
  businessLocationsOptionIds?: Array<string> | null | undefined
  topGoal?: string | null | undefined
  topGoalOptionId?: string | null | undefined
  businessStage?: string | null | undefined
  businessStageOptionId?: string | null | undefined
  isProfit?: boolean | null | undefined
  noOfBusinessStarted?: string | null | undefined
  thisYearRevenue?: string | null | undefined
  lastYearRevenue?: string | null | undefined
  businessNature?: string | null | undefined
  businessNatureOptionId?: string | null | undefined
  hasLogo?: string | null | undefined
  hasLogoOptionId?: string | null | undefined
  EIN?: string | null | undefined
  naicsCode?: string | null | undefined
  numberOfBusinessBankAccounts?: string | null | undefined
  hasGoogleChrome?: string | null | undefined
  hasGoogleChromeOptionId?: string | null | undefined
  hasDomainName?: string | null | undefined
  hasDomainNameOptionId?: string | null | undefined
  domainName?: string | null | undefined
  website?: string | null | undefined
  country?: string | null | undefined
  hasBusinessEmail?: string | null | undefined
  hasBusinessEmailOptionId?: string | null | undefined
  businessEmail?: string | null | undefined
  hasGoogleWorkspace?: string | null | undefined
  hasGoogleWorkspaceOptionId?: string | null | undefined
  hasEsignatureTool?: string | null | undefined
  hasEsignatureToolOptionId?: string | null | undefined
  hasBusinessPhoneNumber?: string | null | undefined
  hasBusinessPhoneNumberOptionId?: string | null | undefined
  hasLogoTrademarked?: string | null | undefined
  hasLogoTrademarkedOptionId?: string | null | undefined
  hasGoogleBusinessProfile?: string | null | undefined
  hasGoogleBusinessProfileOptionId?: string | null | undefined
  googleWorkspacePlaysOptionIds?: Array<string> | null | undefined
  googleWorkspacePlays?: Array<string> | null | undefined
  googleBusinessProfilePlaysOptionIds?: Array<string> | null | undefined
  googleBusinessProfilePlays?: Array<string> | null | undefined
  onboardedAt?: string | null | undefined
  hasAvatar?: boolean | null | undefined
  yearEstablished?: string | null | undefined
  dba?: string | null | undefined
  totalEmployees?: string | null | undefined
  minorityOwned?: string | null | undefined
  sbaCertified?: string | null | undefined
  veteranOwned?: string | null | undefined
  avatar?: string | null | undefined
  businessDescription?: string | null | undefined
  personalGoals?: string | null | undefined
  seasonalityDetails?: string | null | undefined
  exitPlan?: string | null | undefined
  exitPlanOptionId?: string | null | undefined
  otherExitPlan?: string | null | undefined
  motivation?: string | null | undefined
  grossRevenueGoalForThisYear?: string | null | undefined
  launchDate?: string | null | undefined
  whereDoYouDoBusiness?: Array<string> | null | undefined
  whereDoYouDoBusinessOptionIds?: Array<string> | null | undefined
  revenueStatus?: string | null | undefined
  revenueStatusOptionId?: string | null | undefined
  otherWhereDoYouDoBusiness?: string | null | undefined
  hoursSpent?: string | null | undefined
  hoursSpentOptionId?: string | null | undefined
  hoursSpentPerWeek?: number | null | undefined
  hoursSpentPerMonth?: number | null | undefined
  productsAndServices?: Array<string> | null | undefined
  productsAndServicesOptionIds?: Array<string> | null | undefined
  haveStartedGeneratingSales?: boolean | null | undefined
  lastUpdatedBusinessPlan?: string | null | undefined
  facebook?: string | null | undefined
  instagram?: string | null | undefined
  linkedin?: string | null | undefined
  tiktok?: string | null | undefined
  twitter?: string | null | undefined
  youtube?: string | null | undefined
  hasRegisterBusinessStructure?: boolean | null | undefined
  hasEIN?: boolean | null | undefined
  hasWebsite?: boolean | null | undefined
  hasFacebook?: boolean | null | undefined
  hasInstagram?: boolean | null | undefined
  hasLinkedin?: boolean | null | undefined
  hasTikTok?: boolean | null | undefined
  hasTwitter?: boolean | null | undefined
  hasYoutube?: boolean | null | undefined
  businessMetricsViewPermission?: BusinessMetricsViewPermissionState | null | undefined
  logo?:
    | {
        __typename?: 'UserFile'
        id?: string | null | undefined
        name?: string | null | undefined
        size?: string | null | undefined
        tenantId?: string | null | undefined
        type?: string | null | undefined
        url?: string | null | undefined
        userId?: string | null | undefined
      }
    | null
    | undefined
  businessPlan?:
    | {
        __typename?: 'UserFile'
        id?: string | null | undefined
        name?: string | null | undefined
        size?: string | null | undefined
        tenantId?: string | null | undefined
        type?: string | null | undefined
        url?: string | null | undefined
        userId?: string | null | undefined
        tag?: UserFileTag | null | undefined
      }
    | null
    | undefined
  monthlyImpactReports?:
    | Array<{
        __typename?: 'UserFile'
        id?: string | null | undefined
        name?: string | null | undefined
        size?: string | null | undefined
        tenantId?: string | null | undefined
        type?: string | null | undefined
        url?: string | null | undefined
        userId?: string | null | undefined
        createdAt?: string | null | undefined
      }>
    | null
    | undefined
  businessAddress?:
    | {
        __typename?: 'BusinessAddress'
        addressLine1?: string | null | undefined
        addressLine2?: string | null | undefined
        city?: string | null | undefined
        state?: string | null | undefined
        zipCode?: string | null | undefined
        hasBusinessAddress?: boolean | null | undefined
      }
    | null
    | undefined
  users?:
    | Array<{
        __typename?: 'BusinessUser'
        id: string
        userId: string
        type: BusinessUserType
        createdAt: string
        updatedAt: string
        user: {
          __typename?: 'UserProfile'
          id: string
          firstName?: string | null | undefined
          lastName?: string | null | undefined
          email: string
        }
      }>
    | null
    | undefined
  advisors?:
    | Array<{
        __typename?: 'Advisors'
        id: string
        firstName?: string | null | undefined
        lastName?: string | null | undefined
        email?: string | null | undefined
        schedulingUrl?: string | null | undefined
      }>
    | null
    | undefined
}

export type BusinessSummaryResponseFieldsFragment = {
  __typename?: 'BusinessSummaryResponse'
  status: ChartStatus
  data: Array<{
    __typename?: 'BusinessSummaryItem'
    optionType?: string | null | undefined
    data: Array<{
      __typename?: 'BusinessSummaryData'
      optionType?: string | null | undefined
      optionName?: string | null | undefined
      optionId?: string | null | undefined
      tenantId?: string | null | undefined
      summary?: number | null | undefined
    }>
  }>
}

export type GetBusinessProfileQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>
}>

export type GetBusinessProfileQuery = {
  __typename?: 'Query'
  getBusinessProfile?:
    | {
        __typename?: 'BusinessProfile'
        id?: string | null | undefined
        userName?: string | null | undefined
        businessName?: string | null | undefined
        yearsInBusiness?: string | null | undefined
        companyEmployees?: string | null | undefined
        createdAt?: string | null | undefined
        updatedAt?: string | null | undefined
        tenantId?: string | null | undefined
        businessVision?: string | null | undefined
        challenges?: string | null | undefined
        otherGoals?: Array<string> | null | undefined
        otherGoalsOptionIds?: Array<string> | null | undefined
        registerBusinessStructure?: string | null | undefined
        registerBusinessStructureOptionId?: string | null | undefined
        otherRegisteredBusinessStructure?: string | null | undefined
        month?: string | null | undefined
        year?: string | null | undefined
        contractors?: string | null | undefined
        businessBankAccount?: boolean | null | undefined
        jobsCreated?: string | null | undefined
        volunteers?: string | null | undefined
        partTimeEmployees?: string | null | undefined
        fullTimeEmployees?: string | null | undefined
        gender?: string | null | undefined
        race?: string | null | undefined
        education?: string | null | undefined
        wages?: string | null | undefined
        revenue?: string | null | undefined
        debtFinancing?: string | null | undefined
        financialGrowth?: string | null | undefined
        newCustomer?: string | null | undefined
        productSale?: string | null | undefined
        serviceSale?: string | null | undefined
        targetAudience?: string | null | undefined
        physicalLocation?: string | null | undefined
        additionalInfo?: string | null | undefined
        businessClassification?: string | null | undefined
        businessClassificationOptionId?: string | null | undefined
        foodSubIndustry?: Array<string> | null | undefined
        foodSubIndustryOptionIds?: Array<string> | null | undefined
        servicesSubIndustry?: string | null | undefined
        servicesSubIndustryOptionId?: string | null | undefined
        strongBusinessAreas?: Array<string> | null | undefined
        strongBusinessAreasOptionIds?: Array<string> | null | undefined
        supportAndHelp?: Array<string> | null | undefined
        supportAndHelpOptionIds?: Array<string> | null | undefined
        businessLocations?: Array<string> | null | undefined
        businessLocationsOptionIds?: Array<string> | null | undefined
        topGoal?: string | null | undefined
        topGoalOptionId?: string | null | undefined
        businessStage?: string | null | undefined
        businessStageOptionId?: string | null | undefined
        isProfit?: boolean | null | undefined
        noOfBusinessStarted?: string | null | undefined
        thisYearRevenue?: string | null | undefined
        lastYearRevenue?: string | null | undefined
        businessNature?: string | null | undefined
        businessNatureOptionId?: string | null | undefined
        hasLogo?: string | null | undefined
        hasLogoOptionId?: string | null | undefined
        EIN?: string | null | undefined
        naicsCode?: string | null | undefined
        numberOfBusinessBankAccounts?: string | null | undefined
        hasGoogleChrome?: string | null | undefined
        hasGoogleChromeOptionId?: string | null | undefined
        hasDomainName?: string | null | undefined
        hasDomainNameOptionId?: string | null | undefined
        domainName?: string | null | undefined
        website?: string | null | undefined
        country?: string | null | undefined
        hasBusinessEmail?: string | null | undefined
        hasBusinessEmailOptionId?: string | null | undefined
        businessEmail?: string | null | undefined
        hasGoogleWorkspace?: string | null | undefined
        hasGoogleWorkspaceOptionId?: string | null | undefined
        hasEsignatureTool?: string | null | undefined
        hasEsignatureToolOptionId?: string | null | undefined
        hasBusinessPhoneNumber?: string | null | undefined
        hasBusinessPhoneNumberOptionId?: string | null | undefined
        hasLogoTrademarked?: string | null | undefined
        hasLogoTrademarkedOptionId?: string | null | undefined
        hasGoogleBusinessProfile?: string | null | undefined
        hasGoogleBusinessProfileOptionId?: string | null | undefined
        googleWorkspacePlaysOptionIds?: Array<string> | null | undefined
        googleWorkspacePlays?: Array<string> | null | undefined
        googleBusinessProfilePlaysOptionIds?: Array<string> | null | undefined
        googleBusinessProfilePlays?: Array<string> | null | undefined
        onboardedAt?: string | null | undefined
        hasAvatar?: boolean | null | undefined
        yearEstablished?: string | null | undefined
        dba?: string | null | undefined
        totalEmployees?: string | null | undefined
        minorityOwned?: string | null | undefined
        sbaCertified?: string | null | undefined
        veteranOwned?: string | null | undefined
        avatar?: string | null | undefined
        businessDescription?: string | null | undefined
        personalGoals?: string | null | undefined
        seasonalityDetails?: string | null | undefined
        exitPlan?: string | null | undefined
        exitPlanOptionId?: string | null | undefined
        otherExitPlan?: string | null | undefined
        motivation?: string | null | undefined
        grossRevenueGoalForThisYear?: string | null | undefined
        launchDate?: string | null | undefined
        whereDoYouDoBusiness?: Array<string> | null | undefined
        whereDoYouDoBusinessOptionIds?: Array<string> | null | undefined
        revenueStatus?: string | null | undefined
        revenueStatusOptionId?: string | null | undefined
        otherWhereDoYouDoBusiness?: string | null | undefined
        hoursSpent?: string | null | undefined
        hoursSpentOptionId?: string | null | undefined
        hoursSpentPerWeek?: number | null | undefined
        hoursSpentPerMonth?: number | null | undefined
        productsAndServices?: Array<string> | null | undefined
        productsAndServicesOptionIds?: Array<string> | null | undefined
        haveStartedGeneratingSales?: boolean | null | undefined
        lastUpdatedBusinessPlan?: string | null | undefined
        facebook?: string | null | undefined
        instagram?: string | null | undefined
        linkedin?: string | null | undefined
        tiktok?: string | null | undefined
        twitter?: string | null | undefined
        youtube?: string | null | undefined
        hasRegisterBusinessStructure?: boolean | null | undefined
        hasEIN?: boolean | null | undefined
        hasWebsite?: boolean | null | undefined
        hasFacebook?: boolean | null | undefined
        hasInstagram?: boolean | null | undefined
        hasLinkedin?: boolean | null | undefined
        hasTikTok?: boolean | null | undefined
        hasTwitter?: boolean | null | undefined
        hasYoutube?: boolean | null | undefined
        businessMetricsViewPermission?: BusinessMetricsViewPermissionState | null | undefined
        logo?:
          | {
              __typename?: 'UserFile'
              id?: string | null | undefined
              name?: string | null | undefined
              size?: string | null | undefined
              tenantId?: string | null | undefined
              type?: string | null | undefined
              url?: string | null | undefined
              userId?: string | null | undefined
            }
          | null
          | undefined
        businessPlan?:
          | {
              __typename?: 'UserFile'
              id?: string | null | undefined
              name?: string | null | undefined
              size?: string | null | undefined
              tenantId?: string | null | undefined
              type?: string | null | undefined
              url?: string | null | undefined
              userId?: string | null | undefined
              tag?: UserFileTag | null | undefined
            }
          | null
          | undefined
        monthlyImpactReports?:
          | Array<{
              __typename?: 'UserFile'
              id?: string | null | undefined
              name?: string | null | undefined
              size?: string | null | undefined
              tenantId?: string | null | undefined
              type?: string | null | undefined
              url?: string | null | undefined
              userId?: string | null | undefined
              createdAt?: string | null | undefined
            }>
          | null
          | undefined
        businessAddress?:
          | {
              __typename?: 'BusinessAddress'
              addressLine1?: string | null | undefined
              addressLine2?: string | null | undefined
              city?: string | null | undefined
              state?: string | null | undefined
              zipCode?: string | null | undefined
              hasBusinessAddress?: boolean | null | undefined
            }
          | null
          | undefined
        users?:
          | Array<{
              __typename?: 'BusinessUser'
              id: string
              userId: string
              type: BusinessUserType
              createdAt: string
              updatedAt: string
              user: {
                __typename?: 'UserProfile'
                id: string
                firstName?: string | null | undefined
                lastName?: string | null | undefined
                email: string
              }
            }>
          | null
          | undefined
        advisors?:
          | Array<{
              __typename?: 'Advisors'
              id: string
              firstName?: string | null | undefined
              lastName?: string | null | undefined
              email?: string | null | undefined
              schedulingUrl?: string | null | undefined
            }>
          | null
          | undefined
      }
    | null
    | undefined
}

export type GetBusinessRevenueMetricsQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>
  asOfDate: Scalars['AWSDate']
  granularity?: InputMaybe<MetricGranularity>
}>

export type GetBusinessRevenueMetricsQuery = {
  __typename?: 'Query'
  getBusinessProfile?:
    | {
        __typename?: 'BusinessProfile'
        revenueThisMonth?:
          | {
              __typename?: 'MetricValue'
              counter?:
                | {
                    __typename?: 'CounterResponse'
                    value?: number | null | undefined
                    lastUpdatedAt?: string | null | undefined
                    refreshInProgress?: boolean | null | undefined
                  }
                | null
                | undefined
            }
          | null
          | undefined
        revenueGrowthRate?:
          | {
              __typename?: 'MetricValue'
              counter?:
                | {
                    __typename?: 'CounterResponse'
                    value?: number | null | undefined
                    lastUpdatedAt?: string | null | undefined
                    refreshInProgress?: boolean | null | undefined
                  }
                | null
                | undefined
            }
          | null
          | undefined
        revenueYearToDate?:
          | {
              __typename?: 'MetricValue'
              counter?:
                | {
                    __typename?: 'CounterResponse'
                    value?: number | null | undefined
                    lastUpdatedAt?: string | null | undefined
                    refreshInProgress?: boolean | null | undefined
                  }
                | null
                | undefined
            }
          | null
          | undefined
      }
    | null
    | undefined
}

export type GetBusinessNetProfitMetricsQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>
  asOfDate: Scalars['AWSDate']
  granularity?: InputMaybe<MetricGranularity>
}>

export type GetBusinessNetProfitMetricsQuery = {
  __typename?: 'Query'
  getBusinessProfile?:
    | {
        __typename?: 'BusinessProfile'
        netProfitThisMonth?:
          | {
              __typename?: 'MetricValue'
              counter?:
                | {
                    __typename?: 'CounterResponse'
                    value?: number | null | undefined
                    lastUpdatedAt?: string | null | undefined
                    refreshInProgress?: boolean | null | undefined
                  }
                | null
                | undefined
            }
          | null
          | undefined
        netProfitGrowthRate?:
          | {
              __typename?: 'MetricValue'
              counter?:
                | {
                    __typename?: 'CounterResponse'
                    value?: number | null | undefined
                    lastUpdatedAt?: string | null | undefined
                    refreshInProgress?: boolean | null | undefined
                  }
                | null
                | undefined
            }
          | null
          | undefined
        netProfitYearToDate?:
          | {
              __typename?: 'MetricValue'
              counter?:
                | {
                    __typename?: 'CounterResponse'
                    value?: number | null | undefined
                    lastUpdatedAt?: string | null | undefined
                    refreshInProgress?: boolean | null | undefined
                  }
                | null
                | undefined
            }
          | null
          | undefined
      }
    | null
    | undefined
}

export type GetBusinessNumberOfLeadsMetricsQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>
  asOfDate: Scalars['AWSDate']
  granularity?: InputMaybe<MetricGranularity>
}>

export type GetBusinessNumberOfLeadsMetricsQuery = {
  __typename?: 'Query'
  getBusinessProfile?:
    | {
        __typename?: 'BusinessProfile'
        leadCount?:
          | {
              __typename?: 'MetricValue'
              counter?:
                | {
                    __typename?: 'CounterResponse'
                    value?: number | null | undefined
                    lastUpdatedAt?: string | null | undefined
                    refreshInProgress?: boolean | null | undefined
                  }
                | null
                | undefined
            }
          | null
          | undefined
        leadCountGrowthRate?:
          | {
              __typename?: 'MetricValue'
              counter?:
                | {
                    __typename?: 'CounterResponse'
                    value?: number | null | undefined
                    lastUpdatedAt?: string | null | undefined
                    refreshInProgress?: boolean | null | undefined
                  }
                | null
                | undefined
            }
          | null
          | undefined
      }
    | null
    | undefined
}

export type GetBusinessLeadsConversionRateMetricsQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>
  asOfDate: Scalars['AWSDate']
  granularity?: InputMaybe<MetricGranularity>
}>

export type GetBusinessLeadsConversionRateMetricsQuery = {
  __typename?: 'Query'
  getBusinessProfile?:
    | {
        __typename?: 'BusinessProfile'
        leadConversionRate?:
          | {
              __typename?: 'MetricValue'
              counter?:
                | {
                    __typename?: 'CounterResponse'
                    value?: number | null | undefined
                    lastUpdatedAt?: string | null | undefined
                    refreshInProgress?: boolean | null | undefined
                  }
                | null
                | undefined
            }
          | null
          | undefined
        leadConversionRateGrowthRate?:
          | {
              __typename?: 'MetricValue'
              counter?:
                | {
                    __typename?: 'CounterResponse'
                    value?: number | null | undefined
                    lastUpdatedAt?: string | null | undefined
                    refreshInProgress?: boolean | null | undefined
                  }
                | null
                | undefined
            }
          | null
          | undefined
      }
    | null
    | undefined
}

export type UpdateBusinessProfileMutationVariables = Exact<{
  input: UpdateBusinessProfileInput
}>

export type UpdateBusinessProfileMutation = {
  __typename?: 'Mutation'
  updateBusinessProfile?:
    | {
        __typename?: 'BusinessProfile'
        id?: string | null | undefined
        userName?: string | null | undefined
        businessName?: string | null | undefined
        yearsInBusiness?: string | null | undefined
        companyEmployees?: string | null | undefined
        createdAt?: string | null | undefined
        updatedAt?: string | null | undefined
        tenantId?: string | null | undefined
        businessVision?: string | null | undefined
        challenges?: string | null | undefined
        otherGoalsOptionIds?: Array<string> | null | undefined
        registerBusinessStructureOptionId?: string | null | undefined
        otherRegisteredBusinessStructure?: string | null | undefined
        month?: string | null | undefined
        year?: string | null | undefined
        contractors?: string | null | undefined
        businessBankAccount?: boolean | null | undefined
        jobsCreated?: string | null | undefined
        volunteers?: string | null | undefined
        partTimeEmployees?: string | null | undefined
        fullTimeEmployees?: string | null | undefined
        gender?: string | null | undefined
        race?: string | null | undefined
        education?: string | null | undefined
        wages?: string | null | undefined
        revenue?: string | null | undefined
        debtFinancing?: string | null | undefined
        financialGrowth?: string | null | undefined
        newCustomer?: string | null | undefined
        productSale?: string | null | undefined
        serviceSale?: string | null | undefined
        targetAudience?: string | null | undefined
        physicalLocation?: string | null | undefined
        additionalInfo?: string | null | undefined
        businessClassificationOptionId?: string | null | undefined
        foodSubIndustryOptionIds?: Array<string> | null | undefined
        servicesSubIndustryOptionId?: string | null | undefined
        strongBusinessAreasOptionIds?: Array<string> | null | undefined
        supportAndHelpOptionIds?: Array<string> | null | undefined
        businessLocationsOptionIds?: Array<string> | null | undefined
        topGoalOptionId?: string | null | undefined
        businessStageOptionId?: string | null | undefined
        isProfit?: boolean | null | undefined
        domainName?: string | null | undefined
        website?: string | null | undefined
        country?: string | null | undefined
        businessEmail?: string | null | undefined
        naicsCode?: string | null | undefined
        EIN?: string | null | undefined
        hasAvatar?: boolean | null | undefined
        avatar?: string | null | undefined
        yearEstablished?: string | null | undefined
        dba?: string | null | undefined
        totalEmployees?: string | null | undefined
        minorityOwned?: string | null | undefined
        sbaCertified?: string | null | undefined
        veteranOwned?: string | null | undefined
        whereDoYouDoBusinessOptionIds?: Array<string> | null | undefined
        revenueStatusOptionId?: string | null | undefined
        otherWhereDoYouDoBusiness?: string | null | undefined
        hoursSpentOptionId?: string | null | undefined
        hoursSpentPerWeek?: number | null | undefined
        hoursSpentPerMonth?: number | null | undefined
        exitPlanOptionId?: string | null | undefined
        otherExitPlan?: string | null | undefined
        productsAndServicesOptionIds?: Array<string> | null | undefined
        haveStartedGeneratingSales?: boolean | null | undefined
        motivation?: string | null | undefined
        personalGoals?: string | null | undefined
        launchDate?: string | null | undefined
        businessDescription?: string | null | undefined
        lastYearRevenue?: string | null | undefined
        thisYearRevenue?: string | null | undefined
        grossRevenueGoalForThisYear?: string | null | undefined
        facebook?: string | null | undefined
        instagram?: string | null | undefined
        linkedin?: string | null | undefined
        tiktok?: string | null | undefined
        twitter?: string | null | undefined
        youtube?: string | null | undefined
        hasRegisterBusinessStructure?: boolean | null | undefined
        hasEIN?: boolean | null | undefined
        hasWebsite?: boolean | null | undefined
        hasFacebook?: boolean | null | undefined
        hasInstagram?: boolean | null | undefined
        hasLinkedin?: boolean | null | undefined
        hasTikTok?: boolean | null | undefined
        hasTwitter?: boolean | null | undefined
        hasYoutube?: boolean | null | undefined
        businessMetricsViewPermission?: BusinessMetricsViewPermissionState | null | undefined
        businessAddress?:
          | {
              __typename?: 'BusinessAddress'
              addressLine1?: string | null | undefined
              addressLine2?: string | null | undefined
              city?: string | null | undefined
              state?: string | null | undefined
              zipCode?: string | null | undefined
              hasBusinessAddress?: boolean | null | undefined
            }
          | null
          | undefined
        logo?:
          | {
              __typename?: 'UserFile'
              id?: string | null | undefined
              name?: string | null | undefined
              size?: string | null | undefined
              url?: string | null | undefined
            }
          | null
          | undefined
        users?:
          | Array<{
              __typename?: 'BusinessUser'
              id: string
              userId: string
              type: BusinessUserType
              createdAt: string
              updatedAt: string
              user: {
                __typename?: 'UserProfile'
                id: string
                firstName?: string | null | undefined
                lastName?: string | null | undefined
                email: string
              }
            }>
          | null
          | undefined
      }
    | null
    | undefined
}

export type GetBusinessSummaryQueryVariables = Exact<{
  input: GetBusinessSummaryInput
}>

export type GetBusinessSummaryQuery = {
  __typename?: 'Query'
  getBusinessSummary?:
    | {
        __typename?: 'BusinessSummaryResponse'
        status: ChartStatus
        data: Array<{
          __typename?: 'BusinessSummaryItem'
          optionType?: string | null | undefined
          data: Array<{
            __typename?: 'BusinessSummaryData'
            optionType?: string | null | undefined
            optionName?: string | null | undefined
            optionId?: string | null | undefined
            tenantId?: string | null | undefined
            summary?: number | null | undefined
          }>
        }>
      }
    | null
    | undefined
}

export type BusinessUserFieldsFragment = {
  __typename?: 'BusinessUser'
  id: string
  userId: string
  businessId: string
  type: BusinessUserType
  createdAt: string
  updatedAt: string
  user: {
    __typename?: 'UserProfile'
    id: string
    firstName?: string | null | undefined
    lastName?: string | null | undefined
  }
}

export type GetBusinessUsersQueryVariables = Exact<{
  businessId: Scalars['ID']
}>

export type GetBusinessUsersQuery = {
  __typename?: 'Query'
  getBusinessUsers: Array<{
    __typename?: 'BusinessUser'
    id: string
    userId: string
    businessId: string
    type: BusinessUserType
    createdAt: string
    updatedAt: string
    user: {
      __typename?: 'UserProfile'
      id: string
      firstName?: string | null | undefined
      lastName?: string | null | undefined
    }
  }>
}

export type CyclrConnectorFieldsFragment = {
  __typename?: 'CyclrConnectorResponse'
  success: boolean
  message?: string | null | undefined
  error?: string | null | undefined
  data?:
    | Array<{
        __typename?: 'CyclrConnector'
        id?: number | null | undefined
        name?: string | null | undefined
        authenticated?: boolean | null | undefined
        connectorId?: number | null | undefined
      }>
    | null
    | undefined
}

export type CalenderEventFieldsFragment = {
  __typename?: 'CalendarEventResponse'
  success: boolean
  message?: string | null | undefined
  error?: string | null | undefined
  data: Array<{
    __typename?: 'CalendarEvent'
    summary?: string | null | undefined
    description?: string | null | undefined
    status?: string | null | undefined
    eventTime?: string | null | undefined
    meta?: string | null | undefined
    location?: string | null | undefined
    eventType?: string | null | undefined
    advisorProfiles?: string | null | undefined
    profile?: string | null | undefined
    timezone?: string | null | undefined
    eventId?: string | null | undefined
    inviteeId?: string | null | undefined
    advisorId?: string | null | undefined
    availability?: string | null | undefined
    ownerId?: string | null | undefined
    videoLinkDescription?: string | null | undefined
    id?: string | null | undefined
    isAllDay?: boolean | null | undefined
    participantName?: string | null | undefined
    organizerName?: string | null | undefined
    participantFirstName?: string | null | undefined
    participantLastName?: string | null | undefined
    organizerFirstName?: string | null | undefined
    organizerLastName?: string | null | undefined
    teamMemberList?: Array<string | null | undefined> | null | undefined
    businessName?: string | null | undefined
    businessLogo?: string | null | undefined
    start?:
      | {
          __typename?: 'CalendarEventDate'
          dateTime?: string | null | undefined
          timeZone?: string | null | undefined
        }
      | null
      | undefined
    end?:
      | {
          __typename?: 'CalendarEventDate'
          dateTime?: string | null | undefined
          timeZone?: string | null | undefined
        }
      | null
      | undefined
    attendees?:
      | Array<{
          __typename?: 'CalendarEventAttendee'
          email: string
          responseStatus?: string | null | undefined
          optional?: boolean | null | undefined
        }>
      | null
      | undefined
    teamMemberDetails?:
      | Array<
          | {
              __typename?: 'TeamMemberDetails'
              id?: string | null | undefined
              firstName?: string | null | undefined
              lastName?: string | null | undefined
              email?: string | null | undefined
            }
          | null
          | undefined
        >
      | null
      | undefined
    externalReferenceIds?:
      | Array<{
          __typename?: 'CalendarEventExternalReferenceId'
          calendarId?: string | null | undefined
          type: string
          externalEventId?: string | null | undefined
          userId: string
          eventId: string
          status?: string | null | undefined
          meta?: string | null | undefined
          createdAt?: string | null | undefined
          startDate?: string | null | undefined
        }>
      | null
      | undefined
    privateNotes?:
      | Array<
          | {
              __typename?: 'PrivateNote'
              content?: string | null | undefined
              createdBy?: string | null | undefined
              createdAt?: string | null | undefined
            }
          | null
          | undefined
        >
      | null
      | undefined
  }>
}

export type OAuthUrlFieldsFragment = {
  __typename?: 'OAuthUrlResponse'
  success: boolean
  message?: string | null | undefined
  data?: string | null | undefined
  error?: string | null | undefined
}

export type UserMeetingFieldsFragment = {
  __typename?: 'ApiResponse'
  success: boolean
  message?: string | null | undefined
  data?: string | null | undefined
  error?: string | null | undefined
}

export type CalendlyUserFieldsFragment = {
  __typename?: 'CalendlyUserResponse'
  success: boolean
  message?: string | null | undefined
  error?: string | null | undefined
  data?:
    | {
        __typename?: 'CalendlyUser'
        email?: string | null | undefined
        name?: string | null | undefined
        schedulingUrl?: string | null | undefined
        calendlyEventsUrl?: string | null | undefined
      }
    | null
    | undefined
}

export type DeleteCalendarFieldsFragment = {
  __typename?: 'DeleteCalendarEventResponse'
  success: boolean
  message?: string | null | undefined
  data?: string | null | undefined
  error?: string | null | undefined
}

export type DeleteGoogleCalendarEventFieldsFragment = {
  __typename?: 'ApiResponse'
  success: boolean
  message?: string | null | undefined
  data?: string | null | undefined
  error?: string | null | undefined
}

export type CancelOutlookEventFieldsFragment = {
  __typename?: 'ApiResponse'
  success: boolean
  message?: string | null | undefined
  data?: string | null | undefined
  error?: string | null | undefined
}

export type InvitedUserFieldsFragment = {
  __typename?: 'InvitedUser'
  id?: string | null | undefined
  firstName?: string | null | undefined
  lastName?: string | null | undefined
  email?: string | null | undefined
  roles?: Array<string | null | undefined> | null | undefined
}

export type TaggedUserFieldsFragment = {
  __typename?: 'InvitedUser'
  id?: string | null | undefined
  firstName?: string | null | undefined
  lastName?: string | null | undefined
  email?: string | null | undefined
  roles?: Array<string | null | undefined> | null | undefined
}

export type UpdateGoogleCalendarEventFieldsFragment = {
  __typename?: 'ApiResponse'
  success: boolean
  message?: string | null | undefined
  data?: string | null | undefined
  error?: string | null | undefined
}

export type GetMeetingTypesFieldsFragment = {
  __typename?: 'GetMeetingTypeResponse'
  success?: boolean | null | undefined
  message?: string | null | undefined
  error?: string | null | undefined
  data?:
    | Array<
        | {
            __typename?: 'MeetingTypes'
            id?: string | null | undefined
            tenantId?: string | null | undefined
            duration?: string | null | undefined
            label?: string | null | undefined
          }
        | null
        | undefined
      >
    | null
    | undefined
}

export type SetUserAvailabilityFieldsFragment = {
  __typename?: 'SetUserAvailabilityResponse'
  error?: string | null | undefined
  data?:
    | {
        __typename?: 'SetUserAvailabilityObj'
        createdAt?: string | null | undefined
        updatedAt?: string | null | undefined
        userId?: string | null | undefined
        tenantId?: string | null | undefined
        id?: string | null | undefined
        availabilityHours?:
          | {
              __typename?: 'AvailabilityHoursObj'
              duration?: Array<string> | null | undefined
              timezone?: string | null | undefined
              timeSlots?:
                | Array<
                    | {
                        __typename?: 'TimeSlotsObj'
                        label?: string | null | undefined
                        value?: string | null | undefined
                        slots?:
                          | Array<
                              | {
                                  __typename?: 'SlotOutput'
                                  startTime?: string | null | undefined
                                  endTime?: string | null | undefined
                                }
                              | null
                              | undefined
                            >
                          | null
                          | undefined
                      }
                    | null
                    | undefined
                  >
                | null
                | undefined
            }
          | null
          | undefined
      }
    | null
    | undefined
}

export type GetUserAvailabilityFieldsFragment = {
  __typename?: 'GetUserAvailabilityResponse'
  meetingLocation?: Array<string | null | undefined> | null | undefined
  error?: string | null | undefined
  data?:
    | {
        __typename?: 'GetUserAvailability'
        duration: string
        availability: Array<{
          __typename?: 'UserAvailability'
          date: string
          slots: Array<{
            __typename?: 'SlotObj'
            isAvailable?: boolean | null | undefined
            slotStartTime?: string | null | undefined
            slotEndTime?: string | null | undefined
          }>
        }>
      }
    | null
    | undefined
}

export type SetUserMeetingResponseFieldsFragment = {
  __typename?: 'UserMeetingData'
  id?: string | null | undefined
  eventId?: string | null | undefined
  updatedAt?: string | null | undefined
  createdAt?: string | null | undefined
  participantId?: string | null | undefined
  tenantId?: string | null | undefined
  startTime?: string | null | undefined
  endTime?: string | null | undefined
  description?: string | null | undefined
  ownerId?: string | null | undefined
  inviteeId?: string | null | undefined
  title?: string | null | undefined
  timezone?: string | null | undefined
  role?: Array<string | null | undefined> | null | undefined
  status?: string | null | undefined
  location?: string | null | undefined
  videoLinkDescription?: string | null | undefined
  advisorName?: string | null | undefined
  organizerName?: string | null | undefined
  attendees?:
    | Array<{
        __typename?: 'CalendarEventAttendee'
        email: string
        responseStatus?: string | null | undefined
        optional?: boolean | null | undefined
      }>
    | null
    | undefined
}

export type GetUserConnectorsQueryVariables = Exact<{
  connectorName?: InputMaybe<Scalars['String']>
}>

export type GetUserConnectorsQuery = {
  __typename?: 'Query'
  getUserConnectors?:
    | {
        __typename?: 'CyclrConnectorResponse'
        success: boolean
        message?: string | null | undefined
        error?: string | null | undefined
        data?:
          | Array<{
              __typename?: 'CyclrConnector'
              id?: number | null | undefined
              name?: string | null | undefined
              authenticated?: boolean | null | undefined
              connectorId?: number | null | undefined
            }>
          | null
          | undefined
      }
    | null
    | undefined
}

export type GetUserCalendarEventsQueryVariables = Exact<{
  calendarName?: InputMaybe<Scalars['String']>
  timeMin?: InputMaybe<Scalars['String']>
  timeMax?: InputMaybe<Scalars['String']>
  tenantId?: InputMaybe<Scalars['String']>
}>

export type GetUserCalendarEventsQuery = {
  __typename?: 'Query'
  getUserCalendarEvents?:
    | {
        __typename?: 'CalendarEventResponse'
        success: boolean
        message?: string | null | undefined
        error?: string | null | undefined
        data: Array<{
          __typename?: 'CalendarEvent'
          summary?: string | null | undefined
          description?: string | null | undefined
          status?: string | null | undefined
          eventTime?: string | null | undefined
          meta?: string | null | undefined
          location?: string | null | undefined
          eventType?: string | null | undefined
          advisorProfiles?: string | null | undefined
          profile?: string | null | undefined
          timezone?: string | null | undefined
          eventId?: string | null | undefined
          inviteeId?: string | null | undefined
          advisorId?: string | null | undefined
          availability?: string | null | undefined
          ownerId?: string | null | undefined
          videoLinkDescription?: string | null | undefined
          id?: string | null | undefined
          isAllDay?: boolean | null | undefined
          participantName?: string | null | undefined
          organizerName?: string | null | undefined
          participantFirstName?: string | null | undefined
          participantLastName?: string | null | undefined
          organizerFirstName?: string | null | undefined
          organizerLastName?: string | null | undefined
          teamMemberList?: Array<string | null | undefined> | null | undefined
          businessName?: string | null | undefined
          businessLogo?: string | null | undefined
          start?:
            | {
                __typename?: 'CalendarEventDate'
                dateTime?: string | null | undefined
                timeZone?: string | null | undefined
              }
            | null
            | undefined
          end?:
            | {
                __typename?: 'CalendarEventDate'
                dateTime?: string | null | undefined
                timeZone?: string | null | undefined
              }
            | null
            | undefined
          attendees?:
            | Array<{
                __typename?: 'CalendarEventAttendee'
                email: string
                responseStatus?: string | null | undefined
                optional?: boolean | null | undefined
              }>
            | null
            | undefined
          teamMemberDetails?:
            | Array<
                | {
                    __typename?: 'TeamMemberDetails'
                    id?: string | null | undefined
                    firstName?: string | null | undefined
                    lastName?: string | null | undefined
                    email?: string | null | undefined
                  }
                | null
                | undefined
              >
            | null
            | undefined
          externalReferenceIds?:
            | Array<{
                __typename?: 'CalendarEventExternalReferenceId'
                calendarId?: string | null | undefined
                type: string
                externalEventId?: string | null | undefined
                userId: string
                eventId: string
                status?: string | null | undefined
                meta?: string | null | undefined
                createdAt?: string | null | undefined
                startDate?: string | null | undefined
              }>
            | null
            | undefined
          privateNotes?:
            | Array<
                | {
                    __typename?: 'PrivateNote'
                    content?: string | null | undefined
                    createdBy?: string | null | undefined
                    createdAt?: string | null | undefined
                  }
                | null
                | undefined
              >
            | null
            | undefined
        }>
      }
    | null
    | undefined
}

export type GetUserCalendarEventsByUserIdQueryVariables = Exact<{
  calendarName?: InputMaybe<Scalars['String']>
  timeMin?: InputMaybe<Scalars['String']>
  timeMax?: InputMaybe<Scalars['String']>
  tenantId?: InputMaybe<Scalars['String']>
  userId?: InputMaybe<Scalars['String']>
}>

export type GetUserCalendarEventsByUserIdQuery = {
  __typename?: 'Query'
  getUserCalendarEventsByUserId?:
    | {
        __typename?: 'CalendarEventResponse'
        success: boolean
        message?: string | null | undefined
        error?: string | null | undefined
        data: Array<{
          __typename?: 'CalendarEvent'
          summary?: string | null | undefined
          description?: string | null | undefined
          status?: string | null | undefined
          eventTime?: string | null | undefined
          meta?: string | null | undefined
          location?: string | null | undefined
          eventType?: string | null | undefined
          advisorProfiles?: string | null | undefined
          profile?: string | null | undefined
          timezone?: string | null | undefined
          eventId?: string | null | undefined
          inviteeId?: string | null | undefined
          advisorId?: string | null | undefined
          availability?: string | null | undefined
          ownerId?: string | null | undefined
          videoLinkDescription?: string | null | undefined
          id?: string | null | undefined
          isAllDay?: boolean | null | undefined
          participantName?: string | null | undefined
          organizerName?: string | null | undefined
          participantFirstName?: string | null | undefined
          participantLastName?: string | null | undefined
          organizerFirstName?: string | null | undefined
          organizerLastName?: string | null | undefined
          teamMemberList?: Array<string | null | undefined> | null | undefined
          businessName?: string | null | undefined
          businessLogo?: string | null | undefined
          start?:
            | {
                __typename?: 'CalendarEventDate'
                dateTime?: string | null | undefined
                timeZone?: string | null | undefined
              }
            | null
            | undefined
          end?:
            | {
                __typename?: 'CalendarEventDate'
                dateTime?: string | null | undefined
                timeZone?: string | null | undefined
              }
            | null
            | undefined
          attendees?:
            | Array<{
                __typename?: 'CalendarEventAttendee'
                email: string
                responseStatus?: string | null | undefined
                optional?: boolean | null | undefined
              }>
            | null
            | undefined
          teamMemberDetails?:
            | Array<
                | {
                    __typename?: 'TeamMemberDetails'
                    id?: string | null | undefined
                    firstName?: string | null | undefined
                    lastName?: string | null | undefined
                    email?: string | null | undefined
                  }
                | null
                | undefined
              >
            | null
            | undefined
          externalReferenceIds?:
            | Array<{
                __typename?: 'CalendarEventExternalReferenceId'
                calendarId?: string | null | undefined
                type: string
                externalEventId?: string | null | undefined
                userId: string
                eventId: string
                status?: string | null | undefined
                meta?: string | null | undefined
                createdAt?: string | null | undefined
                startDate?: string | null | undefined
              }>
            | null
            | undefined
          privateNotes?:
            | Array<
                | {
                    __typename?: 'PrivateNote'
                    content?: string | null | undefined
                    createdBy?: string | null | undefined
                    createdAt?: string | null | undefined
                  }
                | null
                | undefined
              >
            | null
            | undefined
        }>
      }
    | null
    | undefined
}

export type UpdateUserCalendarFieldsFragment = {
  __typename?: 'UpdateUserCalendarEventResponse'
  error?: string | null | undefined
  data?:
    | {
        __typename?: 'UpdateUserCalendarEvent'
        title?: string | null | undefined
        eventId?: string | null | undefined
        location?: string | null | undefined
        tackleId?: string | null | undefined
        eventType?: string | null | undefined
        description?: string | null | undefined
        comment?: string | null | undefined
        videoLinkDescription?: string | null | undefined
        teamMemberList?: Array<string | null | undefined> | null | undefined
        attendees?:
          | Array<
              | {
                  __typename?: 'AttendeesType'
                  email?: string | null | undefined
                  organizer?: boolean | null | undefined
                  self?: boolean | null | undefined
                  responseStatus?: string | null | undefined
                }
              | null
              | undefined
            >
          | null
          | undefined
      }
    | null
    | undefined
}

export type SubscribeGoogleCalendarWebhookFieldsFragment = {
  __typename?: 'SubscribeGoogleCalendarWebhookResponse'
  data?: string | null | undefined
  error?: string | null | undefined
}

export type CancelUserCalendarFieldsFragment = {
  __typename?: 'CancelUserCalendarEventResponse'
  error?: string | null | undefined
  data?:
    | {
        __typename?: 'CancelUserCalendarEvent'
        tackleId?: string | null | undefined
        eventId?: string | null | undefined
        eventType?: string | null | undefined
      }
    | null
    | undefined
}

export type UpdateUserAvailabilityFieldsFragment = {
  __typename?: 'UpdateUserAvailabilityResponse'
  error?: string | null | undefined
  data?:
    | {
        __typename?: 'SetUserAvailabilityObj'
        createdAt?: string | null | undefined
        updatedAt?: string | null | undefined
        userId?: string | null | undefined
        tenantId?: string | null | undefined
        id?: string | null | undefined
        availabilityHours?:
          | {
              __typename?: 'AvailabilityHoursObj'
              duration?: Array<string> | null | undefined
              timezone?: string | null | undefined
              timeSlots?:
                | Array<
                    | {
                        __typename?: 'TimeSlotsObj'
                        label?: string | null | undefined
                        value?: string | null | undefined
                        slots?:
                          | Array<
                              | {
                                  __typename?: 'SlotOutput'
                                  startTime?: string | null | undefined
                                  endTime?: string | null | undefined
                                }
                              | null
                              | undefined
                            >
                          | null
                          | undefined
                      }
                    | null
                    | undefined
                  >
                | null
                | undefined
            }
          | null
          | undefined
      }
    | null
    | undefined
}

export type GetUserAvailabilityHoursFieldsFragment = {
  __typename?: 'GetUserAvailabilityHoursResponse'
  error?: string | null | undefined
  data?:
    | {
        __typename?: 'SetUserAvailabilityObj'
        createdAt?: string | null | undefined
        updatedAt?: string | null | undefined
        userId?: string | null | undefined
        tenantId?: string | null | undefined
        id?: string | null | undefined
        availabilityHours?:
          | {
              __typename?: 'AvailabilityHoursObj'
              duration?: Array<string> | null | undefined
              timezone?: string | null | undefined
              timeSlots?:
                | Array<
                    | {
                        __typename?: 'TimeSlotsObj'
                        label?: string | null | undefined
                        value?: string | null | undefined
                        slots?:
                          | Array<
                              | {
                                  __typename?: 'SlotOutput'
                                  startTime?: string | null | undefined
                                  endTime?: string | null | undefined
                                }
                              | null
                              | undefined
                            >
                          | null
                          | undefined
                      }
                    | null
                    | undefined
                  >
                | null
                | undefined
            }
          | null
          | undefined
      }
    | null
    | undefined
}

export type GetUserMeetingByIdFieldsFragment = {
  __typename?: 'GetUserMeetingByIdResponse'
  error?: string | null | undefined
  data?:
    | {
        __typename?: 'CalendarEvent'
        summary?: string | null | undefined
        description?: string | null | undefined
        status?: string | null | undefined
        eventTime?: string | null | undefined
        meta?: string | null | undefined
        location?: string | null | undefined
        eventType?: string | null | undefined
        advisorProfiles?: string | null | undefined
        profile?: string | null | undefined
        timezone?: string | null | undefined
        eventId?: string | null | undefined
        inviteeId?: string | null | undefined
        advisorId?: string | null | undefined
        ownerId?: string | null | undefined
        availability?: string | null | undefined
        comment?: string | null | undefined
        videoLinkDescription?: string | null | undefined
        id?: string | null | undefined
        participantName?: string | null | undefined
        organizerName?: string | null | undefined
        participantFirstName?: string | null | undefined
        participantLastName?: string | null | undefined
        organizerFirstName?: string | null | undefined
        organizerLastName?: string | null | undefined
        start?:
          | {
              __typename?: 'CalendarEventDate'
              dateTime?: string | null | undefined
              timeZone?: string | null | undefined
            }
          | null
          | undefined
        end?:
          | {
              __typename?: 'CalendarEventDate'
              dateTime?: string | null | undefined
              timeZone?: string | null | undefined
            }
          | null
          | undefined
        attendees?:
          | Array<{
              __typename?: 'CalendarEventAttendee'
              email: string
              responseStatus?: string | null | undefined
              optional?: boolean | null | undefined
            }>
          | null
          | undefined
      }
    | null
    | undefined
}

export type GetOAuthUrlQueryVariables = Exact<{
  input: GetOAuthUrlInput
}>

export type GetOAuthUrlQuery = {
  __typename?: 'Query'
  getOAuthUrl?:
    | {
        __typename?: 'OAuthUrlResponse'
        success: boolean
        message?: string | null | undefined
        data?: string | null | undefined
        error?: string | null | undefined
      }
    | null
    | undefined
}

export type GetCalendlyUserQueryVariables = Exact<{ [key: string]: never }>

export type GetCalendlyUserQuery = {
  __typename?: 'Query'
  getCalendlyUser?:
    | {
        __typename?: 'CalendlyUserResponse'
        success: boolean
        message?: string | null | undefined
        error?: string | null | undefined
        data?:
          | {
              __typename?: 'CalendlyUser'
              email?: string | null | undefined
              name?: string | null | undefined
              schedulingUrl?: string | null | undefined
              calendlyEventsUrl?: string | null | undefined
            }
          | null
          | undefined
      }
    | null
    | undefined
}

export type SubscribeCalendlyWebhookQueryVariables = Exact<{
  tenantId?: InputMaybe<Scalars['String']>
  email?: InputMaybe<Scalars['String']>
}>

export type SubscribeCalendlyWebhookQuery = {
  __typename?: 'Query'
  subscribeCalendlyWebhook?:
    | {
        __typename?: 'ApiResponse'
        success: boolean
        message?: string | null | undefined
        data?: string | null | undefined
        error?: string | null | undefined
      }
    | null
    | undefined
}

export type SubscribeGoogleCalendarWebhookMutationVariables = Exact<{
  tenantId?: InputMaybe<Scalars['String']>
}>

export type SubscribeGoogleCalendarWebhookMutation = {
  __typename?: 'Mutation'
  subscribeGoogleCalendarWebhook?:
    | {
        __typename?: 'SubscribeGoogleCalendarWebhookResponse'
        data?: string | null | undefined
        error?: string | null | undefined
      }
    | null
    | undefined
}

export type GetUserMeetingQueryVariables = Exact<{
  advisorId?: InputMaybe<Scalars['String']>
}>

export type GetUserMeetingQuery = {
  __typename?: 'Query'
  getUserMeeting?:
    | {
        __typename?: 'ApiResponse'
        success: boolean
        message?: string | null | undefined
        data?: string | null | undefined
        error?: string | null | undefined
      }
    | null
    | undefined
}

export type DeleteCalendarEventMutationVariables = Exact<{
  input: DeleteCalendarEventInput
}>

export type DeleteCalendarEventMutation = {
  __typename?: 'Mutation'
  deleteCalendarEvent?:
    | {
        __typename?: 'DeleteCalendarEventResponse'
        success: boolean
        message?: string | null | undefined
        data?: string | null | undefined
        error?: string | null | undefined
      }
    | null
    | undefined
}

export type DeleteGoogleCalendarEventQueryVariables = Exact<{
  input?: InputMaybe<DeleteGoogleCalendarEventInput>
}>

export type DeleteGoogleCalendarEventQuery = {
  __typename?: 'Query'
  deleteGoogleCalendarEvent?:
    | {
        __typename?: 'ApiResponse'
        success: boolean
        message?: string | null | undefined
        data?: string | null | undefined
        error?: string | null | undefined
      }
    | null
    | undefined
}

export type UpdateGoogleCalendarEventQueryVariables = Exact<{
  input?: InputMaybe<UpdateGoogleCalendarEventInput>
}>

export type UpdateGoogleCalendarEventQuery = {
  __typename?: 'Query'
  updateGoogleCalendarEvent?:
    | {
        __typename?: 'ApiResponse'
        success: boolean
        message?: string | null | undefined
        data?: string | null | undefined
        error?: string | null | undefined
      }
    | null
    | undefined
}

export type CancelOutlookEventQueryVariables = Exact<{
  input?: InputMaybe<CancelOutlookEventInput>
}>

export type CancelOutlookEventQuery = {
  __typename?: 'Query'
  cancelOutlookEvent?:
    | {
        __typename?: 'ApiResponse'
        success: boolean
        message?: string | null | undefined
        data?: string | null | undefined
        error?: string | null | undefined
      }
    | null
    | undefined
}

export type GetMeetingTypesQueryVariables = Exact<{
  tenantId: Scalars['String']
}>

export type GetMeetingTypesQuery = {
  __typename?: 'Query'
  getMeetingTypes?:
    | {
        __typename?: 'GetMeetingTypeResponse'
        success?: boolean | null | undefined
        message?: string | null | undefined
        error?: string | null | undefined
        data?:
          | Array<
              | {
                  __typename?: 'MeetingTypes'
                  id?: string | null | undefined
                  tenantId?: string | null | undefined
                  duration?: string | null | undefined
                  label?: string | null | undefined
                }
              | null
              | undefined
            >
          | null
          | undefined
      }
    | null
    | undefined
}

export type SetUserAvailabilityMutationVariables = Exact<{
  input?: InputMaybe<SetUserAvailabilityInput>
}>

export type SetUserAvailabilityMutation = {
  __typename?: 'Mutation'
  setUserAvailability?:
    | {
        __typename?: 'SetUserAvailabilityResponse'
        error?: string | null | undefined
        data?:
          | {
              __typename?: 'SetUserAvailabilityObj'
              createdAt?: string | null | undefined
              updatedAt?: string | null | undefined
              userId?: string | null | undefined
              tenantId?: string | null | undefined
              id?: string | null | undefined
              availabilityHours?:
                | {
                    __typename?: 'AvailabilityHoursObj'
                    duration?: Array<string> | null | undefined
                    timezone?: string | null | undefined
                    timeSlots?:
                      | Array<
                          | {
                              __typename?: 'TimeSlotsObj'
                              label?: string | null | undefined
                              value?: string | null | undefined
                              slots?:
                                | Array<
                                    | {
                                        __typename?: 'SlotOutput'
                                        startTime?: string | null | undefined
                                        endTime?: string | null | undefined
                                      }
                                    | null
                                    | undefined
                                  >
                                | null
                                | undefined
                            }
                          | null
                          | undefined
                        >
                      | null
                      | undefined
                  }
                | null
                | undefined
            }
          | null
          | undefined
      }
    | null
    | undefined
}

export type GetUserAvailabilityQueryVariables = Exact<{
  input: GetUserAvailabilityInput
}>

export type GetUserAvailabilityQuery = {
  __typename?: 'Query'
  getUserAvailability?:
    | {
        __typename?: 'GetUserAvailabilityResponse'
        meetingLocation?: Array<string | null | undefined> | null | undefined
        error?: string | null | undefined
        data?:
          | {
              __typename?: 'GetUserAvailability'
              duration: string
              availability: Array<{
                __typename?: 'UserAvailability'
                date: string
                slots: Array<{
                  __typename?: 'SlotObj'
                  isAvailable?: boolean | null | undefined
                  slotStartTime?: string | null | undefined
                  slotEndTime?: string | null | undefined
                }>
              }>
            }
          | null
          | undefined
      }
    | null
    | undefined
}

export type SetUserMeetingMutationVariables = Exact<{
  input: SetUserMeetingInput
}>

export type SetUserMeetingMutation = {
  __typename?: 'Mutation'
  setUserMeeting?:
    | {
        __typename?: 'UserMeetingData'
        id?: string | null | undefined
        eventId?: string | null | undefined
        updatedAt?: string | null | undefined
        createdAt?: string | null | undefined
        participantId?: string | null | undefined
        tenantId?: string | null | undefined
        startTime?: string | null | undefined
        endTime?: string | null | undefined
        description?: string | null | undefined
        ownerId?: string | null | undefined
        inviteeId?: string | null | undefined
        title?: string | null | undefined
        timezone?: string | null | undefined
        role?: Array<string | null | undefined> | null | undefined
        status?: string | null | undefined
        location?: string | null | undefined
        videoLinkDescription?: string | null | undefined
        advisorName?: string | null | undefined
        organizerName?: string | null | undefined
        attendees?:
          | Array<{
              __typename?: 'CalendarEventAttendee'
              email: string
              responseStatus?: string | null | undefined
              optional?: boolean | null | undefined
            }>
          | null
          | undefined
      }
    | null
    | undefined
}

export type UpdateUserCalendarEventMutationVariables = Exact<{
  input: UpdateUserCalendarEventInput
}>

export type UpdateUserCalendarEventMutation = {
  __typename?: 'Mutation'
  updateUserCalendarEvent?:
    | {
        __typename?: 'UpdateUserCalendarEventResponse'
        error?: string | null | undefined
        data?:
          | {
              __typename?: 'UpdateUserCalendarEvent'
              title?: string | null | undefined
              eventId?: string | null | undefined
              location?: string | null | undefined
              tackleId?: string | null | undefined
              eventType?: string | null | undefined
              description?: string | null | undefined
              comment?: string | null | undefined
              videoLinkDescription?: string | null | undefined
              teamMemberList?: Array<string | null | undefined> | null | undefined
              attendees?:
                | Array<
                    | {
                        __typename?: 'AttendeesType'
                        email?: string | null | undefined
                        organizer?: boolean | null | undefined
                        self?: boolean | null | undefined
                        responseStatus?: string | null | undefined
                      }
                    | null
                    | undefined
                  >
                | null
                | undefined
            }
          | null
          | undefined
      }
    | null
    | undefined
}

export type RescheduleUserCalendarEventMutationVariables = Exact<{
  input: RescheduleUserCalendarEventInput
}>

export type RescheduleUserCalendarEventMutation = {
  __typename?: 'Mutation'
  rescheduleUserCalendarEvent?:
    | {
        __typename?: 'UpdateUserCalendarEventResponse'
        error?: string | null | undefined
        data?:
          | {
              __typename?: 'UpdateUserCalendarEvent'
              title?: string | null | undefined
              eventId?: string | null | undefined
              location?: string | null | undefined
              tackleId?: string | null | undefined
              eventType?: string | null | undefined
              description?: string | null | undefined
              comment?: string | null | undefined
              videoLinkDescription?: string | null | undefined
              teamMemberList?: Array<string | null | undefined> | null | undefined
              attendees?:
                | Array<
                    | {
                        __typename?: 'AttendeesType'
                        email?: string | null | undefined
                        organizer?: boolean | null | undefined
                        self?: boolean | null | undefined
                        responseStatus?: string | null | undefined
                      }
                    | null
                    | undefined
                  >
                | null
                | undefined
            }
          | null
          | undefined
      }
    | null
    | undefined
}

export type CancelUserCalendarEventMutationVariables = Exact<{
  input: CancelUserCalendarEventInput
}>

export type CancelUserCalendarEventMutation = {
  __typename?: 'Mutation'
  cancelUserCalendarEvent?:
    | {
        __typename?: 'CancelUserCalendarEventResponse'
        error?: string | null | undefined
        data?:
          | {
              __typename?: 'CancelUserCalendarEvent'
              tackleId?: string | null | undefined
              eventId?: string | null | undefined
              eventType?: string | null | undefined
            }
          | null
          | undefined
      }
    | null
    | undefined
}

export type GetUserAvailabilityHoursQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['String']>
}>

export type GetUserAvailabilityHoursQuery = {
  __typename?: 'Query'
  getUserAvailabilityHours?:
    | {
        __typename?: 'GetUserAvailabilityHoursResponse'
        error?: string | null | undefined
        data?:
          | {
              __typename?: 'SetUserAvailabilityObj'
              createdAt?: string | null | undefined
              updatedAt?: string | null | undefined
              userId?: string | null | undefined
              tenantId?: string | null | undefined
              id?: string | null | undefined
              availabilityHours?:
                | {
                    __typename?: 'AvailabilityHoursObj'
                    duration?: Array<string> | null | undefined
                    timezone?: string | null | undefined
                    timeSlots?:
                      | Array<
                          | {
                              __typename?: 'TimeSlotsObj'
                              label?: string | null | undefined
                              value?: string | null | undefined
                              slots?:
                                | Array<
                                    | {
                                        __typename?: 'SlotOutput'
                                        startTime?: string | null | undefined
                                        endTime?: string | null | undefined
                                      }
                                    | null
                                    | undefined
                                  >
                                | null
                                | undefined
                            }
                          | null
                          | undefined
                        >
                      | null
                      | undefined
                  }
                | null
                | undefined
            }
          | null
          | undefined
      }
    | null
    | undefined
}

export type UpdateUserAvailabilityMutationVariables = Exact<{
  input?: InputMaybe<UpdateUserAvailabilityInput>
}>

export type UpdateUserAvailabilityMutation = {
  __typename?: 'Mutation'
  updateUserAvailability?:
    | {
        __typename?: 'UpdateUserAvailabilityResponse'
        error?: string | null | undefined
        data?:
          | {
              __typename?: 'SetUserAvailabilityObj'
              createdAt?: string | null | undefined
              updatedAt?: string | null | undefined
              userId?: string | null | undefined
              tenantId?: string | null | undefined
              id?: string | null | undefined
              availabilityHours?:
                | {
                    __typename?: 'AvailabilityHoursObj'
                    duration?: Array<string> | null | undefined
                    timezone?: string | null | undefined
                    timeSlots?:
                      | Array<
                          | {
                              __typename?: 'TimeSlotsObj'
                              label?: string | null | undefined
                              value?: string | null | undefined
                              slots?:
                                | Array<
                                    | {
                                        __typename?: 'SlotOutput'
                                        startTime?: string | null | undefined
                                        endTime?: string | null | undefined
                                      }
                                    | null
                                    | undefined
                                  >
                                | null
                                | undefined
                            }
                          | null
                          | undefined
                        >
                      | null
                      | undefined
                  }
                | null
                | undefined
            }
          | null
          | undefined
      }
    | null
    | undefined
}

export type GetUserMeetingByIdQueryVariables = Exact<{
  input: GetUserMeetingByIdInput
}>

export type GetUserMeetingByIdQuery = {
  __typename?: 'Query'
  getUserMeetingById?:
    | {
        __typename?: 'GetUserMeetingByIdResponse'
        error?: string | null | undefined
        data?:
          | {
              __typename?: 'CalendarEvent'
              summary?: string | null | undefined
              description?: string | null | undefined
              status?: string | null | undefined
              eventTime?: string | null | undefined
              meta?: string | null | undefined
              location?: string | null | undefined
              eventType?: string | null | undefined
              advisorProfiles?: string | null | undefined
              profile?: string | null | undefined
              timezone?: string | null | undefined
              eventId?: string | null | undefined
              inviteeId?: string | null | undefined
              advisorId?: string | null | undefined
              ownerId?: string | null | undefined
              availability?: string | null | undefined
              comment?: string | null | undefined
              videoLinkDescription?: string | null | undefined
              id?: string | null | undefined
              participantName?: string | null | undefined
              organizerName?: string | null | undefined
              participantFirstName?: string | null | undefined
              participantLastName?: string | null | undefined
              organizerFirstName?: string | null | undefined
              organizerLastName?: string | null | undefined
              start?:
                | {
                    __typename?: 'CalendarEventDate'
                    dateTime?: string | null | undefined
                    timeZone?: string | null | undefined
                  }
                | null
                | undefined
              end?:
                | {
                    __typename?: 'CalendarEventDate'
                    dateTime?: string | null | undefined
                    timeZone?: string | null | undefined
                  }
                | null
                | undefined
              attendees?:
                | Array<{
                    __typename?: 'CalendarEventAttendee'
                    email: string
                    responseStatus?: string | null | undefined
                    optional?: boolean | null | undefined
                  }>
                | null
                | undefined
            }
          | null
          | undefined
      }
    | null
    | undefined
}

export type GetAllInvitedUsersQueryVariables = Exact<{
  input: GetAllInvitedUsersInput
}>

export type GetAllInvitedUsersQuery = {
  __typename?: 'Query'
  getAllInvitedUsers: Array<{
    __typename?: 'InvitedUser'
    id?: string | null | undefined
    firstName?: string | null | undefined
    lastName?: string | null | undefined
    email?: string | null | undefined
    roles?: Array<string | null | undefined> | null | undefined
  }>
}

export type GetAllTagUsersQueryVariables = Exact<{
  input: GetAllTagUsersInput
}>

export type GetAllTagUsersQuery = {
  __typename?: 'Query'
  getAllTagUsers: Array<{
    __typename?: 'InvitedUser'
    id?: string | null | undefined
    firstName?: string | null | undefined
    lastName?: string | null | undefined
    email?: string | null | undefined
    roles?: Array<string | null | undefined> | null | undefined
  }>
}

export type GetAccountingChartsQueryVariables = Exact<{
  input: QueryAccountingReportInput
}>

export type GetAccountingChartsQuery = {
  __typename?: 'Query'
  getAccountingCharts?:
    | {
        __typename?: 'AccountingChartResponse'
        status: ChartStatus
        data: Array<
          | {
              __typename: 'CashBalanceByMonthReport'
              startDate?: string | null | undefined
              endDate?: string | null | undefined
              cashBalance?: number | null | undefined
              source?: string | null | undefined
            }
          | {
              __typename: 'CashBalanceReport'
              cashBalance?: number | null | undefined
              source?: string | null | undefined
              dateRange?: DateRanges | null | undefined
              endDate?: string | null | undefined
              growth?: number | null | undefined
              startDate?: string | null | undefined
            }
          | {
              __typename: 'LiquidCashReport'
              liquidCash?: number | null | undefined
              source?: string | null | undefined
              dateRange?: DateRanges | null | undefined
              endDate?: string | null | undefined
              growth?: number | null | undefined
              startDate?: string | null | undefined
            }
          | {
              __typename: 'ProfitAndLossReport'
              profitAndLossNetIncome?: number | null | undefined
              source?: string | null | undefined
              dateRange?: DateRanges | null | undefined
              endDate?: string | null | undefined
              growth?: number | null | undefined
              startDate?: string | null | undefined
            }
        >
      }
    | null
    | undefined
}

export type AccountingChartFragmentFragment = {
  __typename?: 'AccountingChartResponse'
  status: ChartStatus
  data: Array<
    | {
        __typename: 'CashBalanceByMonthReport'
        startDate?: string | null | undefined
        endDate?: string | null | undefined
        cashBalance?: number | null | undefined
        source?: string | null | undefined
      }
    | {
        __typename: 'CashBalanceReport'
        cashBalance?: number | null | undefined
        source?: string | null | undefined
        dateRange?: DateRanges | null | undefined
        endDate?: string | null | undefined
        growth?: number | null | undefined
        startDate?: string | null | undefined
      }
    | {
        __typename: 'LiquidCashReport'
        liquidCash?: number | null | undefined
        source?: string | null | undefined
        dateRange?: DateRanges | null | undefined
        endDate?: string | null | undefined
        growth?: number | null | undefined
        startDate?: string | null | undefined
      }
    | {
        __typename: 'ProfitAndLossReport'
        profitAndLossNetIncome?: number | null | undefined
        source?: string | null | undefined
        dateRange?: DateRanges | null | undefined
        endDate?: string | null | undefined
        growth?: number | null | undefined
        startDate?: string | null | undefined
      }
  >
}

type AccountingReportOutputFragment_CashBalanceByMonthReport_Fragment = {
  __typename?: 'CashBalanceByMonthReport'
  startDate?: string | null | undefined
  endDate?: string | null | undefined
  cashBalance?: number | null | undefined
  source?: string | null | undefined
}

type AccountingReportOutputFragment_CashBalanceReport_Fragment = {
  __typename?: 'CashBalanceReport'
  cashBalance?: number | null | undefined
  source?: string | null | undefined
  dateRange?: DateRanges | null | undefined
  endDate?: string | null | undefined
  growth?: number | null | undefined
  startDate?: string | null | undefined
}

type AccountingReportOutputFragment_LiquidCashReport_Fragment = {
  __typename?: 'LiquidCashReport'
  liquidCash?: number | null | undefined
  source?: string | null | undefined
  dateRange?: DateRanges | null | undefined
  endDate?: string | null | undefined
  growth?: number | null | undefined
  startDate?: string | null | undefined
}

type AccountingReportOutputFragment_ProfitAndLossReport_Fragment = {
  __typename?: 'ProfitAndLossReport'
  profitAndLossNetIncome?: number | null | undefined
  source?: string | null | undefined
  dateRange?: DateRanges | null | undefined
  endDate?: string | null | undefined
  growth?: number | null | undefined
  startDate?: string | null | undefined
}

export type AccountingReportOutputFragmentFragment =
  | AccountingReportOutputFragment_CashBalanceByMonthReport_Fragment
  | AccountingReportOutputFragment_CashBalanceReport_Fragment
  | AccountingReportOutputFragment_LiquidCashReport_Fragment
  | AccountingReportOutputFragment_ProfitAndLossReport_Fragment

export type LiquidCashReportFieldsFragment = {
  __typename?: 'LiquidCashReport'
  liquidCash?: number | null | undefined
  source?: string | null | undefined
  dateRange?: DateRanges | null | undefined
  endDate?: string | null | undefined
  growth?: number | null | undefined
  startDate?: string | null | undefined
}

export type CashBalanceReportFieldsFragment = {
  __typename?: 'CashBalanceReport'
  cashBalance?: number | null | undefined
  source?: string | null | undefined
  dateRange?: DateRanges | null | undefined
  endDate?: string | null | undefined
  growth?: number | null | undefined
  startDate?: string | null | undefined
}

export type ProfitAndLossReportFieldsFragment = {
  __typename?: 'ProfitAndLossReport'
  profitAndLossNetIncome?: number | null | undefined
  source?: string | null | undefined
  dateRange?: DateRanges | null | undefined
  endDate?: string | null | undefined
  growth?: number | null | undefined
  startDate?: string | null | undefined
}

export type CashBalanceByMonthReportFieldsFragment = {
  __typename?: 'CashBalanceByMonthReport'
  startDate?: string | null | undefined
  endDate?: string | null | undefined
  cashBalance?: number | null | undefined
  source?: string | null | undefined
}

export type ChatBotMessageFieldsFragment = {
  __typename?: 'ChatBotMessage'
  role: string
  content: string
  createdAt: string
  messageType: string
  progress?: number | null | undefined
  isEdited?: boolean | null | undefined
  isVoiceMessage?: boolean | null | undefined
  voiceDuration?: number | null | undefined
}

export type GetMessagesFromBotQueryVariables = Exact<{
  sessionId: Scalars['String']
  cursor?: InputMaybe<Scalars['String']>
  limit?: InputMaybe<Scalars['Int']>
}>

export type GetMessagesFromBotQuery = {
  __typename?: 'Query'
  getMessagesFromBot: {
    __typename?: 'MessageToBotResponse'
    hasMore: boolean
    nextCursor?: string | null | undefined
    messages?:
      | Array<{
          __typename?: 'ChatBotMessage'
          role: string
          content: string
          createdAt: string
          messageType: string
          progress?: number | null | undefined
          isEdited?: boolean | null | undefined
          isVoiceMessage?: boolean | null | undefined
          voiceDuration?: number | null | undefined
        }>
      | null
      | undefined
  }
}

export type CreateChatSessionFieldsFragment = { __typename?: 'ChatSession'; streamUrl: string }

export type CreateChatSessionMutationVariables = Exact<{
  input: CreateChatSessionInput
}>

export type CreateChatSessionMutation = {
  __typename?: 'Mutation'
  createChatSession?: { __typename?: 'ChatSession'; streamUrl: string } | null | undefined
}

export type UserTaskHowToResponseFieldsFragment = {
  __typename?: 'UserTaskHowToResponse'
  text: string
  videoLinks: Array<string | null | undefined>
  steps?: string | null | undefined
  structuredSteps?:
    | Array<
        | {
            __typename?: 'UserTaskHowToStep'
            stepNumber: number
            title: string
            description: string
            videos?:
              | Array<
                  | {
                      __typename?: 'UserTaskHowToVideo'
                      url: string
                      title: string
                      relevance?: string | null | undefined
                      stepsCovered?: Array<number | null | undefined> | null | undefined
                    }
                  | null
                  | undefined
                >
              | null
              | undefined
          }
        | null
        | undefined
      >
    | null
    | undefined
}

export type SearchHowToDoTaskMutationVariables = Exact<{
  input: SearchHowToDoTaskInput
}>

export type SearchHowToDoTaskMutation = {
  __typename?: 'Mutation'
  searchHowToDoTask: {
    __typename?: 'UserTaskHowToResponse'
    text: string
    videoLinks: Array<string | null | undefined>
    steps?: string | null | undefined
    structuredSteps?:
      | Array<
          | {
              __typename?: 'UserTaskHowToStep'
              stepNumber: number
              title: string
              description: string
              videos?:
                | Array<
                    | {
                        __typename?: 'UserTaskHowToVideo'
                        url: string
                        title: string
                        relevance?: string | null | undefined
                        stepsCovered?: Array<number | null | undefined> | null | undefined
                      }
                    | null
                    | undefined
                  >
                | null
                | undefined
            }
          | null
          | undefined
        >
      | null
      | undefined
  }
}

export type SendMessageToBotFieldsFragment = {
  __typename?: 'SendMessageToBotResponse'
  responses?: Array<string> | null | undefined
  progress?: number | null | undefined
  nextFlow?: string | null | undefined
  isFinished?: boolean | null | undefined
  flowType?: string | null | undefined
  transcript?: string | null | undefined
}

export type SendMessageToBotMutationVariables = Exact<{
  input: SendMessageToBotInput
}>

export type SendMessageToBotMutation = {
  __typename?: 'Mutation'
  sendMessageToBot: {
    __typename?: 'SendMessageToBotResponse'
    responses?: Array<string> | null | undefined
    progress?: number | null | undefined
    nextFlow?: string | null | undefined
    isFinished?: boolean | null | undefined
    flowType?: string | null | undefined
    transcript?: string | null | undefined
  }
}

export type GetChatSessionsFieldsFragment = {
  __typename?: 'MessageChatSession'
  id: string
  flow?: string | null | undefined
  createdAt?: string | null | undefined
  title?: string | null | undefined
  status?: ChatSessionStatus | null | undefined
  metadata?: string | null | undefined
  executorId?: string | null | undefined
  lastMessage?:
    | {
        __typename?: 'LastMessage'
        role: string
        content: string
        botResponse?: string | null | undefined
        createdAt: string
        progress?: number | null | undefined
        messageType: string
        isEdited: boolean
      }
    | null
    | undefined
}

export type GetChatSessionsQueryVariables = Exact<{
  input: GetChatSessionsInput
}>

export type GetChatSessionsQuery = {
  __typename?: 'Query'
  getChatSessions?:
    | Array<{
        __typename?: 'MessageChatSession'
        id: string
        flow?: string | null | undefined
        createdAt?: string | null | undefined
        title?: string | null | undefined
        status?: ChatSessionStatus | null | undefined
        metadata?: string | null | undefined
        executorId?: string | null | undefined
        lastMessage?:
          | {
              __typename?: 'LastMessage'
              role: string
              content: string
              botResponse?: string | null | undefined
              createdAt: string
              progress?: number | null | undefined
              messageType: string
              isEdited: boolean
            }
          | null
          | undefined
      }>
    | null
    | undefined
}

export type CreateFlowChatSessionMutationVariables = Exact<{
  input: CreateFlowChatSessionInput
}>

export type CreateFlowChatSessionMutation = {
  __typename?: 'Mutation'
  createFlowChatSession: {
    __typename?: 'MessageChatSession'
    id: string
    flow?: string | null | undefined
    createdAt?: string | null | undefined
    title?: string | null | undefined
    status?: ChatSessionStatus | null | undefined
    metadata?: string | null | undefined
    executorId?: string | null | undefined
    lastMessage?:
      | {
          __typename?: 'LastMessage'
          role: string
          content: string
          botResponse?: string | null | undefined
          createdAt: string
          progress?: number | null | undefined
          messageType: string
          isEdited: boolean
        }
      | null
      | undefined
  }
}

export type SummarySessionTitleMutationVariables = Exact<{
  id: Scalars['String']
}>

export type SummarySessionTitleMutation = {
  __typename?: 'Mutation'
  summarySessionTitle: {
    __typename?: 'MessageChatSession'
    id: string
    flow?: string | null | undefined
    createdAt?: string | null | undefined
    title?: string | null | undefined
    status?: ChatSessionStatus | null | undefined
    metadata?: string | null | undefined
    executorId?: string | null | undefined
    lastMessage?:
      | {
          __typename?: 'LastMessage'
          role: string
          content: string
          botResponse?: string | null | undefined
          createdAt: string
          progress?: number | null | undefined
          messageType: string
          isEdited: boolean
        }
      | null
      | undefined
  }
}

export type AdvisorDashboardFieldsFragment = {
  __typename?: 'ApiResponse'
  success: boolean
  message?: string | null | undefined
  data?: string | null | undefined
  error?: string | null | undefined
}

export type TopActiveClientsFieldsFragment = {
  __typename?: 'GetTopActiveClientsResponse'
  error?: string | null | undefined
  data?:
    | Array<
        | {
            __typename?: 'TopActiveClient'
            id?: string | null | undefined
            firstName?: string | null | undefined
            lastName?: string | null | undefined
            tenantId?: string | null | undefined
            email?: string | null | undefined
            score?: number | null | undefined
            totalTime?: number | null | undefined
            topGoal?: string | null | undefined
            industry?: string | null | undefined
            businessName?: string | null | undefined
            logo?:
              | {
                  __typename?: 'UserFile'
                  id?: string | null | undefined
                  name?: string | null | undefined
                  size?: string | null | undefined
                  tenantId?: string | null | undefined
                  type?: string | null | undefined
                  url?: string | null | undefined
                  userId?: string | null | undefined
                }
              | null
              | undefined
          }
        | null
        | undefined
      >
    | null
    | undefined
}

export type GetUserToolsFieldsFragment = {
  __typename?: 'GetUserToolsResponse'
  success?: boolean | null | undefined
  message?: string | null | undefined
  error?: string | null | undefined
  data?:
    | Array<
        | {
            __typename?: 'Tool'
            id?: string | null | undefined
            cyclrToolId?: string | null | undefined
            imageUrl?: string | null | undefined
            toolName?: string | null | undefined
            toolDisplayName?: string | null | undefined
            userToolsImageUrl?: string | null | undefined
            connectionFormImageUrl?: string | null | undefined
            toolUrl?: string | null | undefined
            isConnected?: boolean | null | undefined
            isRecommended?: boolean | null | undefined
            recommendedBy?: string | null | undefined
            isSelected?: boolean | null | undefined
            group?: string | null | undefined
            category?: string | null | undefined
            visible?: boolean | null | undefined
            connectionStatus?: string | null | undefined
            connectorName?: string | null | undefined
            isBookmarked?: boolean | null | undefined
            supportLevel?: ToolSupportLevel | null | undefined
            description?: string | null | undefined
            diagnosticSupported?: boolean | null | undefined
            longDescription?: string | null | undefined
            toolHelpText?: string | null | undefined
            relatedPlays?: Array<string | null | undefined> | null | undefined
            authType?: ToolAuthType | null | undefined
            options?:
              | {
                  __typename?: 'ToolConnectionOptions'
                  connectionForm?:
                    | {
                        __typename?: 'ToolConnectionForm'
                        description: string
                        inputProperties: Array<{
                          __typename?: 'ToolConnectionFormInputProperty'
                          name: string
                          displayName: string
                          placeholder?: string | null | undefined
                          type: string
                          validationRules: Array<string>
                        }>
                      }
                    | null
                    | undefined
                }
              | null
              | undefined
          }
        | null
        | undefined
      >
    | null
    | undefined
}

export type BookmarkToolFieldsFragment = {
  __typename?: 'BookmarkToolResponse'
  success?: boolean | null | undefined
  message?: string | null | undefined
  error?: string | null | undefined
  data?:
    | {
        __typename?: 'Tool'
        id?: string | null | undefined
        cyclrToolId?: string | null | undefined
        imageUrl?: string | null | undefined
        toolName?: string | null | undefined
        toolDisplayName?: string | null | undefined
        userToolsImageUrl?: string | null | undefined
        connectionFormImageUrl?: string | null | undefined
        toolUrl?: string | null | undefined
        isConnected?: boolean | null | undefined
        isRecommended?: boolean | null | undefined
        recommendedBy?: string | null | undefined
        isSelected?: boolean | null | undefined
        group?: string | null | undefined
        category?: string | null | undefined
        visible?: boolean | null | undefined
        connectionStatus?: string | null | undefined
        connectorName?: string | null | undefined
        isBookmarked?: boolean | null | undefined
        supportLevel?: ToolSupportLevel | null | undefined
        description?: string | null | undefined
        diagnosticSupported?: boolean | null | undefined
        longDescription?: string | null | undefined
        toolHelpText?: string | null | undefined
        options?:
          | {
              __typename?: 'ToolConnectionOptions'
              connectionForm?:
                | {
                    __typename?: 'ToolConnectionForm'
                    description: string
                    inputProperties: Array<{
                      __typename?: 'ToolConnectionFormInputProperty'
                      name: string
                      displayName: string
                      placeholder?: string | null | undefined
                      type: string
                      validationRules: Array<string>
                    }>
                  }
                | null
                | undefined
            }
          | null
          | undefined
      }
    | null
    | undefined
}

export type ClientsFieldsFragment = {
  __typename?: 'GetClientsResponse'
  success: boolean
  message?: string | null | undefined
  error?: string | null | undefined
  data?:
    | Array<
        | {
            __typename?: 'GetClientsResponseData'
            id: string
            name?: string | null | undefined
            firstName?: string | null | undefined
            lastName?: string | null | undefined
            email: string
            createdAt: string
            updatedAt: string
            websiteURL?: string | null | undefined
            bio?: string | null | undefined
            roles?: Array<string | null | undefined> | null | undefined
            isNewUser?: boolean | null | undefined
            businessName?: string | null | undefined
            mobileContactNumber?: string | null | undefined
            yearsInBusiness?: string | null | undefined
            companyAdvisor?: string | null | undefined
            schedulingUrl?: string | null | undefined
            calendlyEventsUrl?: string | null | undefined
          }
        | null
        | undefined
      >
    | null
    | undefined
}

export type TackleMeetingFieldsFragment = {
  __typename?: 'ApiResponse'
  success: boolean
  message?: string | null | undefined
  data?: string | null | undefined
  error?: string | null | undefined
}

export type ActivityLogFieldsFragment = {
  __typename?: 'ApiResponse'
  success: boolean
  message?: string | null | undefined
  data?: string | null | undefined
  error?: string | null | undefined
}

export type OwnerActivityDetailsFieldsFragment = {
  __typename?: 'OwnerActivitySummary'
  timesSignedIn?: number | null | undefined
  timeOnPlatform?: string | null | undefined
  toolsIntegrated?: number | null | undefined
  chats?: number | null | undefined
  meetingsScheduled?: number | null | undefined
  meetingsReScheduled?: number | null | undefined
  signInPerWeek?: number | null | undefined
  avgMinsPerSession?: number | null | undefined
}

export type UserIntegrationFieldsFragment = {
  __typename?: 'ApiResponse'
  success: boolean
  message?: string | null | undefined
  data?: string | null | undefined
  error?: string | null | undefined
}

export type TackleMeetingsFieldsFragment = {
  __typename?: 'GetTackleMeetingResponse'
  success: boolean
  message?: string | null | undefined
  pagination?: string | null | undefined
  error?: string | null | undefined
  data?:
    | Array<
        | {
            __typename?: 'CalendarEvent'
            summary?: string | null | undefined
            description?: string | null | undefined
            status?: string | null | undefined
            eventTime?: string | null | undefined
            meta?: string | null | undefined
            location?: string | null | undefined
            eventType?: string | null | undefined
            advisorProfiles?: string | null | undefined
            profile?: string | null | undefined
            timezone?: string | null | undefined
            eventId?: string | null | undefined
            inviteeId?: string | null | undefined
            advisorId?: string | null | undefined
            availability?: string | null | undefined
            comment?: string | null | undefined
            videoLinkDescription?: string | null | undefined
            organizerName?: string | null | undefined
            participantName?: string | null | undefined
            ownerId?: string | null | undefined
            participantFirstName?: string | null | undefined
            participantLastName?: string | null | undefined
            organizerFirstName?: string | null | undefined
            organizerLastName?: string | null | undefined
            id?: string | null | undefined
            transcriptUrl?: string | null | undefined
            recordingUrl?: string | null | undefined
            transcriptSummary?: string | null | undefined
            transcriptSummaryFile?: string | null | undefined
            teamMemberList?: Array<string | null | undefined> | null | undefined
            start?:
              | {
                  __typename?: 'CalendarEventDate'
                  dateTime?: string | null | undefined
                  timeZone?: string | null | undefined
                }
              | null
              | undefined
            end?:
              | {
                  __typename?: 'CalendarEventDate'
                  dateTime?: string | null | undefined
                  timeZone?: string | null | undefined
                }
              | null
              | undefined
            attendees?:
              | Array<{
                  __typename?: 'CalendarEventAttendee'
                  email: string
                  responseStatus?: string | null | undefined
                  optional?: boolean | null | undefined
                }>
              | null
              | undefined
            privateNotes?:
              | Array<
                  | {
                      __typename?: 'PrivateNote'
                      content?: string | null | undefined
                      createdBy?: string | null | undefined
                      createdAt?: string | null | undefined
                      noteId?: string | null | undefined
                      advisorId?: string | null | undefined
                      tags?: Array<string> | null | undefined
                      files?:
                        | Array<{
                            __typename?: 'UserFile'
                            id?: string | null | undefined
                            name?: string | null | undefined
                            size?: string | null | undefined
                            tenantId?: string | null | undefined
                            type?: string | null | undefined
                            url?: string | null | undefined
                            userId?: string | null | undefined
                            createdAt?: string | null | undefined
                          }>
                        | null
                        | undefined
                    }
                  | null
                  | undefined
                >
              | null
              | undefined
            teamMemberDetails?:
              | Array<
                  | {
                      __typename?: 'TeamMemberDetails'
                      id?: string | null | undefined
                      firstName?: string | null | undefined
                      lastName?: string | null | undefined
                      email?: string | null | undefined
                    }
                  | null
                  | undefined
                >
              | null
              | undefined
            requestDetails?:
              | Array<
                  | {
                      __typename?: 'RequestDetail'
                      reason?: string | null | undefined
                      start?:
                        | {
                            __typename?: 'CalendarEventDate'
                            date?: string | null | undefined
                            dateTime?: string | null | undefined
                            timeZone?: string | null | undefined
                          }
                        | null
                        | undefined
                      end?:
                        | {
                            __typename?: 'CalendarEventDate'
                            date?: string | null | undefined
                            dateTime?: string | null | undefined
                            timeZone?: string | null | undefined
                          }
                        | null
                        | undefined
                    }
                  | null
                  | undefined
                >
              | null
              | undefined
          }
        | null
        | undefined
      >
    | null
    | undefined
}

export type DeauthenticateConnectorFieldsFragment = {
  __typename?: 'ApiResponse'
  message?: string | null | undefined
  data?: string | null | undefined
  error?: string | null | undefined
}

export type GetAllToolsFieldsFragment = {
  __typename?: 'GetAllToolsResponse'
  success?: boolean | null | undefined
  message?: string | null | undefined
  error?: string | null | undefined
  data?:
    | Array<
        | {
            __typename?: 'Tool'
            id?: string | null | undefined
            toolDisplayName?: string | null | undefined
            cyclrToolId?: string | null | undefined
            imageUrl?: string | null | undefined
            toolName?: string | null | undefined
            userToolsImageUrl?: string | null | undefined
            connectionFormImageUrl?: string | null | undefined
            toolUrl?: string | null | undefined
            isConnected?: boolean | null | undefined
            isRecommended?: boolean | null | undefined
            recommendedBy?: string | null | undefined
            isSelected?: boolean | null | undefined
            pricingPageUrl?: string | null | undefined
            group?: string | null | undefined
            category?: string | null | undefined
            visible?: boolean | null | undefined
            supportLevel?: ToolSupportLevel | null | undefined
            relatedPlays?: Array<string | null | undefined> | null | undefined
            isBookmarked?: boolean | null | undefined
            description?: string | null | undefined
            diagnosticSupported?: boolean | null | undefined
            longDescription?: string | null | undefined
            toolHelpText?: string | null | undefined
            authType?: ToolAuthType | null | undefined
            options?:
              | {
                  __typename?: 'ToolConnectionOptions'
                  connectionForm?:
                    | {
                        __typename?: 'ToolConnectionForm'
                        description: string
                        inputProperties: Array<{
                          __typename?: 'ToolConnectionFormInputProperty'
                          name: string
                          displayName: string
                          placeholder?: string | null | undefined
                          type: string
                          validationRules: Array<string>
                        }>
                      }
                    | null
                    | undefined
                }
              | null
              | undefined
          }
        | null
        | undefined
      >
    | null
    | undefined
}

export type GetAttestationReportsFieldsFragment = {
  __typename?: 'GetAttestationReportsResponse'
  error?: string | null | undefined
  data?:
    | {
        __typename?: 'GetAttestationReportsResponseObj'
        lastEvaluatedKey?: string | null | undefined
        prevEvaluatedKey?: string | null | undefined
        totalPages?: number | null | undefined
        totalRecords?: number | null | undefined
        pageSize?: number | null | undefined
        currentPage?: number | null | undefined
        items?:
          | Array<
              | {
                  __typename?: 'Attestation'
                  month?: string | null | undefined
                  year?: string | null | undefined
                  contractors?: string | null | undefined
                  businessBankAccount?: string | null | undefined
                  jobsCreated?: string | null | undefined
                  volunteers?: string | null | undefined
                  partTimeEmployees?: string | null | undefined
                  fullTimeEmployees?: string | null | undefined
                  gender?: string | null | undefined
                  race?: string | null | undefined
                  education?: string | null | undefined
                  wages?: string | null | undefined
                  revenue?: string | null | undefined
                  debtFinancing?: string | null | undefined
                  financialGrowth?: string | null | undefined
                  newCustomer?: string | null | undefined
                  productSale?: string | null | undefined
                  serviceSale?: string | null | undefined
                  targetAudience?: string | null | undefined
                  physicalLocation?: string | null | undefined
                  businessName?: string | null | undefined
                  name?: string | null | undefined
                  signedDocumentUrl?: string | null | undefined
                  properName?: string | null | undefined
                }
              | null
              | undefined
            >
          | null
          | undefined
      }
    | null
    | undefined
}

export type UpdateOwnerFieldsFragment = {
  __typename?: 'ApiResponse'
  success: boolean
  message?: string | null | undefined
  data?: string | null | undefined
  error?: string | null | undefined
}

export type GetAdvisorDashboardQueryVariables = Exact<{
  filterType?: InputMaybe<Scalars['String']>
  tenantId?: InputMaybe<Scalars['String']>
}>

export type GetAdvisorDashboardQuery = {
  __typename?: 'Query'
  getAdvisorDashboard?:
    | {
        __typename?: 'ApiResponse'
        success: boolean
        message?: string | null | undefined
        data?: string | null | undefined
        error?: string | null | undefined
      }
    | null
    | undefined
}

export type GetTopActiveClientsQueryVariables = Exact<{
  tenantId?: InputMaybe<Scalars['String']>
}>

export type GetTopActiveClientsQuery = {
  __typename?: 'Query'
  getTopActiveClients?:
    | {
        __typename?: 'GetTopActiveClientsResponse'
        error?: string | null | undefined
        data?:
          | Array<
              | {
                  __typename?: 'TopActiveClient'
                  id?: string | null | undefined
                  firstName?: string | null | undefined
                  lastName?: string | null | undefined
                  tenantId?: string | null | undefined
                  email?: string | null | undefined
                  score?: number | null | undefined
                  totalTime?: number | null | undefined
                  topGoal?: string | null | undefined
                  industry?: string | null | undefined
                  businessName?: string | null | undefined
                  logo?:
                    | {
                        __typename?: 'UserFile'
                        id?: string | null | undefined
                        name?: string | null | undefined
                        size?: string | null | undefined
                        tenantId?: string | null | undefined
                        type?: string | null | undefined
                        url?: string | null | undefined
                        userId?: string | null | undefined
                      }
                    | null
                    | undefined
                }
              | null
              | undefined
            >
          | null
          | undefined
      }
    | null
    | undefined
}

export type GetClientsQueryVariables = Exact<{
  input?: InputMaybe<GetClientsInput>
}>

export type GetClientsQuery = {
  __typename?: 'Query'
  getClients?:
    | {
        __typename?: 'GetClientsResponse'
        success: boolean
        message?: string | null | undefined
        error?: string | null | undefined
        data?:
          | Array<
              | {
                  __typename?: 'GetClientsResponseData'
                  id: string
                  name?: string | null | undefined
                  firstName?: string | null | undefined
                  lastName?: string | null | undefined
                  email: string
                  createdAt: string
                  updatedAt: string
                  websiteURL?: string | null | undefined
                  bio?: string | null | undefined
                  roles?: Array<string | null | undefined> | null | undefined
                  isNewUser?: boolean | null | undefined
                  businessName?: string | null | undefined
                  mobileContactNumber?: string | null | undefined
                  yearsInBusiness?: string | null | undefined
                  companyAdvisor?: string | null | undefined
                  schedulingUrl?: string | null | undefined
                  calendlyEventsUrl?: string | null | undefined
                }
              | null
              | undefined
            >
          | null
          | undefined
      }
    | null
    | undefined
}

export type GetOwnerActivityDetailsQueryVariables = Exact<{
  ownerId?: InputMaybe<Scalars['String']>
  tenantId: Scalars['String']
}>

export type GetOwnerActivityDetailsQuery = {
  __typename?: 'Query'
  getOwnerActivityDetails?:
    | {
        __typename?: 'OwnerActivitySummary'
        timesSignedIn?: number | null | undefined
        timeOnPlatform?: string | null | undefined
        toolsIntegrated?: number | null | undefined
        chats?: number | null | undefined
        meetingsScheduled?: number | null | undefined
        meetingsReScheduled?: number | null | undefined
        signInPerWeek?: number | null | undefined
        avgMinsPerSession?: number | null | undefined
      }
    | null
    | undefined
}

export type GetActivityLogsQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['String']>
  tenantId: Scalars['String']
}>

export type GetActivityLogsQuery = {
  __typename?: 'Query'
  getActivityLogs?:
    | {
        __typename?: 'ApiResponse'
        success: boolean
        message?: string | null | undefined
        data?: string | null | undefined
        error?: string | null | undefined
      }
    | null
    | undefined
}

export type GetUserIntegrationsQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['String']>
  tenantId: Scalars['String']
}>

export type GetUserIntegrationsQuery = {
  __typename?: 'Query'
  getUserIntegrations?:
    | {
        __typename?: 'ApiResponse'
        success: boolean
        message?: string | null | undefined
        data?: string | null | undefined
        error?: string | null | undefined
      }
    | null
    | undefined
}

export type GetTackleMeetingsQueryVariables = Exact<{
  input: GetTackleMeetingsInput
}>

export type GetTackleMeetingsQuery = {
  __typename?: 'Query'
  getTackleMeetings?:
    | {
        __typename?: 'GetTackleMeetingResponse'
        success: boolean
        message?: string | null | undefined
        pagination?: string | null | undefined
        error?: string | null | undefined
        data?:
          | Array<
              | {
                  __typename?: 'CalendarEvent'
                  summary?: string | null | undefined
                  description?: string | null | undefined
                  status?: string | null | undefined
                  eventTime?: string | null | undefined
                  meta?: string | null | undefined
                  location?: string | null | undefined
                  eventType?: string | null | undefined
                  advisorProfiles?: string | null | undefined
                  profile?: string | null | undefined
                  timezone?: string | null | undefined
                  eventId?: string | null | undefined
                  inviteeId?: string | null | undefined
                  advisorId?: string | null | undefined
                  availability?: string | null | undefined
                  comment?: string | null | undefined
                  videoLinkDescription?: string | null | undefined
                  organizerName?: string | null | undefined
                  participantName?: string | null | undefined
                  ownerId?: string | null | undefined
                  participantFirstName?: string | null | undefined
                  participantLastName?: string | null | undefined
                  organizerFirstName?: string | null | undefined
                  organizerLastName?: string | null | undefined
                  id?: string | null | undefined
                  transcriptUrl?: string | null | undefined
                  recordingUrl?: string | null | undefined
                  transcriptSummary?: string | null | undefined
                  transcriptSummaryFile?: string | null | undefined
                  teamMemberList?: Array<string | null | undefined> | null | undefined
                  start?:
                    | {
                        __typename?: 'CalendarEventDate'
                        dateTime?: string | null | undefined
                        timeZone?: string | null | undefined
                      }
                    | null
                    | undefined
                  end?:
                    | {
                        __typename?: 'CalendarEventDate'
                        dateTime?: string | null | undefined
                        timeZone?: string | null | undefined
                      }
                    | null
                    | undefined
                  attendees?:
                    | Array<{
                        __typename?: 'CalendarEventAttendee'
                        email: string
                        responseStatus?: string | null | undefined
                        optional?: boolean | null | undefined
                      }>
                    | null
                    | undefined
                  privateNotes?:
                    | Array<
                        | {
                            __typename?: 'PrivateNote'
                            content?: string | null | undefined
                            createdBy?: string | null | undefined
                            createdAt?: string | null | undefined
                            noteId?: string | null | undefined
                            advisorId?: string | null | undefined
                            tags?: Array<string> | null | undefined
                            files?:
                              | Array<{
                                  __typename?: 'UserFile'
                                  id?: string | null | undefined
                                  name?: string | null | undefined
                                  size?: string | null | undefined
                                  tenantId?: string | null | undefined
                                  type?: string | null | undefined
                                  url?: string | null | undefined
                                  userId?: string | null | undefined
                                  createdAt?: string | null | undefined
                                }>
                              | null
                              | undefined
                          }
                        | null
                        | undefined
                      >
                    | null
                    | undefined
                  teamMemberDetails?:
                    | Array<
                        | {
                            __typename?: 'TeamMemberDetails'
                            id?: string | null | undefined
                            firstName?: string | null | undefined
                            lastName?: string | null | undefined
                            email?: string | null | undefined
                          }
                        | null
                        | undefined
                      >
                    | null
                    | undefined
                  requestDetails?:
                    | Array<
                        | {
                            __typename?: 'RequestDetail'
                            reason?: string | null | undefined
                            start?:
                              | {
                                  __typename?: 'CalendarEventDate'
                                  date?: string | null | undefined
                                  dateTime?: string | null | undefined
                                  timeZone?: string | null | undefined
                                }
                              | null
                              | undefined
                            end?:
                              | {
                                  __typename?: 'CalendarEventDate'
                                  date?: string | null | undefined
                                  dateTime?: string | null | undefined
                                  timeZone?: string | null | undefined
                                }
                              | null
                              | undefined
                          }
                        | null
                        | undefined
                      >
                    | null
                    | undefined
                }
              | null
              | undefined
            >
          | null
          | undefined
      }
    | null
    | undefined
}

export type SearchMeetingListQueryVariables = Exact<{
  input: SearchMeetingListInput
}>

export type SearchMeetingListQuery = {
  __typename?: 'Query'
  searchMeetingList?:
    | {
        __typename?: 'GetTackleMeetingResponse'
        success: boolean
        message?: string | null | undefined
        pagination?: string | null | undefined
        error?: string | null | undefined
        data?:
          | Array<
              | {
                  __typename?: 'CalendarEvent'
                  summary?: string | null | undefined
                  description?: string | null | undefined
                  status?: string | null | undefined
                  eventTime?: string | null | undefined
                  meta?: string | null | undefined
                  location?: string | null | undefined
                  eventType?: string | null | undefined
                  advisorProfiles?: string | null | undefined
                  profile?: string | null | undefined
                  timezone?: string | null | undefined
                  eventId?: string | null | undefined
                  inviteeId?: string | null | undefined
                  advisorId?: string | null | undefined
                  availability?: string | null | undefined
                  comment?: string | null | undefined
                  videoLinkDescription?: string | null | undefined
                  organizerName?: string | null | undefined
                  participantName?: string | null | undefined
                  ownerId?: string | null | undefined
                  participantFirstName?: string | null | undefined
                  participantLastName?: string | null | undefined
                  organizerFirstName?: string | null | undefined
                  organizerLastName?: string | null | undefined
                  id?: string | null | undefined
                  transcriptUrl?: string | null | undefined
                  recordingUrl?: string | null | undefined
                  transcriptSummary?: string | null | undefined
                  transcriptSummaryFile?: string | null | undefined
                  teamMemberList?: Array<string | null | undefined> | null | undefined
                  start?:
                    | {
                        __typename?: 'CalendarEventDate'
                        dateTime?: string | null | undefined
                        timeZone?: string | null | undefined
                      }
                    | null
                    | undefined
                  end?:
                    | {
                        __typename?: 'CalendarEventDate'
                        dateTime?: string | null | undefined
                        timeZone?: string | null | undefined
                      }
                    | null
                    | undefined
                  attendees?:
                    | Array<{
                        __typename?: 'CalendarEventAttendee'
                        email: string
                        responseStatus?: string | null | undefined
                        optional?: boolean | null | undefined
                      }>
                    | null
                    | undefined
                  privateNotes?:
                    | Array<
                        | {
                            __typename?: 'PrivateNote'
                            content?: string | null | undefined
                            createdBy?: string | null | undefined
                            createdAt?: string | null | undefined
                            noteId?: string | null | undefined
                            advisorId?: string | null | undefined
                            tags?: Array<string> | null | undefined
                            files?:
                              | Array<{
                                  __typename?: 'UserFile'
                                  id?: string | null | undefined
                                  name?: string | null | undefined
                                  size?: string | null | undefined
                                  tenantId?: string | null | undefined
                                  type?: string | null | undefined
                                  url?: string | null | undefined
                                  userId?: string | null | undefined
                                  createdAt?: string | null | undefined
                                }>
                              | null
                              | undefined
                          }
                        | null
                        | undefined
                      >
                    | null
                    | undefined
                  teamMemberDetails?:
                    | Array<
                        | {
                            __typename?: 'TeamMemberDetails'
                            id?: string | null | undefined
                            firstName?: string | null | undefined
                            lastName?: string | null | undefined
                            email?: string | null | undefined
                          }
                        | null
                        | undefined
                      >
                    | null
                    | undefined
                  requestDetails?:
                    | Array<
                        | {
                            __typename?: 'RequestDetail'
                            reason?: string | null | undefined
                            start?:
                              | {
                                  __typename?: 'CalendarEventDate'
                                  date?: string | null | undefined
                                  dateTime?: string | null | undefined
                                  timeZone?: string | null | undefined
                                }
                              | null
                              | undefined
                            end?:
                              | {
                                  __typename?: 'CalendarEventDate'
                                  date?: string | null | undefined
                                  dateTime?: string | null | undefined
                                  timeZone?: string | null | undefined
                                }
                              | null
                              | undefined
                          }
                        | null
                        | undefined
                      >
                    | null
                    | undefined
                }
              | null
              | undefined
            >
          | null
          | undefined
      }
    | null
    | undefined
}

export type DeauthenticateConnectorMutationVariables = Exact<{
  input?: InputMaybe<DeauthenticateConnectorInput>
}>

export type DeauthenticateConnectorMutation = {
  __typename?: 'Mutation'
  deauthenticateConnector?:
    | {
        __typename?: 'ApiResponse'
        message?: string | null | undefined
        data?: string | null | undefined
        error?: string | null | undefined
      }
    | null
    | undefined
}

export type GetAllToolsQueryVariables = Exact<{
  tenantId?: InputMaybe<Scalars['String']>
}>

export type GetAllToolsQuery = {
  __typename?: 'Query'
  getAllTools?:
    | {
        __typename?: 'GetAllToolsResponse'
        success?: boolean | null | undefined
        message?: string | null | undefined
        error?: string | null | undefined
        data?:
          | Array<
              | {
                  __typename?: 'Tool'
                  id?: string | null | undefined
                  toolDisplayName?: string | null | undefined
                  cyclrToolId?: string | null | undefined
                  imageUrl?: string | null | undefined
                  toolName?: string | null | undefined
                  userToolsImageUrl?: string | null | undefined
                  connectionFormImageUrl?: string | null | undefined
                  toolUrl?: string | null | undefined
                  isConnected?: boolean | null | undefined
                  isRecommended?: boolean | null | undefined
                  recommendedBy?: string | null | undefined
                  isSelected?: boolean | null | undefined
                  pricingPageUrl?: string | null | undefined
                  group?: string | null | undefined
                  category?: string | null | undefined
                  visible?: boolean | null | undefined
                  supportLevel?: ToolSupportLevel | null | undefined
                  relatedPlays?: Array<string | null | undefined> | null | undefined
                  isBookmarked?: boolean | null | undefined
                  description?: string | null | undefined
                  diagnosticSupported?: boolean | null | undefined
                  longDescription?: string | null | undefined
                  toolHelpText?: string | null | undefined
                  authType?: ToolAuthType | null | undefined
                  options?:
                    | {
                        __typename?: 'ToolConnectionOptions'
                        connectionForm?:
                          | {
                              __typename?: 'ToolConnectionForm'
                              description: string
                              inputProperties: Array<{
                                __typename?: 'ToolConnectionFormInputProperty'
                                name: string
                                displayName: string
                                placeholder?: string | null | undefined
                                type: string
                                validationRules: Array<string>
                              }>
                            }
                          | null
                          | undefined
                      }
                    | null
                    | undefined
                }
              | null
              | undefined
            >
          | null
          | undefined
      }
    | null
    | undefined
}

export type UpdateOwnerMutationVariables = Exact<{
  input?: InputMaybe<UpdateOwnerInput>
}>

export type UpdateOwnerMutation = {
  __typename?: 'Mutation'
  updateOwner?:
    | {
        __typename?: 'ApiResponse'
        success: boolean
        message?: string | null | undefined
        data?: string | null | undefined
        error?: string | null | undefined
      }
    | null
    | undefined
}

export type GetUserToolsQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['String']>
  tenantId: Scalars['String']
}>

export type GetUserToolsQuery = {
  __typename?: 'Query'
  getUserTools?:
    | {
        __typename?: 'GetUserToolsResponse'
        success?: boolean | null | undefined
        message?: string | null | undefined
        error?: string | null | undefined
        data?:
          | Array<
              | {
                  __typename?: 'Tool'
                  id?: string | null | undefined
                  cyclrToolId?: string | null | undefined
                  imageUrl?: string | null | undefined
                  toolName?: string | null | undefined
                  toolDisplayName?: string | null | undefined
                  userToolsImageUrl?: string | null | undefined
                  connectionFormImageUrl?: string | null | undefined
                  toolUrl?: string | null | undefined
                  isConnected?: boolean | null | undefined
                  isRecommended?: boolean | null | undefined
                  recommendedBy?: string | null | undefined
                  isSelected?: boolean | null | undefined
                  group?: string | null | undefined
                  category?: string | null | undefined
                  visible?: boolean | null | undefined
                  connectionStatus?: string | null | undefined
                  connectorName?: string | null | undefined
                  isBookmarked?: boolean | null | undefined
                  supportLevel?: ToolSupportLevel | null | undefined
                  description?: string | null | undefined
                  diagnosticSupported?: boolean | null | undefined
                  longDescription?: string | null | undefined
                  toolHelpText?: string | null | undefined
                  relatedPlays?: Array<string | null | undefined> | null | undefined
                  authType?: ToolAuthType | null | undefined
                  options?:
                    | {
                        __typename?: 'ToolConnectionOptions'
                        connectionForm?:
                          | {
                              __typename?: 'ToolConnectionForm'
                              description: string
                              inputProperties: Array<{
                                __typename?: 'ToolConnectionFormInputProperty'
                                name: string
                                displayName: string
                                placeholder?: string | null | undefined
                                type: string
                                validationRules: Array<string>
                              }>
                            }
                          | null
                          | undefined
                      }
                    | null
                    | undefined
                }
              | null
              | undefined
            >
          | null
          | undefined
      }
    | null
    | undefined
}

export type GetAttestationReportsQueryVariables = Exact<{
  input: GetAttestationReportsInput
}>

export type GetAttestationReportsQuery = {
  __typename?: 'Query'
  getAttestationReports?:
    | {
        __typename?: 'GetAttestationReportsResponse'
        error?: string | null | undefined
        data?:
          | {
              __typename?: 'GetAttestationReportsResponseObj'
              lastEvaluatedKey?: string | null | undefined
              prevEvaluatedKey?: string | null | undefined
              totalPages?: number | null | undefined
              totalRecords?: number | null | undefined
              pageSize?: number | null | undefined
              currentPage?: number | null | undefined
              items?:
                | Array<
                    | {
                        __typename?: 'Attestation'
                        month?: string | null | undefined
                        year?: string | null | undefined
                        contractors?: string | null | undefined
                        businessBankAccount?: string | null | undefined
                        jobsCreated?: string | null | undefined
                        volunteers?: string | null | undefined
                        partTimeEmployees?: string | null | undefined
                        fullTimeEmployees?: string | null | undefined
                        gender?: string | null | undefined
                        race?: string | null | undefined
                        education?: string | null | undefined
                        wages?: string | null | undefined
                        revenue?: string | null | undefined
                        debtFinancing?: string | null | undefined
                        financialGrowth?: string | null | undefined
                        newCustomer?: string | null | undefined
                        productSale?: string | null | undefined
                        serviceSale?: string | null | undefined
                        targetAudience?: string | null | undefined
                        physicalLocation?: string | null | undefined
                        businessName?: string | null | undefined
                        name?: string | null | undefined
                        signedDocumentUrl?: string | null | undefined
                        properName?: string | null | undefined
                      }
                    | null
                    | undefined
                  >
                | null
                | undefined
            }
          | null
          | undefined
      }
    | null
    | undefined
}

export type ToolConnectionSuccessMutationVariables = Exact<{
  input?: InputMaybe<ToolConnectionSuccessInput>
}>

export type ToolConnectionSuccessMutation = {
  __typename?: 'Mutation'
  toolConnectionSuccess?:
    | {
        __typename?: 'ApiResponse'
        success: boolean
        message?: string | null | undefined
        data?: string | null | undefined
        error?: string | null | undefined
      }
    | null
    | undefined
}

export type BookmarkToolMutationVariables = Exact<{
  input: BookmarkToolInput
}>

export type BookmarkToolMutation = {
  __typename?: 'Mutation'
  bookmarkTool?:
    | {
        __typename?: 'BookmarkToolResponse'
        success?: boolean | null | undefined
        message?: string | null | undefined
        error?: string | null | undefined
        data?:
          | {
              __typename?: 'Tool'
              id?: string | null | undefined
              cyclrToolId?: string | null | undefined
              imageUrl?: string | null | undefined
              toolName?: string | null | undefined
              toolDisplayName?: string | null | undefined
              userToolsImageUrl?: string | null | undefined
              connectionFormImageUrl?: string | null | undefined
              toolUrl?: string | null | undefined
              isConnected?: boolean | null | undefined
              isRecommended?: boolean | null | undefined
              recommendedBy?: string | null | undefined
              isSelected?: boolean | null | undefined
              group?: string | null | undefined
              category?: string | null | undefined
              visible?: boolean | null | undefined
              connectionStatus?: string | null | undefined
              connectorName?: string | null | undefined
              isBookmarked?: boolean | null | undefined
              supportLevel?: ToolSupportLevel | null | undefined
              description?: string | null | undefined
              diagnosticSupported?: boolean | null | undefined
              longDescription?: string | null | undefined
              toolHelpText?: string | null | undefined
              options?:
                | {
                    __typename?: 'ToolConnectionOptions'
                    connectionForm?:
                      | {
                          __typename?: 'ToolConnectionForm'
                          description: string
                          inputProperties: Array<{
                            __typename?: 'ToolConnectionFormInputProperty'
                            name: string
                            displayName: string
                            placeholder?: string | null | undefined
                            type: string
                            validationRules: Array<string>
                          }>
                        }
                      | null
                      | undefined
                  }
                | null
                | undefined
            }
          | null
          | undefined
      }
    | null
    | undefined
}

export type ProcessToolBusinessDataMutationVariables = Exact<{
  input: ProcessToolBusinessDataInput
}>

export type ProcessToolBusinessDataMutation = {
  __typename?: 'Mutation'
  processToolBusinessData: string
}

export type GoalDetailsFieldsFragment = {
  __typename?: 'Goal'
  id: string
  name?: string | null | undefined
  description?: string | null | undefined
  isTopGoal?: boolean | null | undefined
  isActiveGoal?: boolean | null | undefined
  assessments?: string | null | undefined
  createdAt?: string | null | undefined
  orderOfSequence?: string | null | undefined
}

export type GetGoalDetailsQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']>
  businessId: Scalars['String']
}>

export type GetGoalDetailsQuery = {
  __typename?: 'Query'
  getGoalDetails?:
    | {
        __typename?: 'Goal'
        id: string
        name?: string | null | undefined
        description?: string | null | undefined
        isTopGoal?: boolean | null | undefined
        isActiveGoal?: boolean | null | undefined
        assessments?: string | null | undefined
        createdAt?: string | null | undefined
        orderOfSequence?: string | null | undefined
      }
    | null
    | undefined
}

export type GetUserGoalsQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['String']>
  tenantId?: InputMaybe<Scalars['String']>
}>

export type GetUserGoalsQuery = {
  __typename?: 'Query'
  getUserGoals?:
    | Array<
        | {
            __typename?: 'Goal'
            id: string
            name?: string | null | undefined
            description?: string | null | undefined
            isTopGoal?: boolean | null | undefined
            isActiveGoal?: boolean | null | undefined
            assessments?: string | null | undefined
            createdAt?: string | null | undefined
            orderOfSequence?: string | null | undefined
          }
        | null
        | undefined
      >
    | null
    | undefined
}

export type AddInsightMutationVariables = Exact<{
  input: AddInsightInput
}>

export type AddInsightMutation = {
  __typename?: 'Mutation'
  addInsight?:
    | {
        __typename?: 'Insight'
        insightId: string
        name: string
        description?: string | null | undefined
        category?: string | null | undefined
        priority?: InsightPriority | null | undefined
        why?: string | null | undefined
        suggestedBy?: string | null | undefined
        feedback?: FeedbackType | null | undefined
        hasBeenViewed?: boolean | null | undefined
        createdAt: string
        updatedAt: string
        goalsId?: Array<string> | null | undefined
        playsId?: Array<string> | null | undefined
        internal_context?: string | null | undefined
        metadata?: string | null | undefined
        metrics?:
          | Array<{
              __typename?: 'InsightMetric'
              metricTitle: string
              current_status: number
              benchmark: number
              trend: string
            }>
          | null
          | undefined
        feedbackMessage: Array<{
          __typename?: 'FeedbackMessage'
          coachlogic?: string | null | undefined
          client?: string | null | undefined
        }>
      }
    | null
    | undefined
}

export type CheckNewInsightsAvailableQueryVariables = Exact<{
  userId: Scalars['String']
  tenantId: Scalars['String']
}>

export type CheckNewInsightsAvailableQuery = {
  __typename?: 'Query'
  checkNewInsightsAvailable: {
    __typename?: 'NewInsightsCheckResponse'
    hasNewInsights: boolean
    insightsCount?: number | null | undefined
    lastInsightGeneratedAt?: string | null | undefined
    shouldShowPopup: boolean
  }
}

export type UpdateInsightsNotificationStatusMutationVariables = Exact<{
  input: UpdateInsightsNotificationInput
}>

export type UpdateInsightsNotificationStatusMutation = {
  __typename?: 'Mutation'
  updateInsightsNotificationStatus?:
    | {
        __typename?: 'UserProfile'
        id: string
        lastNewInsightsPopupShownAt?: string | null | undefined
        lastNewInsightsViewedAt?: string | null | undefined
      }
    | null
    | undefined
}

export type GetInsightQueryVariables = Exact<{
  tenantId: Scalars['ID']
  userId?: InputMaybe<Scalars['ID']>
  insightId: Scalars['ID']
}>

export type GetInsightQuery = {
  __typename?: 'Query'
  getInsight?:
    | {
        __typename?: 'Insight'
        insightId: string
        name: string
        description?: string | null | undefined
        category?: string | null | undefined
        priority?: InsightPriority | null | undefined
        why?: string | null | undefined
        suggestedBy?: string | null | undefined
        feedback?: FeedbackType | null | undefined
        hasBeenViewed?: boolean | null | undefined
        createdAt: string
        updatedAt: string
        goalsId?: Array<string> | null | undefined
        playsId?: Array<string> | null | undefined
        internal_context?: string | null | undefined
        session?: string | null | undefined
        isApproved?: boolean | null | undefined
        metrics?:
          | Array<{
              __typename?: 'InsightMetric'
              metricTitle: string
              current_status: number
              benchmark: number
              trend: string
            }>
          | null
          | undefined
      }
    | null
    | undefined
}

export type GetInsightsQueryVariables = Exact<{
  tenantId: Scalars['ID']
  userId?: InputMaybe<Scalars['ID']>
  priority?: InputMaybe<InsightPriority>
  hasBeenViewed?: InputMaybe<Scalars['Boolean']>
}>

export type GetInsightsQuery = {
  __typename?: 'Query'
  getInsights: {
    __typename?: 'InsightsConnection'
    nextToken?: string | null | undefined
    items: Array<{
      __typename?: 'Insight'
      insightId: string
      name: string
      description?: string | null | undefined
      category?: string | null | undefined
      priority?: InsightPriority | null | undefined
      why?: string | null | undefined
      suggestedBy?: string | null | undefined
      feedback?: FeedbackType | null | undefined
      hasBeenViewed?: boolean | null | undefined
      createdAt: string
      updatedAt: string
      goalsId?: Array<string> | null | undefined
      playsId?: Array<string> | null | undefined
      internal_context?: string | null | undefined
      session?: string | null | undefined
      isApproved?: boolean | null | undefined
      metrics?:
        | Array<{
            __typename?: 'InsightMetric'
            metricTitle: string
            current_status: number
            benchmark: number
            trend: string
          }>
        | null
        | undefined
    }>
  }
}

export type UpdateInsightMutationVariables = Exact<{
  input: UpdateInsightInput
}>

export type UpdateInsightMutation = {
  __typename?: 'Mutation'
  updateInsight?:
    | {
        __typename?: 'Insight'
        insightId: string
        name: string
        description?: string | null | undefined
        category?: string | null | undefined
        priority?: InsightPriority | null | undefined
        why?: string | null | undefined
        suggestedBy?: string | null | undefined
        feedback?: FeedbackType | null | undefined
        hasBeenViewed?: boolean | null | undefined
        createdAt: string
        updatedAt: string
        goalsId?: Array<string> | null | undefined
        playsId?: Array<string> | null | undefined
        internal_context?: string | null | undefined
        metadata?: string | null | undefined
        session?: string | null | undefined
        isApproved?: boolean | null | undefined
        metrics?:
          | Array<{
              __typename?: 'InsightMetric'
              metricTitle: string
              current_status: number
              benchmark: number
              trend: string
            }>
          | null
          | undefined
        feedbackMessage: Array<{
          __typename?: 'FeedbackMessage'
          coachlogic?: string | null | undefined
          client?: string | null | undefined
        }>
      }
    | null
    | undefined
}

export type GetPendingJobsFieldsFragment = {
  __typename?: 'JobDto'
  id: string
  status: JobStatus
  type: JobTypes
  createdAt?: string | null | undefined
  updatedAt?: string | null | undefined
  payload?: string | null | undefined
}

export type GetPendingJobsQueryVariables = Exact<{ [key: string]: never }>

export type GetPendingJobsQuery = {
  __typename?: 'Query'
  getPendingJobs: Array<{
    __typename?: 'JobDto'
    id: string
    status: JobStatus
    type: JobTypes
    createdAt?: string | null | undefined
    updatedAt?: string | null | undefined
    payload?: string | null | undefined
  }>
}

export type MetricValueFieldsFragment = {
  __typename?: 'MetricValue'
  counter?:
    | {
        __typename?: 'CounterResponse'
        value?: number | null | undefined
        lastUpdatedAt?: string | null | undefined
        refreshInProgress?: boolean | null | undefined
      }
    | null
    | undefined
}

export type GetPlayCountMetricsQueryVariables = Exact<{
  asOfDate: Scalars['AWSDate']
  targetUserId?: InputMaybe<Scalars['ID']>
}>

export type GetPlayCountMetricsQuery = {
  __typename?: 'Query'
  playCount?:
    | {
        __typename?: 'MetricValue'
        counter?:
          | {
              __typename?: 'CounterResponse'
              value?: number | null | undefined
              lastUpdatedAt?: string | null | undefined
              refreshInProgress?: boolean | null | undefined
            }
          | null
          | undefined
      }
    | null
    | undefined
  playCountUsers?:
    | {
        __typename?: 'MetricValue'
        counter?:
          | {
              __typename?: 'CounterResponse'
              value?: number | null | undefined
              lastUpdatedAt?: string | null | undefined
              refreshInProgress?: boolean | null | undefined
            }
          | null
          | undefined
      }
    | null
    | undefined
}

export type GetTouchdownCountMetricsQueryVariables = Exact<{
  asOfDate: Scalars['AWSDate']
  targetUserId?: InputMaybe<Scalars['ID']>
}>

export type GetTouchdownCountMetricsQuery = {
  __typename?: 'Query'
  tdCount?:
    | {
        __typename?: 'MetricValue'
        counter?:
          | {
              __typename?: 'CounterResponse'
              value?: number | null | undefined
              lastUpdatedAt?: string | null | undefined
              refreshInProgress?: boolean | null | undefined
            }
          | null
          | undefined
      }
    | null
    | undefined
  tdCountUsers?:
    | {
        __typename?: 'MetricValue'
        counter?:
          | {
              __typename?: 'CounterResponse'
              value?: number | null | undefined
              lastUpdatedAt?: string | null | undefined
              refreshInProgress?: boolean | null | undefined
            }
          | null
          | undefined
      }
    | null
    | undefined
}

export type GetFumbleCountMetricsQueryVariables = Exact<{
  asOfDate: Scalars['AWSDate']
  targetUserId?: InputMaybe<Scalars['ID']>
}>

export type GetFumbleCountMetricsQuery = {
  __typename?: 'Query'
  fumbleCount?:
    | {
        __typename?: 'MetricValue'
        counter?:
          | {
              __typename?: 'CounterResponse'
              value?: number | null | undefined
              lastUpdatedAt?: string | null | undefined
              refreshInProgress?: boolean | null | undefined
            }
          | null
          | undefined
      }
    | null
    | undefined
  fumbleCountUsers?:
    | {
        __typename?: 'MetricValue'
        counter?:
          | {
              __typename?: 'CounterResponse'
              value?: number | null | undefined
              lastUpdatedAt?: string | null | undefined
              refreshInProgress?: boolean | null | undefined
            }
          | null
          | undefined
      }
    | null
    | undefined
}

export type ChartDataFieldsFragment = {
  __typename?: 'ApiResponse'
  success: boolean
  message?: string | null | undefined
  data?: string | null | undefined
  error?: string | null | undefined
}

export type GetChartDataQueryVariables = Exact<{
  input: GetChartDataInput
}>

export type GetChartDataQuery = {
  __typename?: 'Query'
  getChartData?:
    | {
        __typename?: 'ApiResponse'
        success: boolean
        message?: string | null | undefined
        data?: string | null | undefined
        error?: string | null | undefined
      }
    | null
    | undefined
}

export type OwnerBusinessDataFieldsFragment = {
  __typename?: 'ApiResponse'
  success: boolean
  message?: string | null | undefined
  data?: string | null | undefined
  error?: string | null | undefined
}

export type GetOwnerBusinessDataQueryVariables = Exact<{
  input?: InputMaybe<GetOwnerBusinessDataInput>
}>

export type GetOwnerBusinessDataQuery = {
  __typename?: 'Query'
  getOwnerBusinessData?:
    | {
        __typename?: 'ApiResponse'
        success: boolean
        message?: string | null | undefined
        data?: string | null | undefined
        error?: string | null | undefined
      }
    | null
    | undefined
}

export type GetPlayFieldsFragment = {
  __typename?: 'ApiResponse'
  success: boolean
  message?: string | null | undefined
  data?: string | null | undefined
  error?: string | null | undefined
}

export type GetPlaysFieldsFragment = {
  __typename?: 'GetPlaysResponse'
  success: boolean
  message?: string | null | undefined
  error?: string | null | undefined
  data?:
    | Array<
        | {
            __typename?: 'Play'
            id: string
            content?: string | null | undefined
            title?: string | null | undefined
            type?: string | null | undefined
            recommendedBy?: string | null | undefined
            meta?: string | null | undefined
            guide?: string | null | undefined
            guide1?: string | null | undefined
            setup?: string | null | undefined
            use?: string | null | undefined
            description?: string | null | undefined
            playTabs?: string | null | undefined
          }
        | null
        | undefined
      >
    | null
    | undefined
}

export type AuthorizeConnectorFieldsFragment = {
  __typename?: 'ApiResponse'
  success: boolean
  message?: string | null | undefined
  data?: string | null | undefined
  error?: string | null | undefined
}

export type PlayResponseFieldsFragment = {
  __typename?: 'PlayResponse'
  tenantId?: string | null | undefined
  playId?: string | null | undefined
  playType?: string | null | undefined
  isCompleted?: boolean | null | undefined
  completedAt?: string | null | undefined
  completedBy?: string | null | undefined
  recommendations?: Array<string> | null | undefined
  businessProfileFields?:
    | { __typename?: 'BusinessProfileFields'; logo?: string | null | undefined }
    | null
    | undefined
  playTabResponse?:
    | Array<{
        __typename?: 'TabResponse'
        id?: string | null | undefined
        tabName?: string | null | undefined
        isCompleted?: boolean | null | undefined
        completedAt?: string | null | undefined
        stepResponse?:
          | Array<{
              __typename?: 'StepResponse'
              id?: string | null | undefined
              stepTitle?: string | null | undefined
              isCompleted?: boolean | null | undefined
              completedAt?: string | null | undefined
              stepData?:
                | Array<{
                    __typename?: 'StepData'
                    id?: string | null | undefined
                    value?: Array<string> | null | undefined
                    label?: Array<string> | null | undefined
                    isCompleted?: boolean | null | undefined
                    completedAt?: string | null | undefined
                    recommendations?: Array<string> | null | undefined
                    isMeetingScheduled?: boolean | null | undefined
                    businessProfileFields?:
                      | {
                          __typename?: 'StepBusinessProfileFields'
                          logo?:
                            | {
                                __typename?: 'FileStructure'
                                id?: string | null | undefined
                                name?: string | null | undefined
                                size?: string | null | undefined
                                tenantId?: string | null | undefined
                                type?: string | null | undefined
                                url?: string | null | undefined
                                userId?: string | null | undefined
                              }
                            | null
                            | undefined
                        }
                      | null
                      | undefined
                  }>
                | null
                | undefined
            }>
          | null
          | undefined
      }>
    | null
    | undefined
}

export type GetPlayQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']>
}>

export type GetPlayQuery = {
  __typename?: 'Query'
  getPlay?:
    | {
        __typename?: 'ApiResponse'
        success: boolean
        message?: string | null | undefined
        data?: string | null | undefined
        error?: string | null | undefined
      }
    | null
    | undefined
}

export type GetPlaysQueryVariables = Exact<{
  input?: InputMaybe<GetPlaysInput>
}>

export type GetPlaysQuery = {
  __typename?: 'Query'
  getPlays?:
    | {
        __typename?: 'GetPlaysResponse'
        success: boolean
        message?: string | null | undefined
        error?: string | null | undefined
        data?:
          | Array<
              | {
                  __typename?: 'Play'
                  id: string
                  content?: string | null | undefined
                  title?: string | null | undefined
                  type?: string | null | undefined
                  recommendedBy?: string | null | undefined
                  meta?: string | null | undefined
                  guide?: string | null | undefined
                  guide1?: string | null | undefined
                  setup?: string | null | undefined
                  use?: string | null | undefined
                  description?: string | null | undefined
                  playTabs?: string | null | undefined
                }
              | null
              | undefined
            >
          | null
          | undefined
      }
    | null
    | undefined
}

export type GetPlayResponseQueryVariables = Exact<{
  input: GetPlayResponseInput
}>

export type GetPlayResponseQuery = {
  __typename?: 'Query'
  getPlayResponse?:
    | Array<{
        __typename?: 'PlayResponse'
        tenantId?: string | null | undefined
        playId?: string | null | undefined
        playType?: string | null | undefined
        isCompleted?: boolean | null | undefined
        completedAt?: string | null | undefined
        completedBy?: string | null | undefined
        recommendations?: Array<string> | null | undefined
        businessProfileFields?:
          | { __typename?: 'BusinessProfileFields'; logo?: string | null | undefined }
          | null
          | undefined
        playTabResponse?:
          | Array<{
              __typename?: 'TabResponse'
              id?: string | null | undefined
              tabName?: string | null | undefined
              isCompleted?: boolean | null | undefined
              completedAt?: string | null | undefined
              stepResponse?:
                | Array<{
                    __typename?: 'StepResponse'
                    id?: string | null | undefined
                    stepTitle?: string | null | undefined
                    isCompleted?: boolean | null | undefined
                    completedAt?: string | null | undefined
                    stepData?:
                      | Array<{
                          __typename?: 'StepData'
                          id?: string | null | undefined
                          value?: Array<string> | null | undefined
                          label?: Array<string> | null | undefined
                          isCompleted?: boolean | null | undefined
                          completedAt?: string | null | undefined
                          recommendations?: Array<string> | null | undefined
                          isMeetingScheduled?: boolean | null | undefined
                          businessProfileFields?:
                            | {
                                __typename?: 'StepBusinessProfileFields'
                                logo?:
                                  | {
                                      __typename?: 'FileStructure'
                                      id?: string | null | undefined
                                      name?: string | null | undefined
                                      size?: string | null | undefined
                                      tenantId?: string | null | undefined
                                      type?: string | null | undefined
                                      url?: string | null | undefined
                                      userId?: string | null | undefined
                                    }
                                  | null
                                  | undefined
                              }
                            | null
                            | undefined
                        }>
                      | null
                      | undefined
                  }>
                | null
                | undefined
            }>
          | null
          | undefined
      }>
    | null
    | undefined
}

export type SavePlayResponseMutationVariables = Exact<{
  input: SavePlayResponseInput
}>

export type SavePlayResponseMutation = {
  __typename?: 'Mutation'
  savePlayResponse?:
    | {
        __typename?: 'PlayResponse'
        tenantId?: string | null | undefined
        playId?: string | null | undefined
        playType?: string | null | undefined
        isCompleted?: boolean | null | undefined
        completedAt?: string | null | undefined
        completedBy?: string | null | undefined
        recommendations?: Array<string> | null | undefined
        businessProfileFields?:
          | { __typename?: 'BusinessProfileFields'; logo?: string | null | undefined }
          | null
          | undefined
        playTabResponse?:
          | Array<{
              __typename?: 'TabResponse'
              id?: string | null | undefined
              tabName?: string | null | undefined
              isCompleted?: boolean | null | undefined
              completedAt?: string | null | undefined
              stepResponse?:
                | Array<{
                    __typename?: 'StepResponse'
                    id?: string | null | undefined
                    stepTitle?: string | null | undefined
                    isCompleted?: boolean | null | undefined
                    completedAt?: string | null | undefined
                    stepData?:
                      | Array<{
                          __typename?: 'StepData'
                          id?: string | null | undefined
                          value?: Array<string> | null | undefined
                          label?: Array<string> | null | undefined
                          isCompleted?: boolean | null | undefined
                          completedAt?: string | null | undefined
                          recommendations?: Array<string> | null | undefined
                          isMeetingScheduled?: boolean | null | undefined
                          businessProfileFields?:
                            | {
                                __typename?: 'StepBusinessProfileFields'
                                logo?:
                                  | {
                                      __typename?: 'FileStructure'
                                      id?: string | null | undefined
                                      name?: string | null | undefined
                                      size?: string | null | undefined
                                      tenantId?: string | null | undefined
                                      type?: string | null | undefined
                                      url?: string | null | undefined
                                      userId?: string | null | undefined
                                    }
                                  | null
                                  | undefined
                              }
                            | null
                            | undefined
                        }>
                      | null
                      | undefined
                  }>
                | null
                | undefined
            }>
          | null
          | undefined
      }
    | null
    | undefined
}

export type AuthorizeConnectorMutationVariables = Exact<{
  authValue: Scalars['String']
}>

export type AuthorizeConnectorMutation = {
  __typename?: 'Mutation'
  authorizeConnector?:
    | {
        __typename?: 'ApiResponse'
        success: boolean
        message?: string | null | undefined
        data?: string | null | undefined
        error?: string | null | undefined
      }
    | null
    | undefined
}

export type DashboardListingFieldsFragment = {
  __typename?: 'ApiResponse'
  success: boolean
  message?: string | null | undefined
  data?: string | null | undefined
  error?: string | null | undefined
}

export type AssessmentPlayListingFieldsFragment = {
  __typename?: 'ApiResponse'
  success: boolean
  message?: string | null | undefined
  data?: string | null | undefined
  error?: string | null | undefined
}

export type GetDashboardListingQueryVariables = Exact<{
  tenantId: Scalars['String']
  category?: InputMaybe<Scalars['String']>
}>

export type GetDashboardListingQuery = {
  __typename?: 'Query'
  getDashboardListing?:
    | {
        __typename?: 'ApiResponse'
        success: boolean
        message?: string | null | undefined
        data?: string | null | undefined
        error?: string | null | undefined
      }
    | null
    | undefined
}

export type GetAssessmentPlayListingQueryVariables = Exact<{
  tenantId: Scalars['String']
}>

export type GetAssessmentPlayListingQuery = {
  __typename?: 'Query'
  getAssessmentPlayListing?:
    | {
        __typename?: 'ApiResponse'
        success: boolean
        message?: string | null | undefined
        data?: string | null | undefined
        error?: string | null | undefined
      }
    | null
    | undefined
}

export type AddPrivateNoteMutationVariables = Exact<{
  calendarId: Scalars['String']
  note: PrivateNoteInput
}>

export type AddPrivateNoteMutation = {
  __typename?: 'Mutation'
  addPrivateNoteToCalendarEvent: boolean
}

export type RequestMeetingMutationVariables = Exact<{
  calendarId: Scalars['ID']
  requestDetail: RequestDetailInput
}>

export type RequestMeetingMutation = { __typename?: 'Mutation'; requestMeeting: boolean }

export type UpdateTranscriptSummaryMutationVariables = Exact<{
  calendarId: Scalars['String']
  summaryDetails: TranscriptSummaryInput
}>

export type UpdateTranscriptSummaryMutation = {
  __typename?: 'Mutation'
  updateTranscriptSummary: boolean
}

export type UpdatePrivateNoteMutationVariables = Exact<{
  calendarId: Scalars['String']
  note: PrivateNoteInput
}>

export type UpdatePrivateNoteMutation = {
  __typename?: 'Mutation'
  updatePrivateNoteInCalendarEvent: boolean
}

export type DeletePrivateNoteMutationVariables = Exact<{
  calendarId: Scalars['String']
  noteId: Scalars['ID']
}>

export type DeletePrivateNoteMutation = { __typename?: 'Mutation'; deletePrivateNote: boolean }

export type GetUserMeetingTasksQueryVariables = Exact<{
  input: GetUserMeetingTasksInput
}>

export type GetUserMeetingTasksQuery = {
  __typename?: 'Query'
  getUserMeetingTasks?:
    | Array<{
        __typename?: 'UserTask'
        tenantId?: string | null | undefined
        userId?: string | null | undefined
        taskId?: string | null | undefined
        planId?: string | null | undefined
        milestoneId?: string | null | undefined
        name?: string | null | undefined
        status?: UserTaskItemStatus | null | undefined
        tool?: string | null | undefined
        timeline?: string | null | undefined
        startDate?: string | null | undefined
        expectedEndDate?: string | null | undefined
        howToDo?: string | null | undefined
        estimatedEffortInMinutes?: number | null | undefined
        instructionForTask?: string | null | undefined
        kpis?: string | null | undefined
        role?: string | null | undefined
        why?: string | null | undefined
        order?: number | null | undefined
        resources?: string | null | undefined
        createdBy?: string | null | undefined
        createdById?: string | null | undefined
        taskPriority?: BusinessGoalPriority | null | undefined
        category?: BusinessGoalCategory | null | undefined
        assigneeId?: string | null | undefined
        isCarryOver?: boolean | null | undefined
        goalId?: string | null | undefined
        isOverDue?: boolean | null | undefined
        suggestedStatus?: UserTaskSuggestedItemStatus | null | undefined
        businessAvatar?: string | null | undefined
        planName?: string | null | undefined
        planStartDate?: string | null | undefined
        planExpectedEndDate?: string | null | undefined
        businessHoursSpentPerDay?: number | null | undefined
        goalEndDate?: string | null | undefined
        meetingId?: string | null | undefined
        howToLinks?:
          | Array<
              | {
                  __typename?: 'UserTaskHowTo'
                  howToId: string
                  title?: string | null | undefined
                  url?: string | null | undefined
                }
              | null
              | undefined
            >
          | null
          | undefined
        files?:
          | Array<{
              __typename?: 'UserFile'
              id?: string | null | undefined
              name?: string | null | undefined
              size?: string | null | undefined
              tenantId?: string | null | undefined
              type?: string | null | undefined
              url?: string | null | undefined
              userId?: string | null | undefined
              createdAt?: string | null | undefined
            }>
          | null
          | undefined
        businessAdvisorsData?:
          | Array<
              | {
                  __typename?: 'BusinessAdvisorsData'
                  label?: string | null | undefined
                  value?: string | null | undefined
                }
              | null
              | undefined
            >
          | null
          | undefined
      }>
    | null
    | undefined
}

export type OnTaskProgressUpdatedSubscriptionVariables = Exact<{
  id: Scalars['ID']
}>

export type OnTaskProgressUpdatedSubscription = {
  __typename?: 'Subscription'
  onTaskProgressUpdated?:
    | {
        __typename?: 'TaskResult'
        id?: string | null | undefined
        status?: string | null | undefined
        payload?: string | null | undefined
      }
    | null
    | undefined
}

export type OnRealTimeNotificationSubscriptionVariables = Exact<{
  topic: Scalars['String']
  key?: InputMaybe<Scalars['String']>
}>

export type OnRealTimeNotificationSubscription = {
  __typename?: 'Subscription'
  onRealTimeNotification?:
    | {
        __typename?: 'RealTimeNotification'
        topic: RealTimeNotificationTopic
        key?: string | null | undefined
        data?: string | null | undefined
      }
    | null
    | undefined
}

export type PublishRealTimeNotificationMutationVariables = Exact<{
  input: RealTimeNotificationInput
}>

export type PublishRealTimeNotificationMutation = {
  __typename?: 'Mutation'
  publishRealTimeNotification?:
    | {
        __typename?: 'RealTimeNotification'
        topic: RealTimeNotificationTopic
        key?: string | null | undefined
        data?: string | null | undefined
      }
    | null
    | undefined
}

export type CreateTeamMemberMutationVariables = Exact<{
  input: CreateTeamMemberInput
}>

export type CreateTeamMemberMutation = {
  __typename?: 'Mutation'
  createTeamMember?:
    | {
        __typename?: 'BusinessUser'
        id: string
        userId: string
        businessId: string
        type: BusinessUserType
        createdAt: string
        updatedAt: string
        user: {
          __typename?: 'UserProfile'
          id: string
          email: string
          firstName?: string | null | undefined
          lastName?: string | null | undefined
          roles?: Array<string | null | undefined> | null | undefined
        }
      }
    | null
    | undefined
}

export type GetToolsFieldsFragment = {
  __typename?: 'GetToolsResponse'
  success: boolean
  message?: string | null | undefined
  error?: string | null | undefined
  data?:
    | Array<
        | {
            __typename?: 'Tool'
            id?: string | null | undefined
            toolName?: string | null | undefined
          }
        | null
        | undefined
      >
    | null
    | undefined
}

export type GetToolsQueryVariables = Exact<{ [key: string]: never }>

export type GetToolsQuery = {
  __typename?: 'Query'
  getTools?:
    | {
        __typename?: 'GetToolsResponse'
        success: boolean
        message?: string | null | undefined
        error?: string | null | undefined
        data?:
          | Array<
              | {
                  __typename?: 'Tool'
                  id?: string | null | undefined
                  toolName?: string | null | undefined
                }
              | null
              | undefined
            >
          | null
          | undefined
      }
    | null
    | undefined
}

export type ToolFieldsFragment = {
  __typename?: 'GetToolsByTypeResponse'
  error?: string | null | undefined
  data?:
    | Array<
        | {
            __typename?: 'Tool'
            id?: string | null | undefined
            cyclrToolId?: string | null | undefined
            imageUrl?: string | null | undefined
            toolName?: string | null | undefined
            userToolsImageUrl?: string | null | undefined
            toolUrl?: string | null | undefined
            isConnected?: boolean | null | undefined
            isRecommended?: boolean | null | undefined
            recommendedBy?: string | null | undefined
            isSelected?: boolean | null | undefined
            group?: string | null | undefined
            category?: string | null | undefined
            visible?: boolean | null | undefined
            toolType?: ToolType | null | undefined
            authType?: ToolAuthType | null | undefined
            supportLevel?: ToolSupportLevel | null | undefined
          }
        | null
        | undefined
      >
    | null
    | undefined
}

export type ToolCategoriesFieldsFragment = {
  __typename?: 'GetAllToolCategoriesResponse'
  categories: Array<{
    __typename?: 'GetAllToolCategoriesResponseItem'
    name: string
    description?: string | null | undefined
    clientDescription?: string | null | undefined
  }>
  subCategories: Array<{ __typename?: 'GetAllToolCategoriesResponseItem'; name: string }>
}

export type SearchToolsFieldsFragment = {
  __typename?: 'SearchToolsResponse'
  numberOfPages?: number | null | undefined
  data: Array<{
    __typename?: 'Tool'
    id?: string | null | undefined
    cyclrToolId?: string | null | undefined
    imageUrl?: string | null | undefined
    toolName?: string | null | undefined
    toolDisplayName?: string | null | undefined
    connectionFormImageUrl?: string | null | undefined
    userToolsImageUrl?: string | null | undefined
    toolUrl?: string | null | undefined
    isConnected?: boolean | null | undefined
    isRecommended?: boolean | null | undefined
    recommendedBy?: string | null | undefined
    isSelected?: boolean | null | undefined
    group?: string | null | undefined
    category?: string | null | undefined
    visible?: boolean | null | undefined
    connectionStatus?: string | null | undefined
    connectorName?: string | null | undefined
    pricingPageUrl?: string | null | undefined
    tags?: Array<string> | null | undefined
    subCategory?: string | null | undefined
    supportLevel?: ToolSupportLevel | null | undefined
    relatedPlays?: Array<string | null | undefined> | null | undefined
    isBookmarked?: boolean | null | undefined
    description?: string | null | undefined
    diagnosticSupported?: boolean | null | undefined
    longDescription?: string | null | undefined
    authType?: ToolAuthType | null | undefined
    toolHelpText?: string | null | undefined
    clientId?: string | null | undefined
    clientSecret?: string | null | undefined
    options?:
      | {
          __typename?: 'ToolConnectionOptions'
          connectionForm?:
            | {
                __typename?: 'ToolConnectionForm'
                description: string
                inputProperties: Array<{
                  __typename?: 'ToolConnectionFormInputProperty'
                  name: string
                  displayName: string
                  placeholder?: string | null | undefined
                  type: string
                  validationRules: Array<string>
                }>
              }
            | null
            | undefined
        }
      | null
      | undefined
    categories?:
      | Array<{ __typename?: 'ToolCategory'; category: string; subCategory: string }>
      | null
      | undefined
  }>
}

export type GetToolsByTypeQueryVariables = Exact<{
  input: GetToolsByTypeInput
}>

export type GetToolsByTypeQuery = {
  __typename?: 'Query'
  getToolsByType?:
    | {
        __typename?: 'GetToolsByTypeResponse'
        error?: string | null | undefined
        data?:
          | Array<
              | {
                  __typename?: 'Tool'
                  id?: string | null | undefined
                  cyclrToolId?: string | null | undefined
                  imageUrl?: string | null | undefined
                  toolName?: string | null | undefined
                  userToolsImageUrl?: string | null | undefined
                  toolUrl?: string | null | undefined
                  isConnected?: boolean | null | undefined
                  isRecommended?: boolean | null | undefined
                  recommendedBy?: string | null | undefined
                  isSelected?: boolean | null | undefined
                  group?: string | null | undefined
                  category?: string | null | undefined
                  visible?: boolean | null | undefined
                  toolType?: ToolType | null | undefined
                  authType?: ToolAuthType | null | undefined
                  supportLevel?: ToolSupportLevel | null | undefined
                }
              | null
              | undefined
            >
          | null
          | undefined
      }
    | null
    | undefined
}

export type GetAllToolCategoriesQueryVariables = Exact<{ [key: string]: never }>

export type GetAllToolCategoriesQuery = {
  __typename?: 'Query'
  getAllToolCategories: {
    __typename?: 'GetAllToolCategoriesResponse'
    categories: Array<{
      __typename?: 'GetAllToolCategoriesResponseItem'
      name: string
      description?: string | null | undefined
      clientDescription?: string | null | undefined
    }>
    subCategories: Array<{ __typename?: 'GetAllToolCategoriesResponseItem'; name: string }>
  }
}

export type SearchToolsQueryVariables = Exact<{
  input: SearchToolsInput
}>

export type SearchToolsQuery = {
  __typename?: 'Query'
  searchTools?:
    | {
        __typename?: 'SearchToolsResponse'
        numberOfPages?: number | null | undefined
        data: Array<{
          __typename?: 'Tool'
          id?: string | null | undefined
          cyclrToolId?: string | null | undefined
          imageUrl?: string | null | undefined
          toolName?: string | null | undefined
          toolDisplayName?: string | null | undefined
          connectionFormImageUrl?: string | null | undefined
          userToolsImageUrl?: string | null | undefined
          toolUrl?: string | null | undefined
          isConnected?: boolean | null | undefined
          isRecommended?: boolean | null | undefined
          recommendedBy?: string | null | undefined
          isSelected?: boolean | null | undefined
          group?: string | null | undefined
          category?: string | null | undefined
          visible?: boolean | null | undefined
          connectionStatus?: string | null | undefined
          connectorName?: string | null | undefined
          pricingPageUrl?: string | null | undefined
          tags?: Array<string> | null | undefined
          subCategory?: string | null | undefined
          supportLevel?: ToolSupportLevel | null | undefined
          relatedPlays?: Array<string | null | undefined> | null | undefined
          isBookmarked?: boolean | null | undefined
          description?: string | null | undefined
          diagnosticSupported?: boolean | null | undefined
          longDescription?: string | null | undefined
          authType?: ToolAuthType | null | undefined
          toolHelpText?: string | null | undefined
          clientId?: string | null | undefined
          clientSecret?: string | null | undefined
          options?:
            | {
                __typename?: 'ToolConnectionOptions'
                connectionForm?:
                  | {
                      __typename?: 'ToolConnectionForm'
                      description: string
                      inputProperties: Array<{
                        __typename?: 'ToolConnectionFormInputProperty'
                        name: string
                        displayName: string
                        placeholder?: string | null | undefined
                        type: string
                        validationRules: Array<string>
                      }>
                    }
                  | null
                  | undefined
              }
            | null
            | undefined
          categories?:
            | Array<{ __typename?: 'ToolCategory'; category: string; subCategory: string }>
            | null
            | undefined
        }>
      }
    | null
    | undefined
}

export type GoalSignedUrlFieldsFragment = {
  __typename?: 'SignedUrlResponse'
  success: boolean
  message?: string | null | undefined
  data?: string | null | undefined
  error?: string | null | undefined
}

export type CognitoUserFieldsFragment = {
  __typename?: 'CognitoUser'
  email: string
  userName: string
  enabled?: boolean | null | undefined
  userStatus?: string | null | undefined
  name?: string | null | undefined
}

export type GetUserFilesFiledsFragment = {
  __typename?: 'ApiResponse'
  success: boolean
  message?: string | null | undefined
  data?: string | null | undefined
  error?: string | null | undefined
}

export type SaveUserFileFieldsFragment = {
  __typename?: 'ApiResponse'
  success: boolean
  message?: string | null | undefined
  data?: string | null | undefined
  error?: string | null | undefined
}

export type GetSignedUrlQueryVariables = Exact<{
  contentType?: InputMaybe<Scalars['String']>
  fileName?: InputMaybe<Scalars['String']>
}>

export type GetSignedUrlQuery = {
  __typename?: 'Query'
  getSignedUrl?:
    | {
        __typename?: 'SignedUrlResponse'
        success: boolean
        message?: string | null | undefined
        data?: string | null | undefined
        error?: string | null | undefined
      }
    | null
    | undefined
}

export type GetUserFilesQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['String']>
  tenantId: Scalars['String']
}>

export type GetUserFilesQuery = {
  __typename?: 'Query'
  getUserFiles?:
    | {
        __typename?: 'ApiResponse'
        success: boolean
        message?: string | null | undefined
        data?: string | null | undefined
        error?: string | null | undefined
      }
    | null
    | undefined
}

export type GetFileQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']>
  businessId: Scalars['String']
}>

export type GetFileQuery = {
  __typename?: 'Query'
  getFile?:
    | {
        __typename?: 'ApiResponse'
        success: boolean
        message?: string | null | undefined
        data?: string | null | undefined
        error?: string | null | undefined
      }
    | null
    | undefined
}

export type SaveUserFileMutationVariables = Exact<{
  input: SaveUserFileInput
}>

export type SaveUserFileMutation = {
  __typename?: 'Mutation'
  saveUserFile?:
    | {
        __typename?: 'ApiResponse'
        success: boolean
        message?: string | null | undefined
        data?: string | null | undefined
        error?: string | null | undefined
      }
    | null
    | undefined
}

export type DeleteUserFilesMutationVariables = Exact<{
  input: DeleteUserFilesInput
}>

export type DeleteUserFilesMutation = {
  __typename?: 'Mutation'
  deleteUserFiles?: boolean | null | undefined
}

export type BigQueryFieldsFragment = {
  __typename?: 'ApiResponse'
  success: boolean
  message?: string | null | undefined
  data?: string | null | undefined
  error?: string | null | undefined
}

export type BusinessesFieldsFragment = {
  __typename?: 'ApiResponse'
  success: boolean
  message?: string | null | undefined
  data?: string | null | undefined
  error?: string | null | undefined
}

export type AdvisorsFieldsFragment = {
  __typename?: 'ApiResponse'
  success: boolean
  message?: string | null | undefined
  data?: string | null | undefined
  error?: string | null | undefined
}

export type LogActivityFieldsFragment = {
  __typename?: 'ApiResponse'
  success: boolean
  message?: string | null | undefined
  data?: string | null | undefined
  error?: string | null | undefined
}

export type UserNotificationsFieldsFragment = {
  __typename?: 'GetUserNotificationsResponse'
  error?: string | null | undefined
  data?:
    | {
        __typename?: 'UserNotificationData'
        lastEvaluatedKey?: string | null | undefined
        totalCount?: number | null | undefined
        notifications?:
          | Array<
              | {
                  __typename?: 'UserNotification'
                  id: string
                  createdAt?: string | null | undefined
                  meta?: string | null | undefined
                  notificationType: string
                  sender?: string | null | undefined
                  status?: string | null | undefined
                  firstName?: string | null | undefined
                  lastName?: string | null | undefined
                  updatedAt?: string | null | undefined
                  businessName?: string | null | undefined
                  senderId?: string | null | undefined
                }
              | null
              | undefined
            >
          | null
          | undefined
      }
    | null
    | undefined
}

export type UserNotificationMutateFieldsFragment = {
  __typename?: 'ApiResponse'
  success: boolean
  message?: string | null | undefined
  data?: string | null | undefined
  error?: string | null | undefined
}

export type GetClientsSummaryFieldsFragment = {
  __typename?: 'ApiResponse'
  success: boolean
  message?: string | null | undefined
  data?: string | null | undefined
  error?: string | null | undefined
}

export type ResendUserInviteFieldsFragment = {
  __typename?: 'ApiResponse'
  success: boolean
  message?: string | null | undefined
  data?: string | null | undefined
  error?: string | null | undefined
}

export type SaveAttestationFieldsFragment = {
  __typename?: 'AttestationResponse'
  error?: string | null | undefined
  data?:
    | {
        __typename?: 'Attestation'
        pk?: string | null | undefined
        sk?: string | null | undefined
        id?: string | null | undefined
        tenantId?: string | null | undefined
        month?: string | null | undefined
        year?: string | null | undefined
        contractors?: string | null | undefined
        businessBankAccount?: string | null | undefined
        jobsCreated?: string | null | undefined
        volunteers?: string | null | undefined
        partTimeEmployees?: string | null | undefined
        fullTimeEmployees?: string | null | undefined
        gender?: string | null | undefined
        race?: string | null | undefined
        education?: string | null | undefined
        wages?: string | null | undefined
        revenue?: string | null | undefined
        debtFinancing?: string | null | undefined
        financialGrowth?: string | null | undefined
        newCustomer?: string | null | undefined
        productSale?: string | null | undefined
        serviceSale?: string | null | undefined
        targetAudience?: string | null | undefined
        physicalLocation?: string | null | undefined
        url?: string | null | undefined
      }
    | null
    | undefined
}

export type GetBusinessesQueryVariables = Exact<{
  getBusinessesInput: GetBusinessesInput
}>

export type GetBusinessesQuery = {
  __typename?: 'Query'
  getBusinesses?:
    | {
        __typename?: 'ApiResponse'
        success: boolean
        message?: string | null | undefined
        data?: string | null | undefined
        error?: string | null | undefined
      }
    | null
    | undefined
}

export type ListCognitoUsersMutationVariables = Exact<{
  input: ListCognitoUsersInput
}>

export type ListCognitoUsersMutation = {
  __typename?: 'Mutation'
  listCognitoUsers: Array<
    | {
        __typename?: 'CognitoUser'
        email: string
        userName: string
        enabled?: boolean | null | undefined
        userStatus?: string | null | undefined
        name?: string | null | undefined
      }
    | null
    | undefined
  >
}

export type AddUserToGroupMutationVariables = Exact<{
  input: AddUserToGroupInput
}>

export type AddUserToGroupMutation = { __typename?: 'Mutation'; addUserToGroup: boolean }

export type UpdateUserPasswordMutationVariables = Exact<{
  input: UpdateUserPasswordInput
}>

export type UpdateUserPasswordMutation = {
  __typename?: 'Mutation'
  updateUserPassword?: boolean | null | undefined
}

export type GetAdvisorsQueryVariables = Exact<{
  getAdvisorsInput?: InputMaybe<GetAdvisorsInput>
}>

export type GetAdvisorsQuery = {
  __typename?: 'Query'
  getAdvisors?:
    | {
        __typename?: 'ApiResponse'
        success: boolean
        message?: string | null | undefined
        data?: string | null | undefined
        error?: string | null | undefined
      }
    | null
    | undefined
}

export type LogActivityMutationVariables = Exact<{
  activityLogInput: ActivityLogInput
}>

export type LogActivityMutation = {
  __typename?: 'Mutation'
  logActivity?:
    | {
        __typename?: 'ApiResponse'
        success: boolean
        message?: string | null | undefined
        data?: string | null | undefined
        error?: string | null | undefined
      }
    | null
    | undefined
}

export type GetUserNotificationsQueryVariables = Exact<{
  input?: InputMaybe<GetUserNotificationsInput>
}>

export type GetUserNotificationsQuery = {
  __typename?: 'Query'
  getUserNotifications?:
    | {
        __typename?: 'GetUserNotificationsResponse'
        error?: string | null | undefined
        data?:
          | {
              __typename?: 'UserNotificationData'
              lastEvaluatedKey?: string | null | undefined
              totalCount?: number | null | undefined
              notifications?:
                | Array<
                    | {
                        __typename?: 'UserNotification'
                        id: string
                        createdAt?: string | null | undefined
                        meta?: string | null | undefined
                        notificationType: string
                        sender?: string | null | undefined
                        status?: string | null | undefined
                        firstName?: string | null | undefined
                        lastName?: string | null | undefined
                        updatedAt?: string | null | undefined
                        businessName?: string | null | undefined
                        senderId?: string | null | undefined
                      }
                    | null
                    | undefined
                  >
                | null
                | undefined
            }
          | null
          | undefined
      }
    | null
    | undefined
}

export type GetClientsSummaryQueryVariables = Exact<{
  tenantId?: InputMaybe<Scalars['String']>
}>

export type GetClientsSummaryQuery = {
  __typename?: 'Query'
  getClientsSummary?:
    | {
        __typename?: 'ApiResponse'
        success: boolean
        message?: string | null | undefined
        data?: string | null | undefined
        error?: string | null | undefined
      }
    | null
    | undefined
}

export type UpdateUserNotificationsMutationVariables = Exact<{
  input?: InputMaybe<UpdateUserNotificationsInput>
}>

export type UpdateUserNotificationsMutation = {
  __typename?: 'Mutation'
  updateUserNotifications?:
    | {
        __typename?: 'ApiResponse'
        success: boolean
        message?: string | null | undefined
        data?: string | null | undefined
        error?: string | null | undefined
      }
    | null
    | undefined
}

export type DeleteUserNotificationsMutationVariables = Exact<{
  input?: InputMaybe<DeleteUserNotificationsInput>
}>

export type DeleteUserNotificationsMutation = {
  __typename?: 'Mutation'
  deleteUserNotifications?:
    | {
        __typename?: 'ApiResponse'
        success: boolean
        message?: string | null | undefined
        data?: string | null | undefined
        error?: string | null | undefined
      }
    | null
    | undefined
}

export type ResendUserInviteMutationVariables = Exact<{
  input: ResendUserInviteInput
}>

export type ResendUserInviteMutation = {
  __typename?: 'Mutation'
  resendUserInvite?: boolean | null | undefined
}

export type SaveAttestationMutationVariables = Exact<{
  input: AttestationInput
}>

export type SaveAttestationMutation = {
  __typename?: 'Mutation'
  saveAttestation?:
    | {
        __typename?: 'AttestationResponse'
        error?: string | null | undefined
        data?:
          | {
              __typename?: 'Attestation'
              pk?: string | null | undefined
              sk?: string | null | undefined
              id?: string | null | undefined
              tenantId?: string | null | undefined
              month?: string | null | undefined
              year?: string | null | undefined
              contractors?: string | null | undefined
              businessBankAccount?: string | null | undefined
              jobsCreated?: string | null | undefined
              volunteers?: string | null | undefined
              partTimeEmployees?: string | null | undefined
              fullTimeEmployees?: string | null | undefined
              gender?: string | null | undefined
              race?: string | null | undefined
              education?: string | null | undefined
              wages?: string | null | undefined
              revenue?: string | null | undefined
              debtFinancing?: string | null | undefined
              financialGrowth?: string | null | undefined
              newCustomer?: string | null | undefined
              productSale?: string | null | undefined
              serviceSale?: string | null | undefined
              targetAudience?: string | null | undefined
              physicalLocation?: string | null | undefined
              url?: string | null | undefined
            }
          | null
          | undefined
      }
    | null
    | undefined
}

export type MakeAnnouncementMutationVariables = Exact<{
  input: MakeAnnouncementInput
}>

export type MakeAnnouncementMutation = {
  __typename?: 'Mutation'
  makeAnnouncement?: boolean | null | undefined
}

export type SendDirectNotificationMutationVariables = Exact<{
  input: SendDirectNotificationInput
}>

export type SendDirectNotificationMutation = {
  __typename?: 'Mutation'
  sendDirectNotification?: string | null | undefined
}

export type UserSummariesFieldsFragment = {
  __typename?: 'UserSummaryResponse'
  lastEvaluatedKey?: string | null | undefined
  totalRecordsCount?: number | null | undefined
  items?:
    | Array<{
        __typename?: 'UserSummary'
        firstName?: string | null | undefined
        fumbleCount?: number | null | undefined
        lastLoginDate?: string | null | undefined
        lastName?: string | null | undefined
        nextMeetingDate?: string | null | undefined
        touchdownCount?: number | null | undefined
        userId?: string | null | undefined
        phoneNumber?: string | null | undefined
        email?: string | null | undefined
        status?: string | null | undefined
      }>
    | null
    | undefined
}

export type GetUserSummariesQueryVariables = Exact<{
  input: UserSummariesInput
}>

export type GetUserSummariesQuery = {
  __typename?: 'Query'
  getUserSummaries?:
    | {
        __typename?: 'UserSummaryResponse'
        lastEvaluatedKey?: string | null | undefined
        totalRecordsCount?: number | null | undefined
        items?:
          | Array<{
              __typename?: 'UserSummary'
              firstName?: string | null | undefined
              fumbleCount?: number | null | undefined
              lastLoginDate?: string | null | undefined
              lastName?: string | null | undefined
              nextMeetingDate?: string | null | undefined
              touchdownCount?: number | null | undefined
              userId?: string | null | undefined
              phoneNumber?: string | null | undefined
              email?: string | null | undefined
              status?: string | null | undefined
            }>
          | null
          | undefined
      }
    | null
    | undefined
}

export type SearchUserSummariesQueryVariables = Exact<{
  input: SearchUserSummariesInput
}>

export type SearchUserSummariesQuery = {
  __typename?: 'Query'
  searchUserSummaries?:
    | {
        __typename?: 'UserSummaryResponse'
        lastEvaluatedKey?: string | null | undefined
        totalRecordsCount?: number | null | undefined
        items?:
          | Array<{
              __typename?: 'UserSummary'
              firstName?: string | null | undefined
              fumbleCount?: number | null | undefined
              lastLoginDate?: string | null | undefined
              lastName?: string | null | undefined
              nextMeetingDate?: string | null | undefined
              touchdownCount?: number | null | undefined
              userId?: string | null | undefined
              phoneNumber?: string | null | undefined
              email?: string | null | undefined
              status?: string | null | undefined
            }>
          | null
          | undefined
      }
    | null
    | undefined
}

export type UserProfileFieldsFragment = {
  __typename?: 'UserProfile'
  id: string
  name?: string | null | undefined
  firstName?: string | null | undefined
  lastName?: string | null | undefined
  email: string
  createdAt: string
  updatedAt: string
  websiteURL?: string | null | undefined
  bio?: string | null | undefined
  roles?: Array<string | null | undefined> | null | undefined
  isNewUser?: boolean | null | undefined
  mobileContactNumber?: string | null | undefined
  yearsInBusiness?: string | null | undefined
  companyEmployees?: number | null | undefined
  companyAdvisor?: string | null | undefined
  schedulingUrl?: string | null | undefined
  calendlyEventsUrl?: string | null | undefined
  tenantId?: Array<string> | null | undefined
  streamAccessToken?: string | null | undefined
  algoliaSearchKey?: string | null | undefined
  firstSigninDate?: string | null | undefined
  activatedAt?: string | null | undefined
  status?: string | null | undefined
  ownerExperience?: string | null | undefined
  submissionStartDay?: number | null | undefined
  submissionEndDay?: number | null | undefined
  submissionReminderDay?: number | null | undefined
  submissionReportDay?: number | null | undefined
  attestationStatus?: string | null | undefined
  isSmsEnabled?: boolean | null | undefined
  defaultVideoLinkDescription?: string | null | undefined
  organizationName?: string | null | undefined
  timezone?: string | null | undefined
  interimTimezone?: string | null | undefined
  tempPassword?: string | null | undefined
  calendarEventViewPreference?: CalendarEventViewPreference | null | undefined
  isConsentGivenToAdvisor?: boolean | null | undefined
  onboardingStatus?: OnboardingStatus | null | undefined
  quoteViewDate?: string | null | undefined
  isJoinedBetaProgram?: boolean | null | undefined
  jobTitle?: string | null | undefined
  expertise?: string | null | undefined
  workPhoneNumber?: string | null | undefined
  workLocation?: string | null | undefined
  employmentType?: string | null | undefined
  linkedinProfile?: string | null | undefined
  education?: string | null | undefined
  workExperience?: string | null | undefined
  avatar?: string | null | undefined
  country?: string | null | undefined
  workAddress?: string | null | undefined
}

export type BoAdvisorsFieldsFragment = {
  __typename?: 'BOAdvisorsResponse'
  success: boolean
  message?: string | null | undefined
  error?: string | null | undefined
  data?:
    | Array<
        | {
            __typename?: 'Advisors'
            id: string
            firstName?: string | null | undefined
            lastName?: string | null | undefined
            email?: string | null | undefined
            schedulingUrl?: string | null | undefined
          }
        | null
        | undefined
      >
    | null
    | undefined
}

export type SaveAssessmentResponseInputFragment = {
  __typename?: 'AssessmentResponse'
  currentStage?: string | null | undefined
  type?: string | null | undefined
  userId?: string | null | undefined
  createdAt?: string | null | undefined
  updatedAt?: string | null | undefined
  assessmentResponse?:
    | Array<{
        __typename?: 'AssessmentResponseOutput'
        next?: string | null | undefined
        previous?: Array<string> | null | undefined
        id?: string | null | undefined
        value?: string | null | undefined
        label?: string | null | undefined
        playResponse?: string | null | undefined
        isIndustry?: boolean | null | undefined
        isSubIndustry?: boolean | null | undefined
        isTopGoal?: boolean | null | undefined
        recommendations?:
          | {
              __typename?: 'Recommendations'
              assessments?: Array<string> | null | undefined
              plays?: Array<string> | null | undefined
              assessmentRecommendedAt?: string | null | undefined
              playRecommendedAt?: string | null | undefined
            }
          | null
          | undefined
      }>
    | null
    | undefined
}

export type AdvisorProfileFieldsFragment = {
  __typename?: 'AdvisorProfile'
  id?: string | null | undefined
  firstName?: string | null | undefined
  lastName?: string | null | undefined
  defaultVideoLinkDescription?: string | null | undefined
}

export type BusinessIndustryChangedFieldsFragment = {
  __typename?: 'GetBusinessIndustryDetailsResponse'
  isSubIndustryUpdated?: boolean | null | undefined
}

export type GetBusinessIndustryDetailsQueryVariables = Exact<{
  input: GetBusinessIndustryDetailsInput
}>

export type GetBusinessIndustryDetailsQuery = {
  __typename?: 'Query'
  getBusinessIndustryDetails?:
    | {
        __typename?: 'GetBusinessIndustryDetailsResponse'
        isSubIndustryUpdated?: boolean | null | undefined
      }
    | null
    | undefined
}

export type GetMyProfileQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['String']>
  tenantId?: InputMaybe<Scalars['String']>
}>

export type GetMyProfileQuery = {
  __typename?: 'Query'
  getMyProfile: {
    __typename?: 'UserProfile'
    id: string
    name?: string | null | undefined
    firstName?: string | null | undefined
    lastName?: string | null | undefined
    email: string
    createdAt: string
    updatedAt: string
    websiteURL?: string | null | undefined
    bio?: string | null | undefined
    roles?: Array<string | null | undefined> | null | undefined
    isNewUser?: boolean | null | undefined
    mobileContactNumber?: string | null | undefined
    yearsInBusiness?: string | null | undefined
    companyEmployees?: number | null | undefined
    companyAdvisor?: string | null | undefined
    schedulingUrl?: string | null | undefined
    calendlyEventsUrl?: string | null | undefined
    tenantId?: Array<string> | null | undefined
    streamAccessToken?: string | null | undefined
    algoliaSearchKey?: string | null | undefined
    firstSigninDate?: string | null | undefined
    activatedAt?: string | null | undefined
    status?: string | null | undefined
    ownerExperience?: string | null | undefined
    submissionStartDay?: number | null | undefined
    submissionEndDay?: number | null | undefined
    submissionReminderDay?: number | null | undefined
    submissionReportDay?: number | null | undefined
    attestationStatus?: string | null | undefined
    isSmsEnabled?: boolean | null | undefined
    defaultVideoLinkDescription?: string | null | undefined
    organizationName?: string | null | undefined
    timezone?: string | null | undefined
    interimTimezone?: string | null | undefined
    tempPassword?: string | null | undefined
    calendarEventViewPreference?: CalendarEventViewPreference | null | undefined
    isConsentGivenToAdvisor?: boolean | null | undefined
    onboardingStatus?: OnboardingStatus | null | undefined
    quoteViewDate?: string | null | undefined
    isJoinedBetaProgram?: boolean | null | undefined
    jobTitle?: string | null | undefined
    expertise?: string | null | undefined
    workPhoneNumber?: string | null | undefined
    workLocation?: string | null | undefined
    employmentType?: string | null | undefined
    linkedinProfile?: string | null | undefined
    education?: string | null | undefined
    workExperience?: string | null | undefined
    avatar?: string | null | undefined
    country?: string | null | undefined
    workAddress?: string | null | undefined
  }
}

export type GetBoAdvisorsQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['String']>
  tenantId?: InputMaybe<Scalars['String']>
}>

export type GetBoAdvisorsQuery = {
  __typename?: 'Query'
  getBoAdvisors?:
    | {
        __typename?: 'BOAdvisorsResponse'
        success: boolean
        message?: string | null | undefined
        error?: string | null | undefined
        data?:
          | Array<
              | {
                  __typename?: 'Advisors'
                  id: string
                  firstName?: string | null | undefined
                  lastName?: string | null | undefined
                  email?: string | null | undefined
                  schedulingUrl?: string | null | undefined
                }
              | null
              | undefined
            >
          | null
          | undefined
      }
    | null
    | undefined
}

export type UpdateMyProfileMutationVariables = Exact<{
  input: UpdateMyProfileInput
}>

export type UpdateMyProfileMutation = {
  __typename?: 'Mutation'
  updateMyProfile?:
    | {
        __typename?: 'UserProfile'
        id: string
        name?: string | null | undefined
        firstName?: string | null | undefined
        lastName?: string | null | undefined
        email: string
        createdAt: string
        updatedAt: string
        websiteURL?: string | null | undefined
        bio?: string | null | undefined
        roles?: Array<string | null | undefined> | null | undefined
        isNewUser?: boolean | null | undefined
        mobileContactNumber?: string | null | undefined
        yearsInBusiness?: string | null | undefined
        companyEmployees?: number | null | undefined
        companyAdvisor?: string | null | undefined
        schedulingUrl?: string | null | undefined
        calendlyEventsUrl?: string | null | undefined
        tenantId?: Array<string> | null | undefined
        streamAccessToken?: string | null | undefined
        algoliaSearchKey?: string | null | undefined
        firstSigninDate?: string | null | undefined
        activatedAt?: string | null | undefined
        status?: string | null | undefined
        ownerExperience?: string | null | undefined
        submissionStartDay?: number | null | undefined
        submissionEndDay?: number | null | undefined
        submissionReminderDay?: number | null | undefined
        submissionReportDay?: number | null | undefined
        attestationStatus?: string | null | undefined
        isSmsEnabled?: boolean | null | undefined
        defaultVideoLinkDescription?: string | null | undefined
        organizationName?: string | null | undefined
        timezone?: string | null | undefined
        interimTimezone?: string | null | undefined
        tempPassword?: string | null | undefined
        calendarEventViewPreference?: CalendarEventViewPreference | null | undefined
        isConsentGivenToAdvisor?: boolean | null | undefined
        onboardingStatus?: OnboardingStatus | null | undefined
        quoteViewDate?: string | null | undefined
        isJoinedBetaProgram?: boolean | null | undefined
        jobTitle?: string | null | undefined
        expertise?: string | null | undefined
        workPhoneNumber?: string | null | undefined
        workLocation?: string | null | undefined
        employmentType?: string | null | undefined
        linkedinProfile?: string | null | undefined
        education?: string | null | undefined
        workExperience?: string | null | undefined
        avatar?: string | null | undefined
        country?: string | null | undefined
        workAddress?: string | null | undefined
      }
    | null
    | undefined
}

export type CreateUserMutationVariables = Exact<{
  input: CreateUserInput
}>

export type CreateUserMutation = {
  __typename?: 'Mutation'
  createUser?:
    | {
        __typename?: 'UserProfile'
        id: string
        name?: string | null | undefined
        firstName?: string | null | undefined
        lastName?: string | null | undefined
        email: string
        createdAt: string
        updatedAt: string
        websiteURL?: string | null | undefined
        bio?: string | null | undefined
        roles?: Array<string | null | undefined> | null | undefined
        isNewUser?: boolean | null | undefined
        mobileContactNumber?: string | null | undefined
        yearsInBusiness?: string | null | undefined
        companyEmployees?: number | null | undefined
        companyAdvisor?: string | null | undefined
        schedulingUrl?: string | null | undefined
        calendlyEventsUrl?: string | null | undefined
        tenantId?: Array<string> | null | undefined
        streamAccessToken?: string | null | undefined
        algoliaSearchKey?: string | null | undefined
        firstSigninDate?: string | null | undefined
        activatedAt?: string | null | undefined
        status?: string | null | undefined
        ownerExperience?: string | null | undefined
        submissionStartDay?: number | null | undefined
        submissionEndDay?: number | null | undefined
        submissionReminderDay?: number | null | undefined
        submissionReportDay?: number | null | undefined
        attestationStatus?: string | null | undefined
        isSmsEnabled?: boolean | null | undefined
        defaultVideoLinkDescription?: string | null | undefined
        organizationName?: string | null | undefined
        timezone?: string | null | undefined
        interimTimezone?: string | null | undefined
        tempPassword?: string | null | undefined
        calendarEventViewPreference?: CalendarEventViewPreference | null | undefined
        isConsentGivenToAdvisor?: boolean | null | undefined
        onboardingStatus?: OnboardingStatus | null | undefined
        quoteViewDate?: string | null | undefined
        isJoinedBetaProgram?: boolean | null | undefined
        jobTitle?: string | null | undefined
        expertise?: string | null | undefined
        workPhoneNumber?: string | null | undefined
        workLocation?: string | null | undefined
        employmentType?: string | null | undefined
        linkedinProfile?: string | null | undefined
        education?: string | null | undefined
        workExperience?: string | null | undefined
        avatar?: string | null | undefined
        country?: string | null | undefined
        workAddress?: string | null | undefined
      }
    | null
    | undefined
}

export type GetAdvisorProfileQueryVariables = Exact<{
  input: GetAdvisorProfileInput
}>

export type GetAdvisorProfileQuery = {
  __typename?: 'Query'
  getAdvisorProfile?:
    | {
        __typename?: 'AdvisorProfile'
        id?: string | null | undefined
        firstName?: string | null | undefined
        lastName?: string | null | undefined
        defaultVideoLinkDescription?: string | null | undefined
      }
    | null
    | undefined
}

export type GoalHistoryMessageFieldsFragment = {
  __typename?: 'GoalHistoryMessage'
  senderName?: string | null | undefined
  senderRole?: string | null | undefined
  avatar?: string | null | undefined
  text: string
  createdAt: string
}

export type GoalHistorySectionFieldsFragment = {
  __typename?: 'GoalHistorySection'
  sessionId: string
  title: string
  type: OnboardingFlowType
  createdAt?: string | null | undefined
  hasMore: boolean
  nextCursor?: string | null | undefined
  messages: Array<{
    __typename?: 'GoalHistoryMessage'
    senderName?: string | null | undefined
    senderRole?: string | null | undefined
    avatar?: string | null | undefined
    text: string
    createdAt: string
  }>
}

export type GetGoalHistoryQueryVariables = Exact<{
  input: GetGoalHistoryInput
}>

export type GetGoalHistoryQuery = {
  __typename?: 'Query'
  getGoalHistory?:
    | {
        __typename?: 'GoalHistory'
        goalId: string
        sections: Array<{
          __typename?: 'GoalHistorySection'
          sessionId: string
          title: string
          type: OnboardingFlowType
          createdAt?: string | null | undefined
          hasMore: boolean
          nextCursor?: string | null | undefined
          messages: Array<{
            __typename?: 'GoalHistoryMessage'
            senderName?: string | null | undefined
            senderRole?: string | null | undefined
            avatar?: string | null | undefined
            text: string
            createdAt: string
          }>
        }>
      }
    | null
    | undefined
}

export type GoalsFieldsFragment = {
  __typename?: 'BusinessGoal'
  goalId?: string | null | undefined
  name?: string | null | undefined
  status?: UserTaskItemStatus | null | undefined
  progress?: number | null | undefined
  why?: string | null | undefined
  goalPriority?: BusinessGoalPriority | null | undefined
  createdById?: string | null | undefined
  suggestedById?: string | null | undefined
  description?: string | null | undefined
  category?: BusinessGoalCategory | null | undefined
  goalTimeFrame?: BusinessGoalTimeFrame | null | undefined
  logo?: string | null | undefined
  startDate?: string | null | undefined
  expectedEndDate?: string | null | undefined
  experimentalCurrentDay?: number | null | undefined
  dedicatedHoursPerWeek?: number | null | undefined
  resourcesAverageDedicatedTimePerWeek?: number | null | undefined
  createdAt?: string | null | undefined
  updatedAt?: string | null | undefined
  sessionId?: string | null | undefined
  suggestedStatus?: UserTaskSuggestedItemStatus | null | undefined
  suggestedBy?:
    | {
        __typename?: 'Advisors'
        id: string
        firstName?: string | null | undefined
        lastName?: string | null | undefined
        email?: string | null | undefined
        schedulingUrl?: string | null | undefined
        tenantId?: string | null | undefined
      }
    | null
    | undefined
  createdBy?:
    | {
        __typename?: 'User'
        id: string
        firstName?: string | null | undefined
        lastName?: string | null | undefined
      }
    | null
    | undefined
  plan?:
    | {
        __typename?: 'BusinessGoalPlan'
        planId?: string | null | undefined
        goalId?: string | null | undefined
        name?: string | null | undefined
        startDate?: string | null | undefined
        expectedEndDate?: string | null | undefined
        timeline?: string | null | undefined
        state?: BusinessGoalPlanState | null | undefined
        progress?: number | null | undefined
        pauseDuration?: number | null | undefined
        pauseDate?: string | null | undefined
        isUndismissedFumbledState?: boolean | null | undefined
        isUndismissedMicroCelebrationState?: boolean | null | undefined
        tasks?:
          | Array<
              | {
                  __typename?: 'UserTask'
                  tenantId?: string | null | undefined
                  userId?: string | null | undefined
                  taskId?: string | null | undefined
                  planId?: string | null | undefined
                  milestoneId?: string | null | undefined
                  name?: string | null | undefined
                  description?: string | null | undefined
                  source?: UserTaskSource | null | undefined
                  status?: UserTaskItemStatus | null | undefined
                  tool?: string | null | undefined
                  timeline?: string | null | undefined
                  startDate?: string | null | undefined
                  expectedEndDate?: string | null | undefined
                  howToDo?: string | null | undefined
                  tutorialGenerationStatus?: TutorialGenerationStatus | null | undefined
                  tutorialGenerationStartedAt?: string | null | undefined
                  tutorialGenerationError?: string | null | undefined
                  estimatedEffortInMinutes?: number | null | undefined
                  instructionForTask?: string | null | undefined
                  kpis?: string | null | undefined
                  role?: string | null | undefined
                  why?: string | null | undefined
                  order?: number | null | undefined
                  resources?: string | null | undefined
                  createdBy?: string | null | undefined
                  createdById?: string | null | undefined
                  taskPriority?: BusinessGoalPriority | null | undefined
                  category?: BusinessGoalCategory | null | undefined
                  assigneeId?: string | null | undefined
                  isCarryOver?: boolean | null | undefined
                  goalId?: string | null | undefined
                  goalName?: string | null | undefined
                  isOverDue?: boolean | null | undefined
                  suggestedStatus?: UserTaskSuggestedItemStatus | null | undefined
                  businessAvatar?: string | null | undefined
                  businessLogo?: string | null | undefined
                  businessName?: string | null | undefined
                  planName?: string | null | undefined
                  planStartDate?: string | null | undefined
                  planExpectedEndDate?: string | null | undefined
                  businessHoursSpentPerDay?: number | null | undefined
                  goalEndDate?: string | null | undefined
                  meetingId?: string | null | undefined
                  howToLinks?:
                    | Array<
                        | {
                            __typename?: 'UserTaskHowTo'
                            howToId: string
                            title?: string | null | undefined
                            url?: string | null | undefined
                            steps?: string | null | undefined
                          }
                        | null
                        | undefined
                      >
                    | null
                    | undefined
                  structuredSteps?:
                    | Array<
                        | {
                            __typename?: 'UserTaskHowToStep'
                            stepNumber: number
                            title: string
                            description: string
                            videos?:
                              | Array<
                                  | {
                                      __typename?: 'UserTaskHowToVideo'
                                      url: string
                                      title: string
                                      relevance?: string | null | undefined
                                      stepsCovered?:
                                        | Array<number | null | undefined>
                                        | null
                                        | undefined
                                    }
                                  | null
                                  | undefined
                                >
                              | null
                              | undefined
                          }
                        | null
                        | undefined
                      >
                    | null
                    | undefined
                  files?:
                    | Array<{
                        __typename?: 'UserFile'
                        id?: string | null | undefined
                        name?: string | null | undefined
                        size?: string | null | undefined
                        tenantId?: string | null | undefined
                        type?: string | null | undefined
                        url?: string | null | undefined
                        userId?: string | null | undefined
                        createdAt?: string | null | undefined
                      }>
                    | null
                    | undefined
                  businessAdvisorsData?:
                    | Array<
                        | {
                            __typename?: 'BusinessAdvisorsData'
                            label?: string | null | undefined
                            value?: string | null | undefined
                          }
                        | null
                        | undefined
                      >
                    | null
                    | undefined
                }
              | null
              | undefined
            >
          | null
          | undefined
        milestones?:
          | Array<{
              __typename?: 'BusinessGoalMilestone'
              planId?: string | null | undefined
              milestoneId?: string | null | undefined
              name?: string | null | undefined
              descriptions?: string | null | undefined
              timeline?: string | null | undefined
              startDate?: string | null | undefined
              expectedEndDate?: string | null | undefined
              riskAndChallenges?: string | null | undefined
              status?: UserTaskItemStatus | null | undefined
              order?: number | null | undefined
              milestoneSpan?: string | null | undefined
              isFumbled?: boolean | null | undefined
              tasks?:
                | Array<{
                    __typename?: 'UserTask'
                    tenantId?: string | null | undefined
                    userId?: string | null | undefined
                    taskId?: string | null | undefined
                    planId?: string | null | undefined
                    milestoneId?: string | null | undefined
                    name?: string | null | undefined
                    description?: string | null | undefined
                    source?: UserTaskSource | null | undefined
                    status?: UserTaskItemStatus | null | undefined
                    tool?: string | null | undefined
                    timeline?: string | null | undefined
                    startDate?: string | null | undefined
                    expectedEndDate?: string | null | undefined
                    howToDo?: string | null | undefined
                    tutorialGenerationStatus?: TutorialGenerationStatus | null | undefined
                    tutorialGenerationStartedAt?: string | null | undefined
                    tutorialGenerationError?: string | null | undefined
                    estimatedEffortInMinutes?: number | null | undefined
                    instructionForTask?: string | null | undefined
                    kpis?: string | null | undefined
                    role?: string | null | undefined
                    why?: string | null | undefined
                    order?: number | null | undefined
                    resources?: string | null | undefined
                    createdBy?: string | null | undefined
                    createdById?: string | null | undefined
                    taskPriority?: BusinessGoalPriority | null | undefined
                    category?: BusinessGoalCategory | null | undefined
                    assigneeId?: string | null | undefined
                    isCarryOver?: boolean | null | undefined
                    goalId?: string | null | undefined
                    goalName?: string | null | undefined
                    isOverDue?: boolean | null | undefined
                    suggestedStatus?: UserTaskSuggestedItemStatus | null | undefined
                    businessAvatar?: string | null | undefined
                    businessLogo?: string | null | undefined
                    businessName?: string | null | undefined
                    planName?: string | null | undefined
                    planStartDate?: string | null | undefined
                    planExpectedEndDate?: string | null | undefined
                    businessHoursSpentPerDay?: number | null | undefined
                    goalEndDate?: string | null | undefined
                    meetingId?: string | null | undefined
                    howToLinks?:
                      | Array<
                          | {
                              __typename?: 'UserTaskHowTo'
                              howToId: string
                              title?: string | null | undefined
                              url?: string | null | undefined
                              steps?: string | null | undefined
                            }
                          | null
                          | undefined
                        >
                      | null
                      | undefined
                    structuredSteps?:
                      | Array<
                          | {
                              __typename?: 'UserTaskHowToStep'
                              stepNumber: number
                              title: string
                              description: string
                              videos?:
                                | Array<
                                    | {
                                        __typename?: 'UserTaskHowToVideo'
                                        url: string
                                        title: string
                                        relevance?: string | null | undefined
                                        stepsCovered?:
                                          | Array<number | null | undefined>
                                          | null
                                          | undefined
                                      }
                                    | null
                                    | undefined
                                  >
                                | null
                                | undefined
                            }
                          | null
                          | undefined
                        >
                      | null
                      | undefined
                    files?:
                      | Array<{
                          __typename?: 'UserFile'
                          id?: string | null | undefined
                          name?: string | null | undefined
                          size?: string | null | undefined
                          tenantId?: string | null | undefined
                          type?: string | null | undefined
                          url?: string | null | undefined
                          userId?: string | null | undefined
                          createdAt?: string | null | undefined
                        }>
                      | null
                      | undefined
                    businessAdvisorsData?:
                      | Array<
                          | {
                              __typename?: 'BusinessAdvisorsData'
                              label?: string | null | undefined
                              value?: string | null | undefined
                            }
                          | null
                          | undefined
                        >
                      | null
                      | undefined
                  }>
                | null
                | undefined
            }>
          | null
          | undefined
      }
    | null
    | undefined
}

export type GoalResponseFragment = {
  __typename?: 'BusinessGoal'
  goalId?: string | null | undefined
  name?: string | null | undefined
  status?: UserTaskItemStatus | null | undefined
  startDate?: string | null | undefined
  expectedEndDate?: string | null | undefined
  suggestedById?: string | null | undefined
  sessionId?: string | null | undefined
  suggestedStatus?: UserTaskSuggestedItemStatus | null | undefined
  suggestedBy?:
    | {
        __typename?: 'Advisors'
        id: string
        firstName?: string | null | undefined
        lastName?: string | null | undefined
        email?: string | null | undefined
        schedulingUrl?: string | null | undefined
        tenantId?: string | null | undefined
      }
    | null
    | undefined
  plan?:
    | {
        __typename?: 'BusinessGoalPlan'
        planId?: string | null | undefined
        goalId?: string | null | undefined
        name?: string | null | undefined
        startDate?: string | null | undefined
        expectedEndDate?: string | null | undefined
      }
    | null
    | undefined
}

export type TaskFragment = {
  __typename?: 'UserTask'
  tenantId?: string | null | undefined
  userId?: string | null | undefined
  taskId?: string | null | undefined
  planId?: string | null | undefined
  milestoneId?: string | null | undefined
  name?: string | null | undefined
  description?: string | null | undefined
  source?: UserTaskSource | null | undefined
  status?: UserTaskItemStatus | null | undefined
  tool?: string | null | undefined
  timeline?: string | null | undefined
  startDate?: string | null | undefined
  expectedEndDate?: string | null | undefined
  howToDo?: string | null | undefined
  tutorialGenerationStatus?: TutorialGenerationStatus | null | undefined
  tutorialGenerationStartedAt?: string | null | undefined
  tutorialGenerationError?: string | null | undefined
  estimatedEffortInMinutes?: number | null | undefined
  instructionForTask?: string | null | undefined
  kpis?: string | null | undefined
  role?: string | null | undefined
  why?: string | null | undefined
  order?: number | null | undefined
  resources?: string | null | undefined
  createdBy?: string | null | undefined
  createdById?: string | null | undefined
  taskPriority?: BusinessGoalPriority | null | undefined
  category?: BusinessGoalCategory | null | undefined
  assigneeId?: string | null | undefined
  isCarryOver?: boolean | null | undefined
  goalId?: string | null | undefined
  goalName?: string | null | undefined
  isOverDue?: boolean | null | undefined
  suggestedStatus?: UserTaskSuggestedItemStatus | null | undefined
  businessAvatar?: string | null | undefined
  businessLogo?: string | null | undefined
  businessName?: string | null | undefined
  planName?: string | null | undefined
  planStartDate?: string | null | undefined
  planExpectedEndDate?: string | null | undefined
  businessHoursSpentPerDay?: number | null | undefined
  goalEndDate?: string | null | undefined
  meetingId?: string | null | undefined
  howToLinks?:
    | Array<
        | {
            __typename?: 'UserTaskHowTo'
            howToId: string
            title?: string | null | undefined
            url?: string | null | undefined
            steps?: string | null | undefined
          }
        | null
        | undefined
      >
    | null
    | undefined
  structuredSteps?:
    | Array<
        | {
            __typename?: 'UserTaskHowToStep'
            stepNumber: number
            title: string
            description: string
            videos?:
              | Array<
                  | {
                      __typename?: 'UserTaskHowToVideo'
                      url: string
                      title: string
                      relevance?: string | null | undefined
                      stepsCovered?: Array<number | null | undefined> | null | undefined
                    }
                  | null
                  | undefined
                >
              | null
              | undefined
          }
        | null
        | undefined
      >
    | null
    | undefined
  files?:
    | Array<{
        __typename?: 'UserFile'
        id?: string | null | undefined
        name?: string | null | undefined
        size?: string | null | undefined
        tenantId?: string | null | undefined
        type?: string | null | undefined
        url?: string | null | undefined
        userId?: string | null | undefined
        createdAt?: string | null | undefined
      }>
    | null
    | undefined
  businessAdvisorsData?:
    | Array<
        | {
            __typename?: 'BusinessAdvisorsData'
            label?: string | null | undefined
            value?: string | null | undefined
          }
        | null
        | undefined
      >
    | null
    | undefined
}

export type GoalFieldsFragment = {
  __typename?: 'BusinessGoal'
  goalId?: string | null | undefined
  userId?: string | null | undefined
  name?: string | null | undefined
  status?: UserTaskItemStatus | null | undefined
  progress?: number | null | undefined
  startDate?: string | null | undefined
  expectedEndDate?: string | null | undefined
  goalPriority?: BusinessGoalPriority | null | undefined
  suggestedById?: string | null | undefined
  experimentalCurrentDay?: number | null | undefined
  dedicatedHoursPerWeek?: number | null | undefined
  resourcesAverageDedicatedTimePerWeek?: number | null | undefined
  createdAt?: string | null | undefined
  updatedAt?: string | null | undefined
  suggestedStatus?: UserTaskSuggestedItemStatus | null | undefined
  suggestedBy?:
    | {
        __typename?: 'Advisors'
        id: string
        firstName?: string | null | undefined
        lastName?: string | null | undefined
        email?: string | null | undefined
        schedulingUrl?: string | null | undefined
        tenantId?: string | null | undefined
      }
    | null
    | undefined
  plan?:
    | {
        __typename?: 'BusinessGoalPlan'
        planId?: string | null | undefined
        goalId?: string | null | undefined
        name?: string | null | undefined
        startDate?: string | null | undefined
        expectedEndDate?: string | null | undefined
        timeline?: string | null | undefined
        state?: BusinessGoalPlanState | null | undefined
        progress?: number | null | undefined
        pauseDuration?: number | null | undefined
        pauseDate?: string | null | undefined
        isUndismissedFumbledState?: boolean | null | undefined
        isUndismissedMicroCelebrationState?: boolean | null | undefined
        tasks?:
          | Array<
              | {
                  __typename?: 'UserTask'
                  tenantId?: string | null | undefined
                  userId?: string | null | undefined
                  taskId?: string | null | undefined
                  planId?: string | null | undefined
                  milestoneId?: string | null | undefined
                  name?: string | null | undefined
                  description?: string | null | undefined
                  source?: UserTaskSource | null | undefined
                  status?: UserTaskItemStatus | null | undefined
                  tool?: string | null | undefined
                  timeline?: string | null | undefined
                  startDate?: string | null | undefined
                  expectedEndDate?: string | null | undefined
                  howToDo?: string | null | undefined
                  tutorialGenerationStatus?: TutorialGenerationStatus | null | undefined
                  tutorialGenerationStartedAt?: string | null | undefined
                  tutorialGenerationError?: string | null | undefined
                  estimatedEffortInMinutes?: number | null | undefined
                  instructionForTask?: string | null | undefined
                  kpis?: string | null | undefined
                  role?: string | null | undefined
                  why?: string | null | undefined
                  order?: number | null | undefined
                  resources?: string | null | undefined
                  createdBy?: string | null | undefined
                  createdById?: string | null | undefined
                  taskPriority?: BusinessGoalPriority | null | undefined
                  category?: BusinessGoalCategory | null | undefined
                  assigneeId?: string | null | undefined
                  isCarryOver?: boolean | null | undefined
                  goalId?: string | null | undefined
                  goalName?: string | null | undefined
                  isOverDue?: boolean | null | undefined
                  suggestedStatus?: UserTaskSuggestedItemStatus | null | undefined
                  businessAvatar?: string | null | undefined
                  businessLogo?: string | null | undefined
                  businessName?: string | null | undefined
                  planName?: string | null | undefined
                  planStartDate?: string | null | undefined
                  planExpectedEndDate?: string | null | undefined
                  businessHoursSpentPerDay?: number | null | undefined
                  goalEndDate?: string | null | undefined
                  meetingId?: string | null | undefined
                  howToLinks?:
                    | Array<
                        | {
                            __typename?: 'UserTaskHowTo'
                            howToId: string
                            title?: string | null | undefined
                            url?: string | null | undefined
                            steps?: string | null | undefined
                          }
                        | null
                        | undefined
                      >
                    | null
                    | undefined
                  structuredSteps?:
                    | Array<
                        | {
                            __typename?: 'UserTaskHowToStep'
                            stepNumber: number
                            title: string
                            description: string
                            videos?:
                              | Array<
                                  | {
                                      __typename?: 'UserTaskHowToVideo'
                                      url: string
                                      title: string
                                      relevance?: string | null | undefined
                                      stepsCovered?:
                                        | Array<number | null | undefined>
                                        | null
                                        | undefined
                                    }
                                  | null
                                  | undefined
                                >
                              | null
                              | undefined
                          }
                        | null
                        | undefined
                      >
                    | null
                    | undefined
                  files?:
                    | Array<{
                        __typename?: 'UserFile'
                        id?: string | null | undefined
                        name?: string | null | undefined
                        size?: string | null | undefined
                        tenantId?: string | null | undefined
                        type?: string | null | undefined
                        url?: string | null | undefined
                        userId?: string | null | undefined
                        createdAt?: string | null | undefined
                      }>
                    | null
                    | undefined
                  businessAdvisorsData?:
                    | Array<
                        | {
                            __typename?: 'BusinessAdvisorsData'
                            label?: string | null | undefined
                            value?: string | null | undefined
                          }
                        | null
                        | undefined
                      >
                    | null
                    | undefined
                }
              | null
              | undefined
            >
          | null
          | undefined
        milestones?:
          | Array<{
              __typename?: 'BusinessGoalMilestone'
              planId?: string | null | undefined
              milestoneId?: string | null | undefined
              name?: string | null | undefined
              descriptions?: string | null | undefined
              timeline?: string | null | undefined
              startDate?: string | null | undefined
              expectedEndDate?: string | null | undefined
              riskAndChallenges?: string | null | undefined
              status?: UserTaskItemStatus | null | undefined
              order?: number | null | undefined
              milestoneSpan?: string | null | undefined
              isFumbled?: boolean | null | undefined
              tasks?:
                | Array<{
                    __typename?: 'UserTask'
                    tenantId?: string | null | undefined
                    userId?: string | null | undefined
                    taskId?: string | null | undefined
                    planId?: string | null | undefined
                    milestoneId?: string | null | undefined
                    name?: string | null | undefined
                    description?: string | null | undefined
                    source?: UserTaskSource | null | undefined
                    status?: UserTaskItemStatus | null | undefined
                    tool?: string | null | undefined
                    timeline?: string | null | undefined
                    startDate?: string | null | undefined
                    expectedEndDate?: string | null | undefined
                    howToDo?: string | null | undefined
                    tutorialGenerationStatus?: TutorialGenerationStatus | null | undefined
                    tutorialGenerationStartedAt?: string | null | undefined
                    tutorialGenerationError?: string | null | undefined
                    estimatedEffortInMinutes?: number | null | undefined
                    instructionForTask?: string | null | undefined
                    kpis?: string | null | undefined
                    role?: string | null | undefined
                    why?: string | null | undefined
                    order?: number | null | undefined
                    resources?: string | null | undefined
                    createdBy?: string | null | undefined
                    createdById?: string | null | undefined
                    taskPriority?: BusinessGoalPriority | null | undefined
                    category?: BusinessGoalCategory | null | undefined
                    assigneeId?: string | null | undefined
                    isCarryOver?: boolean | null | undefined
                    goalId?: string | null | undefined
                    goalName?: string | null | undefined
                    isOverDue?: boolean | null | undefined
                    suggestedStatus?: UserTaskSuggestedItemStatus | null | undefined
                    businessAvatar?: string | null | undefined
                    businessLogo?: string | null | undefined
                    businessName?: string | null | undefined
                    planName?: string | null | undefined
                    planStartDate?: string | null | undefined
                    planExpectedEndDate?: string | null | undefined
                    businessHoursSpentPerDay?: number | null | undefined
                    goalEndDate?: string | null | undefined
                    meetingId?: string | null | undefined
                    howToLinks?:
                      | Array<
                          | {
                              __typename?: 'UserTaskHowTo'
                              howToId: string
                              title?: string | null | undefined
                              url?: string | null | undefined
                              steps?: string | null | undefined
                            }
                          | null
                          | undefined
                        >
                      | null
                      | undefined
                    structuredSteps?:
                      | Array<
                          | {
                              __typename?: 'UserTaskHowToStep'
                              stepNumber: number
                              title: string
                              description: string
                              videos?:
                                | Array<
                                    | {
                                        __typename?: 'UserTaskHowToVideo'
                                        url: string
                                        title: string
                                        relevance?: string | null | undefined
                                        stepsCovered?:
                                          | Array<number | null | undefined>
                                          | null
                                          | undefined
                                      }
                                    | null
                                    | undefined
                                  >
                                | null
                                | undefined
                            }
                          | null
                          | undefined
                        >
                      | null
                      | undefined
                    files?:
                      | Array<{
                          __typename?: 'UserFile'
                          id?: string | null | undefined
                          name?: string | null | undefined
                          size?: string | null | undefined
                          tenantId?: string | null | undefined
                          type?: string | null | undefined
                          url?: string | null | undefined
                          userId?: string | null | undefined
                          createdAt?: string | null | undefined
                        }>
                      | null
                      | undefined
                    businessAdvisorsData?:
                      | Array<
                          | {
                              __typename?: 'BusinessAdvisorsData'
                              label?: string | null | undefined
                              value?: string | null | undefined
                            }
                          | null
                          | undefined
                        >
                      | null
                      | undefined
                  }>
                | null
                | undefined
            }>
          | null
          | undefined
      }
    | null
    | undefined
}

export type UserInputFieldsFragment = {
  __typename?: 'UserInputField'
  fieldType: FieldType
  label: string
  name: string
  placeholder?: string | null | undefined
  value?: string | null | undefined
  multiple?: boolean | null | undefined
  optionsSource?: string | null | undefined
  options?: Array<{ __typename?: 'Option'; label: string; value: string }> | null | undefined
  validation?:
    | {
        __typename?: 'Validation'
        type?: ValidationTypes | null | undefined
        required?:
          | {
              __typename?: 'ValidationRequired'
              value?: boolean | null | undefined
              message?: string | null | undefined
            }
          | null
          | undefined
        pattern?:
          | { __typename?: 'ValidationRule'; value?: string | null | undefined; message: string }
          | null
          | undefined
        min?:
          | { __typename?: 'ValidationRule'; value?: string | null | undefined; message: string }
          | null
          | undefined
        max?:
          | { __typename?: 'ValidationRule'; value?: string | null | undefined; message: string }
          | null
          | undefined
        dateMin?:
          | {
              __typename?: 'DateValidationRule'
              value?: string | null | undefined
              message: string
              dependsOn?: string | null | undefined
              dependsOnMessage?: string | null | undefined
            }
          | null
          | undefined
        dateMax?:
          | {
              __typename?: 'DateValidationRule'
              value?: string | null | undefined
              message: string
              dependsOn?: string | null | undefined
              dependsOnMessage?: string | null | undefined
            }
          | null
          | undefined
      }
    | null
    | undefined
  conditionalField?:
    | {
        __typename?: 'ConditionalField'
        dependsOn: string
        values: Array<string>
        excludeValues?: Array<string> | null | undefined
      }
    | null
    | undefined
  destinationResource?:
    | { __typename?: 'DestinationResource'; baseResource: BaseResource; field: string }
    | null
    | undefined
}

export type UserTaskFieldsFragment = {
  __typename?: 'UserTask'
  tenantId?: string | null | undefined
  userId?: string | null | undefined
  taskId?: string | null | undefined
  planId?: string | null | undefined
  milestoneId?: string | null | undefined
  name?: string | null | undefined
  description?: string | null | undefined
  source?: UserTaskSource | null | undefined
  status?: UserTaskItemStatus | null | undefined
  tool?: string | null | undefined
  timeline?: string | null | undefined
  startDate?: string | null | undefined
  expectedEndDate?: string | null | undefined
  howToDo?: string | null | undefined
  tutorialGenerationStatus?: TutorialGenerationStatus | null | undefined
  tutorialGenerationStartedAt?: string | null | undefined
  tutorialGenerationError?: string | null | undefined
  estimatedEffortInMinutes?: number | null | undefined
  instructionForTask?: string | null | undefined
  kpis?: string | null | undefined
  role?: string | null | undefined
  why?: string | null | undefined
  order?: number | null | undefined
  resources?: string | null | undefined
  createdBy?: string | null | undefined
  createdById?: string | null | undefined
  taskPriority?: BusinessGoalPriority | null | undefined
  category?: BusinessGoalCategory | null | undefined
  assigneeId?: string | null | undefined
  isCarryOver?: boolean | null | undefined
  goalId?: string | null | undefined
  goalName?: string | null | undefined
  isOverDue?: boolean | null | undefined
  suggestedStatus?: UserTaskSuggestedItemStatus | null | undefined
  businessAvatar?: string | null | undefined
  businessLogo?: string | null | undefined
  businessName?: string | null | undefined
  planName?: string | null | undefined
  planStartDate?: string | null | undefined
  planExpectedEndDate?: string | null | undefined
  businessHoursSpentPerDay?: number | null | undefined
  goalEndDate?: string | null | undefined
  meetingId?: string | null | undefined
  userInputFields?:
    | Array<{
        __typename?: 'UserInputField'
        fieldType: FieldType
        label: string
        name: string
        placeholder?: string | null | undefined
        value?: string | null | undefined
        multiple?: boolean | null | undefined
        optionsSource?: string | null | undefined
        options?: Array<{ __typename?: 'Option'; label: string; value: string }> | null | undefined
        validation?:
          | {
              __typename?: 'Validation'
              type?: ValidationTypes | null | undefined
              required?:
                | {
                    __typename?: 'ValidationRequired'
                    value?: boolean | null | undefined
                    message?: string | null | undefined
                  }
                | null
                | undefined
              pattern?:
                | {
                    __typename?: 'ValidationRule'
                    value?: string | null | undefined
                    message: string
                  }
                | null
                | undefined
              min?:
                | {
                    __typename?: 'ValidationRule'
                    value?: string | null | undefined
                    message: string
                  }
                | null
                | undefined
              max?:
                | {
                    __typename?: 'ValidationRule'
                    value?: string | null | undefined
                    message: string
                  }
                | null
                | undefined
              dateMin?:
                | {
                    __typename?: 'DateValidationRule'
                    value?: string | null | undefined
                    message: string
                    dependsOn?: string | null | undefined
                    dependsOnMessage?: string | null | undefined
                  }
                | null
                | undefined
              dateMax?:
                | {
                    __typename?: 'DateValidationRule'
                    value?: string | null | undefined
                    message: string
                    dependsOn?: string | null | undefined
                    dependsOnMessage?: string | null | undefined
                  }
                | null
                | undefined
            }
          | null
          | undefined
        conditionalField?:
          | {
              __typename?: 'ConditionalField'
              dependsOn: string
              values: Array<string>
              excludeValues?: Array<string> | null | undefined
            }
          | null
          | undefined
        destinationResource?:
          | { __typename?: 'DestinationResource'; baseResource: BaseResource; field: string }
          | null
          | undefined
      }>
    | null
    | undefined
  howToLinks?:
    | Array<
        | {
            __typename?: 'UserTaskHowTo'
            howToId: string
            title?: string | null | undefined
            url?: string | null | undefined
            steps?: string | null | undefined
          }
        | null
        | undefined
      >
    | null
    | undefined
  structuredSteps?:
    | Array<
        | {
            __typename?: 'UserTaskHowToStep'
            stepNumber: number
            title: string
            description: string
            videos?:
              | Array<
                  | {
                      __typename?: 'UserTaskHowToVideo'
                      url: string
                      title: string
                      relevance?: string | null | undefined
                      stepsCovered?: Array<number | null | undefined> | null | undefined
                    }
                  | null
                  | undefined
                >
              | null
              | undefined
          }
        | null
        | undefined
      >
    | null
    | undefined
  files?:
    | Array<{
        __typename?: 'UserFile'
        id?: string | null | undefined
        name?: string | null | undefined
        size?: string | null | undefined
        tenantId?: string | null | undefined
        type?: string | null | undefined
        url?: string | null | undefined
        userId?: string | null | undefined
        createdAt?: string | null | undefined
      }>
    | null
    | undefined
  businessAdvisorsData?:
    | Array<
        | {
            __typename?: 'BusinessAdvisorsData'
            label?: string | null | undefined
            value?: string | null | undefined
          }
        | null
        | undefined
      >
    | null
    | undefined
}

export type GetBusinessGoalsQueryVariables = Exact<{
  input: GetBusinessGoalsInput
}>

export type GetBusinessGoalsQuery = {
  __typename?: 'Query'
  getBusinessGoals?:
    | Array<{
        __typename?: 'BusinessGoal'
        goalId?: string | null | undefined
        name?: string | null | undefined
        status?: UserTaskItemStatus | null | undefined
        progress?: number | null | undefined
        why?: string | null | undefined
        goalPriority?: BusinessGoalPriority | null | undefined
        createdById?: string | null | undefined
        suggestedById?: string | null | undefined
        description?: string | null | undefined
        category?: BusinessGoalCategory | null | undefined
        goalTimeFrame?: BusinessGoalTimeFrame | null | undefined
        logo?: string | null | undefined
        startDate?: string | null | undefined
        expectedEndDate?: string | null | undefined
        experimentalCurrentDay?: number | null | undefined
        dedicatedHoursPerWeek?: number | null | undefined
        resourcesAverageDedicatedTimePerWeek?: number | null | undefined
        createdAt?: string | null | undefined
        updatedAt?: string | null | undefined
        sessionId?: string | null | undefined
        suggestedStatus?: UserTaskSuggestedItemStatus | null | undefined
        suggestedBy?:
          | {
              __typename?: 'Advisors'
              id: string
              firstName?: string | null | undefined
              lastName?: string | null | undefined
              email?: string | null | undefined
              schedulingUrl?: string | null | undefined
              tenantId?: string | null | undefined
            }
          | null
          | undefined
        createdBy?:
          | {
              __typename?: 'User'
              id: string
              firstName?: string | null | undefined
              lastName?: string | null | undefined
            }
          | null
          | undefined
        plan?:
          | {
              __typename?: 'BusinessGoalPlan'
              planId?: string | null | undefined
              goalId?: string | null | undefined
              name?: string | null | undefined
              startDate?: string | null | undefined
              expectedEndDate?: string | null | undefined
              timeline?: string | null | undefined
              state?: BusinessGoalPlanState | null | undefined
              progress?: number | null | undefined
              pauseDuration?: number | null | undefined
              pauseDate?: string | null | undefined
              isUndismissedFumbledState?: boolean | null | undefined
              isUndismissedMicroCelebrationState?: boolean | null | undefined
              tasks?:
                | Array<
                    | {
                        __typename?: 'UserTask'
                        tenantId?: string | null | undefined
                        userId?: string | null | undefined
                        taskId?: string | null | undefined
                        planId?: string | null | undefined
                        milestoneId?: string | null | undefined
                        name?: string | null | undefined
                        description?: string | null | undefined
                        source?: UserTaskSource | null | undefined
                        status?: UserTaskItemStatus | null | undefined
                        tool?: string | null | undefined
                        timeline?: string | null | undefined
                        startDate?: string | null | undefined
                        expectedEndDate?: string | null | undefined
                        howToDo?: string | null | undefined
                        tutorialGenerationStatus?: TutorialGenerationStatus | null | undefined
                        tutorialGenerationStartedAt?: string | null | undefined
                        tutorialGenerationError?: string | null | undefined
                        estimatedEffortInMinutes?: number | null | undefined
                        instructionForTask?: string | null | undefined
                        kpis?: string | null | undefined
                        role?: string | null | undefined
                        why?: string | null | undefined
                        order?: number | null | undefined
                        resources?: string | null | undefined
                        createdBy?: string | null | undefined
                        createdById?: string | null | undefined
                        taskPriority?: BusinessGoalPriority | null | undefined
                        category?: BusinessGoalCategory | null | undefined
                        assigneeId?: string | null | undefined
                        isCarryOver?: boolean | null | undefined
                        goalId?: string | null | undefined
                        goalName?: string | null | undefined
                        isOverDue?: boolean | null | undefined
                        suggestedStatus?: UserTaskSuggestedItemStatus | null | undefined
                        businessAvatar?: string | null | undefined
                        businessLogo?: string | null | undefined
                        businessName?: string | null | undefined
                        planName?: string | null | undefined
                        planStartDate?: string | null | undefined
                        planExpectedEndDate?: string | null | undefined
                        businessHoursSpentPerDay?: number | null | undefined
                        goalEndDate?: string | null | undefined
                        meetingId?: string | null | undefined
                        howToLinks?:
                          | Array<
                              | {
                                  __typename?: 'UserTaskHowTo'
                                  howToId: string
                                  title?: string | null | undefined
                                  url?: string | null | undefined
                                  steps?: string | null | undefined
                                }
                              | null
                              | undefined
                            >
                          | null
                          | undefined
                        structuredSteps?:
                          | Array<
                              | {
                                  __typename?: 'UserTaskHowToStep'
                                  stepNumber: number
                                  title: string
                                  description: string
                                  videos?:
                                    | Array<
                                        | {
                                            __typename?: 'UserTaskHowToVideo'
                                            url: string
                                            title: string
                                            relevance?: string | null | undefined
                                            stepsCovered?:
                                              | Array<number | null | undefined>
                                              | null
                                              | undefined
                                          }
                                        | null
                                        | undefined
                                      >
                                    | null
                                    | undefined
                                }
                              | null
                              | undefined
                            >
                          | null
                          | undefined
                        files?:
                          | Array<{
                              __typename?: 'UserFile'
                              id?: string | null | undefined
                              name?: string | null | undefined
                              size?: string | null | undefined
                              tenantId?: string | null | undefined
                              type?: string | null | undefined
                              url?: string | null | undefined
                              userId?: string | null | undefined
                              createdAt?: string | null | undefined
                            }>
                          | null
                          | undefined
                        businessAdvisorsData?:
                          | Array<
                              | {
                                  __typename?: 'BusinessAdvisorsData'
                                  label?: string | null | undefined
                                  value?: string | null | undefined
                                }
                              | null
                              | undefined
                            >
                          | null
                          | undefined
                      }
                    | null
                    | undefined
                  >
                | null
                | undefined
              milestones?:
                | Array<{
                    __typename?: 'BusinessGoalMilestone'
                    planId?: string | null | undefined
                    milestoneId?: string | null | undefined
                    name?: string | null | undefined
                    descriptions?: string | null | undefined
                    timeline?: string | null | undefined
                    startDate?: string | null | undefined
                    expectedEndDate?: string | null | undefined
                    riskAndChallenges?: string | null | undefined
                    status?: UserTaskItemStatus | null | undefined
                    order?: number | null | undefined
                    milestoneSpan?: string | null | undefined
                    isFumbled?: boolean | null | undefined
                    tasks?:
                      | Array<{
                          __typename?: 'UserTask'
                          tenantId?: string | null | undefined
                          userId?: string | null | undefined
                          taskId?: string | null | undefined
                          planId?: string | null | undefined
                          milestoneId?: string | null | undefined
                          name?: string | null | undefined
                          description?: string | null | undefined
                          source?: UserTaskSource | null | undefined
                          status?: UserTaskItemStatus | null | undefined
                          tool?: string | null | undefined
                          timeline?: string | null | undefined
                          startDate?: string | null | undefined
                          expectedEndDate?: string | null | undefined
                          howToDo?: string | null | undefined
                          tutorialGenerationStatus?: TutorialGenerationStatus | null | undefined
                          tutorialGenerationStartedAt?: string | null | undefined
                          tutorialGenerationError?: string | null | undefined
                          estimatedEffortInMinutes?: number | null | undefined
                          instructionForTask?: string | null | undefined
                          kpis?: string | null | undefined
                          role?: string | null | undefined
                          why?: string | null | undefined
                          order?: number | null | undefined
                          resources?: string | null | undefined
                          createdBy?: string | null | undefined
                          createdById?: string | null | undefined
                          taskPriority?: BusinessGoalPriority | null | undefined
                          category?: BusinessGoalCategory | null | undefined
                          assigneeId?: string | null | undefined
                          isCarryOver?: boolean | null | undefined
                          goalId?: string | null | undefined
                          goalName?: string | null | undefined
                          isOverDue?: boolean | null | undefined
                          suggestedStatus?: UserTaskSuggestedItemStatus | null | undefined
                          businessAvatar?: string | null | undefined
                          businessLogo?: string | null | undefined
                          businessName?: string | null | undefined
                          planName?: string | null | undefined
                          planStartDate?: string | null | undefined
                          planExpectedEndDate?: string | null | undefined
                          businessHoursSpentPerDay?: number | null | undefined
                          goalEndDate?: string | null | undefined
                          meetingId?: string | null | undefined
                          howToLinks?:
                            | Array<
                                | {
                                    __typename?: 'UserTaskHowTo'
                                    howToId: string
                                    title?: string | null | undefined
                                    url?: string | null | undefined
                                    steps?: string | null | undefined
                                  }
                                | null
                                | undefined
                              >
                            | null
                            | undefined
                          structuredSteps?:
                            | Array<
                                | {
                                    __typename?: 'UserTaskHowToStep'
                                    stepNumber: number
                                    title: string
                                    description: string
                                    videos?:
                                      | Array<
                                          | {
                                              __typename?: 'UserTaskHowToVideo'
                                              url: string
                                              title: string
                                              relevance?: string | null | undefined
                                              stepsCovered?:
                                                | Array<number | null | undefined>
                                                | null
                                                | undefined
                                            }
                                          | null
                                          | undefined
                                        >
                                      | null
                                      | undefined
                                  }
                                | null
                                | undefined
                              >
                            | null
                            | undefined
                          files?:
                            | Array<{
                                __typename?: 'UserFile'
                                id?: string | null | undefined
                                name?: string | null | undefined
                                size?: string | null | undefined
                                tenantId?: string | null | undefined
                                type?: string | null | undefined
                                url?: string | null | undefined
                                userId?: string | null | undefined
                                createdAt?: string | null | undefined
                              }>
                            | null
                            | undefined
                          businessAdvisorsData?:
                            | Array<
                                | {
                                    __typename?: 'BusinessAdvisorsData'
                                    label?: string | null | undefined
                                    value?: string | null | undefined
                                  }
                                | null
                                | undefined
                              >
                            | null
                            | undefined
                        }>
                      | null
                      | undefined
                  }>
                | null
                | undefined
            }
          | null
          | undefined
      }>
    | null
    | undefined
}

export type GetFilteredBusinessGoalsQueryVariables = Exact<{
  input: GetBusinessGoalsInput
}>

export type GetFilteredBusinessGoalsQuery = {
  __typename?: 'Query'
  getBusinessGoals?:
    | Array<{
        __typename?: 'BusinessGoal'
        goalId?: string | null | undefined
        name?: string | null | undefined
        status?: UserTaskItemStatus | null | undefined
        startDate?: string | null | undefined
        expectedEndDate?: string | null | undefined
        suggestedById?: string | null | undefined
        sessionId?: string | null | undefined
        suggestedStatus?: UserTaskSuggestedItemStatus | null | undefined
        suggestedBy?:
          | {
              __typename?: 'Advisors'
              id: string
              firstName?: string | null | undefined
              lastName?: string | null | undefined
              email?: string | null | undefined
              schedulingUrl?: string | null | undefined
              tenantId?: string | null | undefined
            }
          | null
          | undefined
        plan?:
          | {
              __typename?: 'BusinessGoalPlan'
              planId?: string | null | undefined
              goalId?: string | null | undefined
              name?: string | null | undefined
              startDate?: string | null | undefined
              expectedEndDate?: string | null | undefined
            }
          | null
          | undefined
      }>
    | null
    | undefined
}

export type GetBusinessGoalQueryVariables = Exact<{
  input: GetBusinessGoalInput
}>

export type GetBusinessGoalQuery = {
  __typename?: 'Query'
  getBusinessGoal?:
    | {
        __typename?: 'BusinessGoal'
        goalId?: string | null | undefined
        userId?: string | null | undefined
        name?: string | null | undefined
        status?: UserTaskItemStatus | null | undefined
        progress?: number | null | undefined
        startDate?: string | null | undefined
        expectedEndDate?: string | null | undefined
        goalPriority?: BusinessGoalPriority | null | undefined
        suggestedById?: string | null | undefined
        experimentalCurrentDay?: number | null | undefined
        dedicatedHoursPerWeek?: number | null | undefined
        resourcesAverageDedicatedTimePerWeek?: number | null | undefined
        createdAt?: string | null | undefined
        updatedAt?: string | null | undefined
        suggestedStatus?: UserTaskSuggestedItemStatus | null | undefined
        suggestedBy?:
          | {
              __typename?: 'Advisors'
              id: string
              firstName?: string | null | undefined
              lastName?: string | null | undefined
              email?: string | null | undefined
              schedulingUrl?: string | null | undefined
              tenantId?: string | null | undefined
            }
          | null
          | undefined
        plan?:
          | {
              __typename?: 'BusinessGoalPlan'
              planId?: string | null | undefined
              goalId?: string | null | undefined
              name?: string | null | undefined
              startDate?: string | null | undefined
              expectedEndDate?: string | null | undefined
              timeline?: string | null | undefined
              state?: BusinessGoalPlanState | null | undefined
              progress?: number | null | undefined
              pauseDuration?: number | null | undefined
              pauseDate?: string | null | undefined
              isUndismissedFumbledState?: boolean | null | undefined
              isUndismissedMicroCelebrationState?: boolean | null | undefined
              tasks?:
                | Array<
                    | {
                        __typename?: 'UserTask'
                        tenantId?: string | null | undefined
                        userId?: string | null | undefined
                        taskId?: string | null | undefined
                        planId?: string | null | undefined
                        milestoneId?: string | null | undefined
                        name?: string | null | undefined
                        description?: string | null | undefined
                        source?: UserTaskSource | null | undefined
                        status?: UserTaskItemStatus | null | undefined
                        tool?: string | null | undefined
                        timeline?: string | null | undefined
                        startDate?: string | null | undefined
                        expectedEndDate?: string | null | undefined
                        howToDo?: string | null | undefined
                        tutorialGenerationStatus?: TutorialGenerationStatus | null | undefined
                        tutorialGenerationStartedAt?: string | null | undefined
                        tutorialGenerationError?: string | null | undefined
                        estimatedEffortInMinutes?: number | null | undefined
                        instructionForTask?: string | null | undefined
                        kpis?: string | null | undefined
                        role?: string | null | undefined
                        why?: string | null | undefined
                        order?: number | null | undefined
                        resources?: string | null | undefined
                        createdBy?: string | null | undefined
                        createdById?: string | null | undefined
                        taskPriority?: BusinessGoalPriority | null | undefined
                        category?: BusinessGoalCategory | null | undefined
                        assigneeId?: string | null | undefined
                        isCarryOver?: boolean | null | undefined
                        goalId?: string | null | undefined
                        goalName?: string | null | undefined
                        isOverDue?: boolean | null | undefined
                        suggestedStatus?: UserTaskSuggestedItemStatus | null | undefined
                        businessAvatar?: string | null | undefined
                        businessLogo?: string | null | undefined
                        businessName?: string | null | undefined
                        planName?: string | null | undefined
                        planStartDate?: string | null | undefined
                        planExpectedEndDate?: string | null | undefined
                        businessHoursSpentPerDay?: number | null | undefined
                        goalEndDate?: string | null | undefined
                        meetingId?: string | null | undefined
                        howToLinks?:
                          | Array<
                              | {
                                  __typename?: 'UserTaskHowTo'
                                  howToId: string
                                  title?: string | null | undefined
                                  url?: string | null | undefined
                                  steps?: string | null | undefined
                                }
                              | null
                              | undefined
                            >
                          | null
                          | undefined
                        structuredSteps?:
                          | Array<
                              | {
                                  __typename?: 'UserTaskHowToStep'
                                  stepNumber: number
                                  title: string
                                  description: string
                                  videos?:
                                    | Array<
                                        | {
                                            __typename?: 'UserTaskHowToVideo'
                                            url: string
                                            title: string
                                            relevance?: string | null | undefined
                                            stepsCovered?:
                                              | Array<number | null | undefined>
                                              | null
                                              | undefined
                                          }
                                        | null
                                        | undefined
                                      >
                                    | null
                                    | undefined
                                }
                              | null
                              | undefined
                            >
                          | null
                          | undefined
                        files?:
                          | Array<{
                              __typename?: 'UserFile'
                              id?: string | null | undefined
                              name?: string | null | undefined
                              size?: string | null | undefined
                              tenantId?: string | null | undefined
                              type?: string | null | undefined
                              url?: string | null | undefined
                              userId?: string | null | undefined
                              createdAt?: string | null | undefined
                            }>
                          | null
                          | undefined
                        businessAdvisorsData?:
                          | Array<
                              | {
                                  __typename?: 'BusinessAdvisorsData'
                                  label?: string | null | undefined
                                  value?: string | null | undefined
                                }
                              | null
                              | undefined
                            >
                          | null
                          | undefined
                      }
                    | null
                    | undefined
                  >
                | null
                | undefined
              milestones?:
                | Array<{
                    __typename?: 'BusinessGoalMilestone'
                    planId?: string | null | undefined
                    milestoneId?: string | null | undefined
                    name?: string | null | undefined
                    descriptions?: string | null | undefined
                    timeline?: string | null | undefined
                    startDate?: string | null | undefined
                    expectedEndDate?: string | null | undefined
                    riskAndChallenges?: string | null | undefined
                    status?: UserTaskItemStatus | null | undefined
                    order?: number | null | undefined
                    milestoneSpan?: string | null | undefined
                    isFumbled?: boolean | null | undefined
                    tasks?:
                      | Array<{
                          __typename?: 'UserTask'
                          tenantId?: string | null | undefined
                          userId?: string | null | undefined
                          taskId?: string | null | undefined
                          planId?: string | null | undefined
                          milestoneId?: string | null | undefined
                          name?: string | null | undefined
                          description?: string | null | undefined
                          source?: UserTaskSource | null | undefined
                          status?: UserTaskItemStatus | null | undefined
                          tool?: string | null | undefined
                          timeline?: string | null | undefined
                          startDate?: string | null | undefined
                          expectedEndDate?: string | null | undefined
                          howToDo?: string | null | undefined
                          tutorialGenerationStatus?: TutorialGenerationStatus | null | undefined
                          tutorialGenerationStartedAt?: string | null | undefined
                          tutorialGenerationError?: string | null | undefined
                          estimatedEffortInMinutes?: number | null | undefined
                          instructionForTask?: string | null | undefined
                          kpis?: string | null | undefined
                          role?: string | null | undefined
                          why?: string | null | undefined
                          order?: number | null | undefined
                          resources?: string | null | undefined
                          createdBy?: string | null | undefined
                          createdById?: string | null | undefined
                          taskPriority?: BusinessGoalPriority | null | undefined
                          category?: BusinessGoalCategory | null | undefined
                          assigneeId?: string | null | undefined
                          isCarryOver?: boolean | null | undefined
                          goalId?: string | null | undefined
                          goalName?: string | null | undefined
                          isOverDue?: boolean | null | undefined
                          suggestedStatus?: UserTaskSuggestedItemStatus | null | undefined
                          businessAvatar?: string | null | undefined
                          businessLogo?: string | null | undefined
                          businessName?: string | null | undefined
                          planName?: string | null | undefined
                          planStartDate?: string | null | undefined
                          planExpectedEndDate?: string | null | undefined
                          businessHoursSpentPerDay?: number | null | undefined
                          goalEndDate?: string | null | undefined
                          meetingId?: string | null | undefined
                          howToLinks?:
                            | Array<
                                | {
                                    __typename?: 'UserTaskHowTo'
                                    howToId: string
                                    title?: string | null | undefined
                                    url?: string | null | undefined
                                    steps?: string | null | undefined
                                  }
                                | null
                                | undefined
                              >
                            | null
                            | undefined
                          structuredSteps?:
                            | Array<
                                | {
                                    __typename?: 'UserTaskHowToStep'
                                    stepNumber: number
                                    title: string
                                    description: string
                                    videos?:
                                      | Array<
                                          | {
                                              __typename?: 'UserTaskHowToVideo'
                                              url: string
                                              title: string
                                              relevance?: string | null | undefined
                                              stepsCovered?:
                                                | Array<number | null | undefined>
                                                | null
                                                | undefined
                                            }
                                          | null
                                          | undefined
                                        >
                                      | null
                                      | undefined
                                  }
                                | null
                                | undefined
                              >
                            | null
                            | undefined
                          files?:
                            | Array<{
                                __typename?: 'UserFile'
                                id?: string | null | undefined
                                name?: string | null | undefined
                                size?: string | null | undefined
                                tenantId?: string | null | undefined
                                type?: string | null | undefined
                                url?: string | null | undefined
                                userId?: string | null | undefined
                                createdAt?: string | null | undefined
                              }>
                            | null
                            | undefined
                          businessAdvisorsData?:
                            | Array<
                                | {
                                    __typename?: 'BusinessAdvisorsData'
                                    label?: string | null | undefined
                                    value?: string | null | undefined
                                  }
                                | null
                                | undefined
                              >
                            | null
                            | undefined
                        }>
                      | null
                      | undefined
                  }>
                | null
                | undefined
            }
          | null
          | undefined
      }
    | null
    | undefined
}

export type GetUserTaskQueryVariables = Exact<{
  input: GetUserTaskInput
}>

export type GetUserTaskQuery = {
  __typename?: 'Query'
  getUserTask?:
    | {
        __typename?: 'UserTask'
        tenantId?: string | null | undefined
        userId?: string | null | undefined
        taskId?: string | null | undefined
        planId?: string | null | undefined
        milestoneId?: string | null | undefined
        name?: string | null | undefined
        description?: string | null | undefined
        source?: UserTaskSource | null | undefined
        status?: UserTaskItemStatus | null | undefined
        tool?: string | null | undefined
        timeline?: string | null | undefined
        startDate?: string | null | undefined
        expectedEndDate?: string | null | undefined
        howToDo?: string | null | undefined
        tutorialGenerationStatus?: TutorialGenerationStatus | null | undefined
        tutorialGenerationStartedAt?: string | null | undefined
        tutorialGenerationError?: string | null | undefined
        estimatedEffortInMinutes?: number | null | undefined
        instructionForTask?: string | null | undefined
        kpis?: string | null | undefined
        role?: string | null | undefined
        why?: string | null | undefined
        order?: number | null | undefined
        resources?: string | null | undefined
        createdBy?: string | null | undefined
        createdById?: string | null | undefined
        taskPriority?: BusinessGoalPriority | null | undefined
        category?: BusinessGoalCategory | null | undefined
        assigneeId?: string | null | undefined
        isCarryOver?: boolean | null | undefined
        goalId?: string | null | undefined
        goalName?: string | null | undefined
        isOverDue?: boolean | null | undefined
        suggestedStatus?: UserTaskSuggestedItemStatus | null | undefined
        businessAvatar?: string | null | undefined
        businessLogo?: string | null | undefined
        businessName?: string | null | undefined
        planName?: string | null | undefined
        planStartDate?: string | null | undefined
        planExpectedEndDate?: string | null | undefined
        businessHoursSpentPerDay?: number | null | undefined
        goalEndDate?: string | null | undefined
        meetingId?: string | null | undefined
        userInputFields?:
          | Array<{
              __typename?: 'UserInputField'
              fieldType: FieldType
              label: string
              name: string
              placeholder?: string | null | undefined
              value?: string | null | undefined
              multiple?: boolean | null | undefined
              optionsSource?: string | null | undefined
              options?:
                | Array<{ __typename?: 'Option'; label: string; value: string }>
                | null
                | undefined
              validation?:
                | {
                    __typename?: 'Validation'
                    type?: ValidationTypes | null | undefined
                    required?:
                      | {
                          __typename?: 'ValidationRequired'
                          value?: boolean | null | undefined
                          message?: string | null | undefined
                        }
                      | null
                      | undefined
                    pattern?:
                      | {
                          __typename?: 'ValidationRule'
                          value?: string | null | undefined
                          message: string
                        }
                      | null
                      | undefined
                    min?:
                      | {
                          __typename?: 'ValidationRule'
                          value?: string | null | undefined
                          message: string
                        }
                      | null
                      | undefined
                    max?:
                      | {
                          __typename?: 'ValidationRule'
                          value?: string | null | undefined
                          message: string
                        }
                      | null
                      | undefined
                    dateMin?:
                      | {
                          __typename?: 'DateValidationRule'
                          value?: string | null | undefined
                          message: string
                          dependsOn?: string | null | undefined
                          dependsOnMessage?: string | null | undefined
                        }
                      | null
                      | undefined
                    dateMax?:
                      | {
                          __typename?: 'DateValidationRule'
                          value?: string | null | undefined
                          message: string
                          dependsOn?: string | null | undefined
                          dependsOnMessage?: string | null | undefined
                        }
                      | null
                      | undefined
                  }
                | null
                | undefined
              conditionalField?:
                | {
                    __typename?: 'ConditionalField'
                    dependsOn: string
                    values: Array<string>
                    excludeValues?: Array<string> | null | undefined
                  }
                | null
                | undefined
              destinationResource?:
                | { __typename?: 'DestinationResource'; baseResource: BaseResource; field: string }
                | null
                | undefined
            }>
          | null
          | undefined
        howToLinks?:
          | Array<
              | {
                  __typename?: 'UserTaskHowTo'
                  howToId: string
                  title?: string | null | undefined
                  url?: string | null | undefined
                  steps?: string | null | undefined
                }
              | null
              | undefined
            >
          | null
          | undefined
        structuredSteps?:
          | Array<
              | {
                  __typename?: 'UserTaskHowToStep'
                  stepNumber: number
                  title: string
                  description: string
                  videos?:
                    | Array<
                        | {
                            __typename?: 'UserTaskHowToVideo'
                            url: string
                            title: string
                            relevance?: string | null | undefined
                            stepsCovered?: Array<number | null | undefined> | null | undefined
                          }
                        | null
                        | undefined
                      >
                    | null
                    | undefined
                }
              | null
              | undefined
            >
          | null
          | undefined
        files?:
          | Array<{
              __typename?: 'UserFile'
              id?: string | null | undefined
              name?: string | null | undefined
              size?: string | null | undefined
              tenantId?: string | null | undefined
              type?: string | null | undefined
              url?: string | null | undefined
              userId?: string | null | undefined
              createdAt?: string | null | undefined
            }>
          | null
          | undefined
        businessAdvisorsData?:
          | Array<
              | {
                  __typename?: 'BusinessAdvisorsData'
                  label?: string | null | undefined
                  value?: string | null | undefined
                }
              | null
              | undefined
            >
          | null
          | undefined
      }
    | null
    | undefined
}

export type GetUserTasksQueryVariables = Exact<{
  input: GetUserTasksInput
}>

export type GetUserTasksQuery = {
  __typename?: 'Query'
  getUserTasks?:
    | Array<{
        __typename?: 'UserTask'
        tenantId?: string | null | undefined
        userId?: string | null | undefined
        taskId?: string | null | undefined
        planId?: string | null | undefined
        milestoneId?: string | null | undefined
        name?: string | null | undefined
        description?: string | null | undefined
        source?: UserTaskSource | null | undefined
        status?: UserTaskItemStatus | null | undefined
        tool?: string | null | undefined
        timeline?: string | null | undefined
        startDate?: string | null | undefined
        expectedEndDate?: string | null | undefined
        howToDo?: string | null | undefined
        tutorialGenerationStatus?: TutorialGenerationStatus | null | undefined
        tutorialGenerationStartedAt?: string | null | undefined
        tutorialGenerationError?: string | null | undefined
        estimatedEffortInMinutes?: number | null | undefined
        instructionForTask?: string | null | undefined
        kpis?: string | null | undefined
        role?: string | null | undefined
        why?: string | null | undefined
        order?: number | null | undefined
        resources?: string | null | undefined
        createdBy?: string | null | undefined
        createdById?: string | null | undefined
        taskPriority?: BusinessGoalPriority | null | undefined
        category?: BusinessGoalCategory | null | undefined
        assigneeId?: string | null | undefined
        isCarryOver?: boolean | null | undefined
        goalId?: string | null | undefined
        goalName?: string | null | undefined
        isOverDue?: boolean | null | undefined
        suggestedStatus?: UserTaskSuggestedItemStatus | null | undefined
        businessAvatar?: string | null | undefined
        businessLogo?: string | null | undefined
        businessName?: string | null | undefined
        planName?: string | null | undefined
        planStartDate?: string | null | undefined
        planExpectedEndDate?: string | null | undefined
        businessHoursSpentPerDay?: number | null | undefined
        goalEndDate?: string | null | undefined
        meetingId?: string | null | undefined
        userInputFields?:
          | Array<{
              __typename?: 'UserInputField'
              fieldType: FieldType
              label: string
              name: string
              placeholder?: string | null | undefined
              value?: string | null | undefined
              multiple?: boolean | null | undefined
              optionsSource?: string | null | undefined
              options?:
                | Array<{ __typename?: 'Option'; label: string; value: string }>
                | null
                | undefined
              validation?:
                | {
                    __typename?: 'Validation'
                    type?: ValidationTypes | null | undefined
                    required?:
                      | {
                          __typename?: 'ValidationRequired'
                          value?: boolean | null | undefined
                          message?: string | null | undefined
                        }
                      | null
                      | undefined
                    pattern?:
                      | {
                          __typename?: 'ValidationRule'
                          value?: string | null | undefined
                          message: string
                        }
                      | null
                      | undefined
                    min?:
                      | {
                          __typename?: 'ValidationRule'
                          value?: string | null | undefined
                          message: string
                        }
                      | null
                      | undefined
                    max?:
                      | {
                          __typename?: 'ValidationRule'
                          value?: string | null | undefined
                          message: string
                        }
                      | null
                      | undefined
                    dateMin?:
                      | {
                          __typename?: 'DateValidationRule'
                          value?: string | null | undefined
                          message: string
                          dependsOn?: string | null | undefined
                          dependsOnMessage?: string | null | undefined
                        }
                      | null
                      | undefined
                    dateMax?:
                      | {
                          __typename?: 'DateValidationRule'
                          value?: string | null | undefined
                          message: string
                          dependsOn?: string | null | undefined
                          dependsOnMessage?: string | null | undefined
                        }
                      | null
                      | undefined
                  }
                | null
                | undefined
              conditionalField?:
                | {
                    __typename?: 'ConditionalField'
                    dependsOn: string
                    values: Array<string>
                    excludeValues?: Array<string> | null | undefined
                  }
                | null
                | undefined
              destinationResource?:
                | { __typename?: 'DestinationResource'; baseResource: BaseResource; field: string }
                | null
                | undefined
            }>
          | null
          | undefined
        howToLinks?:
          | Array<
              | {
                  __typename?: 'UserTaskHowTo'
                  howToId: string
                  title?: string | null | undefined
                  url?: string | null | undefined
                  steps?: string | null | undefined
                }
              | null
              | undefined
            >
          | null
          | undefined
        structuredSteps?:
          | Array<
              | {
                  __typename?: 'UserTaskHowToStep'
                  stepNumber: number
                  title: string
                  description: string
                  videos?:
                    | Array<
                        | {
                            __typename?: 'UserTaskHowToVideo'
                            url: string
                            title: string
                            relevance?: string | null | undefined
                            stepsCovered?: Array<number | null | undefined> | null | undefined
                          }
                        | null
                        | undefined
                      >
                    | null
                    | undefined
                }
              | null
              | undefined
            >
          | null
          | undefined
        files?:
          | Array<{
              __typename?: 'UserFile'
              id?: string | null | undefined
              name?: string | null | undefined
              size?: string | null | undefined
              tenantId?: string | null | undefined
              type?: string | null | undefined
              url?: string | null | undefined
              userId?: string | null | undefined
              createdAt?: string | null | undefined
            }>
          | null
          | undefined
        businessAdvisorsData?:
          | Array<
              | {
                  __typename?: 'BusinessAdvisorsData'
                  label?: string | null | undefined
                  value?: string | null | undefined
                }
              | null
              | undefined
            >
          | null
          | undefined
      }>
    | null
    | undefined
}

export type SearchUserTasksQueryVariables = Exact<{
  input: SearchUserTasksInput
}>

export type SearchUserTasksQuery = {
  __typename?: 'Query'
  searchUserTasks?:
    | Array<{
        __typename?: 'UserTask'
        tenantId?: string | null | undefined
        userId?: string | null | undefined
        taskId?: string | null | undefined
        planId?: string | null | undefined
        milestoneId?: string | null | undefined
        name?: string | null | undefined
        description?: string | null | undefined
        source?: UserTaskSource | null | undefined
        status?: UserTaskItemStatus | null | undefined
        tool?: string | null | undefined
        timeline?: string | null | undefined
        startDate?: string | null | undefined
        expectedEndDate?: string | null | undefined
        howToDo?: string | null | undefined
        tutorialGenerationStatus?: TutorialGenerationStatus | null | undefined
        tutorialGenerationStartedAt?: string | null | undefined
        tutorialGenerationError?: string | null | undefined
        estimatedEffortInMinutes?: number | null | undefined
        instructionForTask?: string | null | undefined
        kpis?: string | null | undefined
        role?: string | null | undefined
        why?: string | null | undefined
        order?: number | null | undefined
        resources?: string | null | undefined
        createdBy?: string | null | undefined
        createdById?: string | null | undefined
        taskPriority?: BusinessGoalPriority | null | undefined
        category?: BusinessGoalCategory | null | undefined
        assigneeId?: string | null | undefined
        isCarryOver?: boolean | null | undefined
        goalId?: string | null | undefined
        goalName?: string | null | undefined
        isOverDue?: boolean | null | undefined
        suggestedStatus?: UserTaskSuggestedItemStatus | null | undefined
        businessAvatar?: string | null | undefined
        businessLogo?: string | null | undefined
        businessName?: string | null | undefined
        planName?: string | null | undefined
        planStartDate?: string | null | undefined
        planExpectedEndDate?: string | null | undefined
        businessHoursSpentPerDay?: number | null | undefined
        goalEndDate?: string | null | undefined
        meetingId?: string | null | undefined
        userInputFields?:
          | Array<{
              __typename?: 'UserInputField'
              fieldType: FieldType
              label: string
              name: string
              placeholder?: string | null | undefined
              value?: string | null | undefined
              multiple?: boolean | null | undefined
              optionsSource?: string | null | undefined
              options?:
                | Array<{ __typename?: 'Option'; label: string; value: string }>
                | null
                | undefined
              validation?:
                | {
                    __typename?: 'Validation'
                    type?: ValidationTypes | null | undefined
                    required?:
                      | {
                          __typename?: 'ValidationRequired'
                          value?: boolean | null | undefined
                          message?: string | null | undefined
                        }
                      | null
                      | undefined
                    pattern?:
                      | {
                          __typename?: 'ValidationRule'
                          value?: string | null | undefined
                          message: string
                        }
                      | null
                      | undefined
                    min?:
                      | {
                          __typename?: 'ValidationRule'
                          value?: string | null | undefined
                          message: string
                        }
                      | null
                      | undefined
                    max?:
                      | {
                          __typename?: 'ValidationRule'
                          value?: string | null | undefined
                          message: string
                        }
                      | null
                      | undefined
                    dateMin?:
                      | {
                          __typename?: 'DateValidationRule'
                          value?: string | null | undefined
                          message: string
                          dependsOn?: string | null | undefined
                          dependsOnMessage?: string | null | undefined
                        }
                      | null
                      | undefined
                    dateMax?:
                      | {
                          __typename?: 'DateValidationRule'
                          value?: string | null | undefined
                          message: string
                          dependsOn?: string | null | undefined
                          dependsOnMessage?: string | null | undefined
                        }
                      | null
                      | undefined
                  }
                | null
                | undefined
              conditionalField?:
                | {
                    __typename?: 'ConditionalField'
                    dependsOn: string
                    values: Array<string>
                    excludeValues?: Array<string> | null | undefined
                  }
                | null
                | undefined
              destinationResource?:
                | { __typename?: 'DestinationResource'; baseResource: BaseResource; field: string }
                | null
                | undefined
            }>
          | null
          | undefined
        howToLinks?:
          | Array<
              | {
                  __typename?: 'UserTaskHowTo'
                  howToId: string
                  title?: string | null | undefined
                  url?: string | null | undefined
                  steps?: string | null | undefined
                }
              | null
              | undefined
            >
          | null
          | undefined
        structuredSteps?:
          | Array<
              | {
                  __typename?: 'UserTaskHowToStep'
                  stepNumber: number
                  title: string
                  description: string
                  videos?:
                    | Array<
                        | {
                            __typename?: 'UserTaskHowToVideo'
                            url: string
                            title: string
                            relevance?: string | null | undefined
                            stepsCovered?: Array<number | null | undefined> | null | undefined
                          }
                        | null
                        | undefined
                      >
                    | null
                    | undefined
                }
              | null
              | undefined
            >
          | null
          | undefined
        files?:
          | Array<{
              __typename?: 'UserFile'
              id?: string | null | undefined
              name?: string | null | undefined
              size?: string | null | undefined
              tenantId?: string | null | undefined
              type?: string | null | undefined
              url?: string | null | undefined
              userId?: string | null | undefined
              createdAt?: string | null | undefined
            }>
          | null
          | undefined
        businessAdvisorsData?:
          | Array<
              | {
                  __typename?: 'BusinessAdvisorsData'
                  label?: string | null | undefined
                  value?: string | null | undefined
                }
              | null
              | undefined
            >
          | null
          | undefined
      }>
    | null
    | undefined
}

export type GetAdvisorAssignedTasksQueryVariables = Exact<{
  input: GetAdvisorAssignedTasksInput
}>

export type GetAdvisorAssignedTasksQuery = {
  __typename?: 'Query'
  getAdvisorAssignedTasks?:
    | Array<{
        __typename?: 'UserTask'
        tenantId?: string | null | undefined
        userId?: string | null | undefined
        taskId?: string | null | undefined
        planId?: string | null | undefined
        milestoneId?: string | null | undefined
        name?: string | null | undefined
        description?: string | null | undefined
        source?: UserTaskSource | null | undefined
        status?: UserTaskItemStatus | null | undefined
        tool?: string | null | undefined
        timeline?: string | null | undefined
        startDate?: string | null | undefined
        expectedEndDate?: string | null | undefined
        howToDo?: string | null | undefined
        tutorialGenerationStatus?: TutorialGenerationStatus | null | undefined
        tutorialGenerationStartedAt?: string | null | undefined
        tutorialGenerationError?: string | null | undefined
        estimatedEffortInMinutes?: number | null | undefined
        instructionForTask?: string | null | undefined
        kpis?: string | null | undefined
        role?: string | null | undefined
        why?: string | null | undefined
        order?: number | null | undefined
        resources?: string | null | undefined
        createdBy?: string | null | undefined
        createdById?: string | null | undefined
        taskPriority?: BusinessGoalPriority | null | undefined
        category?: BusinessGoalCategory | null | undefined
        assigneeId?: string | null | undefined
        isCarryOver?: boolean | null | undefined
        goalId?: string | null | undefined
        goalName?: string | null | undefined
        isOverDue?: boolean | null | undefined
        suggestedStatus?: UserTaskSuggestedItemStatus | null | undefined
        businessAvatar?: string | null | undefined
        businessLogo?: string | null | undefined
        businessName?: string | null | undefined
        planName?: string | null | undefined
        planStartDate?: string | null | undefined
        planExpectedEndDate?: string | null | undefined
        businessHoursSpentPerDay?: number | null | undefined
        goalEndDate?: string | null | undefined
        meetingId?: string | null | undefined
        userInputFields?:
          | Array<{
              __typename?: 'UserInputField'
              fieldType: FieldType
              label: string
              name: string
              placeholder?: string | null | undefined
              value?: string | null | undefined
              multiple?: boolean | null | undefined
              optionsSource?: string | null | undefined
              options?:
                | Array<{ __typename?: 'Option'; label: string; value: string }>
                | null
                | undefined
              validation?:
                | {
                    __typename?: 'Validation'
                    type?: ValidationTypes | null | undefined
                    required?:
                      | {
                          __typename?: 'ValidationRequired'
                          value?: boolean | null | undefined
                          message?: string | null | undefined
                        }
                      | null
                      | undefined
                    pattern?:
                      | {
                          __typename?: 'ValidationRule'
                          value?: string | null | undefined
                          message: string
                        }
                      | null
                      | undefined
                    min?:
                      | {
                          __typename?: 'ValidationRule'
                          value?: string | null | undefined
                          message: string
                        }
                      | null
                      | undefined
                    max?:
                      | {
                          __typename?: 'ValidationRule'
                          value?: string | null | undefined
                          message: string
                        }
                      | null
                      | undefined
                    dateMin?:
                      | {
                          __typename?: 'DateValidationRule'
                          value?: string | null | undefined
                          message: string
                          dependsOn?: string | null | undefined
                          dependsOnMessage?: string | null | undefined
                        }
                      | null
                      | undefined
                    dateMax?:
                      | {
                          __typename?: 'DateValidationRule'
                          value?: string | null | undefined
                          message: string
                          dependsOn?: string | null | undefined
                          dependsOnMessage?: string | null | undefined
                        }
                      | null
                      | undefined
                  }
                | null
                | undefined
              conditionalField?:
                | {
                    __typename?: 'ConditionalField'
                    dependsOn: string
                    values: Array<string>
                    excludeValues?: Array<string> | null | undefined
                  }
                | null
                | undefined
              destinationResource?:
                | { __typename?: 'DestinationResource'; baseResource: BaseResource; field: string }
                | null
                | undefined
            }>
          | null
          | undefined
        howToLinks?:
          | Array<
              | {
                  __typename?: 'UserTaskHowTo'
                  howToId: string
                  title?: string | null | undefined
                  url?: string | null | undefined
                  steps?: string | null | undefined
                }
              | null
              | undefined
            >
          | null
          | undefined
        structuredSteps?:
          | Array<
              | {
                  __typename?: 'UserTaskHowToStep'
                  stepNumber: number
                  title: string
                  description: string
                  videos?:
                    | Array<
                        | {
                            __typename?: 'UserTaskHowToVideo'
                            url: string
                            title: string
                            relevance?: string | null | undefined
                            stepsCovered?: Array<number | null | undefined> | null | undefined
                          }
                        | null
                        | undefined
                      >
                    | null
                    | undefined
                }
              | null
              | undefined
            >
          | null
          | undefined
        files?:
          | Array<{
              __typename?: 'UserFile'
              id?: string | null | undefined
              name?: string | null | undefined
              size?: string | null | undefined
              tenantId?: string | null | undefined
              type?: string | null | undefined
              url?: string | null | undefined
              userId?: string | null | undefined
              createdAt?: string | null | undefined
            }>
          | null
          | undefined
        businessAdvisorsData?:
          | Array<
              | {
                  __typename?: 'BusinessAdvisorsData'
                  label?: string | null | undefined
                  value?: string | null | undefined
                }
              | null
              | undefined
            >
          | null
          | undefined
      }>
    | null
    | undefined
}

export type QuoteFieldFragment = {
  __typename?: 'QuoteResponse'
  author?: string | null | undefined
  date?: string | null | undefined
  quote?: string | null | undefined
}

export type GetQuoteQueryVariables = Exact<{ [key: string]: never }>

export type GetQuoteQuery = {
  __typename?: 'Query'
  getQuote: {
    __typename?: 'QuoteResponse'
    author?: string | null | undefined
    date?: string | null | undefined
    quote?: string | null | undefined
  }
}

export type SaveBusinessGoalMutationVariables = Exact<{
  input: SaveBusinessGoalInput
}>

export type SaveBusinessGoalMutation = {
  __typename?: 'Mutation'
  saveBusinessGoal?: string | null | undefined
}

export type UpdateBusinessGoalMutationVariables = Exact<{
  input: UpdateBusinessGoalInput
}>

export type UpdateBusinessGoalMutation = {
  __typename?: 'Mutation'
  updateBusinessGoal?: string | null | undefined
}

export type UpdateBusinessGoalMilestoneMutationVariables = Exact<{
  input: UpdateBusinessGoalMilestoneInput
}>

export type UpdateBusinessGoalMilestoneMutation = {
  __typename?: 'Mutation'
  updateBusinessGoalMilestone?: string | null | undefined
}

export type CreateUserTaskMutationVariables = Exact<{
  input: CreateUserTaskInput
}>

export type CreateUserTaskMutation = {
  __typename?: 'Mutation'
  createUserTask?:
    | {
        __typename?: 'UserTask'
        tenantId?: string | null | undefined
        userId?: string | null | undefined
        taskId?: string | null | undefined
        planId?: string | null | undefined
        milestoneId?: string | null | undefined
        name?: string | null | undefined
        description?: string | null | undefined
        source?: UserTaskSource | null | undefined
        status?: UserTaskItemStatus | null | undefined
        tool?: string | null | undefined
        timeline?: string | null | undefined
        startDate?: string | null | undefined
        expectedEndDate?: string | null | undefined
        howToDo?: string | null | undefined
        tutorialGenerationStatus?: TutorialGenerationStatus | null | undefined
        tutorialGenerationStartedAt?: string | null | undefined
        tutorialGenerationError?: string | null | undefined
        estimatedEffortInMinutes?: number | null | undefined
        instructionForTask?: string | null | undefined
        kpis?: string | null | undefined
        role?: string | null | undefined
        why?: string | null | undefined
        order?: number | null | undefined
        resources?: string | null | undefined
        createdBy?: string | null | undefined
        createdById?: string | null | undefined
        taskPriority?: BusinessGoalPriority | null | undefined
        category?: BusinessGoalCategory | null | undefined
        assigneeId?: string | null | undefined
        isCarryOver?: boolean | null | undefined
        goalId?: string | null | undefined
        goalName?: string | null | undefined
        isOverDue?: boolean | null | undefined
        suggestedStatus?: UserTaskSuggestedItemStatus | null | undefined
        businessAvatar?: string | null | undefined
        businessLogo?: string | null | undefined
        businessName?: string | null | undefined
        planName?: string | null | undefined
        planStartDate?: string | null | undefined
        planExpectedEndDate?: string | null | undefined
        businessHoursSpentPerDay?: number | null | undefined
        goalEndDate?: string | null | undefined
        meetingId?: string | null | undefined
        userInputFields?:
          | Array<{
              __typename?: 'UserInputField'
              fieldType: FieldType
              label: string
              name: string
              placeholder?: string | null | undefined
              value?: string | null | undefined
              multiple?: boolean | null | undefined
              optionsSource?: string | null | undefined
              options?:
                | Array<{ __typename?: 'Option'; label: string; value: string }>
                | null
                | undefined
              validation?:
                | {
                    __typename?: 'Validation'
                    type?: ValidationTypes | null | undefined
                    required?:
                      | {
                          __typename?: 'ValidationRequired'
                          value?: boolean | null | undefined
                          message?: string | null | undefined
                        }
                      | null
                      | undefined
                    pattern?:
                      | {
                          __typename?: 'ValidationRule'
                          value?: string | null | undefined
                          message: string
                        }
                      | null
                      | undefined
                    min?:
                      | {
                          __typename?: 'ValidationRule'
                          value?: string | null | undefined
                          message: string
                        }
                      | null
                      | undefined
                    max?:
                      | {
                          __typename?: 'ValidationRule'
                          value?: string | null | undefined
                          message: string
                        }
                      | null
                      | undefined
                    dateMin?:
                      | {
                          __typename?: 'DateValidationRule'
                          value?: string | null | undefined
                          message: string
                          dependsOn?: string | null | undefined
                          dependsOnMessage?: string | null | undefined
                        }
                      | null
                      | undefined
                    dateMax?:
                      | {
                          __typename?: 'DateValidationRule'
                          value?: string | null | undefined
                          message: string
                          dependsOn?: string | null | undefined
                          dependsOnMessage?: string | null | undefined
                        }
                      | null
                      | undefined
                  }
                | null
                | undefined
              conditionalField?:
                | {
                    __typename?: 'ConditionalField'
                    dependsOn: string
                    values: Array<string>
                    excludeValues?: Array<string> | null | undefined
                  }
                | null
                | undefined
              destinationResource?:
                | { __typename?: 'DestinationResource'; baseResource: BaseResource; field: string }
                | null
                | undefined
            }>
          | null
          | undefined
        howToLinks?:
          | Array<
              | {
                  __typename?: 'UserTaskHowTo'
                  howToId: string
                  title?: string | null | undefined
                  url?: string | null | undefined
                  steps?: string | null | undefined
                }
              | null
              | undefined
            >
          | null
          | undefined
        structuredSteps?:
          | Array<
              | {
                  __typename?: 'UserTaskHowToStep'
                  stepNumber: number
                  title: string
                  description: string
                  videos?:
                    | Array<
                        | {
                            __typename?: 'UserTaskHowToVideo'
                            url: string
                            title: string
                            relevance?: string | null | undefined
                            stepsCovered?: Array<number | null | undefined> | null | undefined
                          }
                        | null
                        | undefined
                      >
                    | null
                    | undefined
                }
              | null
              | undefined
            >
          | null
          | undefined
        files?:
          | Array<{
              __typename?: 'UserFile'
              id?: string | null | undefined
              name?: string | null | undefined
              size?: string | null | undefined
              tenantId?: string | null | undefined
              type?: string | null | undefined
              url?: string | null | undefined
              userId?: string | null | undefined
              createdAt?: string | null | undefined
            }>
          | null
          | undefined
        businessAdvisorsData?:
          | Array<
              | {
                  __typename?: 'BusinessAdvisorsData'
                  label?: string | null | undefined
                  value?: string | null | undefined
                }
              | null
              | undefined
            >
          | null
          | undefined
      }
    | null
    | undefined
}

export type DeleteUserTaskMutationVariables = Exact<{
  input: DeleteUserTaskInput
}>

export type DeleteUserTaskMutation = {
  __typename?: 'Mutation'
  deleteUserTask?: string | null | undefined
}

export type UpdateUserTaskMutationVariables = Exact<{
  input: UpdateUserTaskInput
}>

export type UpdateUserTaskMutation = {
  __typename?: 'Mutation'
  updateUserTask?:
    | {
        __typename?: 'UserTask'
        tenantId?: string | null | undefined
        userId?: string | null | undefined
        taskId?: string | null | undefined
        planId?: string | null | undefined
        milestoneId?: string | null | undefined
        name?: string | null | undefined
        description?: string | null | undefined
        source?: UserTaskSource | null | undefined
        status?: UserTaskItemStatus | null | undefined
        tool?: string | null | undefined
        timeline?: string | null | undefined
        startDate?: string | null | undefined
        expectedEndDate?: string | null | undefined
        howToDo?: string | null | undefined
        tutorialGenerationStatus?: TutorialGenerationStatus | null | undefined
        tutorialGenerationStartedAt?: string | null | undefined
        tutorialGenerationError?: string | null | undefined
        estimatedEffortInMinutes?: number | null | undefined
        instructionForTask?: string | null | undefined
        kpis?: string | null | undefined
        role?: string | null | undefined
        why?: string | null | undefined
        order?: number | null | undefined
        resources?: string | null | undefined
        createdBy?: string | null | undefined
        createdById?: string | null | undefined
        taskPriority?: BusinessGoalPriority | null | undefined
        category?: BusinessGoalCategory | null | undefined
        assigneeId?: string | null | undefined
        isCarryOver?: boolean | null | undefined
        goalId?: string | null | undefined
        goalName?: string | null | undefined
        isOverDue?: boolean | null | undefined
        suggestedStatus?: UserTaskSuggestedItemStatus | null | undefined
        businessAvatar?: string | null | undefined
        businessLogo?: string | null | undefined
        businessName?: string | null | undefined
        planName?: string | null | undefined
        planStartDate?: string | null | undefined
        planExpectedEndDate?: string | null | undefined
        businessHoursSpentPerDay?: number | null | undefined
        goalEndDate?: string | null | undefined
        meetingId?: string | null | undefined
        userInputFields?:
          | Array<{
              __typename?: 'UserInputField'
              fieldType: FieldType
              label: string
              name: string
              placeholder?: string | null | undefined
              value?: string | null | undefined
              multiple?: boolean | null | undefined
              optionsSource?: string | null | undefined
              options?:
                | Array<{ __typename?: 'Option'; label: string; value: string }>
                | null
                | undefined
              validation?:
                | {
                    __typename?: 'Validation'
                    type?: ValidationTypes | null | undefined
                    required?:
                      | {
                          __typename?: 'ValidationRequired'
                          value?: boolean | null | undefined
                          message?: string | null | undefined
                        }
                      | null
                      | undefined
                    pattern?:
                      | {
                          __typename?: 'ValidationRule'
                          value?: string | null | undefined
                          message: string
                        }
                      | null
                      | undefined
                    min?:
                      | {
                          __typename?: 'ValidationRule'
                          value?: string | null | undefined
                          message: string
                        }
                      | null
                      | undefined
                    max?:
                      | {
                          __typename?: 'ValidationRule'
                          value?: string | null | undefined
                          message: string
                        }
                      | null
                      | undefined
                    dateMin?:
                      | {
                          __typename?: 'DateValidationRule'
                          value?: string | null | undefined
                          message: string
                          dependsOn?: string | null | undefined
                          dependsOnMessage?: string | null | undefined
                        }
                      | null
                      | undefined
                    dateMax?:
                      | {
                          __typename?: 'DateValidationRule'
                          value?: string | null | undefined
                          message: string
                          dependsOn?: string | null | undefined
                          dependsOnMessage?: string | null | undefined
                        }
                      | null
                      | undefined
                  }
                | null
                | undefined
              conditionalField?:
                | {
                    __typename?: 'ConditionalField'
                    dependsOn: string
                    values: Array<string>
                    excludeValues?: Array<string> | null | undefined
                  }
                | null
                | undefined
              destinationResource?:
                | { __typename?: 'DestinationResource'; baseResource: BaseResource; field: string }
                | null
                | undefined
            }>
          | null
          | undefined
        howToLinks?:
          | Array<
              | {
                  __typename?: 'UserTaskHowTo'
                  howToId: string
                  title?: string | null | undefined
                  url?: string | null | undefined
                  steps?: string | null | undefined
                }
              | null
              | undefined
            >
          | null
          | undefined
        structuredSteps?:
          | Array<
              | {
                  __typename?: 'UserTaskHowToStep'
                  stepNumber: number
                  title: string
                  description: string
                  videos?:
                    | Array<
                        | {
                            __typename?: 'UserTaskHowToVideo'
                            url: string
                            title: string
                            relevance?: string | null | undefined
                            stepsCovered?: Array<number | null | undefined> | null | undefined
                          }
                        | null
                        | undefined
                      >
                    | null
                    | undefined
                }
              | null
              | undefined
            >
          | null
          | undefined
        files?:
          | Array<{
              __typename?: 'UserFile'
              id?: string | null | undefined
              name?: string | null | undefined
              size?: string | null | undefined
              tenantId?: string | null | undefined
              type?: string | null | undefined
              url?: string | null | undefined
              userId?: string | null | undefined
              createdAt?: string | null | undefined
            }>
          | null
          | undefined
        businessAdvisorsData?:
          | Array<
              | {
                  __typename?: 'BusinessAdvisorsData'
                  label?: string | null | undefined
                  value?: string | null | undefined
                }
              | null
              | undefined
            >
          | null
          | undefined
      }
    | null
    | undefined
}

export type UpdateGoalPlanMutationVariables = Exact<{
  input: UpdateGoalPlanInput
}>

export type UpdateGoalPlanMutation = {
  __typename?: 'Mutation'
  updateGoalPlan?: string | null | undefined
}

export type RegeneratePlanMutationVariables = Exact<{
  input: RegeneratePlanInput
}>

export type RegeneratePlanMutation = {
  __typename?: 'Mutation'
  regeneratePlan?: boolean | null | undefined
}

export type PopulateTaskInformationFieldsFragment = {
  __typename?: 'PopulateTaskInformationResponse'
  estimatedMinutes: number
  category: BusinessGoalCategory
}

export type PopulateTaskInformationMutationVariables = Exact<{
  taskName: Scalars['String']
}>

export type PopulateTaskInformationMutation = {
  __typename?: 'Mutation'
  populateTaskInformation: {
    __typename?: 'PopulateTaskInformationResponse'
    estimatedMinutes: number
    category: BusinessGoalCategory
  }
}

export type TaskCommentFieldsFragment = {
  __typename?: 'TaskComment'
  id: string
  content: string
  createdAt: string
  updatedAt: string
  createdById: string
  taskId: string
  createdBy: {
    __typename?: 'UserProfile'
    id: string
    firstName?: string | null | undefined
    lastName?: string | null | undefined
    email: string
  }
  reactions?:
    | Array<{ __typename?: 'Reaction'; id: string; type: string; userId: string }>
    | null
    | undefined
  replies?:
    | Array<{
        __typename?: 'TaskComment'
        id: string
        content: string
        createdAt: string
        updatedAt: string
        createdById: string
        taskId: string
        parentId?: string | null | undefined
        createdBy: {
          __typename?: 'UserProfile'
          id: string
          firstName?: string | null | undefined
          lastName?: string | null | undefined
          email: string
        }
        reactions?:
          | Array<{ __typename?: 'Reaction'; id: string; type: string; userId: string }>
          | null
          | undefined
      }>
    | null
    | undefined
}

export type AddTaskCommentMutationVariables = Exact<{
  input: AddTaskCommentInput
}>

export type AddTaskCommentMutation = {
  __typename?: 'Mutation'
  addTaskComment?:
    | {
        __typename?: 'TaskComment'
        id: string
        content: string
        createdAt: string
        updatedAt: string
        createdById: string
        taskId: string
        createdBy: {
          __typename?: 'UserProfile'
          id: string
          firstName?: string | null | undefined
          lastName?: string | null | undefined
          email: string
        }
        reactions?:
          | Array<{ __typename?: 'Reaction'; id: string; type: string; userId: string }>
          | null
          | undefined
        replies?:
          | Array<{
              __typename?: 'TaskComment'
              id: string
              content: string
              createdAt: string
              updatedAt: string
              createdById: string
              taskId: string
              parentId?: string | null | undefined
              createdBy: {
                __typename?: 'UserProfile'
                id: string
                firstName?: string | null | undefined
                lastName?: string | null | undefined
                email: string
              }
              reactions?:
                | Array<{ __typename?: 'Reaction'; id: string; type: string; userId: string }>
                | null
                | undefined
            }>
          | null
          | undefined
      }
    | null
    | undefined
}

export type DeleteTaskCommentMutationVariables = Exact<{
  input: DeleteTaskCommentInput
}>

export type DeleteTaskCommentMutation = {
  __typename?: 'Mutation'
  deleteTaskComment?: boolean | null | undefined
}

export type UpdateTaskCommentMutationVariables = Exact<{
  input: UpdateTaskCommentInput
}>

export type UpdateTaskCommentMutation = {
  __typename?: 'Mutation'
  updateTaskComment?:
    | {
        __typename?: 'TaskComment'
        id: string
        content: string
        createdAt: string
        updatedAt: string
        createdById: string
        taskId: string
        createdBy: {
          __typename?: 'UserProfile'
          id: string
          firstName?: string | null | undefined
          lastName?: string | null | undefined
          email: string
        }
        reactions?:
          | Array<{ __typename?: 'Reaction'; id: string; type: string; userId: string }>
          | null
          | undefined
        replies?:
          | Array<{
              __typename?: 'TaskComment'
              id: string
              content: string
              createdAt: string
              updatedAt: string
              createdById: string
              taskId: string
              parentId?: string | null | undefined
              createdBy: {
                __typename?: 'UserProfile'
                id: string
                firstName?: string | null | undefined
                lastName?: string | null | undefined
                email: string
              }
              reactions?:
                | Array<{ __typename?: 'Reaction'; id: string; type: string; userId: string }>
                | null
                | undefined
            }>
          | null
          | undefined
      }
    | null
    | undefined
}

export type UpdateTaskReactionMutationVariables = Exact<{
  input: UpdateTaskReactionInput
}>

export type UpdateTaskReactionMutation = {
  __typename?: 'Mutation'
  updateTaskReaction?: boolean | null | undefined
}

export type GetTaskCommentsQueryVariables = Exact<{
  input: GetTaskCommentsInput
}>

export type GetTaskCommentsQuery = {
  __typename?: 'Query'
  getTaskComments: Array<{
    __typename?: 'TaskComment'
    id: string
    content: string
    createdAt: string
    updatedAt: string
    createdById: string
    taskId: string
    createdBy: {
      __typename?: 'UserProfile'
      id: string
      firstName?: string | null | undefined
      lastName?: string | null | undefined
      email: string
    }
    reactions?:
      | Array<{ __typename?: 'Reaction'; id: string; type: string; userId: string }>
      | null
      | undefined
    replies?:
      | Array<{
          __typename?: 'TaskComment'
          id: string
          content: string
          createdAt: string
          updatedAt: string
          createdById: string
          taskId: string
          parentId?: string | null | undefined
          createdBy: {
            __typename?: 'UserProfile'
            id: string
            firstName?: string | null | undefined
            lastName?: string | null | undefined
            email: string
          }
          reactions?:
            | Array<{ __typename?: 'Reaction'; id: string; type: string; userId: string }>
            | null
            | undefined
        }>
      | null
      | undefined
  }>
}

export type OnGoalPlanRegenerationErrorSubscriptionVariables = Exact<{
  userId: Scalars['ID']
}>

export type OnGoalPlanRegenerationErrorSubscription = {
  __typename?: 'Subscription'
  onGoalPlanRegenerationError?:
    | {
        __typename?: 'GoalPlanRegenerationError'
        goalId: string
        message: string
        timestamp: string
        userId: string
        isLastAttempt?: boolean | null | undefined
      }
    | null
    | undefined
}

export type GetOnboardingFlowStateFieldsFragment = {
  __typename?: 'OnboardingFlowState'
  userId: string
  flowType?: OnboardingFlowType | null | undefined
  status: OnboardingFlowStepStatus
  step: string
  toolProcessingData?: Array<string> | null | undefined
  metadata: string
  currentStepType: OnboardingFlowStepTypes
}

export type GetOnboardingFlowStateQueryVariables = Exact<{
  input: GetOnboardingFlowStateInput
}>

export type GetOnboardingFlowStateQuery = {
  __typename?: 'Query'
  getOnboardingFlowState?:
    | {
        __typename?: 'OnboardingFlowState'
        userId: string
        flowType?: OnboardingFlowType | null | undefined
        status: OnboardingFlowStepStatus
        step: string
        toolProcessingData?: Array<string> | null | undefined
        metadata: string
        currentStepType: OnboardingFlowStepTypes
      }
    | null
    | undefined
}

export const AssessmentResponseFieldsFragmentDoc = `
    fragment assessmentResponseFields on AssessmentResponse {
  id
  currentStage
  playStage
  type
  userId
  assessmentResponse {
    next
    previous
    id
    value
    label
    recommendations {
      assessments
      plays
      assessmentRecommendedAt
      playRecommendedAt
    }
    playResponse
    isIndustry
    isSubIndustry
    isTopGoal
    optionType
    submittedAt
    showInReview
    questionLabel
  }
  createdAt
  updatedAt
}
    `
export const AssessmentQuestionFieldsFragmentDoc = `
    fragment assessmentQuestionFields on Assessment {
  id
  tenantId
  previous
  assessmentType
  meta
  content
  optionType
  options
  createdAt
  updatedAt
  isVisible
}
    `
export const GetAssessmentResponseByQuestionFieldsFragmentDoc = `
    fragment getAssessmentResponseByQuestionFields on UserResponse {
  success
  message
  data {
    id
    value
    question
    meta
  }
  error
}
    `
export const UserAssessmentResponseFieldsFragmentDoc = `
    fragment userAssessmentResponseFields on UserAssessmentResponse {
  success
  message
  data {
    id
    currentStage
    playStage
    type
    userId
    assessmentResponse {
      next
      previous
      id
      value
      label
      recommendations {
        assessments
        plays
        assessmentRecommendedAt
        playRecommendedAt
      }
      playResponse
      isIndustry
      isSubIndustry
      isTopGoal
      optionType
      submittedAt
      showInReview
      questionLabel
    }
    totalItems
    totalAttemptedItems
    createdAt
    updatedAt
    completedAt
  }
  error
}
    `
export const GetUserRecommendationsFieldsFragmentDoc = `
    fragment getUserRecommendationsFields on UserRecommendationsResponse {
  success
  message
  data
  error
}
    `
export const ListAssessmentsFieldsFragmentDoc = `
    fragment listAssessmentsFields on ListAssessmentResponse {
  success
  message
  data {
    type
    order
    isCompleted
    isLocked
    inProgress
  }
  error
}
    `
export const OptionsFieldsFragmentDoc = `
    fragment optionsFields on GetOptionsResponse {
  error
  data {
    id
    type
    name
    order
    dependencies
    toolTipText
    label
    infoText
    category
    categoryType
    isNew
  }
}
    `
export const GetAttestationSummaryFieldsFragmentDoc = `
    fragment getAttestationSummaryFields on AttestationSummary {
  tenantId
  unsignedCount
  signedCount
  submissionStartDate
  submissionEndDate
  submissionReminderDate
  submissionReportDate
  newAggregatedReport {
    month
    year
    contractors
    businessBankAccount
    jobsCreated
    volunteers
    partTimeEmployees
    fullTimeEmployees
    gender
    race
    education
    wages
    revenue
    debtFinancing
    financialGrowth
    newCustomer
    productSale
    serviceSale
    targetAudience
    physicalLocation
    businessName
    name
    signedDocumentUrl
    error
    createdAt
    downloadUrl
    fileName
  }
  aggregationReportHistory {
    month
    year
    contractors
    businessBankAccount
    jobsCreated
    volunteers
    partTimeEmployees
    fullTimeEmployees
    gender
    race
    education
    wages
    revenue
    debtFinancing
    financialGrowth
    newCustomer
    productSale
    serviceSale
    targetAudience
    physicalLocation
    businessName
    name
    signedDocumentUrl
    error
    createdAt
    downloadUrl
    fileName
  }
}
    `
export const BusinessSupportOrganizationFieldsFragmentDoc = `
    fragment businessSupportOrganizationFields on BusinessSupportOrganization {
  id
  adminId
  name
  logoUrl
  terminology {
    term
    replacement
  }
  licenseCount
  licensesUsed
  adminCount
  advisorCount
  mtdHighEngagementCriteria {
    lastMeetingDaysThreshold
    nextMeetingDaysThreshold
    commentChatDaysThreshold
    taskCompletionPercentageThreshold
    touchdownCountThreshold
    fumbleCountThreshold
    criteriaMetCount
  }
  mtdMediumEngagementCriteria {
    lastMeetingDaysThreshold
    nextMeetingDaysThreshold
    commentChatDaysThreshold
    taskCompletionPercentageThreshold
    touchdownCountThreshold
    fumbleCountThreshold
    criteriaMetCount
  }
  intakeFormCompleted
}
    `
export const SearchIndustryReportFieldsFragmentDoc = `
    fragment searchIndustryReportFields on IndustryReport {
  summaryText
  searchedKeyword
  results {
    summary
    docUrl
    docTitle
    pageNumber
  }
}
    `
export const BusinessProfileFieldsFragmentDoc = `
    fragment businessProfileFields on BusinessProfile {
  id
  userName
  businessName
  yearsInBusiness
  companyEmployees
  createdAt
  updatedAt
  tenantId
  businessVision
  challenges
  otherGoalsOptionIds
  registerBusinessStructureOptionId
  otherRegisteredBusinessStructure
  month
  year
  contractors
  businessBankAccount
  jobsCreated
  volunteers
  partTimeEmployees
  fullTimeEmployees
  gender
  race
  education
  wages
  revenue
  debtFinancing
  financialGrowth
  newCustomer
  productSale
  serviceSale
  targetAudience
  physicalLocation
  additionalInfo
  businessClassificationOptionId
  foodSubIndustryOptionIds
  servicesSubIndustryOptionId
  strongBusinessAreasOptionIds
  supportAndHelpOptionIds
  businessLocationsOptionIds
  topGoalOptionId
  businessStageOptionId
  isProfit
  domainName
  website
  country
  businessEmail
  naicsCode
  EIN
  businessAddress {
    addressLine1
    addressLine2
    city
    state
    zipCode
    hasBusinessAddress
  }
  logo {
    id
    name
    size
    url
  }
  hasAvatar
  avatar
  yearEstablished
  dba
  totalEmployees
  minorityOwned
  sbaCertified
  veteranOwned
  whereDoYouDoBusinessOptionIds
  revenueStatusOptionId
  otherWhereDoYouDoBusiness
  hoursSpentOptionId
  hoursSpentPerWeek
  hoursSpentPerMonth
  exitPlanOptionId
  otherExitPlan
  productsAndServicesOptionIds
  haveStartedGeneratingSales
  motivation
  personalGoals
  launchDate
  businessDescription
  lastYearRevenue
  thisYearRevenue
  grossRevenueGoalForThisYear
  facebook
  instagram
  linkedin
  tiktok
  twitter
  youtube
  hasRegisterBusinessStructure
  hasEIN
  hasWebsite
  hasFacebook
  hasInstagram
  hasLinkedin
  hasTikTok
  hasTwitter
  hasYoutube
  users {
    id
    userId
    type
    createdAt
    updatedAt
    user {
      id
      firstName
      lastName
      email
    }
  }
  businessMetricsViewPermission
}
    `
export const BusinessProfileFragmentDoc = `
    fragment businessProfile on BusinessProfile {
  id
  userName
  businessName
  yearsInBusiness
  companyEmployees
  createdAt
  updatedAt
  tenantId
  businessVision
  challenges
  otherGoals
  otherGoalsOptionIds
  registerBusinessStructure
  registerBusinessStructureOptionId
  otherRegisteredBusinessStructure
  month
  year
  contractors
  businessBankAccount
  jobsCreated
  volunteers
  partTimeEmployees
  fullTimeEmployees
  gender
  race
  education
  wages
  revenue
  debtFinancing
  financialGrowth
  newCustomer
  productSale
  serviceSale
  targetAudience
  physicalLocation
  additionalInfo
  businessClassification
  businessClassificationOptionId
  foodSubIndustry
  foodSubIndustryOptionIds
  servicesSubIndustry
  servicesSubIndustryOptionId
  strongBusinessAreas
  strongBusinessAreasOptionIds
  supportAndHelp
  supportAndHelpOptionIds
  businessLocations
  businessLocationsOptionIds
  topGoal
  topGoalOptionId
  businessStage
  businessStageOptionId
  isProfit
  noOfBusinessStarted
  thisYearRevenue
  lastYearRevenue
  businessNature
  businessNatureOptionId
  hasLogo
  hasLogoOptionId
  logo {
    id
    name
    size
    tenantId
    type
    url
    userId
  }
  businessPlan {
    id
    name
    size
    tenantId
    type
    url
    userId
    tag
  }
  EIN
  naicsCode
  numberOfBusinessBankAccounts
  hasGoogleChrome
  hasGoogleChromeOptionId
  hasDomainName
  hasDomainNameOptionId
  domainName
  website
  country
  hasBusinessEmail
  hasBusinessEmailOptionId
  businessEmail
  hasGoogleWorkspace
  hasGoogleWorkspaceOptionId
  hasEsignatureTool
  hasEsignatureToolOptionId
  hasBusinessPhoneNumber
  hasBusinessPhoneNumberOptionId
  hasLogoTrademarked
  hasLogoTrademarkedOptionId
  hasGoogleBusinessProfile
  hasGoogleBusinessProfileOptionId
  googleWorkspacePlaysOptionIds
  googleWorkspacePlays
  googleBusinessProfilePlaysOptionIds
  googleBusinessProfilePlays
  onboardedAt
  monthlyImpactReports {
    id
    name
    size
    tenantId
    type
    url
    userId
    createdAt
  }
  businessAddress {
    addressLine1
    addressLine2
    city
    state
    zipCode
    hasBusinessAddress
  }
  hasAvatar
  yearEstablished
  dba
  totalEmployees
  minorityOwned
  sbaCertified
  veteranOwned
  avatar
  businessDescription
  personalGoals
  seasonalityDetails
  exitPlan
  exitPlanOptionId
  otherExitPlan
  motivation
  grossRevenueGoalForThisYear
  launchDate
  whereDoYouDoBusiness
  whereDoYouDoBusinessOptionIds
  revenueStatus
  revenueStatusOptionId
  otherWhereDoYouDoBusiness
  hoursSpent
  hoursSpentOptionId
  hoursSpentPerWeek
  hoursSpentPerMonth
  productsAndServices
  productsAndServicesOptionIds
  haveStartedGeneratingSales
  lastUpdatedBusinessPlan
  facebook
  instagram
  linkedin
  tiktok
  twitter
  youtube
  hasRegisterBusinessStructure
  hasEIN
  hasWebsite
  hasFacebook
  hasInstagram
  hasLinkedin
  hasTikTok
  hasTwitter
  hasYoutube
  users {
    id
    userId
    type
    createdAt
    updatedAt
    user {
      id
      firstName
      lastName
      email
    }
  }
  businessMetricsViewPermission
  advisors {
    id
    firstName
    lastName
    email
    schedulingUrl
  }
}
    `
export const BusinessSummaryResponseFieldsFragmentDoc = `
    fragment businessSummaryResponseFields on BusinessSummaryResponse {
  data {
    optionType
    data {
      optionType
      optionName
      optionId
      tenantId
      summary
    }
  }
  status
}
    `
export const BusinessUserFieldsFragmentDoc = `
    fragment businessUserFields on BusinessUser {
  id
  userId
  businessId
  type
  createdAt
  updatedAt
  user {
    id
    firstName
    lastName
  }
}
    `
export const CyclrConnectorFieldsFragmentDoc = `
    fragment cyclrConnectorFields on CyclrConnectorResponse {
  success
  message
  data {
    id
    name
    authenticated
    connectorId
  }
  error
}
    `
export const CalenderEventFieldsFragmentDoc = `
    fragment calenderEventFields on CalendarEventResponse {
  success
  message
  data {
    summary
    description
    start {
      dateTime
      timeZone
    }
    end {
      dateTime
      timeZone
    }
    status
    eventTime
    meta
    location
    eventType
    attendees {
      email
      responseStatus
      optional
    }
    advisorProfiles
    profile
    timezone
    eventId
    inviteeId
    advisorId
    availability
    ownerId
    videoLinkDescription
    id
    isAllDay
    participantName
    organizerName
    participantFirstName
    participantLastName
    organizerFirstName
    organizerLastName
    teamMemberList
    teamMemberDetails {
      id
      firstName
      lastName
      email
    }
    externalReferenceIds {
      calendarId
      type
      externalEventId
      userId
      eventId
      status
      meta
      createdAt
      startDate
    }
    privateNotes {
      content
      createdBy
      createdAt
    }
    businessName
    businessLogo
  }
  error
}
    `
export const OAuthUrlFieldsFragmentDoc = `
    fragment oAuthUrlFields on OAuthUrlResponse {
  success
  message
  data
  error
}
    `
export const UserMeetingFieldsFragmentDoc = `
    fragment userMeetingFields on ApiResponse {
  success
  message
  data
  error
}
    `
export const CalendlyUserFieldsFragmentDoc = `
    fragment calendlyUserFields on CalendlyUserResponse {
  success
  message
  data {
    email
    name
    schedulingUrl
    calendlyEventsUrl
  }
  error
}
    `
export const DeleteCalendarFieldsFragmentDoc = `
    fragment deleteCalendarFields on DeleteCalendarEventResponse {
  success
  message
  data
  error
}
    `
export const DeleteGoogleCalendarEventFieldsFragmentDoc = `
    fragment deleteGoogleCalendarEventFields on ApiResponse {
  success
  message
  data
  error
}
    `
export const CancelOutlookEventFieldsFragmentDoc = `
    fragment cancelOutlookEventFields on ApiResponse {
  success
  message
  data
  error
}
    `
export const InvitedUserFieldsFragmentDoc = `
    fragment invitedUserFields on InvitedUser {
  id
  firstName
  lastName
  email
  roles
}
    `
export const TaggedUserFieldsFragmentDoc = `
    fragment taggedUserFields on InvitedUser {
  id
  firstName
  lastName
  email
  roles
}
    `
export const UpdateGoogleCalendarEventFieldsFragmentDoc = `
    fragment updateGoogleCalendarEventFields on ApiResponse {
  success
  message
  data
  error
}
    `
export const GetMeetingTypesFieldsFragmentDoc = `
    fragment getMeetingTypesFields on GetMeetingTypeResponse {
  success
  message
  data {
    id
    tenantId
    duration
    label
  }
  error
}
    `
export const SetUserAvailabilityFieldsFragmentDoc = `
    fragment setUserAvailabilityFields on SetUserAvailabilityResponse {
  data {
    createdAt
    updatedAt
    userId
    tenantId
    id
    availabilityHours {
      duration
      timezone
      timeSlots {
        label
        value
        slots {
          startTime
          endTime
        }
      }
    }
  }
  error
}
    `
export const GetUserAvailabilityFieldsFragmentDoc = `
    fragment getUserAvailabilityFields on GetUserAvailabilityResponse {
  data {
    duration
    availability {
      date
      slots {
        isAvailable
        slotStartTime
        slotEndTime
      }
    }
  }
  meetingLocation
  error
}
    `
export const SetUserMeetingResponseFieldsFragmentDoc = `
    fragment setUserMeetingResponseFields on UserMeetingData {
  id
  eventId
  updatedAt
  createdAt
  participantId
  tenantId
  startTime
  endTime
  description
  ownerId
  inviteeId
  title
  timezone
  attendees {
    email
    responseStatus
    optional
  }
  role
  status
  location
  videoLinkDescription
  advisorName
  organizerName
}
    `
export const UpdateUserCalendarFieldsFragmentDoc = `
    fragment UpdateUserCalendarFields on UpdateUserCalendarEventResponse {
  data {
    title
    eventId
    location
    tackleId
    eventType
    description
    comment
    attendees {
      email
      organizer
      self
      responseStatus
    }
    videoLinkDescription
    teamMemberList
  }
  error
}
    `
export const SubscribeGoogleCalendarWebhookFieldsFragmentDoc = `
    fragment subscribeGoogleCalendarWebhookFields on SubscribeGoogleCalendarWebhookResponse {
  data
  error
}
    `
export const CancelUserCalendarFieldsFragmentDoc = `
    fragment CancelUserCalendarFields on CancelUserCalendarEventResponse {
  data {
    tackleId
    eventId
    eventType
  }
  error
}
    `
export const UpdateUserAvailabilityFieldsFragmentDoc = `
    fragment updateUserAvailabilityFields on UpdateUserAvailabilityResponse {
  data {
    createdAt
    updatedAt
    userId
    tenantId
    id
    availabilityHours {
      duration
      timezone
      timeSlots {
        label
        value
        slots {
          startTime
          endTime
        }
      }
    }
  }
  error
}
    `
export const GetUserAvailabilityHoursFieldsFragmentDoc = `
    fragment getUserAvailabilityHoursFields on GetUserAvailabilityHoursResponse {
  data {
    createdAt
    updatedAt
    userId
    tenantId
    id
    availabilityHours {
      duration
      timezone
      timeSlots {
        label
        value
        slots {
          startTime
          endTime
        }
      }
    }
  }
  error
}
    `
export const GetUserMeetingByIdFieldsFragmentDoc = `
    fragment getUserMeetingByIdFields on GetUserMeetingByIdResponse {
  data {
    summary
    description
    start {
      dateTime
      timeZone
    }
    end {
      dateTime
      timeZone
    }
    status
    eventTime
    meta
    location
    eventType
    attendees {
      email
      responseStatus
      optional
    }
    advisorProfiles
    profile
    timezone
    eventId
    inviteeId
    advisorId
    ownerId
    availability
    comment
    videoLinkDescription
    id
    participantName
    organizerName
    participantFirstName
    participantLastName
    organizerFirstName
    organizerLastName
  }
  error
}
    `
export const LiquidCashReportFieldsFragmentDoc = `
    fragment liquidCashReportFields on LiquidCashReport {
  liquidCash
  source
  dateRange
  endDate
  growth
  startDate
}
    `
export const CashBalanceReportFieldsFragmentDoc = `
    fragment cashBalanceReportFields on CashBalanceReport {
  cashBalance
  source
  dateRange
  endDate
  growth
  startDate
}
    `
export const ProfitAndLossReportFieldsFragmentDoc = `
    fragment profitAndLossReportFields on ProfitAndLossReport {
  profitAndLossNetIncome
  source
  dateRange
  endDate
  growth
  startDate
}
    `
export const CashBalanceByMonthReportFieldsFragmentDoc = `
    fragment cashBalanceByMonthReportFields on CashBalanceByMonthReport {
  startDate
  endDate
  cashBalance
  source
}
    `
export const AccountingReportOutputFragmentFragmentDoc = `
    fragment AccountingReportOutputFragment on AccountingReportOutput {
  ...liquidCashReportFields
  ...cashBalanceReportFields
  ...profitAndLossReportFields
  ...cashBalanceByMonthReportFields
}
    ${LiquidCashReportFieldsFragmentDoc}
${CashBalanceReportFieldsFragmentDoc}
${ProfitAndLossReportFieldsFragmentDoc}
${CashBalanceByMonthReportFieldsFragmentDoc}`
export const AccountingChartFragmentFragmentDoc = `
    fragment AccountingChartFragment on AccountingChartResponse {
  data {
    __typename
    ...AccountingReportOutputFragment
  }
  status
}
    ${AccountingReportOutputFragmentFragmentDoc}`
export const ChatBotMessageFieldsFragmentDoc = `
    fragment chatBotMessageFields on ChatBotMessage {
  role
  content
  createdAt
  messageType
  progress
  isEdited
  isVoiceMessage
  voiceDuration
}
    `
export const CreateChatSessionFieldsFragmentDoc = `
    fragment createChatSessionFields on ChatSession {
  streamUrl
}
    `
export const UserTaskHowToResponseFieldsFragmentDoc = `
    fragment userTaskHowToResponseFields on UserTaskHowToResponse {
  text
  videoLinks
  steps
  structuredSteps {
    stepNumber
    title
    description
    videos {
      url
      title
      relevance
      stepsCovered
    }
  }
}
    `
export const SendMessageToBotFieldsFragmentDoc = `
    fragment sendMessageToBotFields on SendMessageToBotResponse {
  responses
  progress
  nextFlow
  isFinished
  flowType
  transcript
}
    `
export const GetChatSessionsFieldsFragmentDoc = `
    fragment getChatSessionsFields on MessageChatSession {
  id
  flow
  createdAt
  title
  status
  metadata
  executorId
  lastMessage {
    role
    content
    botResponse
    createdAt
    progress
    messageType
    isEdited
  }
}
    `
export const AdvisorDashboardFieldsFragmentDoc = `
    fragment AdvisorDashboardFields on ApiResponse {
  success
  message
  data
  data
  error
}
    `
export const TopActiveClientsFieldsFragmentDoc = `
    fragment TopActiveClientsFields on GetTopActiveClientsResponse {
  error
  data {
    id
    firstName
    lastName
    tenantId
    email
    score
    totalTime
    topGoal
    industry
    businessName
    logo {
      id
      name
      size
      tenantId
      type
      url
      userId
    }
  }
}
    `
export const GetUserToolsFieldsFragmentDoc = `
    fragment getUserToolsFields on GetUserToolsResponse {
  success
  message
  data {
    id
    cyclrToolId
    imageUrl
    toolName
    toolDisplayName
    userToolsImageUrl
    connectionFormImageUrl
    toolUrl
    isConnected
    isRecommended
    recommendedBy
    isSelected
    group
    category
    visible
    connectionStatus
    connectorName
    isBookmarked
    supportLevel
    options {
      connectionForm {
        description
        inputProperties {
          name
          displayName
          placeholder
          type
          validationRules
        }
      }
    }
    description
    diagnosticSupported
    longDescription
    toolHelpText
    relatedPlays
    authType
  }
  error
}
    `
export const BookmarkToolFieldsFragmentDoc = `
    fragment bookmarkToolFields on BookmarkToolResponse {
  success
  message
  data {
    id
    cyclrToolId
    imageUrl
    toolName
    toolDisplayName
    userToolsImageUrl
    connectionFormImageUrl
    toolUrl
    isConnected
    isRecommended
    recommendedBy
    isSelected
    group
    category
    visible
    connectionStatus
    connectorName
    isBookmarked
    supportLevel
    options {
      connectionForm {
        description
        inputProperties {
          name
          displayName
          placeholder
          type
          validationRules
        }
      }
    }
    description
    diagnosticSupported
    longDescription
    toolHelpText
  }
  error
}
    `
export const ClientsFieldsFragmentDoc = `
    fragment ClientsFields on GetClientsResponse {
  success
  message
  data {
    id
    name
    firstName
    lastName
    email
    createdAt
    updatedAt
    websiteURL
    bio
    roles
    isNewUser
    businessName
    mobileContactNumber
    yearsInBusiness
    companyAdvisor
    schedulingUrl
    calendlyEventsUrl
  }
  error
}
    `
export const TackleMeetingFieldsFragmentDoc = `
    fragment tackleMeetingFields on ApiResponse {
  success
  message
  data
  error
}
    `
export const ActivityLogFieldsFragmentDoc = `
    fragment activityLogFields on ApiResponse {
  success
  message
  data
  error
}
    `
export const OwnerActivityDetailsFieldsFragmentDoc = `
    fragment ownerActivityDetailsFields on OwnerActivitySummary {
  timesSignedIn
  timeOnPlatform
  toolsIntegrated
  chats
  meetingsScheduled
  meetingsReScheduled
  signInPerWeek
  avgMinsPerSession
}
    `
export const UserIntegrationFieldsFragmentDoc = `
    fragment userIntegrationFields on ApiResponse {
  success
  message
  data
  error
}
    `
export const TackleMeetingsFieldsFragmentDoc = `
    fragment tackleMeetingsFields on GetTackleMeetingResponse {
  success
  message
  data {
    summary
    description
    start {
      dateTime
      timeZone
    }
    end {
      dateTime
      timeZone
    }
    status
    eventTime
    meta
    location
    eventType
    attendees {
      email
      responseStatus
      optional
    }
    advisorProfiles
    profile
    timezone
    eventId
    inviteeId
    advisorId
    availability
    comment
    videoLinkDescription
    organizerName
    participantName
    ownerId
    participantFirstName
    participantLastName
    organizerFirstName
    organizerLastName
    privateNotes {
      content
      createdBy
      createdAt
      noteId
      files {
        id
        name
        size
        tenantId
        type
        url
        userId
        createdAt
      }
      advisorId
      tags
    }
    id
    status
    transcriptUrl
    recordingUrl
    transcriptSummary
    transcriptSummaryFile
    teamMemberList
    teamMemberDetails {
      id
      firstName
      lastName
      email
    }
    requestDetails {
      start {
        date
        dateTime
        timeZone
      }
      end {
        date
        dateTime
        timeZone
      }
      reason
    }
  }
  pagination
  error
}
    `
export const DeauthenticateConnectorFieldsFragmentDoc = `
    fragment deauthenticateConnectorFields on ApiResponse {
  message
  data
  error
}
    `
export const GetAllToolsFieldsFragmentDoc = `
    fragment getAllToolsFields on GetAllToolsResponse {
  success
  message
  data {
    id
    toolDisplayName
    cyclrToolId
    imageUrl
    toolName
    userToolsImageUrl
    connectionFormImageUrl
    toolUrl
    isConnected
    isRecommended
    recommendedBy
    isSelected
    pricingPageUrl
    group
    category
    visible
    supportLevel
    relatedPlays
    isBookmarked
    supportLevel
    options {
      connectionForm {
        description
        inputProperties {
          name
          displayName
          placeholder
          type
          validationRules
        }
      }
    }
    description
    diagnosticSupported
    longDescription
    toolHelpText
    authType
  }
  error
}
    `
export const GetAttestationReportsFieldsFragmentDoc = `
    fragment getAttestationReportsFields on GetAttestationReportsResponse {
  error
  data {
    lastEvaluatedKey
    prevEvaluatedKey
    totalPages
    totalRecords
    pageSize
    currentPage
    items {
      month
      year
      contractors
      businessBankAccount
      jobsCreated
      volunteers
      partTimeEmployees
      fullTimeEmployees
      gender
      race
      education
      wages
      revenue
      debtFinancing
      financialGrowth
      newCustomer
      productSale
      serviceSale
      targetAudience
      physicalLocation
      businessName
      name
      signedDocumentUrl
      properName
    }
  }
}
    `
export const UpdateOwnerFieldsFragmentDoc = `
    fragment updateOwnerFields on ApiResponse {
  success
  message
  data
  error
}
    `
export const GoalDetailsFieldsFragmentDoc = `
    fragment goalDetailsFields on Goal {
  id
  name
  description
  isTopGoal
  isActiveGoal
  assessments
  createdAt
  orderOfSequence
}
    `
export const GetPendingJobsFieldsFragmentDoc = `
    fragment getPendingJobsFields on JobDto {
  id
  status
  type
  createdAt
  updatedAt
  payload
}
    `
export const MetricValueFieldsFragmentDoc = `
    fragment metricValueFields on MetricValue {
  counter {
    value
    lastUpdatedAt
    refreshInProgress
  }
}
    `
export const ChartDataFieldsFragmentDoc = `
    fragment chartDataFields on ApiResponse {
  success
  message
  data
  error
}
    `
export const OwnerBusinessDataFieldsFragmentDoc = `
    fragment ownerBusinessDataFields on ApiResponse {
  success
  message
  data
  error
}
    `
export const GetPlayFieldsFragmentDoc = `
    fragment getPlayFields on ApiResponse {
  success
  message
  data
  error
}
    `
export const GetPlaysFieldsFragmentDoc = `
    fragment getPlaysFields on GetPlaysResponse {
  success
  message
  data {
    id
    content
    title
    type
    recommendedBy
    meta
    guide
    guide1
    setup
    use
    description
    playTabs
  }
  error
}
    `
export const AuthorizeConnectorFieldsFragmentDoc = `
    fragment authorizeConnectorFields on ApiResponse {
  success
  message
  data
  error
}
    `
export const PlayResponseFieldsFragmentDoc = `
    fragment playResponseFields on PlayResponse {
  tenantId
  playId
  playType
  isCompleted
  completedAt
  completedBy
  recommendations
  businessProfileFields {
    logo
  }
  playTabResponse {
    id
    tabName
    isCompleted
    completedAt
    stepResponse {
      id
      stepTitle
      isCompleted
      completedAt
      stepData {
        id
        value
        label
        isCompleted
        completedAt
        recommendations
        isMeetingScheduled
        businessProfileFields {
          logo {
            id
            name
            size
            tenantId
            type
            url
            userId
          }
        }
      }
    }
  }
}
    `
export const DashboardListingFieldsFragmentDoc = `
    fragment dashboardListingFields on ApiResponse {
  success
  message
  data
  error
}
    `
export const AssessmentPlayListingFieldsFragmentDoc = `
    fragment assessmentPlayListingFields on ApiResponse {
  success
  message
  data
  error
}
    `
export const GetToolsFieldsFragmentDoc = `
    fragment getToolsFields on GetToolsResponse {
  success
  message
  data {
    id
    toolName
  }
  error
}
    `
export const ToolFieldsFragmentDoc = `
    fragment toolFields on GetToolsByTypeResponse {
  error
  data {
    id
    cyclrToolId
    imageUrl
    toolName
    userToolsImageUrl
    toolUrl
    isConnected
    isRecommended
    recommendedBy
    isSelected
    group
    category
    visible
    toolType
    authType
    supportLevel
  }
}
    `
export const ToolCategoriesFieldsFragmentDoc = `
    fragment toolCategoriesFields on GetAllToolCategoriesResponse {
  categories {
    name
    description
    clientDescription
  }
  subCategories {
    name
  }
}
    `
export const SearchToolsFieldsFragmentDoc = `
    fragment searchToolsFields on SearchToolsResponse {
  data {
    id
    cyclrToolId
    imageUrl
    toolName
    toolDisplayName
    connectionFormImageUrl
    userToolsImageUrl
    toolUrl
    isConnected
    isRecommended
    recommendedBy
    isSelected
    group
    category
    visible
    connectionStatus
    connectorName
    pricingPageUrl
    tags
    subCategory
    options {
      connectionForm {
        description
        inputProperties {
          name
          displayName
          placeholder
          type
          validationRules
        }
      }
    }
    supportLevel
    relatedPlays
    isBookmarked
    description
    diagnosticSupported
    longDescription
    authType
    toolHelpText
    categories {
      category
      subCategory
    }
    clientId
    clientSecret
  }
  numberOfPages
}
    `
export const GoalSignedUrlFieldsFragmentDoc = `
    fragment goalSignedUrlFields on SignedUrlResponse {
  success
  message
  data
  error
}
    `
export const CognitoUserFieldsFragmentDoc = `
    fragment cognitoUserFields on CognitoUser {
  email
  userName
  enabled
  userStatus
  name
}
    `
export const GetUserFilesFiledsFragmentDoc = `
    fragment getUserFilesFileds on ApiResponse {
  success
  message
  data
  error
}
    `
export const SaveUserFileFieldsFragmentDoc = `
    fragment saveUserFileFields on ApiResponse {
  success
  message
  data
  error
}
    `
export const BigQueryFieldsFragmentDoc = `
    fragment bigQueryFields on ApiResponse {
  success
  message
  data
  error
}
    `
export const BusinessesFieldsFragmentDoc = `
    fragment BusinessesFields on ApiResponse {
  success
  message
  data
  error
}
    `
export const AdvisorsFieldsFragmentDoc = `
    fragment AdvisorsFields on ApiResponse {
  success
  message
  data
  error
}
    `
export const LogActivityFieldsFragmentDoc = `
    fragment logActivityFields on ApiResponse {
  success
  message
  data
  error
}
    `
export const UserNotificationsFieldsFragmentDoc = `
    fragment UserNotificationsFields on GetUserNotificationsResponse {
  error
  data {
    lastEvaluatedKey
    totalCount
    notifications {
      id
      createdAt
      meta
      notificationType
      sender
      status
      firstName
      lastName
      updatedAt
      businessName
      senderId
    }
  }
}
    `
export const UserNotificationMutateFieldsFragmentDoc = `
    fragment UserNotificationMutateFields on ApiResponse {
  success
  message
  data
  error
}
    `
export const GetClientsSummaryFieldsFragmentDoc = `
    fragment GetClientsSummaryFields on ApiResponse {
  success
  message
  data
  error
}
    `
export const ResendUserInviteFieldsFragmentDoc = `
    fragment resendUserInviteFields on ApiResponse {
  success
  message
  data
  error
}
    `
export const SaveAttestationFieldsFragmentDoc = `
    fragment saveAttestationFields on AttestationResponse {
  error
  data {
    pk
    sk
    id
    tenantId
    month
    year
    contractors
    businessBankAccount
    jobsCreated
    volunteers
    partTimeEmployees
    fullTimeEmployees
    gender
    race
    education
    wages
    revenue
    debtFinancing
    financialGrowth
    newCustomer
    productSale
    serviceSale
    targetAudience
    physicalLocation
    url
  }
}
    `
export const UserSummariesFieldsFragmentDoc = `
    fragment UserSummariesFields on UserSummaryResponse {
  items {
    firstName
    fumbleCount
    lastLoginDate
    lastName
    nextMeetingDate
    touchdownCount
    userId
    phoneNumber
    email
    status
  }
  lastEvaluatedKey
  totalRecordsCount
}
    `
export const UserProfileFieldsFragmentDoc = `
    fragment userProfileFields on UserProfile {
  id
  name
  firstName
  lastName
  email
  createdAt
  updatedAt
  websiteURL
  bio
  roles
  isNewUser
  mobileContactNumber
  yearsInBusiness
  companyEmployees
  companyAdvisor
  schedulingUrl
  calendlyEventsUrl
  tenantId
  streamAccessToken
  algoliaSearchKey
  firstSigninDate
  activatedAt
  status
  ownerExperience
  submissionStartDay
  submissionEndDay
  submissionReminderDay
  submissionReportDay
  attestationStatus
  isSmsEnabled
  defaultVideoLinkDescription
  organizationName
  timezone
  interimTimezone
  tempPassword
  calendarEventViewPreference
  isConsentGivenToAdvisor
  onboardingStatus
  quoteViewDate
  isJoinedBetaProgram
  jobTitle
  expertise
  workPhoneNumber
  workLocation
  employmentType
  linkedinProfile
  education
  workExperience
  avatar
  country
  workAddress
}
    `
export const BoAdvisorsFieldsFragmentDoc = `
    fragment BoAdvisorsFields on BOAdvisorsResponse {
  success
  message
  data {
    id
    firstName
    lastName
    email
    schedulingUrl
  }
  error
}
    `
export const SaveAssessmentResponseInputFragmentDoc = `
    fragment SaveAssessmentResponseInput on AssessmentResponse {
  currentStage
  type
  assessmentResponse {
    next
    previous
    id
    value
    label
    recommendations {
      assessments
      plays
      assessmentRecommendedAt
      playRecommendedAt
    }
    playResponse
    isIndustry
    isSubIndustry
    isTopGoal
  }
  userId
  createdAt
  updatedAt
}
    `
export const AdvisorProfileFieldsFragmentDoc = `
    fragment advisorProfileFields on AdvisorProfile {
  id
  firstName
  lastName
  defaultVideoLinkDescription
}
    `
export const BusinessIndustryChangedFieldsFragmentDoc = `
    fragment businessIndustryChangedFields on GetBusinessIndustryDetailsResponse {
  isSubIndustryUpdated
}
    `
export const GoalHistoryMessageFieldsFragmentDoc = `
    fragment goalHistoryMessageFields on GoalHistoryMessage {
  senderName
  senderRole
  avatar
  text
  createdAt
}
    `
export const GoalHistorySectionFieldsFragmentDoc = `
    fragment goalHistorySectionFields on GoalHistorySection {
  sessionId
  title
  type
  createdAt
  messages {
    ...goalHistoryMessageFields
  }
  hasMore
  nextCursor
}
    ${GoalHistoryMessageFieldsFragmentDoc}`
export const TaskFragmentDoc = `
    fragment task on UserTask {
  tenantId
  userId
  taskId
  planId
  milestoneId
  name
  description
  source
  status
  tool
  timeline
  startDate
  expectedEndDate
  howToDo
  tutorialGenerationStatus
  tutorialGenerationStartedAt
  tutorialGenerationError
  estimatedEffortInMinutes
  instructionForTask
  kpis
  role
  why
  order
  resources
  createdBy
  createdById
  howToLinks {
    howToId
    title
    url
    steps
  }
  structuredSteps {
    stepNumber
    title
    description
    videos {
      url
      title
      relevance
      stepsCovered
    }
  }
  taskPriority
  category
  assigneeId
  isCarryOver
  goalId
  goalName
  isOverDue
  files {
    id
    name
    size
    tenantId
    type
    url
    userId
    createdAt
  }
  suggestedStatus
  businessAvatar
  businessLogo
  businessName
  planName
  planStartDate
  planExpectedEndDate
  businessAdvisorsData {
    label
    value
  }
  businessHoursSpentPerDay
  goalEndDate
  meetingId
}
    `
export const GoalsFieldsFragmentDoc = `
    fragment goalsFields on BusinessGoal {
  goalId
  name
  status
  progress
  why
  goalPriority
  suggestedBy {
    id
    firstName
    lastName
    email
    schedulingUrl
    tenantId
  }
  createdBy {
    id
    firstName
    lastName
  }
  createdById
  suggestedById
  description
  category
  goalTimeFrame
  logo
  startDate
  expectedEndDate
  plan {
    planId
    goalId
    name
    startDate
    expectedEndDate
    timeline
    state
    progress
    pauseDuration
    pauseDate
    isUndismissedFumbledState
    isUndismissedMicroCelebrationState
    tasks {
      ...task
    }
    milestones {
      planId
      milestoneId
      name
      descriptions
      timeline
      startDate
      expectedEndDate
      riskAndChallenges
      status
      order
      milestoneSpan
      isFumbled
      tasks {
        ...task
      }
    }
  }
  experimentalCurrentDay
  dedicatedHoursPerWeek
  resourcesAverageDedicatedTimePerWeek
  createdAt
  updatedAt
  sessionId
  suggestedStatus
}
    ${TaskFragmentDoc}`
export const GoalResponseFragmentDoc = `
    fragment goalResponse on BusinessGoal {
  goalId
  name
  status
  startDate
  expectedEndDate
  suggestedBy {
    id
    firstName
    lastName
    email
    schedulingUrl
    tenantId
  }
  suggestedById
  plan {
    planId
    goalId
    name
    startDate
    expectedEndDate
  }
  sessionId
  suggestedStatus
}
    `
export const GoalFieldsFragmentDoc = `
    fragment goalFields on BusinessGoal {
  goalId
  userId
  name
  status
  progress
  startDate
  expectedEndDate
  goalPriority
  suggestedBy {
    id
    firstName
    lastName
    email
    schedulingUrl
    tenantId
  }
  suggestedById
  plan {
    planId
    goalId
    name
    startDate
    expectedEndDate
    timeline
    state
    progress
    pauseDuration
    pauseDate
    isUndismissedFumbledState
    isUndismissedMicroCelebrationState
    tasks {
      ...task
    }
    milestones {
      planId
      milestoneId
      name
      descriptions
      timeline
      startDate
      expectedEndDate
      riskAndChallenges
      status
      order
      milestoneSpan
      isFumbled
      tasks {
        ...task
      }
    }
  }
  experimentalCurrentDay
  dedicatedHoursPerWeek
  resourcesAverageDedicatedTimePerWeek
  createdAt
  updatedAt
  suggestedStatus
}
    ${TaskFragmentDoc}`
export const UserInputFieldsFragmentDoc = `
    fragment userInputFields on UserInputField {
  fieldType
  label
  name
  placeholder
  value
  options {
    label
    value
  }
  validation {
    required {
      value
      message
    }
    pattern {
      value
      message
    }
    type
    min {
      value
      message
    }
    max {
      value
      message
    }
    dateMin {
      value
      message
      dependsOn
      dependsOnMessage
    }
    dateMax {
      value
      message
      dependsOn
      dependsOnMessage
    }
  }
  multiple
  optionsSource
  conditionalField {
    dependsOn
    values
    excludeValues
  }
  destinationResource {
    baseResource
    field
  }
}
    `
export const UserTaskFieldsFragmentDoc = `
    fragment userTaskFields on UserTask {
  ...task
  userInputFields {
    ...userInputFields
  }
}
    ${TaskFragmentDoc}
${UserInputFieldsFragmentDoc}`
export const QuoteFieldFragmentDoc = `
    fragment quoteField on QuoteResponse {
  author
  date
  quote
}
    `
export const PopulateTaskInformationFieldsFragmentDoc = `
    fragment populateTaskInformationFields on PopulateTaskInformationResponse {
  estimatedMinutes
  category
}
    `
export const TaskCommentFieldsFragmentDoc = `
    fragment taskCommentFields on TaskComment {
  id
  content
  createdAt
  updatedAt
  createdById
  taskId
  createdBy {
    id
    firstName
    lastName
    email
  }
  reactions {
    id
    type
    userId
  }
  replies {
    id
    content
    createdAt
    updatedAt
    createdById
    taskId
    parentId
    createdBy {
      id
      firstName
      lastName
      email
    }
    reactions {
      id
      type
      userId
    }
  }
}
    `
export const GetOnboardingFlowStateFieldsFragmentDoc = `
    fragment getOnboardingFlowStateFields on OnboardingFlowState {
  userId
  flowType
  status
  step
  toolProcessingData
  metadata
  currentStepType
}
    `
export const GetUserAssessmentResponseDocument = `
    query getUserAssessmentResponse($userId: String, $type: String) {
  getUserAssessmentResponse(type: $type, userId: $userId) {
    ...userAssessmentResponseFields
  }
}
    ${UserAssessmentResponseFieldsFragmentDoc}`
export const useGetUserAssessmentResponseQuery = <
  TData = GetUserAssessmentResponseQuery,
  TError = any
>(
  variables?: GetUserAssessmentResponseQueryVariables,
  options?: UseQueryOptions<GetUserAssessmentResponseQuery, TError, TData>
) =>
  useQuery<GetUserAssessmentResponseQuery, TError, TData>(
    variables === undefined
      ? ['getUserAssessmentResponse']
      : ['getUserAssessmentResponse', variables],
    fetcher<GetUserAssessmentResponseQuery, GetUserAssessmentResponseQueryVariables>(
      GetUserAssessmentResponseDocument,
      variables
    ),
    options
  )
export const GetAssessmentsDocument = `
    query getAssessments($type: String) {
  getAssessments(type: $type) {
    ...assessmentQuestionFields
  }
}
    ${AssessmentQuestionFieldsFragmentDoc}`
export const useGetAssessmentsQuery = <TData = GetAssessmentsQuery, TError = any>(
  variables?: GetAssessmentsQueryVariables,
  options?: UseQueryOptions<GetAssessmentsQuery, TError, TData>
) =>
  useQuery<GetAssessmentsQuery, TError, TData>(
    variables === undefined ? ['getAssessments'] : ['getAssessments', variables],
    fetcher<GetAssessmentsQuery, GetAssessmentsQueryVariables>(GetAssessmentsDocument, variables),
    options
  )
export const SaveAssessmentResponseDocument = `
    mutation saveAssessmentResponse($input: SaveAssessmentResponseInput!) {
  saveAssessmentResponse(input: $input) {
    ...assessmentResponseFields
  }
}
    ${AssessmentResponseFieldsFragmentDoc}`
export const useSaveAssessmentResponseMutation = <TError = any, TContext = unknown>(
  options?: UseMutationOptions<
    SaveAssessmentResponseMutation,
    TError,
    SaveAssessmentResponseMutationVariables,
    TContext
  >
) =>
  useMutation<
    SaveAssessmentResponseMutation,
    TError,
    SaveAssessmentResponseMutationVariables,
    TContext
  >(
    ['saveAssessmentResponse'],
    (variables?: SaveAssessmentResponseMutationVariables) =>
      fetcher<SaveAssessmentResponseMutation, SaveAssessmentResponseMutationVariables>(
        SaveAssessmentResponseDocument,
        variables
      )(),
    options
  )
export const GetAssessmentResponseByQuestionDocument = `
    query getAssessmentResponseByQuestion($type: String, $question: String, $userId: String) {
  getAssessmentResponseByQuestion(
    type: $type
    question: $question
    userId: $userId
  ) {
    ...getAssessmentResponseByQuestionFields
  }
}
    ${GetAssessmentResponseByQuestionFieldsFragmentDoc}`
export const useGetAssessmentResponseByQuestionQuery = <
  TData = GetAssessmentResponseByQuestionQuery,
  TError = any
>(
  variables?: GetAssessmentResponseByQuestionQueryVariables,
  options?: UseQueryOptions<GetAssessmentResponseByQuestionQuery, TError, TData>
) =>
  useQuery<GetAssessmentResponseByQuestionQuery, TError, TData>(
    variables === undefined
      ? ['getAssessmentResponseByQuestion']
      : ['getAssessmentResponseByQuestion', variables],
    fetcher<GetAssessmentResponseByQuestionQuery, GetAssessmentResponseByQuestionQueryVariables>(
      GetAssessmentResponseByQuestionDocument,
      variables
    ),
    options
  )
export const GetUserRecommendationsDocument = `
    query getUserRecommendations($input: GetUserRecommendationsInput!) {
  getUserRecommendations(input: $input) {
    ...getUserRecommendationsFields
  }
}
    ${GetUserRecommendationsFieldsFragmentDoc}`
export const useGetUserRecommendationsQuery = <TData = GetUserRecommendationsQuery, TError = any>(
  variables: GetUserRecommendationsQueryVariables,
  options?: UseQueryOptions<GetUserRecommendationsQuery, TError, TData>
) =>
  useQuery<GetUserRecommendationsQuery, TError, TData>(
    ['getUserRecommendations', variables],
    fetcher<GetUserRecommendationsQuery, GetUserRecommendationsQueryVariables>(
      GetUserRecommendationsDocument,
      variables
    ),
    options
  )
export const ListAssessmentsDocument = `
    query listAssessments($userId: String, $tenantId: String!) {
  listAssessments(userId: $userId, tenantId: $tenantId) {
    ...listAssessmentsFields
  }
}
    ${ListAssessmentsFieldsFragmentDoc}`
export const useListAssessmentsQuery = <TData = ListAssessmentsQuery, TError = any>(
  variables: ListAssessmentsQueryVariables,
  options?: UseQueryOptions<ListAssessmentsQuery, TError, TData>
) =>
  useQuery<ListAssessmentsQuery, TError, TData>(
    ['listAssessments', variables],
    fetcher<ListAssessmentsQuery, ListAssessmentsQueryVariables>(
      ListAssessmentsDocument,
      variables
    ),
    options
  )
export const GetOptionsDocument = `
    query getOptions($optionTypes: [String!]!) {
  getOptions(optionTypes: $optionTypes) {
    ...optionsFields
  }
}
    ${OptionsFieldsFragmentDoc}`
export const useGetOptionsQuery = <TData = GetOptionsQuery, TError = any>(
  variables: GetOptionsQueryVariables,
  options?: UseQueryOptions<GetOptionsQuery, TError, TData>
) =>
  useQuery<GetOptionsQuery, TError, TData>(
    ['getOptions', variables],
    fetcher<GetOptionsQuery, GetOptionsQueryVariables>(GetOptionsDocument, variables),
    options
  )
export const GetAttestationSummaryDocument = `
    query getAttestationSummary($input: GetAttestationSummaryInput) {
  getAttestationSummary(input: $input) {
    ...getAttestationSummaryFields
  }
}
    ${GetAttestationSummaryFieldsFragmentDoc}`
export const useGetAttestationSummaryQuery = <TData = GetAttestationSummaryQuery, TError = any>(
  variables?: GetAttestationSummaryQueryVariables,
  options?: UseQueryOptions<GetAttestationSummaryQuery, TError, TData>
) =>
  useQuery<GetAttestationSummaryQuery, TError, TData>(
    variables === undefined ? ['getAttestationSummary'] : ['getAttestationSummary', variables],
    fetcher<GetAttestationSummaryQuery, GetAttestationSummaryQueryVariables>(
      GetAttestationSummaryDocument,
      variables
    ),
    options
  )
export const GetBusinessSupportOrganizationDocument = `
    query getBusinessSupportOrganization($input: GetBusinessSupportOrganizationInput!) {
  getBusinessSupportOrganization(input: $input) {
    ...businessSupportOrganizationFields
  }
}
    ${BusinessSupportOrganizationFieldsFragmentDoc}`
export const useGetBusinessSupportOrganizationQuery = <
  TData = GetBusinessSupportOrganizationQuery,
  TError = any
>(
  variables: GetBusinessSupportOrganizationQueryVariables,
  options?: UseQueryOptions<GetBusinessSupportOrganizationQuery, TError, TData>
) =>
  useQuery<GetBusinessSupportOrganizationQuery, TError, TData>(
    ['getBusinessSupportOrganization', variables],
    fetcher<GetBusinessSupportOrganizationQuery, GetBusinessSupportOrganizationQueryVariables>(
      GetBusinessSupportOrganizationDocument,
      variables
    ),
    options
  )
export const SearchIndustryReportDocument = `
    query searchIndustryReport($input: SearchIndustryReportInput!) {
  searchIndustryReport(input: $input) {
    ...searchIndustryReportFields
  }
}
    ${SearchIndustryReportFieldsFragmentDoc}`
export const useSearchIndustryReportQuery = <TData = SearchIndustryReportQuery, TError = any>(
  variables: SearchIndustryReportQueryVariables,
  options?: UseQueryOptions<SearchIndustryReportQuery, TError, TData>
) =>
  useQuery<SearchIndustryReportQuery, TError, TData>(
    ['searchIndustryReport', variables],
    fetcher<SearchIndustryReportQuery, SearchIndustryReportQueryVariables>(
      SearchIndustryReportDocument,
      variables
    ),
    options
  )
export const UpdateBusinessSupportOrganizationDocument = `
    mutation updateBusinessSupportOrganization($input: UpdateBusinessSupportOrganizationInput!) {
  updateBusinessSupportOrganization(input: $input) {
    ...businessSupportOrganizationFields
  }
}
    ${BusinessSupportOrganizationFieldsFragmentDoc}`
export const useUpdateBusinessSupportOrganizationMutation = <TError = any, TContext = unknown>(
  options?: UseMutationOptions<
    UpdateBusinessSupportOrganizationMutation,
    TError,
    UpdateBusinessSupportOrganizationMutationVariables,
    TContext
  >
) =>
  useMutation<
    UpdateBusinessSupportOrganizationMutation,
    TError,
    UpdateBusinessSupportOrganizationMutationVariables,
    TContext
  >(
    ['updateBusinessSupportOrganization'],
    (variables?: UpdateBusinessSupportOrganizationMutationVariables) =>
      fetcher<
        UpdateBusinessSupportOrganizationMutation,
        UpdateBusinessSupportOrganizationMutationVariables
      >(UpdateBusinessSupportOrganizationDocument, variables)(),
    options
  )
export const GetBusinessProfileDocument = `
    query getBusinessProfile($id: ID) {
  getBusinessProfile(id: $id) {
    ...businessProfile
  }
}
    ${BusinessProfileFragmentDoc}`
export const useGetBusinessProfileQuery = <TData = GetBusinessProfileQuery, TError = any>(
  variables?: GetBusinessProfileQueryVariables,
  options?: UseQueryOptions<GetBusinessProfileQuery, TError, TData>
) =>
  useQuery<GetBusinessProfileQuery, TError, TData>(
    variables === undefined ? ['getBusinessProfile'] : ['getBusinessProfile', variables],
    fetcher<GetBusinessProfileQuery, GetBusinessProfileQueryVariables>(
      GetBusinessProfileDocument,
      variables
    ),
    options
  )
export const GetBusinessRevenueMetricsDocument = `
    query getBusinessRevenueMetrics($id: ID, $asOfDate: AWSDate!, $granularity: MetricGranularity) {
  getBusinessProfile(id: $id) {
    revenueThisMonth: metricValue(
      input: {metricCode: "annualRevenue", timeRange: {asOfDate: $asOfDate, granularity: $granularity}, forceSync: true}
    ) {
      counter {
        value
        lastUpdatedAt
        refreshInProgress
      }
    }
    revenueGrowthRate: metricValue(
      input: {metricCode: "revenueGrowthRate", timeRange: {asOfDate: $asOfDate, granularity: $granularity}, forceSync: true}
    ) {
      counter {
        value
        lastUpdatedAt
        refreshInProgress
      }
    }
    revenueYearToDate: metricValue(
      input: {metricCode: "annualRevenue", timeRange: {asOfDate: $asOfDate, granularity: $granularity}, forceSync: true}
    ) {
      counter {
        value
        lastUpdatedAt
        refreshInProgress
      }
    }
  }
}
    `
export const useGetBusinessRevenueMetricsQuery = <
  TData = GetBusinessRevenueMetricsQuery,
  TError = any
>(
  variables: GetBusinessRevenueMetricsQueryVariables,
  options?: UseQueryOptions<GetBusinessRevenueMetricsQuery, TError, TData>
) =>
  useQuery<GetBusinessRevenueMetricsQuery, TError, TData>(
    ['getBusinessRevenueMetrics', variables],
    fetcher<GetBusinessRevenueMetricsQuery, GetBusinessRevenueMetricsQueryVariables>(
      GetBusinessRevenueMetricsDocument,
      variables
    ),
    options
  )
export const GetBusinessNetProfitMetricsDocument = `
    query getBusinessNetProfitMetrics($id: ID, $asOfDate: AWSDate!, $granularity: MetricGranularity) {
  getBusinessProfile(id: $id) {
    netProfitThisMonth: metricValue(
      input: {metricCode: "netProfit", timeRange: {asOfDate: $asOfDate, granularity: $granularity}, forceSync: true}
    ) {
      counter {
        value
        lastUpdatedAt
        refreshInProgress
      }
    }
    netProfitGrowthRate: metricValue(
      input: {metricCode: "netProfitGrowthRate", timeRange: {asOfDate: $asOfDate, granularity: $granularity}, forceSync: true}
    ) {
      counter {
        value
        lastUpdatedAt
        refreshInProgress
      }
    }
    netProfitYearToDate: metricValue(
      input: {metricCode: "netProfit", timeRange: {asOfDate: $asOfDate, granularity: $granularity}, forceSync: true}
    ) {
      counter {
        value
        lastUpdatedAt
        refreshInProgress
      }
    }
  }
}
    `
export const useGetBusinessNetProfitMetricsQuery = <
  TData = GetBusinessNetProfitMetricsQuery,
  TError = any
>(
  variables: GetBusinessNetProfitMetricsQueryVariables,
  options?: UseQueryOptions<GetBusinessNetProfitMetricsQuery, TError, TData>
) =>
  useQuery<GetBusinessNetProfitMetricsQuery, TError, TData>(
    ['getBusinessNetProfitMetrics', variables],
    fetcher<GetBusinessNetProfitMetricsQuery, GetBusinessNetProfitMetricsQueryVariables>(
      GetBusinessNetProfitMetricsDocument,
      variables
    ),
    options
  )
export const GetBusinessNumberOfLeadsMetricsDocument = `
    query getBusinessNumberOfLeadsMetrics($id: ID, $asOfDate: AWSDate!, $granularity: MetricGranularity) {
  getBusinessProfile(id: $id) {
    leadCount: metricValue(
      input: {metricCode: "leadCount", timeRange: {asOfDate: $asOfDate, granularity: $granularity}, forceSync: true}
    ) {
      counter {
        value
        lastUpdatedAt
        refreshInProgress
      }
    }
    leadCountGrowthRate: metricValue(
      input: {metricCode: "leadCountGrowthRate", timeRange: {asOfDate: $asOfDate, granularity: $granularity}, forceSync: true}
    ) {
      counter {
        value
        lastUpdatedAt
        refreshInProgress
      }
    }
  }
}
    `
export const useGetBusinessNumberOfLeadsMetricsQuery = <
  TData = GetBusinessNumberOfLeadsMetricsQuery,
  TError = any
>(
  variables: GetBusinessNumberOfLeadsMetricsQueryVariables,
  options?: UseQueryOptions<GetBusinessNumberOfLeadsMetricsQuery, TError, TData>
) =>
  useQuery<GetBusinessNumberOfLeadsMetricsQuery, TError, TData>(
    ['getBusinessNumberOfLeadsMetrics', variables],
    fetcher<GetBusinessNumberOfLeadsMetricsQuery, GetBusinessNumberOfLeadsMetricsQueryVariables>(
      GetBusinessNumberOfLeadsMetricsDocument,
      variables
    ),
    options
  )
export const GetBusinessLeadsConversionRateMetricsDocument = `
    query getBusinessLeadsConversionRateMetrics($id: ID, $asOfDate: AWSDate!, $granularity: MetricGranularity) {
  getBusinessProfile(id: $id) {
    leadConversionRate: metricValue(
      input: {metricCode: "leadConversionRate", timeRange: {asOfDate: $asOfDate, granularity: $granularity}, forceSync: true}
    ) {
      counter {
        value
        lastUpdatedAt
        refreshInProgress
      }
    }
    leadConversionRateGrowthRate: metricValue(
      input: {metricCode: "leadConversionRateGrowthRate", timeRange: {asOfDate: $asOfDate, granularity: $granularity}, forceSync: true}
    ) {
      counter {
        value
        lastUpdatedAt
        refreshInProgress
      }
    }
  }
}
    `
export const useGetBusinessLeadsConversionRateMetricsQuery = <
  TData = GetBusinessLeadsConversionRateMetricsQuery,
  TError = any
>(
  variables: GetBusinessLeadsConversionRateMetricsQueryVariables,
  options?: UseQueryOptions<GetBusinessLeadsConversionRateMetricsQuery, TError, TData>
) =>
  useQuery<GetBusinessLeadsConversionRateMetricsQuery, TError, TData>(
    ['getBusinessLeadsConversionRateMetrics', variables],
    fetcher<
      GetBusinessLeadsConversionRateMetricsQuery,
      GetBusinessLeadsConversionRateMetricsQueryVariables
    >(GetBusinessLeadsConversionRateMetricsDocument, variables),
    options
  )
export const UpdateBusinessProfileDocument = `
    mutation updateBusinessProfile($input: UpdateBusinessProfileInput!) {
  updateBusinessProfile(input: $input) {
    ...businessProfileFields
  }
}
    ${BusinessProfileFieldsFragmentDoc}`
export const useUpdateBusinessProfileMutation = <TError = any, TContext = unknown>(
  options?: UseMutationOptions<
    UpdateBusinessProfileMutation,
    TError,
    UpdateBusinessProfileMutationVariables,
    TContext
  >
) =>
  useMutation<
    UpdateBusinessProfileMutation,
    TError,
    UpdateBusinessProfileMutationVariables,
    TContext
  >(
    ['updateBusinessProfile'],
    (variables?: UpdateBusinessProfileMutationVariables) =>
      fetcher<UpdateBusinessProfileMutation, UpdateBusinessProfileMutationVariables>(
        UpdateBusinessProfileDocument,
        variables
      )(),
    options
  )
export const GetBusinessSummaryDocument = `
    query getBusinessSummary($input: GetBusinessSummaryInput!) {
  getBusinessSummary(input: $input) {
    ...businessSummaryResponseFields
  }
}
    ${BusinessSummaryResponseFieldsFragmentDoc}`
export const useGetBusinessSummaryQuery = <TData = GetBusinessSummaryQuery, TError = any>(
  variables: GetBusinessSummaryQueryVariables,
  options?: UseQueryOptions<GetBusinessSummaryQuery, TError, TData>
) =>
  useQuery<GetBusinessSummaryQuery, TError, TData>(
    ['getBusinessSummary', variables],
    fetcher<GetBusinessSummaryQuery, GetBusinessSummaryQueryVariables>(
      GetBusinessSummaryDocument,
      variables
    ),
    options
  )
export const GetBusinessUsersDocument = `
    query getBusinessUsers($businessId: ID!) {
  getBusinessUsers(businessId: $businessId) {
    ...businessUserFields
  }
}
    ${BusinessUserFieldsFragmentDoc}`
export const useGetBusinessUsersQuery = <TData = GetBusinessUsersQuery, TError = any>(
  variables: GetBusinessUsersQueryVariables,
  options?: UseQueryOptions<GetBusinessUsersQuery, TError, TData>
) =>
  useQuery<GetBusinessUsersQuery, TError, TData>(
    ['getBusinessUsers', variables],
    fetcher<GetBusinessUsersQuery, GetBusinessUsersQueryVariables>(
      GetBusinessUsersDocument,
      variables
    ),
    options
  )
export const GetUserConnectorsDocument = `
    query getUserConnectors($connectorName: String) {
  getUserConnectors(connectorName: $connectorName) {
    ...cyclrConnectorFields
  }
}
    ${CyclrConnectorFieldsFragmentDoc}`
export const useGetUserConnectorsQuery = <TData = GetUserConnectorsQuery, TError = any>(
  variables?: GetUserConnectorsQueryVariables,
  options?: UseQueryOptions<GetUserConnectorsQuery, TError, TData>
) =>
  useQuery<GetUserConnectorsQuery, TError, TData>(
    variables === undefined ? ['getUserConnectors'] : ['getUserConnectors', variables],
    fetcher<GetUserConnectorsQuery, GetUserConnectorsQueryVariables>(
      GetUserConnectorsDocument,
      variables
    ),
    options
  )
export const GetUserCalendarEventsDocument = `
    query getUserCalendarEvents($calendarName: String, $timeMin: String, $timeMax: String, $tenantId: String) {
  getUserCalendarEvents(
    calendarName: $calendarName
    timeMin: $timeMin
    timeMax: $timeMax
    tenantId: $tenantId
  ) {
    ...calenderEventFields
  }
}
    ${CalenderEventFieldsFragmentDoc}`
export const useGetUserCalendarEventsQuery = <TData = GetUserCalendarEventsQuery, TError = any>(
  variables?: GetUserCalendarEventsQueryVariables,
  options?: UseQueryOptions<GetUserCalendarEventsQuery, TError, TData>
) =>
  useQuery<GetUserCalendarEventsQuery, TError, TData>(
    variables === undefined ? ['getUserCalendarEvents'] : ['getUserCalendarEvents', variables],
    fetcher<GetUserCalendarEventsQuery, GetUserCalendarEventsQueryVariables>(
      GetUserCalendarEventsDocument,
      variables
    ),
    options
  )
export const GetUserCalendarEventsByUserIdDocument = `
    query getUserCalendarEventsByUserId($calendarName: String, $timeMin: String, $timeMax: String, $tenantId: String, $userId: String) {
  getUserCalendarEventsByUserId(
    calendarName: $calendarName
    timeMin: $timeMin
    timeMax: $timeMax
    tenantId: $tenantId
    userId: $userId
  ) {
    ...calenderEventFields
  }
}
    ${CalenderEventFieldsFragmentDoc}`
export const useGetUserCalendarEventsByUserIdQuery = <
  TData = GetUserCalendarEventsByUserIdQuery,
  TError = any
>(
  variables?: GetUserCalendarEventsByUserIdQueryVariables,
  options?: UseQueryOptions<GetUserCalendarEventsByUserIdQuery, TError, TData>
) =>
  useQuery<GetUserCalendarEventsByUserIdQuery, TError, TData>(
    variables === undefined
      ? ['getUserCalendarEventsByUserId']
      : ['getUserCalendarEventsByUserId', variables],
    fetcher<GetUserCalendarEventsByUserIdQuery, GetUserCalendarEventsByUserIdQueryVariables>(
      GetUserCalendarEventsByUserIdDocument,
      variables
    ),
    options
  )
export const GetOAuthUrlDocument = `
    query getOAuthUrl($input: GetOAuthUrlInput!) {
  getOAuthUrl(input: $input) {
    ...oAuthUrlFields
  }
}
    ${OAuthUrlFieldsFragmentDoc}`
export const useGetOAuthUrlQuery = <TData = GetOAuthUrlQuery, TError = any>(
  variables: GetOAuthUrlQueryVariables,
  options?: UseQueryOptions<GetOAuthUrlQuery, TError, TData>
) =>
  useQuery<GetOAuthUrlQuery, TError, TData>(
    ['getOAuthUrl', variables],
    fetcher<GetOAuthUrlQuery, GetOAuthUrlQueryVariables>(GetOAuthUrlDocument, variables),
    options
  )
export const GetCalendlyUserDocument = `
    query getCalendlyUser {
  getCalendlyUser {
    ...calendlyUserFields
  }
}
    ${CalendlyUserFieldsFragmentDoc}`
export const useGetCalendlyUserQuery = <TData = GetCalendlyUserQuery, TError = any>(
  variables?: GetCalendlyUserQueryVariables,
  options?: UseQueryOptions<GetCalendlyUserQuery, TError, TData>
) =>
  useQuery<GetCalendlyUserQuery, TError, TData>(
    variables === undefined ? ['getCalendlyUser'] : ['getCalendlyUser', variables],
    fetcher<GetCalendlyUserQuery, GetCalendlyUserQueryVariables>(
      GetCalendlyUserDocument,
      variables
    ),
    options
  )
export const SubscribeCalendlyWebhookDocument = `
    query subscribeCalendlyWebhook($tenantId: String, $email: String) {
  subscribeCalendlyWebhook(tenantId: $tenantId, email: $email) {
    ...userMeetingFields
  }
}
    ${UserMeetingFieldsFragmentDoc}`
export const useSubscribeCalendlyWebhookQuery = <
  TData = SubscribeCalendlyWebhookQuery,
  TError = any
>(
  variables?: SubscribeCalendlyWebhookQueryVariables,
  options?: UseQueryOptions<SubscribeCalendlyWebhookQuery, TError, TData>
) =>
  useQuery<SubscribeCalendlyWebhookQuery, TError, TData>(
    variables === undefined
      ? ['subscribeCalendlyWebhook']
      : ['subscribeCalendlyWebhook', variables],
    fetcher<SubscribeCalendlyWebhookQuery, SubscribeCalendlyWebhookQueryVariables>(
      SubscribeCalendlyWebhookDocument,
      variables
    ),
    options
  )
export const SubscribeGoogleCalendarWebhookDocument = `
    mutation subscribeGoogleCalendarWebhook($tenantId: String) {
  subscribeGoogleCalendarWebhook(tenantId: $tenantId) {
    ...subscribeGoogleCalendarWebhookFields
  }
}
    ${SubscribeGoogleCalendarWebhookFieldsFragmentDoc}`
export const useSubscribeGoogleCalendarWebhookMutation = <TError = any, TContext = unknown>(
  options?: UseMutationOptions<
    SubscribeGoogleCalendarWebhookMutation,
    TError,
    SubscribeGoogleCalendarWebhookMutationVariables,
    TContext
  >
) =>
  useMutation<
    SubscribeGoogleCalendarWebhookMutation,
    TError,
    SubscribeGoogleCalendarWebhookMutationVariables,
    TContext
  >(
    ['subscribeGoogleCalendarWebhook'],
    (variables?: SubscribeGoogleCalendarWebhookMutationVariables) =>
      fetcher<
        SubscribeGoogleCalendarWebhookMutation,
        SubscribeGoogleCalendarWebhookMutationVariables
      >(SubscribeGoogleCalendarWebhookDocument, variables)(),
    options
  )
export const GetUserMeetingDocument = `
    query getUserMeeting($advisorId: String) {
  getUserMeeting(advisorId: $advisorId) {
    ...userMeetingFields
  }
}
    ${UserMeetingFieldsFragmentDoc}`
export const useGetUserMeetingQuery = <TData = GetUserMeetingQuery, TError = any>(
  variables?: GetUserMeetingQueryVariables,
  options?: UseQueryOptions<GetUserMeetingQuery, TError, TData>
) =>
  useQuery<GetUserMeetingQuery, TError, TData>(
    variables === undefined ? ['getUserMeeting'] : ['getUserMeeting', variables],
    fetcher<GetUserMeetingQuery, GetUserMeetingQueryVariables>(GetUserMeetingDocument, variables),
    options
  )
export const DeleteCalendarEventDocument = `
    mutation deleteCalendarEvent($input: DeleteCalendarEventInput!) {
  deleteCalendarEvent(input: $input) {
    ...deleteCalendarFields
  }
}
    ${DeleteCalendarFieldsFragmentDoc}`
export const useDeleteCalendarEventMutation = <TError = any, TContext = unknown>(
  options?: UseMutationOptions<
    DeleteCalendarEventMutation,
    TError,
    DeleteCalendarEventMutationVariables,
    TContext
  >
) =>
  useMutation<DeleteCalendarEventMutation, TError, DeleteCalendarEventMutationVariables, TContext>(
    ['deleteCalendarEvent'],
    (variables?: DeleteCalendarEventMutationVariables) =>
      fetcher<DeleteCalendarEventMutation, DeleteCalendarEventMutationVariables>(
        DeleteCalendarEventDocument,
        variables
      )(),
    options
  )
export const DeleteGoogleCalendarEventDocument = `
    query deleteGoogleCalendarEvent($input: deleteGoogleCalendarEventInput) {
  deleteGoogleCalendarEvent(input: $input) {
    ...deleteGoogleCalendarEventFields
  }
}
    ${DeleteGoogleCalendarEventFieldsFragmentDoc}`
export const useDeleteGoogleCalendarEventQuery = <
  TData = DeleteGoogleCalendarEventQuery,
  TError = any
>(
  variables?: DeleteGoogleCalendarEventQueryVariables,
  options?: UseQueryOptions<DeleteGoogleCalendarEventQuery, TError, TData>
) =>
  useQuery<DeleteGoogleCalendarEventQuery, TError, TData>(
    variables === undefined
      ? ['deleteGoogleCalendarEvent']
      : ['deleteGoogleCalendarEvent', variables],
    fetcher<DeleteGoogleCalendarEventQuery, DeleteGoogleCalendarEventQueryVariables>(
      DeleteGoogleCalendarEventDocument,
      variables
    ),
    options
  )
export const UpdateGoogleCalendarEventDocument = `
    query updateGoogleCalendarEvent($input: updateGoogleCalendarEventInput) {
  updateGoogleCalendarEvent(input: $input) {
    ...updateGoogleCalendarEventFields
  }
}
    ${UpdateGoogleCalendarEventFieldsFragmentDoc}`
export const useUpdateGoogleCalendarEventQuery = <
  TData = UpdateGoogleCalendarEventQuery,
  TError = any
>(
  variables?: UpdateGoogleCalendarEventQueryVariables,
  options?: UseQueryOptions<UpdateGoogleCalendarEventQuery, TError, TData>
) =>
  useQuery<UpdateGoogleCalendarEventQuery, TError, TData>(
    variables === undefined
      ? ['updateGoogleCalendarEvent']
      : ['updateGoogleCalendarEvent', variables],
    fetcher<UpdateGoogleCalendarEventQuery, UpdateGoogleCalendarEventQueryVariables>(
      UpdateGoogleCalendarEventDocument,
      variables
    ),
    options
  )
export const CancelOutlookEventDocument = `
    query cancelOutlookEvent($input: cancelOutlookEventInput) {
  cancelOutlookEvent(input: $input) {
    ...cancelOutlookEventFields
  }
}
    ${CancelOutlookEventFieldsFragmentDoc}`
export const useCancelOutlookEventQuery = <TData = CancelOutlookEventQuery, TError = any>(
  variables?: CancelOutlookEventQueryVariables,
  options?: UseQueryOptions<CancelOutlookEventQuery, TError, TData>
) =>
  useQuery<CancelOutlookEventQuery, TError, TData>(
    variables === undefined ? ['cancelOutlookEvent'] : ['cancelOutlookEvent', variables],
    fetcher<CancelOutlookEventQuery, CancelOutlookEventQueryVariables>(
      CancelOutlookEventDocument,
      variables
    ),
    options
  )
export const GetMeetingTypesDocument = `
    query getMeetingTypes($tenantId: String!) {
  getMeetingTypes(tenantId: $tenantId) {
    ...getMeetingTypesFields
  }
}
    ${GetMeetingTypesFieldsFragmentDoc}`
export const useGetMeetingTypesQuery = <TData = GetMeetingTypesQuery, TError = any>(
  variables: GetMeetingTypesQueryVariables,
  options?: UseQueryOptions<GetMeetingTypesQuery, TError, TData>
) =>
  useQuery<GetMeetingTypesQuery, TError, TData>(
    ['getMeetingTypes', variables],
    fetcher<GetMeetingTypesQuery, GetMeetingTypesQueryVariables>(
      GetMeetingTypesDocument,
      variables
    ),
    options
  )
export const SetUserAvailabilityDocument = `
    mutation setUserAvailability($input: SetUserAvailabilityInput) {
  setUserAvailability(input: $input) {
    ...setUserAvailabilityFields
  }
}
    ${SetUserAvailabilityFieldsFragmentDoc}`
export const useSetUserAvailabilityMutation = <TError = any, TContext = unknown>(
  options?: UseMutationOptions<
    SetUserAvailabilityMutation,
    TError,
    SetUserAvailabilityMutationVariables,
    TContext
  >
) =>
  useMutation<SetUserAvailabilityMutation, TError, SetUserAvailabilityMutationVariables, TContext>(
    ['setUserAvailability'],
    (variables?: SetUserAvailabilityMutationVariables) =>
      fetcher<SetUserAvailabilityMutation, SetUserAvailabilityMutationVariables>(
        SetUserAvailabilityDocument,
        variables
      )(),
    options
  )
export const GetUserAvailabilityDocument = `
    query getUserAvailability($input: GetUserAvailabilityInput!) {
  getUserAvailability(input: $input) {
    ...getUserAvailabilityFields
  }
}
    ${GetUserAvailabilityFieldsFragmentDoc}`
export const useGetUserAvailabilityQuery = <TData = GetUserAvailabilityQuery, TError = any>(
  variables: GetUserAvailabilityQueryVariables,
  options?: UseQueryOptions<GetUserAvailabilityQuery, TError, TData>
) =>
  useQuery<GetUserAvailabilityQuery, TError, TData>(
    ['getUserAvailability', variables],
    fetcher<GetUserAvailabilityQuery, GetUserAvailabilityQueryVariables>(
      GetUserAvailabilityDocument,
      variables
    ),
    options
  )
export const SetUserMeetingDocument = `
    mutation setUserMeeting($input: SetUserMeetingInput!) {
  setUserMeeting(input: $input) {
    ...setUserMeetingResponseFields
  }
}
    ${SetUserMeetingResponseFieldsFragmentDoc}`
export const useSetUserMeetingMutation = <TError = any, TContext = unknown>(
  options?: UseMutationOptions<
    SetUserMeetingMutation,
    TError,
    SetUserMeetingMutationVariables,
    TContext
  >
) =>
  useMutation<SetUserMeetingMutation, TError, SetUserMeetingMutationVariables, TContext>(
    ['setUserMeeting'],
    (variables?: SetUserMeetingMutationVariables) =>
      fetcher<SetUserMeetingMutation, SetUserMeetingMutationVariables>(
        SetUserMeetingDocument,
        variables
      )(),
    options
  )
export const UpdateUserCalendarEventDocument = `
    mutation updateUserCalendarEvent($input: UpdateUserCalendarEventInput!) {
  updateUserCalendarEvent(input: $input) {
    ...UpdateUserCalendarFields
  }
}
    ${UpdateUserCalendarFieldsFragmentDoc}`
export const useUpdateUserCalendarEventMutation = <TError = any, TContext = unknown>(
  options?: UseMutationOptions<
    UpdateUserCalendarEventMutation,
    TError,
    UpdateUserCalendarEventMutationVariables,
    TContext
  >
) =>
  useMutation<
    UpdateUserCalendarEventMutation,
    TError,
    UpdateUserCalendarEventMutationVariables,
    TContext
  >(
    ['updateUserCalendarEvent'],
    (variables?: UpdateUserCalendarEventMutationVariables) =>
      fetcher<UpdateUserCalendarEventMutation, UpdateUserCalendarEventMutationVariables>(
        UpdateUserCalendarEventDocument,
        variables
      )(),
    options
  )
export const RescheduleUserCalendarEventDocument = `
    mutation rescheduleUserCalendarEvent($input: RescheduleUserCalendarEventInput!) {
  rescheduleUserCalendarEvent(input: $input) {
    ...UpdateUserCalendarFields
  }
}
    ${UpdateUserCalendarFieldsFragmentDoc}`
export const useRescheduleUserCalendarEventMutation = <TError = any, TContext = unknown>(
  options?: UseMutationOptions<
    RescheduleUserCalendarEventMutation,
    TError,
    RescheduleUserCalendarEventMutationVariables,
    TContext
  >
) =>
  useMutation<
    RescheduleUserCalendarEventMutation,
    TError,
    RescheduleUserCalendarEventMutationVariables,
    TContext
  >(
    ['rescheduleUserCalendarEvent'],
    (variables?: RescheduleUserCalendarEventMutationVariables) =>
      fetcher<RescheduleUserCalendarEventMutation, RescheduleUserCalendarEventMutationVariables>(
        RescheduleUserCalendarEventDocument,
        variables
      )(),
    options
  )
export const CancelUserCalendarEventDocument = `
    mutation cancelUserCalendarEvent($input: CancelUserCalendarEventInput!) {
  cancelUserCalendarEvent(input: $input) {
    ...CancelUserCalendarFields
  }
}
    ${CancelUserCalendarFieldsFragmentDoc}`
export const useCancelUserCalendarEventMutation = <TError = any, TContext = unknown>(
  options?: UseMutationOptions<
    CancelUserCalendarEventMutation,
    TError,
    CancelUserCalendarEventMutationVariables,
    TContext
  >
) =>
  useMutation<
    CancelUserCalendarEventMutation,
    TError,
    CancelUserCalendarEventMutationVariables,
    TContext
  >(
    ['cancelUserCalendarEvent'],
    (variables?: CancelUserCalendarEventMutationVariables) =>
      fetcher<CancelUserCalendarEventMutation, CancelUserCalendarEventMutationVariables>(
        CancelUserCalendarEventDocument,
        variables
      )(),
    options
  )
export const GetUserAvailabilityHoursDocument = `
    query getUserAvailabilityHours($userId: String) {
  getUserAvailabilityHours(userId: $userId) {
    ...getUserAvailabilityHoursFields
  }
}
    ${GetUserAvailabilityHoursFieldsFragmentDoc}`
export const useGetUserAvailabilityHoursQuery = <
  TData = GetUserAvailabilityHoursQuery,
  TError = any
>(
  variables?: GetUserAvailabilityHoursQueryVariables,
  options?: UseQueryOptions<GetUserAvailabilityHoursQuery, TError, TData>
) =>
  useQuery<GetUserAvailabilityHoursQuery, TError, TData>(
    variables === undefined
      ? ['getUserAvailabilityHours']
      : ['getUserAvailabilityHours', variables],
    fetcher<GetUserAvailabilityHoursQuery, GetUserAvailabilityHoursQueryVariables>(
      GetUserAvailabilityHoursDocument,
      variables
    ),
    options
  )
export const UpdateUserAvailabilityDocument = `
    mutation updateUserAvailability($input: UpdateUserAvailabilityInput) {
  updateUserAvailability(input: $input) {
    ...updateUserAvailabilityFields
  }
}
    ${UpdateUserAvailabilityFieldsFragmentDoc}`
export const useUpdateUserAvailabilityMutation = <TError = any, TContext = unknown>(
  options?: UseMutationOptions<
    UpdateUserAvailabilityMutation,
    TError,
    UpdateUserAvailabilityMutationVariables,
    TContext
  >
) =>
  useMutation<
    UpdateUserAvailabilityMutation,
    TError,
    UpdateUserAvailabilityMutationVariables,
    TContext
  >(
    ['updateUserAvailability'],
    (variables?: UpdateUserAvailabilityMutationVariables) =>
      fetcher<UpdateUserAvailabilityMutation, UpdateUserAvailabilityMutationVariables>(
        UpdateUserAvailabilityDocument,
        variables
      )(),
    options
  )
export const GetUserMeetingByIdDocument = `
    query getUserMeetingById($input: GetUserMeetingByIdInput!) {
  getUserMeetingById(input: $input) {
    ...getUserMeetingByIdFields
  }
}
    ${GetUserMeetingByIdFieldsFragmentDoc}`
export const useGetUserMeetingByIdQuery = <TData = GetUserMeetingByIdQuery, TError = any>(
  variables: GetUserMeetingByIdQueryVariables,
  options?: UseQueryOptions<GetUserMeetingByIdQuery, TError, TData>
) =>
  useQuery<GetUserMeetingByIdQuery, TError, TData>(
    ['getUserMeetingById', variables],
    fetcher<GetUserMeetingByIdQuery, GetUserMeetingByIdQueryVariables>(
      GetUserMeetingByIdDocument,
      variables
    ),
    options
  )
export const GetAllInvitedUsersDocument = `
    query getAllInvitedUsers($input: getAllInvitedUsersInput!) {
  getAllInvitedUsers(input: $input) {
    ...invitedUserFields
  }
}
    ${InvitedUserFieldsFragmentDoc}`
export const useGetAllInvitedUsersQuery = <TData = GetAllInvitedUsersQuery, TError = any>(
  variables: GetAllInvitedUsersQueryVariables,
  options?: UseQueryOptions<GetAllInvitedUsersQuery, TError, TData>
) =>
  useQuery<GetAllInvitedUsersQuery, TError, TData>(
    ['getAllInvitedUsers', variables],
    fetcher<GetAllInvitedUsersQuery, GetAllInvitedUsersQueryVariables>(
      GetAllInvitedUsersDocument,
      variables
    ),
    options
  )
export const GetAllTagUsersDocument = `
    query getAllTagUsers($input: getAllTagUsersInput!) {
  getAllTagUsers(input: $input) {
    ...taggedUserFields
  }
}
    ${TaggedUserFieldsFragmentDoc}`
export const useGetAllTagUsersQuery = <TData = GetAllTagUsersQuery, TError = any>(
  variables: GetAllTagUsersQueryVariables,
  options?: UseQueryOptions<GetAllTagUsersQuery, TError, TData>
) =>
  useQuery<GetAllTagUsersQuery, TError, TData>(
    ['getAllTagUsers', variables],
    fetcher<GetAllTagUsersQuery, GetAllTagUsersQueryVariables>(GetAllTagUsersDocument, variables),
    options
  )
export const GetAccountingChartsDocument = `
    query getAccountingCharts($input: QueryAccountingReportInput!) {
  getAccountingCharts(input: $input) {
    ...AccountingChartFragment
  }
}
    ${AccountingChartFragmentFragmentDoc}`
export const useGetAccountingChartsQuery = <TData = GetAccountingChartsQuery, TError = any>(
  variables: GetAccountingChartsQueryVariables,
  options?: UseQueryOptions<GetAccountingChartsQuery, TError, TData>
) =>
  useQuery<GetAccountingChartsQuery, TError, TData>(
    ['getAccountingCharts', variables],
    fetcher<GetAccountingChartsQuery, GetAccountingChartsQueryVariables>(
      GetAccountingChartsDocument,
      variables
    ),
    options
  )
export const GetMessagesFromBotDocument = `
    query getMessagesFromBot($sessionId: String!, $cursor: String, $limit: Int) {
  getMessagesFromBot(sessionId: $sessionId, cursor: $cursor, limit: $limit) {
    messages {
      ...chatBotMessageFields
    }
    hasMore
    nextCursor
  }
}
    ${ChatBotMessageFieldsFragmentDoc}`
export const useGetMessagesFromBotQuery = <TData = GetMessagesFromBotQuery, TError = any>(
  variables: GetMessagesFromBotQueryVariables,
  options?: UseQueryOptions<GetMessagesFromBotQuery, TError, TData>
) =>
  useQuery<GetMessagesFromBotQuery, TError, TData>(
    ['getMessagesFromBot', variables],
    fetcher<GetMessagesFromBotQuery, GetMessagesFromBotQueryVariables>(
      GetMessagesFromBotDocument,
      variables
    ),
    options
  )
export const CreateChatSessionDocument = `
    mutation createChatSession($input: CreateChatSessionInput!) {
  createChatSession(input: $input) {
    ...createChatSessionFields
  }
}
    ${CreateChatSessionFieldsFragmentDoc}`
export const useCreateChatSessionMutation = <TError = any, TContext = unknown>(
  options?: UseMutationOptions<
    CreateChatSessionMutation,
    TError,
    CreateChatSessionMutationVariables,
    TContext
  >
) =>
  useMutation<CreateChatSessionMutation, TError, CreateChatSessionMutationVariables, TContext>(
    ['createChatSession'],
    (variables?: CreateChatSessionMutationVariables) =>
      fetcher<CreateChatSessionMutation, CreateChatSessionMutationVariables>(
        CreateChatSessionDocument,
        variables
      )(),
    options
  )
export const SearchHowToDoTaskDocument = `
    mutation searchHowToDoTask($input: SearchHowToDoTaskInput!) {
  searchHowToDoTask(input: $input) {
    ...userTaskHowToResponseFields
  }
}
    ${UserTaskHowToResponseFieldsFragmentDoc}`
export const useSearchHowToDoTaskMutation = <TError = any, TContext = unknown>(
  options?: UseMutationOptions<
    SearchHowToDoTaskMutation,
    TError,
    SearchHowToDoTaskMutationVariables,
    TContext
  >
) =>
  useMutation<SearchHowToDoTaskMutation, TError, SearchHowToDoTaskMutationVariables, TContext>(
    ['searchHowToDoTask'],
    (variables?: SearchHowToDoTaskMutationVariables) =>
      fetcher<SearchHowToDoTaskMutation, SearchHowToDoTaskMutationVariables>(
        SearchHowToDoTaskDocument,
        variables
      )(),
    options
  )
export const SendMessageToBotDocument = `
    mutation sendMessageToBot($input: SendMessageToBotInput!) {
  sendMessageToBot(input: $input) {
    ...sendMessageToBotFields
  }
}
    ${SendMessageToBotFieldsFragmentDoc}`
export const useSendMessageToBotMutation = <TError = any, TContext = unknown>(
  options?: UseMutationOptions<
    SendMessageToBotMutation,
    TError,
    SendMessageToBotMutationVariables,
    TContext
  >
) =>
  useMutation<SendMessageToBotMutation, TError, SendMessageToBotMutationVariables, TContext>(
    ['sendMessageToBot'],
    (variables?: SendMessageToBotMutationVariables) =>
      fetcher<SendMessageToBotMutation, SendMessageToBotMutationVariables>(
        SendMessageToBotDocument,
        variables
      )(),
    options
  )
export const GetChatSessionsDocument = `
    query getChatSessions($input: GetChatSessionsInput!) {
  getChatSessions(input: $input) {
    ...getChatSessionsFields
  }
}
    ${GetChatSessionsFieldsFragmentDoc}`
export const useGetChatSessionsQuery = <TData = GetChatSessionsQuery, TError = any>(
  variables: GetChatSessionsQueryVariables,
  options?: UseQueryOptions<GetChatSessionsQuery, TError, TData>
) =>
  useQuery<GetChatSessionsQuery, TError, TData>(
    ['getChatSessions', variables],
    fetcher<GetChatSessionsQuery, GetChatSessionsQueryVariables>(
      GetChatSessionsDocument,
      variables
    ),
    options
  )
export const CreateFlowChatSessionDocument = `
    mutation createFlowChatSession($input: CreateFlowChatSessionInput!) {
  createFlowChatSession(input: $input) {
    ...getChatSessionsFields
  }
}
    ${GetChatSessionsFieldsFragmentDoc}`
export const useCreateFlowChatSessionMutation = <TError = any, TContext = unknown>(
  options?: UseMutationOptions<
    CreateFlowChatSessionMutation,
    TError,
    CreateFlowChatSessionMutationVariables,
    TContext
  >
) =>
  useMutation<
    CreateFlowChatSessionMutation,
    TError,
    CreateFlowChatSessionMutationVariables,
    TContext
  >(
    ['createFlowChatSession'],
    (variables?: CreateFlowChatSessionMutationVariables) =>
      fetcher<CreateFlowChatSessionMutation, CreateFlowChatSessionMutationVariables>(
        CreateFlowChatSessionDocument,
        variables
      )(),
    options
  )
export const SummarySessionTitleDocument = `
    mutation summarySessionTitle($id: String!) {
  summarySessionTitle(id: $id) {
    ...getChatSessionsFields
  }
}
    ${GetChatSessionsFieldsFragmentDoc}`
export const useSummarySessionTitleMutation = <TError = any, TContext = unknown>(
  options?: UseMutationOptions<
    SummarySessionTitleMutation,
    TError,
    SummarySessionTitleMutationVariables,
    TContext
  >
) =>
  useMutation<SummarySessionTitleMutation, TError, SummarySessionTitleMutationVariables, TContext>(
    ['summarySessionTitle'],
    (variables?: SummarySessionTitleMutationVariables) =>
      fetcher<SummarySessionTitleMutation, SummarySessionTitleMutationVariables>(
        SummarySessionTitleDocument,
        variables
      )(),
    options
  )
export const GetAdvisorDashboardDocument = `
    query getAdvisorDashboard($filterType: String, $tenantId: String) {
  getAdvisorDashboard(filterType: $filterType, tenantId: $tenantId) {
    ...AdvisorDashboardFields
  }
}
    ${AdvisorDashboardFieldsFragmentDoc}`
export const useGetAdvisorDashboardQuery = <TData = GetAdvisorDashboardQuery, TError = any>(
  variables?: GetAdvisorDashboardQueryVariables,
  options?: UseQueryOptions<GetAdvisorDashboardQuery, TError, TData>
) =>
  useQuery<GetAdvisorDashboardQuery, TError, TData>(
    variables === undefined ? ['getAdvisorDashboard'] : ['getAdvisorDashboard', variables],
    fetcher<GetAdvisorDashboardQuery, GetAdvisorDashboardQueryVariables>(
      GetAdvisorDashboardDocument,
      variables
    ),
    options
  )
export const GetTopActiveClientsDocument = `
    query getTopActiveClients($tenantId: String) {
  getTopActiveClients(tenantId: $tenantId) {
    ...TopActiveClientsFields
  }
}
    ${TopActiveClientsFieldsFragmentDoc}`
export const useGetTopActiveClientsQuery = <TData = GetTopActiveClientsQuery, TError = any>(
  variables?: GetTopActiveClientsQueryVariables,
  options?: UseQueryOptions<GetTopActiveClientsQuery, TError, TData>
) =>
  useQuery<GetTopActiveClientsQuery, TError, TData>(
    variables === undefined ? ['getTopActiveClients'] : ['getTopActiveClients', variables],
    fetcher<GetTopActiveClientsQuery, GetTopActiveClientsQueryVariables>(
      GetTopActiveClientsDocument,
      variables
    ),
    options
  )
export const GetClientsDocument = `
    query getClients($input: GetClientsInput) {
  getClients(input: $input) {
    ...ClientsFields
  }
}
    ${ClientsFieldsFragmentDoc}`
export const useGetClientsQuery = <TData = GetClientsQuery, TError = any>(
  variables?: GetClientsQueryVariables,
  options?: UseQueryOptions<GetClientsQuery, TError, TData>
) =>
  useQuery<GetClientsQuery, TError, TData>(
    variables === undefined ? ['getClients'] : ['getClients', variables],
    fetcher<GetClientsQuery, GetClientsQueryVariables>(GetClientsDocument, variables),
    options
  )
export const GetOwnerActivityDetailsDocument = `
    query getOwnerActivityDetails($ownerId: String, $tenantId: String!) {
  getOwnerActivityDetails(ownerId: $ownerId, tenantId: $tenantId) {
    ...ownerActivityDetailsFields
  }
}
    ${OwnerActivityDetailsFieldsFragmentDoc}`
export const useGetOwnerActivityDetailsQuery = <TData = GetOwnerActivityDetailsQuery, TError = any>(
  variables: GetOwnerActivityDetailsQueryVariables,
  options?: UseQueryOptions<GetOwnerActivityDetailsQuery, TError, TData>
) =>
  useQuery<GetOwnerActivityDetailsQuery, TError, TData>(
    ['getOwnerActivityDetails', variables],
    fetcher<GetOwnerActivityDetailsQuery, GetOwnerActivityDetailsQueryVariables>(
      GetOwnerActivityDetailsDocument,
      variables
    ),
    options
  )
export const GetActivityLogsDocument = `
    query getActivityLogs($userId: String, $tenantId: String!) {
  getActivityLogs(userId: $userId, tenantId: $tenantId) {
    ...activityLogFields
  }
}
    ${ActivityLogFieldsFragmentDoc}`
export const useGetActivityLogsQuery = <TData = GetActivityLogsQuery, TError = any>(
  variables: GetActivityLogsQueryVariables,
  options?: UseQueryOptions<GetActivityLogsQuery, TError, TData>
) =>
  useQuery<GetActivityLogsQuery, TError, TData>(
    ['getActivityLogs', variables],
    fetcher<GetActivityLogsQuery, GetActivityLogsQueryVariables>(
      GetActivityLogsDocument,
      variables
    ),
    options
  )
export const GetUserIntegrationsDocument = `
    query getUserIntegrations($userId: String, $tenantId: String!) {
  getUserIntegrations(userId: $userId, tenantId: $tenantId) {
    ...userIntegrationFields
  }
}
    ${UserIntegrationFieldsFragmentDoc}`
export const useGetUserIntegrationsQuery = <TData = GetUserIntegrationsQuery, TError = any>(
  variables: GetUserIntegrationsQueryVariables,
  options?: UseQueryOptions<GetUserIntegrationsQuery, TError, TData>
) =>
  useQuery<GetUserIntegrationsQuery, TError, TData>(
    ['getUserIntegrations', variables],
    fetcher<GetUserIntegrationsQuery, GetUserIntegrationsQueryVariables>(
      GetUserIntegrationsDocument,
      variables
    ),
    options
  )
export const GetTackleMeetingsDocument = `
    query getTackleMeetings($input: GetTackleMeetingsInput!) {
  getTackleMeetings(input: $input) {
    ...tackleMeetingsFields
  }
}
    ${TackleMeetingsFieldsFragmentDoc}`
export const useGetTackleMeetingsQuery = <TData = GetTackleMeetingsQuery, TError = any>(
  variables: GetTackleMeetingsQueryVariables,
  options?: UseQueryOptions<GetTackleMeetingsQuery, TError, TData>
) =>
  useQuery<GetTackleMeetingsQuery, TError, TData>(
    ['getTackleMeetings', variables],
    fetcher<GetTackleMeetingsQuery, GetTackleMeetingsQueryVariables>(
      GetTackleMeetingsDocument,
      variables
    ),
    options
  )
export const SearchMeetingListDocument = `
    query searchMeetingList($input: SearchMeetingListInput!) {
  searchMeetingList(input: $input) {
    ...tackleMeetingsFields
  }
}
    ${TackleMeetingsFieldsFragmentDoc}`
export const useSearchMeetingListQuery = <TData = SearchMeetingListQuery, TError = any>(
  variables: SearchMeetingListQueryVariables,
  options?: UseQueryOptions<SearchMeetingListQuery, TError, TData>
) =>
  useQuery<SearchMeetingListQuery, TError, TData>(
    ['searchMeetingList', variables],
    fetcher<SearchMeetingListQuery, SearchMeetingListQueryVariables>(
      SearchMeetingListDocument,
      variables
    ),
    options
  )
export const DeauthenticateConnectorDocument = `
    mutation deauthenticateConnector($input: DeauthenticateConnectorInput) {
  deauthenticateConnector(input: $input) {
    ...deauthenticateConnectorFields
  }
}
    ${DeauthenticateConnectorFieldsFragmentDoc}`
export const useDeauthenticateConnectorMutation = <TError = any, TContext = unknown>(
  options?: UseMutationOptions<
    DeauthenticateConnectorMutation,
    TError,
    DeauthenticateConnectorMutationVariables,
    TContext
  >
) =>
  useMutation<
    DeauthenticateConnectorMutation,
    TError,
    DeauthenticateConnectorMutationVariables,
    TContext
  >(
    ['deauthenticateConnector'],
    (variables?: DeauthenticateConnectorMutationVariables) =>
      fetcher<DeauthenticateConnectorMutation, DeauthenticateConnectorMutationVariables>(
        DeauthenticateConnectorDocument,
        variables
      )(),
    options
  )
export const GetAllToolsDocument = `
    query getAllTools($tenantId: String) {
  getAllTools(tenantId: $tenantId) {
    ...getAllToolsFields
  }
}
    ${GetAllToolsFieldsFragmentDoc}`
export const useGetAllToolsQuery = <TData = GetAllToolsQuery, TError = any>(
  variables?: GetAllToolsQueryVariables,
  options?: UseQueryOptions<GetAllToolsQuery, TError, TData>
) =>
  useQuery<GetAllToolsQuery, TError, TData>(
    variables === undefined ? ['getAllTools'] : ['getAllTools', variables],
    fetcher<GetAllToolsQuery, GetAllToolsQueryVariables>(GetAllToolsDocument, variables),
    options
  )
export const UpdateOwnerDocument = `
    mutation updateOwner($input: UpdateOwnerInput) {
  updateOwner(input: $input) {
    ...updateOwnerFields
  }
}
    ${UpdateOwnerFieldsFragmentDoc}`
export const useUpdateOwnerMutation = <TError = any, TContext = unknown>(
  options?: UseMutationOptions<UpdateOwnerMutation, TError, UpdateOwnerMutationVariables, TContext>
) =>
  useMutation<UpdateOwnerMutation, TError, UpdateOwnerMutationVariables, TContext>(
    ['updateOwner'],
    (variables?: UpdateOwnerMutationVariables) =>
      fetcher<UpdateOwnerMutation, UpdateOwnerMutationVariables>(UpdateOwnerDocument, variables)(),
    options
  )
export const GetUserToolsDocument = `
    query getUserTools($userId: String, $tenantId: String!) {
  getUserTools(userId: $userId, tenantId: $tenantId) {
    ...getUserToolsFields
  }
}
    ${GetUserToolsFieldsFragmentDoc}`
export const useGetUserToolsQuery = <TData = GetUserToolsQuery, TError = any>(
  variables: GetUserToolsQueryVariables,
  options?: UseQueryOptions<GetUserToolsQuery, TError, TData>
) =>
  useQuery<GetUserToolsQuery, TError, TData>(
    ['getUserTools', variables],
    fetcher<GetUserToolsQuery, GetUserToolsQueryVariables>(GetUserToolsDocument, variables),
    options
  )
export const GetAttestationReportsDocument = `
    query getAttestationReports($input: GetAttestationReportsInput!) {
  getAttestationReports(input: $input) {
    ...getAttestationReportsFields
  }
}
    ${GetAttestationReportsFieldsFragmentDoc}`
export const useGetAttestationReportsQuery = <TData = GetAttestationReportsQuery, TError = any>(
  variables: GetAttestationReportsQueryVariables,
  options?: UseQueryOptions<GetAttestationReportsQuery, TError, TData>
) =>
  useQuery<GetAttestationReportsQuery, TError, TData>(
    ['getAttestationReports', variables],
    fetcher<GetAttestationReportsQuery, GetAttestationReportsQueryVariables>(
      GetAttestationReportsDocument,
      variables
    ),
    options
  )
export const ToolConnectionSuccessDocument = `
    mutation toolConnectionSuccess($input: ToolConnectionSuccessInput) {
  toolConnectionSuccess(input: $input) {
    ...updateOwnerFields
  }
}
    ${UpdateOwnerFieldsFragmentDoc}`
export const useToolConnectionSuccessMutation = <TError = any, TContext = unknown>(
  options?: UseMutationOptions<
    ToolConnectionSuccessMutation,
    TError,
    ToolConnectionSuccessMutationVariables,
    TContext
  >
) =>
  useMutation<
    ToolConnectionSuccessMutation,
    TError,
    ToolConnectionSuccessMutationVariables,
    TContext
  >(
    ['toolConnectionSuccess'],
    (variables?: ToolConnectionSuccessMutationVariables) =>
      fetcher<ToolConnectionSuccessMutation, ToolConnectionSuccessMutationVariables>(
        ToolConnectionSuccessDocument,
        variables
      )(),
    options
  )
export const BookmarkToolDocument = `
    mutation bookmarkTool($input: BookmarkToolInput!) {
  bookmarkTool(input: $input) {
    ...bookmarkToolFields
  }
}
    ${BookmarkToolFieldsFragmentDoc}`
export const useBookmarkToolMutation = <TError = any, TContext = unknown>(
  options?: UseMutationOptions<
    BookmarkToolMutation,
    TError,
    BookmarkToolMutationVariables,
    TContext
  >
) =>
  useMutation<BookmarkToolMutation, TError, BookmarkToolMutationVariables, TContext>(
    ['bookmarkTool'],
    (variables?: BookmarkToolMutationVariables) =>
      fetcher<BookmarkToolMutation, BookmarkToolMutationVariables>(
        BookmarkToolDocument,
        variables
      )(),
    options
  )
export const ProcessToolBusinessDataDocument = `
    mutation processToolBusinessData($input: ProcessToolBusinessDataInput!) {
  processToolBusinessData(input: $input)
}
    `
export const useProcessToolBusinessDataMutation = <TError = any, TContext = unknown>(
  options?: UseMutationOptions<
    ProcessToolBusinessDataMutation,
    TError,
    ProcessToolBusinessDataMutationVariables,
    TContext
  >
) =>
  useMutation<
    ProcessToolBusinessDataMutation,
    TError,
    ProcessToolBusinessDataMutationVariables,
    TContext
  >(
    ['processToolBusinessData'],
    (variables?: ProcessToolBusinessDataMutationVariables) =>
      fetcher<ProcessToolBusinessDataMutation, ProcessToolBusinessDataMutationVariables>(
        ProcessToolBusinessDataDocument,
        variables
      )(),
    options
  )
export const GetGoalDetailsDocument = `
    query getGoalDetails($id: String, $businessId: String!) {
  getGoalDetails(id: $id, businessId: $businessId) {
    ...goalDetailsFields
  }
}
    ${GoalDetailsFieldsFragmentDoc}`
export const useGetGoalDetailsQuery = <TData = GetGoalDetailsQuery, TError = any>(
  variables: GetGoalDetailsQueryVariables,
  options?: UseQueryOptions<GetGoalDetailsQuery, TError, TData>
) =>
  useQuery<GetGoalDetailsQuery, TError, TData>(
    ['getGoalDetails', variables],
    fetcher<GetGoalDetailsQuery, GetGoalDetailsQueryVariables>(GetGoalDetailsDocument, variables),
    options
  )
export const GetUserGoalsDocument = `
    query getUserGoals($userId: String, $tenantId: String) {
  getUserGoals(userId: $userId, tenantId: $tenantId) {
    ...goalDetailsFields
  }
}
    ${GoalDetailsFieldsFragmentDoc}`
export const useGetUserGoalsQuery = <TData = GetUserGoalsQuery, TError = any>(
  variables?: GetUserGoalsQueryVariables,
  options?: UseQueryOptions<GetUserGoalsQuery, TError, TData>
) =>
  useQuery<GetUserGoalsQuery, TError, TData>(
    variables === undefined ? ['getUserGoals'] : ['getUserGoals', variables],
    fetcher<GetUserGoalsQuery, GetUserGoalsQueryVariables>(GetUserGoalsDocument, variables),
    options
  )
export const AddInsightDocument = `
    mutation AddInsight($input: AddInsightInput!) {
  addInsight(input: $input) {
    insightId
    name
    description
    category
    priority
    why
    suggestedBy
    feedback
    hasBeenViewed
    createdAt
    updatedAt
    goalsId
    playsId
    metrics {
      metricTitle
      current_status
      benchmark
      trend
    }
    internal_context
    feedbackMessage {
      coachlogic
      client
    }
    metadata
  }
}
    `
export const useAddInsightMutation = <TError = any, TContext = unknown>(
  options?: UseMutationOptions<AddInsightMutation, TError, AddInsightMutationVariables, TContext>
) =>
  useMutation<AddInsightMutation, TError, AddInsightMutationVariables, TContext>(
    ['AddInsight'],
    (variables?: AddInsightMutationVariables) =>
      fetcher<AddInsightMutation, AddInsightMutationVariables>(AddInsightDocument, variables)(),
    options
  )
export const CheckNewInsightsAvailableDocument = `
    query CheckNewInsightsAvailable($userId: String!, $tenantId: String!) {
  checkNewInsightsAvailable(userId: $userId, tenantId: $tenantId) {
    hasNewInsights
    insightsCount
    lastInsightGeneratedAt
    shouldShowPopup
  }
}
    `
export const useCheckNewInsightsAvailableQuery = <
  TData = CheckNewInsightsAvailableQuery,
  TError = any
>(
  variables: CheckNewInsightsAvailableQueryVariables,
  options?: UseQueryOptions<CheckNewInsightsAvailableQuery, TError, TData>
) =>
  useQuery<CheckNewInsightsAvailableQuery, TError, TData>(
    ['CheckNewInsightsAvailable', variables],
    fetcher<CheckNewInsightsAvailableQuery, CheckNewInsightsAvailableQueryVariables>(
      CheckNewInsightsAvailableDocument,
      variables
    ),
    options
  )
export const UpdateInsightsNotificationStatusDocument = `
    mutation UpdateInsightsNotificationStatus($input: UpdateInsightsNotificationInput!) {
  updateInsightsNotificationStatus(input: $input) {
    id
    lastNewInsightsPopupShownAt
    lastNewInsightsViewedAt
  }
}
    `
export const useUpdateInsightsNotificationStatusMutation = <TError = any, TContext = unknown>(
  options?: UseMutationOptions<
    UpdateInsightsNotificationStatusMutation,
    TError,
    UpdateInsightsNotificationStatusMutationVariables,
    TContext
  >
) =>
  useMutation<
    UpdateInsightsNotificationStatusMutation,
    TError,
    UpdateInsightsNotificationStatusMutationVariables,
    TContext
  >(
    ['UpdateInsightsNotificationStatus'],
    (variables?: UpdateInsightsNotificationStatusMutationVariables) =>
      fetcher<
        UpdateInsightsNotificationStatusMutation,
        UpdateInsightsNotificationStatusMutationVariables
      >(UpdateInsightsNotificationStatusDocument, variables)(),
    options
  )
export const GetInsightDocument = `
    query GetInsight($tenantId: ID!, $userId: ID, $insightId: ID!) {
  getInsight(tenantId: $tenantId, userId: $userId, insightId: $insightId) {
    insightId
    name
    description
    category
    priority
    why
    suggestedBy
    feedback
    hasBeenViewed
    createdAt
    updatedAt
    goalsId
    playsId
    metrics {
      metricTitle
      current_status
      benchmark
      trend
    }
    internal_context
    session
    isApproved
  }
}
    `
export const useGetInsightQuery = <TData = GetInsightQuery, TError = any>(
  variables: GetInsightQueryVariables,
  options?: UseQueryOptions<GetInsightQuery, TError, TData>
) =>
  useQuery<GetInsightQuery, TError, TData>(
    ['GetInsight', variables],
    fetcher<GetInsightQuery, GetInsightQueryVariables>(GetInsightDocument, variables),
    options
  )
export const GetInsightsDocument = `
    query GetInsights($tenantId: ID!, $userId: ID, $priority: InsightPriority, $hasBeenViewed: Boolean) {
  getInsights(
    tenantId: $tenantId
    userId: $userId
    priority: $priority
    hasBeenViewed: $hasBeenViewed
  ) {
    items {
      insightId
      name
      description
      category
      priority
      why
      suggestedBy
      feedback
      hasBeenViewed
      createdAt
      updatedAt
      goalsId
      playsId
      metrics {
        metricTitle
        current_status
        benchmark
        trend
      }
      internal_context
      session
      isApproved
    }
    nextToken
  }
}
    `
export const useGetInsightsQuery = <TData = GetInsightsQuery, TError = any>(
  variables: GetInsightsQueryVariables,
  options?: UseQueryOptions<GetInsightsQuery, TError, TData>
) =>
  useQuery<GetInsightsQuery, TError, TData>(
    ['GetInsights', variables],
    fetcher<GetInsightsQuery, GetInsightsQueryVariables>(GetInsightsDocument, variables),
    options
  )
export const UpdateInsightDocument = `
    mutation UpdateInsight($input: UpdateInsightInput!) {
  updateInsight(input: $input) {
    insightId
    name
    description
    category
    priority
    why
    suggestedBy
    feedback
    hasBeenViewed
    createdAt
    updatedAt
    goalsId
    playsId
    metrics {
      metricTitle
      current_status
      benchmark
      trend
    }
    internal_context
    feedbackMessage {
      coachlogic
      client
    }
    metadata
    session
    isApproved
  }
}
    `
export const useUpdateInsightMutation = <TError = any, TContext = unknown>(
  options?: UseMutationOptions<
    UpdateInsightMutation,
    TError,
    UpdateInsightMutationVariables,
    TContext
  >
) =>
  useMutation<UpdateInsightMutation, TError, UpdateInsightMutationVariables, TContext>(
    ['UpdateInsight'],
    (variables?: UpdateInsightMutationVariables) =>
      fetcher<UpdateInsightMutation, UpdateInsightMutationVariables>(
        UpdateInsightDocument,
        variables
      )(),
    options
  )
export const GetPendingJobsDocument = `
    query getPendingJobs {
  getPendingJobs {
    ...getPendingJobsFields
  }
}
    ${GetPendingJobsFieldsFragmentDoc}`
export const useGetPendingJobsQuery = <TData = GetPendingJobsQuery, TError = any>(
  variables?: GetPendingJobsQueryVariables,
  options?: UseQueryOptions<GetPendingJobsQuery, TError, TData>
) =>
  useQuery<GetPendingJobsQuery, TError, TData>(
    variables === undefined ? ['getPendingJobs'] : ['getPendingJobs', variables],
    fetcher<GetPendingJobsQuery, GetPendingJobsQueryVariables>(GetPendingJobsDocument, variables),
    options
  )
export const GetPlayCountMetricsDocument = `
    query getPlayCountMetrics($asOfDate: AWSDate!, $targetUserId: ID) {
  playCount: metricValue(
    input: {metricCode: "playsCompleted", timeRange: {asOfDate: $asOfDate}, targetUserId: $targetUserId}
  ) {
    ...metricValueFields
  }
  playCountUsers: metricValue(
    input: {metricCode: "playsCompletedDistinctUsers", timeRange: {asOfDate: $asOfDate}}
  ) {
    ...metricValueFields
  }
}
    ${MetricValueFieldsFragmentDoc}`
export const useGetPlayCountMetricsQuery = <TData = GetPlayCountMetricsQuery, TError = any>(
  variables: GetPlayCountMetricsQueryVariables,
  options?: UseQueryOptions<GetPlayCountMetricsQuery, TError, TData>
) =>
  useQuery<GetPlayCountMetricsQuery, TError, TData>(
    ['getPlayCountMetrics', variables],
    fetcher<GetPlayCountMetricsQuery, GetPlayCountMetricsQueryVariables>(
      GetPlayCountMetricsDocument,
      variables
    ),
    options
  )
export const GetTouchdownCountMetricsDocument = `
    query getTouchdownCountMetrics($asOfDate: AWSDate!, $targetUserId: ID) {
  tdCount: metricValue(
    input: {metricCode: "touchdownsCompleted", timeRange: {asOfDate: $asOfDate}, targetUserId: $targetUserId}
  ) {
    ...metricValueFields
  }
  tdCountUsers: metricValue(
    input: {metricCode: "touchdownsCompletedDistinctUsers", timeRange: {asOfDate: $asOfDate}, targetUserId: $targetUserId}
  ) {
    ...metricValueFields
  }
}
    ${MetricValueFieldsFragmentDoc}`
export const useGetTouchdownCountMetricsQuery = <
  TData = GetTouchdownCountMetricsQuery,
  TError = any
>(
  variables: GetTouchdownCountMetricsQueryVariables,
  options?: UseQueryOptions<GetTouchdownCountMetricsQuery, TError, TData>
) =>
  useQuery<GetTouchdownCountMetricsQuery, TError, TData>(
    ['getTouchdownCountMetrics', variables],
    fetcher<GetTouchdownCountMetricsQuery, GetTouchdownCountMetricsQueryVariables>(
      GetTouchdownCountMetricsDocument,
      variables
    ),
    options
  )
export const GetFumbleCountMetricsDocument = `
    query getFumbleCountMetrics($asOfDate: AWSDate!, $targetUserId: ID) {
  fumbleCount: metricValue(
    input: {metricCode: "fumblesCompleted", timeRange: {asOfDate: $asOfDate}, targetUserId: $targetUserId}
  ) {
    ...metricValueFields
  }
  fumbleCountUsers: metricValue(
    input: {metricCode: "fumblesCompletedDistinctUsers", timeRange: {asOfDate: $asOfDate}, targetUserId: $targetUserId}
  ) {
    ...metricValueFields
  }
}
    ${MetricValueFieldsFragmentDoc}`
export const useGetFumbleCountMetricsQuery = <TData = GetFumbleCountMetricsQuery, TError = any>(
  variables: GetFumbleCountMetricsQueryVariables,
  options?: UseQueryOptions<GetFumbleCountMetricsQuery, TError, TData>
) =>
  useQuery<GetFumbleCountMetricsQuery, TError, TData>(
    ['getFumbleCountMetrics', variables],
    fetcher<GetFumbleCountMetricsQuery, GetFumbleCountMetricsQueryVariables>(
      GetFumbleCountMetricsDocument,
      variables
    ),
    options
  )
export const GetChartDataDocument = `
    query getChartData($input: GetChartDataInput!) {
  getChartData(input: $input) {
    ...chartDataFields
  }
}
    ${ChartDataFieldsFragmentDoc}`
export const useGetChartDataQuery = <TData = GetChartDataQuery, TError = any>(
  variables: GetChartDataQueryVariables,
  options?: UseQueryOptions<GetChartDataQuery, TError, TData>
) =>
  useQuery<GetChartDataQuery, TError, TData>(
    ['getChartData', variables],
    fetcher<GetChartDataQuery, GetChartDataQueryVariables>(GetChartDataDocument, variables),
    options
  )
export const GetOwnerBusinessDataDocument = `
    query getOwnerBusinessData($input: getOwnerBusinessDataInput) {
  getOwnerBusinessData(input: $input) {
    ...ownerBusinessDataFields
  }
}
    ${OwnerBusinessDataFieldsFragmentDoc}`
export const useGetOwnerBusinessDataQuery = <TData = GetOwnerBusinessDataQuery, TError = any>(
  variables?: GetOwnerBusinessDataQueryVariables,
  options?: UseQueryOptions<GetOwnerBusinessDataQuery, TError, TData>
) =>
  useQuery<GetOwnerBusinessDataQuery, TError, TData>(
    variables === undefined ? ['getOwnerBusinessData'] : ['getOwnerBusinessData', variables],
    fetcher<GetOwnerBusinessDataQuery, GetOwnerBusinessDataQueryVariables>(
      GetOwnerBusinessDataDocument,
      variables
    ),
    options
  )
export const GetPlayDocument = `
    query getPlay($id: String) {
  getPlay(id: $id) {
    ...getPlayFields
  }
}
    ${GetPlayFieldsFragmentDoc}`
export const useGetPlayQuery = <TData = GetPlayQuery, TError = any>(
  variables?: GetPlayQueryVariables,
  options?: UseQueryOptions<GetPlayQuery, TError, TData>
) =>
  useQuery<GetPlayQuery, TError, TData>(
    variables === undefined ? ['getPlay'] : ['getPlay', variables],
    fetcher<GetPlayQuery, GetPlayQueryVariables>(GetPlayDocument, variables),
    options
  )
export const GetPlaysDocument = `
    query getPlays($input: GetPlaysInput) {
  getPlays(input: $input) {
    ...getPlaysFields
  }
}
    ${GetPlaysFieldsFragmentDoc}`
export const useGetPlaysQuery = <TData = GetPlaysQuery, TError = any>(
  variables?: GetPlaysQueryVariables,
  options?: UseQueryOptions<GetPlaysQuery, TError, TData>
) =>
  useQuery<GetPlaysQuery, TError, TData>(
    variables === undefined ? ['getPlays'] : ['getPlays', variables],
    fetcher<GetPlaysQuery, GetPlaysQueryVariables>(GetPlaysDocument, variables),
    options
  )
export const GetPlayResponseDocument = `
    query getPlayResponse($input: GetPlayResponseInput!) {
  getPlayResponse(input: $input) {
    ...playResponseFields
  }
}
    ${PlayResponseFieldsFragmentDoc}`
export const useGetPlayResponseQuery = <TData = GetPlayResponseQuery, TError = any>(
  variables: GetPlayResponseQueryVariables,
  options?: UseQueryOptions<GetPlayResponseQuery, TError, TData>
) =>
  useQuery<GetPlayResponseQuery, TError, TData>(
    ['getPlayResponse', variables],
    fetcher<GetPlayResponseQuery, GetPlayResponseQueryVariables>(
      GetPlayResponseDocument,
      variables
    ),
    options
  )
export const SavePlayResponseDocument = `
    mutation savePlayResponse($input: SavePlayResponseInput!) {
  savePlayResponse(input: $input) {
    ...playResponseFields
  }
}
    ${PlayResponseFieldsFragmentDoc}`
export const useSavePlayResponseMutation = <TError = any, TContext = unknown>(
  options?: UseMutationOptions<
    SavePlayResponseMutation,
    TError,
    SavePlayResponseMutationVariables,
    TContext
  >
) =>
  useMutation<SavePlayResponseMutation, TError, SavePlayResponseMutationVariables, TContext>(
    ['savePlayResponse'],
    (variables?: SavePlayResponseMutationVariables) =>
      fetcher<SavePlayResponseMutation, SavePlayResponseMutationVariables>(
        SavePlayResponseDocument,
        variables
      )(),
    options
  )
export const AuthorizeConnectorDocument = `
    mutation authorizeConnector($authValue: String!) {
  authorizeConnector(authValue: $authValue) {
    ...authorizeConnectorFields
  }
}
    ${AuthorizeConnectorFieldsFragmentDoc}`
export const useAuthorizeConnectorMutation = <TError = any, TContext = unknown>(
  options?: UseMutationOptions<
    AuthorizeConnectorMutation,
    TError,
    AuthorizeConnectorMutationVariables,
    TContext
  >
) =>
  useMutation<AuthorizeConnectorMutation, TError, AuthorizeConnectorMutationVariables, TContext>(
    ['authorizeConnector'],
    (variables?: AuthorizeConnectorMutationVariables) =>
      fetcher<AuthorizeConnectorMutation, AuthorizeConnectorMutationVariables>(
        AuthorizeConnectorDocument,
        variables
      )(),
    options
  )
export const GetDashboardListingDocument = `
    query getDashboardListing($tenantId: String!, $category: String) {
  getDashboardListing(tenantId: $tenantId, category: $category) {
    ...dashboardListingFields
  }
}
    ${DashboardListingFieldsFragmentDoc}`
export const useGetDashboardListingQuery = <TData = GetDashboardListingQuery, TError = any>(
  variables: GetDashboardListingQueryVariables,
  options?: UseQueryOptions<GetDashboardListingQuery, TError, TData>
) =>
  useQuery<GetDashboardListingQuery, TError, TData>(
    ['getDashboardListing', variables],
    fetcher<GetDashboardListingQuery, GetDashboardListingQueryVariables>(
      GetDashboardListingDocument,
      variables
    ),
    options
  )
export const GetAssessmentPlayListingDocument = `
    query getAssessmentPlayListing($tenantId: String!) {
  getAssessmentPlayListing(tenantId: $tenantId) {
    ...assessmentPlayListingFields
  }
}
    ${AssessmentPlayListingFieldsFragmentDoc}`
export const useGetAssessmentPlayListingQuery = <
  TData = GetAssessmentPlayListingQuery,
  TError = any
>(
  variables: GetAssessmentPlayListingQueryVariables,
  options?: UseQueryOptions<GetAssessmentPlayListingQuery, TError, TData>
) =>
  useQuery<GetAssessmentPlayListingQuery, TError, TData>(
    ['getAssessmentPlayListing', variables],
    fetcher<GetAssessmentPlayListingQuery, GetAssessmentPlayListingQueryVariables>(
      GetAssessmentPlayListingDocument,
      variables
    ),
    options
  )
export const AddPrivateNoteDocument = `
    mutation AddPrivateNote($calendarId: String!, $note: PrivateNoteInput!) {
  addPrivateNoteToCalendarEvent(calendarId: $calendarId, note: $note)
}
    `
export const useAddPrivateNoteMutation = <TError = any, TContext = unknown>(
  options?: UseMutationOptions<
    AddPrivateNoteMutation,
    TError,
    AddPrivateNoteMutationVariables,
    TContext
  >
) =>
  useMutation<AddPrivateNoteMutation, TError, AddPrivateNoteMutationVariables, TContext>(
    ['AddPrivateNote'],
    (variables?: AddPrivateNoteMutationVariables) =>
      fetcher<AddPrivateNoteMutation, AddPrivateNoteMutationVariables>(
        AddPrivateNoteDocument,
        variables
      )(),
    options
  )
export const RequestMeetingDocument = `
    mutation requestMeeting($calendarId: ID!, $requestDetail: RequestDetailInput!) {
  requestMeeting(calendarId: $calendarId, requestDetail: $requestDetail)
}
    `
export const useRequestMeetingMutation = <TError = any, TContext = unknown>(
  options?: UseMutationOptions<
    RequestMeetingMutation,
    TError,
    RequestMeetingMutationVariables,
    TContext
  >
) =>
  useMutation<RequestMeetingMutation, TError, RequestMeetingMutationVariables, TContext>(
    ['requestMeeting'],
    (variables?: RequestMeetingMutationVariables) =>
      fetcher<RequestMeetingMutation, RequestMeetingMutationVariables>(
        RequestMeetingDocument,
        variables
      )(),
    options
  )
export const UpdateTranscriptSummaryDocument = `
    mutation UpdateTranscriptSummary($calendarId: String!, $summaryDetails: TranscriptSummaryInput!) {
  updateTranscriptSummary(
    calendarId: $calendarId
    summaryDetails: $summaryDetails
  )
}
    `
export const useUpdateTranscriptSummaryMutation = <TError = any, TContext = unknown>(
  options?: UseMutationOptions<
    UpdateTranscriptSummaryMutation,
    TError,
    UpdateTranscriptSummaryMutationVariables,
    TContext
  >
) =>
  useMutation<
    UpdateTranscriptSummaryMutation,
    TError,
    UpdateTranscriptSummaryMutationVariables,
    TContext
  >(
    ['UpdateTranscriptSummary'],
    (variables?: UpdateTranscriptSummaryMutationVariables) =>
      fetcher<UpdateTranscriptSummaryMutation, UpdateTranscriptSummaryMutationVariables>(
        UpdateTranscriptSummaryDocument,
        variables
      )(),
    options
  )
export const UpdatePrivateNoteDocument = `
    mutation UpdatePrivateNote($calendarId: String!, $note: PrivateNoteInput!) {
  updatePrivateNoteInCalendarEvent(calendarId: $calendarId, note: $note)
}
    `
export const useUpdatePrivateNoteMutation = <TError = any, TContext = unknown>(
  options?: UseMutationOptions<
    UpdatePrivateNoteMutation,
    TError,
    UpdatePrivateNoteMutationVariables,
    TContext
  >
) =>
  useMutation<UpdatePrivateNoteMutation, TError, UpdatePrivateNoteMutationVariables, TContext>(
    ['UpdatePrivateNote'],
    (variables?: UpdatePrivateNoteMutationVariables) =>
      fetcher<UpdatePrivateNoteMutation, UpdatePrivateNoteMutationVariables>(
        UpdatePrivateNoteDocument,
        variables
      )(),
    options
  )
export const DeletePrivateNoteDocument = `
    mutation DeletePrivateNote($calendarId: String!, $noteId: ID!) {
  deletePrivateNote(calendarId: $calendarId, noteId: $noteId)
}
    `
export const useDeletePrivateNoteMutation = <TError = any, TContext = unknown>(
  options?: UseMutationOptions<
    DeletePrivateNoteMutation,
    TError,
    DeletePrivateNoteMutationVariables,
    TContext
  >
) =>
  useMutation<DeletePrivateNoteMutation, TError, DeletePrivateNoteMutationVariables, TContext>(
    ['DeletePrivateNote'],
    (variables?: DeletePrivateNoteMutationVariables) =>
      fetcher<DeletePrivateNoteMutation, DeletePrivateNoteMutationVariables>(
        DeletePrivateNoteDocument,
        variables
      )(),
    options
  )
export const GetUserMeetingTasksDocument = `
    query GetUserMeetingTasks($input: GetUserMeetingTasksInput!) {
  getUserMeetingTasks(input: $input) {
    tenantId
    userId
    taskId
    planId
    milestoneId
    name
    status
    tool
    timeline
    startDate
    expectedEndDate
    howToDo
    estimatedEffortInMinutes
    instructionForTask
    kpis
    role
    why
    order
    resources
    createdBy
    createdById
    howToLinks {
      howToId
      title
      url
    }
    taskPriority
    category
    assigneeId
    isCarryOver
    goalId
    isOverDue
    files {
      id
      name
      size
      tenantId
      type
      url
      userId
      createdAt
    }
    suggestedStatus
    businessAvatar
    planName
    planStartDate
    planExpectedEndDate
    businessAdvisorsData {
      label
      value
    }
    businessHoursSpentPerDay
    goalEndDate
    meetingId
  }
}
    `
export const useGetUserMeetingTasksQuery = <TData = GetUserMeetingTasksQuery, TError = any>(
  variables: GetUserMeetingTasksQueryVariables,
  options?: UseQueryOptions<GetUserMeetingTasksQuery, TError, TData>
) =>
  useQuery<GetUserMeetingTasksQuery, TError, TData>(
    ['GetUserMeetingTasks', variables],
    fetcher<GetUserMeetingTasksQuery, GetUserMeetingTasksQueryVariables>(
      GetUserMeetingTasksDocument,
      variables
    ),
    options
  )
export const OnTaskProgressUpdatedDocument = `
    subscription OnTaskProgressUpdated($id: ID!) {
  onTaskProgressUpdated(id: $id) {
    id
    status
    payload
  }
}
    `
export const OnRealTimeNotificationDocument = `
    subscription OnRealTimeNotification($topic: String!, $key: String) {
  onRealTimeNotification(topic: $topic, key: $key) {
    topic
    key
    data
  }
}
    `
export const PublishRealTimeNotificationDocument = `
    mutation PublishRealTimeNotification($input: RealTimeNotificationInput!) {
  publishRealTimeNotification(input: $input) {
    topic
    key
    data
  }
}
    `
export const usePublishRealTimeNotificationMutation = <TError = any, TContext = unknown>(
  options?: UseMutationOptions<
    PublishRealTimeNotificationMutation,
    TError,
    PublishRealTimeNotificationMutationVariables,
    TContext
  >
) =>
  useMutation<
    PublishRealTimeNotificationMutation,
    TError,
    PublishRealTimeNotificationMutationVariables,
    TContext
  >(
    ['PublishRealTimeNotification'],
    (variables?: PublishRealTimeNotificationMutationVariables) =>
      fetcher<PublishRealTimeNotificationMutation, PublishRealTimeNotificationMutationVariables>(
        PublishRealTimeNotificationDocument,
        variables
      )(),
    options
  )
export const CreateTeamMemberDocument = `
    mutation CreateTeamMember($input: CreateTeamMemberInput!) {
  createTeamMember(input: $input) {
    id
    userId
    businessId
    type
    createdAt
    updatedAt
    user {
      id
      email
      firstName
      lastName
      roles
    }
  }
}
    `
export const useCreateTeamMemberMutation = <TError = any, TContext = unknown>(
  options?: UseMutationOptions<
    CreateTeamMemberMutation,
    TError,
    CreateTeamMemberMutationVariables,
    TContext
  >
) =>
  useMutation<CreateTeamMemberMutation, TError, CreateTeamMemberMutationVariables, TContext>(
    ['CreateTeamMember'],
    (variables?: CreateTeamMemberMutationVariables) =>
      fetcher<CreateTeamMemberMutation, CreateTeamMemberMutationVariables>(
        CreateTeamMemberDocument,
        variables
      )(),
    options
  )
export const GetToolsDocument = `
    query getTools {
  getTools {
    ...getToolsFields
  }
}
    ${GetToolsFieldsFragmentDoc}`
export const useGetToolsQuery = <TData = GetToolsQuery, TError = any>(
  variables?: GetToolsQueryVariables,
  options?: UseQueryOptions<GetToolsQuery, TError, TData>
) =>
  useQuery<GetToolsQuery, TError, TData>(
    variables === undefined ? ['getTools'] : ['getTools', variables],
    fetcher<GetToolsQuery, GetToolsQueryVariables>(GetToolsDocument, variables),
    options
  )
export const GetToolsByTypeDocument = `
    query getToolsByType($input: GetToolsByTypeInput!) {
  getToolsByType(input: $input) {
    ...toolFields
  }
}
    ${ToolFieldsFragmentDoc}`
export const useGetToolsByTypeQuery = <TData = GetToolsByTypeQuery, TError = any>(
  variables: GetToolsByTypeQueryVariables,
  options?: UseQueryOptions<GetToolsByTypeQuery, TError, TData>
) =>
  useQuery<GetToolsByTypeQuery, TError, TData>(
    ['getToolsByType', variables],
    fetcher<GetToolsByTypeQuery, GetToolsByTypeQueryVariables>(GetToolsByTypeDocument, variables),
    options
  )
export const GetAllToolCategoriesDocument = `
    query getAllToolCategories {
  getAllToolCategories {
    ...toolCategoriesFields
  }
}
    ${ToolCategoriesFieldsFragmentDoc}`
export const useGetAllToolCategoriesQuery = <TData = GetAllToolCategoriesQuery, TError = any>(
  variables?: GetAllToolCategoriesQueryVariables,
  options?: UseQueryOptions<GetAllToolCategoriesQuery, TError, TData>
) =>
  useQuery<GetAllToolCategoriesQuery, TError, TData>(
    variables === undefined ? ['getAllToolCategories'] : ['getAllToolCategories', variables],
    fetcher<GetAllToolCategoriesQuery, GetAllToolCategoriesQueryVariables>(
      GetAllToolCategoriesDocument,
      variables
    ),
    options
  )
export const SearchToolsDocument = `
    query searchTools($input: SearchToolsInput!) {
  searchTools(input: $input) {
    ...searchToolsFields
  }
}
    ${SearchToolsFieldsFragmentDoc}`
export const useSearchToolsQuery = <TData = SearchToolsQuery, TError = any>(
  variables: SearchToolsQueryVariables,
  options?: UseQueryOptions<SearchToolsQuery, TError, TData>
) =>
  useQuery<SearchToolsQuery, TError, TData>(
    ['searchTools', variables],
    fetcher<SearchToolsQuery, SearchToolsQueryVariables>(SearchToolsDocument, variables),
    options
  )
export const GetSignedUrlDocument = `
    query getSignedUrl($contentType: String, $fileName: String) {
  getSignedUrl(contentType: $contentType, fileName: $fileName) {
    ...goalSignedUrlFields
  }
}
    ${GoalSignedUrlFieldsFragmentDoc}`
export const useGetSignedUrlQuery = <TData = GetSignedUrlQuery, TError = any>(
  variables?: GetSignedUrlQueryVariables,
  options?: UseQueryOptions<GetSignedUrlQuery, TError, TData>
) =>
  useQuery<GetSignedUrlQuery, TError, TData>(
    variables === undefined ? ['getSignedUrl'] : ['getSignedUrl', variables],
    fetcher<GetSignedUrlQuery, GetSignedUrlQueryVariables>(GetSignedUrlDocument, variables),
    options
  )
export const GetUserFilesDocument = `
    query getUserFiles($userId: String, $tenantId: String!) {
  getUserFiles(userId: $userId, tenantId: $tenantId) {
    ...getUserFilesFileds
  }
}
    ${GetUserFilesFiledsFragmentDoc}`
export const useGetUserFilesQuery = <TData = GetUserFilesQuery, TError = any>(
  variables: GetUserFilesQueryVariables,
  options?: UseQueryOptions<GetUserFilesQuery, TError, TData>
) =>
  useQuery<GetUserFilesQuery, TError, TData>(
    ['getUserFiles', variables],
    fetcher<GetUserFilesQuery, GetUserFilesQueryVariables>(GetUserFilesDocument, variables),
    options
  )
export const GetFileDocument = `
    query getFile($id: String, $businessId: String!) {
  getFile(id: $id, businessId: $businessId) {
    ...getUserFilesFileds
  }
}
    ${GetUserFilesFiledsFragmentDoc}`
export const useGetFileQuery = <TData = GetFileQuery, TError = any>(
  variables: GetFileQueryVariables,
  options?: UseQueryOptions<GetFileQuery, TError, TData>
) =>
  useQuery<GetFileQuery, TError, TData>(
    ['getFile', variables],
    fetcher<GetFileQuery, GetFileQueryVariables>(GetFileDocument, variables),
    options
  )
export const SaveUserFileDocument = `
    mutation saveUserFile($input: SaveUserFileInput!) {
  saveUserFile(input: $input) {
    ...saveUserFileFields
  }
}
    ${SaveUserFileFieldsFragmentDoc}`
export const useSaveUserFileMutation = <TError = any, TContext = unknown>(
  options?: UseMutationOptions<
    SaveUserFileMutation,
    TError,
    SaveUserFileMutationVariables,
    TContext
  >
) =>
  useMutation<SaveUserFileMutation, TError, SaveUserFileMutationVariables, TContext>(
    ['saveUserFile'],
    (variables?: SaveUserFileMutationVariables) =>
      fetcher<SaveUserFileMutation, SaveUserFileMutationVariables>(
        SaveUserFileDocument,
        variables
      )(),
    options
  )
export const DeleteUserFilesDocument = `
    mutation deleteUserFiles($input: DeleteUserFilesInput!) {
  deleteUserFiles(input: $input)
}
    `
export const useDeleteUserFilesMutation = <TError = any, TContext = unknown>(
  options?: UseMutationOptions<
    DeleteUserFilesMutation,
    TError,
    DeleteUserFilesMutationVariables,
    TContext
  >
) =>
  useMutation<DeleteUserFilesMutation, TError, DeleteUserFilesMutationVariables, TContext>(
    ['deleteUserFiles'],
    (variables?: DeleteUserFilesMutationVariables) =>
      fetcher<DeleteUserFilesMutation, DeleteUserFilesMutationVariables>(
        DeleteUserFilesDocument,
        variables
      )(),
    options
  )
export const GetBusinessesDocument = `
    query getBusinesses($getBusinessesInput: GetBusinessesInput!) {
  getBusinesses(getBusinessesInput: $getBusinessesInput) {
    ...BusinessesFields
  }
}
    ${BusinessesFieldsFragmentDoc}`
export const useGetBusinessesQuery = <TData = GetBusinessesQuery, TError = any>(
  variables: GetBusinessesQueryVariables,
  options?: UseQueryOptions<GetBusinessesQuery, TError, TData>
) =>
  useQuery<GetBusinessesQuery, TError, TData>(
    ['getBusinesses', variables],
    fetcher<GetBusinessesQuery, GetBusinessesQueryVariables>(GetBusinessesDocument, variables),
    options
  )
export const ListCognitoUsersDocument = `
    mutation listCognitoUsers($input: ListCognitoUsersInput!) {
  listCognitoUsers(input: $input) {
    ...cognitoUserFields
  }
}
    ${CognitoUserFieldsFragmentDoc}`
export const useListCognitoUsersMutation = <TError = any, TContext = unknown>(
  options?: UseMutationOptions<
    ListCognitoUsersMutation,
    TError,
    ListCognitoUsersMutationVariables,
    TContext
  >
) =>
  useMutation<ListCognitoUsersMutation, TError, ListCognitoUsersMutationVariables, TContext>(
    ['listCognitoUsers'],
    (variables?: ListCognitoUsersMutationVariables) =>
      fetcher<ListCognitoUsersMutation, ListCognitoUsersMutationVariables>(
        ListCognitoUsersDocument,
        variables
      )(),
    options
  )
export const AddUserToGroupDocument = `
    mutation addUserToGroup($input: AddUserToGroupInput!) {
  addUserToGroup(input: $input)
}
    `
export const useAddUserToGroupMutation = <TError = any, TContext = unknown>(
  options?: UseMutationOptions<
    AddUserToGroupMutation,
    TError,
    AddUserToGroupMutationVariables,
    TContext
  >
) =>
  useMutation<AddUserToGroupMutation, TError, AddUserToGroupMutationVariables, TContext>(
    ['addUserToGroup'],
    (variables?: AddUserToGroupMutationVariables) =>
      fetcher<AddUserToGroupMutation, AddUserToGroupMutationVariables>(
        AddUserToGroupDocument,
        variables
      )(),
    options
  )
export const UpdateUserPasswordDocument = `
    mutation updateUserPassword($input: UpdateUserPasswordInput!) {
  updateUserPassword(input: $input)
}
    `
export const useUpdateUserPasswordMutation = <TError = any, TContext = unknown>(
  options?: UseMutationOptions<
    UpdateUserPasswordMutation,
    TError,
    UpdateUserPasswordMutationVariables,
    TContext
  >
) =>
  useMutation<UpdateUserPasswordMutation, TError, UpdateUserPasswordMutationVariables, TContext>(
    ['updateUserPassword'],
    (variables?: UpdateUserPasswordMutationVariables) =>
      fetcher<UpdateUserPasswordMutation, UpdateUserPasswordMutationVariables>(
        UpdateUserPasswordDocument,
        variables
      )(),
    options
  )
export const GetAdvisorsDocument = `
    query getAdvisors($getAdvisorsInput: GetAdvisorsInput) {
  getAdvisors(getAdvisorsInput: $getAdvisorsInput) {
    ...AdvisorsFields
  }
}
    ${AdvisorsFieldsFragmentDoc}`
export const useGetAdvisorsQuery = <TData = GetAdvisorsQuery, TError = any>(
  variables?: GetAdvisorsQueryVariables,
  options?: UseQueryOptions<GetAdvisorsQuery, TError, TData>
) =>
  useQuery<GetAdvisorsQuery, TError, TData>(
    variables === undefined ? ['getAdvisors'] : ['getAdvisors', variables],
    fetcher<GetAdvisorsQuery, GetAdvisorsQueryVariables>(GetAdvisorsDocument, variables),
    options
  )
export const LogActivityDocument = `
    mutation logActivity($activityLogInput: ActivityLogInput!) {
  logActivity(activityLogInput: $activityLogInput) {
    ...logActivityFields
  }
}
    ${LogActivityFieldsFragmentDoc}`
export const useLogActivityMutation = <TError = any, TContext = unknown>(
  options?: UseMutationOptions<LogActivityMutation, TError, LogActivityMutationVariables, TContext>
) =>
  useMutation<LogActivityMutation, TError, LogActivityMutationVariables, TContext>(
    ['logActivity'],
    (variables?: LogActivityMutationVariables) =>
      fetcher<LogActivityMutation, LogActivityMutationVariables>(LogActivityDocument, variables)(),
    options
  )
export const GetUserNotificationsDocument = `
    query getUserNotifications($input: GetUserNotificationsInput) {
  getUserNotifications(input: $input) {
    ...UserNotificationsFields
  }
}
    ${UserNotificationsFieldsFragmentDoc}`
export const useGetUserNotificationsQuery = <TData = GetUserNotificationsQuery, TError = any>(
  variables?: GetUserNotificationsQueryVariables,
  options?: UseQueryOptions<GetUserNotificationsQuery, TError, TData>
) =>
  useQuery<GetUserNotificationsQuery, TError, TData>(
    variables === undefined ? ['getUserNotifications'] : ['getUserNotifications', variables],
    fetcher<GetUserNotificationsQuery, GetUserNotificationsQueryVariables>(
      GetUserNotificationsDocument,
      variables
    ),
    options
  )
export const GetClientsSummaryDocument = `
    query getClientsSummary($tenantId: String) {
  getClientsSummary(tenantId: $tenantId) {
    ...GetClientsSummaryFields
  }
}
    ${GetClientsSummaryFieldsFragmentDoc}`
export const useGetClientsSummaryQuery = <TData = GetClientsSummaryQuery, TError = any>(
  variables?: GetClientsSummaryQueryVariables,
  options?: UseQueryOptions<GetClientsSummaryQuery, TError, TData>
) =>
  useQuery<GetClientsSummaryQuery, TError, TData>(
    variables === undefined ? ['getClientsSummary'] : ['getClientsSummary', variables],
    fetcher<GetClientsSummaryQuery, GetClientsSummaryQueryVariables>(
      GetClientsSummaryDocument,
      variables
    ),
    options
  )
export const UpdateUserNotificationsDocument = `
    mutation updateUserNotifications($input: UpdateUserNotificationsInput) {
  updateUserNotifications(input: $input) {
    ...UserNotificationMutateFields
  }
}
    ${UserNotificationMutateFieldsFragmentDoc}`
export const useUpdateUserNotificationsMutation = <TError = any, TContext = unknown>(
  options?: UseMutationOptions<
    UpdateUserNotificationsMutation,
    TError,
    UpdateUserNotificationsMutationVariables,
    TContext
  >
) =>
  useMutation<
    UpdateUserNotificationsMutation,
    TError,
    UpdateUserNotificationsMutationVariables,
    TContext
  >(
    ['updateUserNotifications'],
    (variables?: UpdateUserNotificationsMutationVariables) =>
      fetcher<UpdateUserNotificationsMutation, UpdateUserNotificationsMutationVariables>(
        UpdateUserNotificationsDocument,
        variables
      )(),
    options
  )
export const DeleteUserNotificationsDocument = `
    mutation deleteUserNotifications($input: DeleteUserNotificationsInput) {
  deleteUserNotifications(input: $input) {
    ...UserNotificationMutateFields
  }
}
    ${UserNotificationMutateFieldsFragmentDoc}`
export const useDeleteUserNotificationsMutation = <TError = any, TContext = unknown>(
  options?: UseMutationOptions<
    DeleteUserNotificationsMutation,
    TError,
    DeleteUserNotificationsMutationVariables,
    TContext
  >
) =>
  useMutation<
    DeleteUserNotificationsMutation,
    TError,
    DeleteUserNotificationsMutationVariables,
    TContext
  >(
    ['deleteUserNotifications'],
    (variables?: DeleteUserNotificationsMutationVariables) =>
      fetcher<DeleteUserNotificationsMutation, DeleteUserNotificationsMutationVariables>(
        DeleteUserNotificationsDocument,
        variables
      )(),
    options
  )
export const ResendUserInviteDocument = `
    mutation resendUserInvite($input: ResendUserInviteInput!) {
  resendUserInvite(input: $input)
}
    `
export const useResendUserInviteMutation = <TError = any, TContext = unknown>(
  options?: UseMutationOptions<
    ResendUserInviteMutation,
    TError,
    ResendUserInviteMutationVariables,
    TContext
  >
) =>
  useMutation<ResendUserInviteMutation, TError, ResendUserInviteMutationVariables, TContext>(
    ['resendUserInvite'],
    (variables?: ResendUserInviteMutationVariables) =>
      fetcher<ResendUserInviteMutation, ResendUserInviteMutationVariables>(
        ResendUserInviteDocument,
        variables
      )(),
    options
  )
export const SaveAttestationDocument = `
    mutation saveAttestation($input: AttestationInput!) {
  saveAttestation(input: $input) {
    ...saveAttestationFields
  }
}
    ${SaveAttestationFieldsFragmentDoc}`
export const useSaveAttestationMutation = <TError = any, TContext = unknown>(
  options?: UseMutationOptions<
    SaveAttestationMutation,
    TError,
    SaveAttestationMutationVariables,
    TContext
  >
) =>
  useMutation<SaveAttestationMutation, TError, SaveAttestationMutationVariables, TContext>(
    ['saveAttestation'],
    (variables?: SaveAttestationMutationVariables) =>
      fetcher<SaveAttestationMutation, SaveAttestationMutationVariables>(
        SaveAttestationDocument,
        variables
      )(),
    options
  )
export const MakeAnnouncementDocument = `
    mutation makeAnnouncement($input: MakeAnnouncementInput!) {
  makeAnnouncement(input: $input)
}
    `
export const useMakeAnnouncementMutation = <TError = any, TContext = unknown>(
  options?: UseMutationOptions<
    MakeAnnouncementMutation,
    TError,
    MakeAnnouncementMutationVariables,
    TContext
  >
) =>
  useMutation<MakeAnnouncementMutation, TError, MakeAnnouncementMutationVariables, TContext>(
    ['makeAnnouncement'],
    (variables?: MakeAnnouncementMutationVariables) =>
      fetcher<MakeAnnouncementMutation, MakeAnnouncementMutationVariables>(
        MakeAnnouncementDocument,
        variables
      )(),
    options
  )
export const SendDirectNotificationDocument = `
    mutation sendDirectNotification($input: SendDirectNotificationInput!) {
  sendDirectNotification(input: $input)
}
    `
export const useSendDirectNotificationMutation = <TError = any, TContext = unknown>(
  options?: UseMutationOptions<
    SendDirectNotificationMutation,
    TError,
    SendDirectNotificationMutationVariables,
    TContext
  >
) =>
  useMutation<
    SendDirectNotificationMutation,
    TError,
    SendDirectNotificationMutationVariables,
    TContext
  >(
    ['sendDirectNotification'],
    (variables?: SendDirectNotificationMutationVariables) =>
      fetcher<SendDirectNotificationMutation, SendDirectNotificationMutationVariables>(
        SendDirectNotificationDocument,
        variables
      )(),
    options
  )
export const GetUserSummariesDocument = `
    query getUserSummaries($input: UserSummariesInput!) {
  getUserSummaries(input: $input) {
    ...UserSummariesFields
  }
}
    ${UserSummariesFieldsFragmentDoc}`
export const useGetUserSummariesQuery = <TData = GetUserSummariesQuery, TError = any>(
  variables: GetUserSummariesQueryVariables,
  options?: UseQueryOptions<GetUserSummariesQuery, TError, TData>
) =>
  useQuery<GetUserSummariesQuery, TError, TData>(
    ['getUserSummaries', variables],
    fetcher<GetUserSummariesQuery, GetUserSummariesQueryVariables>(
      GetUserSummariesDocument,
      variables
    ),
    options
  )
export const SearchUserSummariesDocument = `
    query searchUserSummaries($input: SearchUserSummariesInput!) {
  searchUserSummaries(input: $input) {
    ...UserSummariesFields
  }
}
    ${UserSummariesFieldsFragmentDoc}`
export const useSearchUserSummariesQuery = <TData = SearchUserSummariesQuery, TError = any>(
  variables: SearchUserSummariesQueryVariables,
  options?: UseQueryOptions<SearchUserSummariesQuery, TError, TData>
) =>
  useQuery<SearchUserSummariesQuery, TError, TData>(
    ['searchUserSummaries', variables],
    fetcher<SearchUserSummariesQuery, SearchUserSummariesQueryVariables>(
      SearchUserSummariesDocument,
      variables
    ),
    options
  )
export const GetBusinessIndustryDetailsDocument = `
    query getBusinessIndustryDetails($input: GetBusinessIndustryDetailsInput!) {
  getBusinessIndustryDetails(input: $input) {
    ...businessIndustryChangedFields
  }
}
    ${BusinessIndustryChangedFieldsFragmentDoc}`
export const useGetBusinessIndustryDetailsQuery = <
  TData = GetBusinessIndustryDetailsQuery,
  TError = any
>(
  variables: GetBusinessIndustryDetailsQueryVariables,
  options?: UseQueryOptions<GetBusinessIndustryDetailsQuery, TError, TData>
) =>
  useQuery<GetBusinessIndustryDetailsQuery, TError, TData>(
    ['getBusinessIndustryDetails', variables],
    fetcher<GetBusinessIndustryDetailsQuery, GetBusinessIndustryDetailsQueryVariables>(
      GetBusinessIndustryDetailsDocument,
      variables
    ),
    options
  )
export const GetMyProfileDocument = `
    query getMyProfile($userId: String, $tenantId: String) {
  getMyProfile(userId: $userId, tenantId: $tenantId) {
    ...userProfileFields
  }
}
    ${UserProfileFieldsFragmentDoc}`
export const useGetMyProfileQuery = <TData = GetMyProfileQuery, TError = any>(
  variables?: GetMyProfileQueryVariables,
  options?: UseQueryOptions<GetMyProfileQuery, TError, TData>
) =>
  useQuery<GetMyProfileQuery, TError, TData>(
    variables === undefined ? ['getMyProfile'] : ['getMyProfile', variables],
    fetcher<GetMyProfileQuery, GetMyProfileQueryVariables>(GetMyProfileDocument, variables),
    options
  )
export const GetBoAdvisorsDocument = `
    query getBoAdvisors($userId: String, $tenantId: String) {
  getBoAdvisors(tenantId: $tenantId, userId: $userId) {
    ...BoAdvisorsFields
  }
}
    ${BoAdvisorsFieldsFragmentDoc}`
export const useGetBoAdvisorsQuery = <TData = GetBoAdvisorsQuery, TError = any>(
  variables?: GetBoAdvisorsQueryVariables,
  options?: UseQueryOptions<GetBoAdvisorsQuery, TError, TData>
) =>
  useQuery<GetBoAdvisorsQuery, TError, TData>(
    variables === undefined ? ['getBoAdvisors'] : ['getBoAdvisors', variables],
    fetcher<GetBoAdvisorsQuery, GetBoAdvisorsQueryVariables>(GetBoAdvisorsDocument, variables),
    options
  )
export const UpdateMyProfileDocument = `
    mutation updateMyProfile($input: UpdateMyProfileInput!) {
  updateMyProfile(input: $input) {
    ...userProfileFields
  }
}
    ${UserProfileFieldsFragmentDoc}`
export const useUpdateMyProfileMutation = <TError = any, TContext = unknown>(
  options?: UseMutationOptions<
    UpdateMyProfileMutation,
    TError,
    UpdateMyProfileMutationVariables,
    TContext
  >
) =>
  useMutation<UpdateMyProfileMutation, TError, UpdateMyProfileMutationVariables, TContext>(
    ['updateMyProfile'],
    (variables?: UpdateMyProfileMutationVariables) =>
      fetcher<UpdateMyProfileMutation, UpdateMyProfileMutationVariables>(
        UpdateMyProfileDocument,
        variables
      )(),
    options
  )
export const CreateUserDocument = `
    mutation createUser($input: CreateUserInput!) {
  createUser(input: $input) {
    ...userProfileFields
  }
}
    ${UserProfileFieldsFragmentDoc}`
export const useCreateUserMutation = <TError = any, TContext = unknown>(
  options?: UseMutationOptions<CreateUserMutation, TError, CreateUserMutationVariables, TContext>
) =>
  useMutation<CreateUserMutation, TError, CreateUserMutationVariables, TContext>(
    ['createUser'],
    (variables?: CreateUserMutationVariables) =>
      fetcher<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument, variables)(),
    options
  )
export const GetAdvisorProfileDocument = `
    query getAdvisorProfile($input: GetAdvisorProfileInput!) {
  getAdvisorProfile(input: $input) {
    ...advisorProfileFields
  }
}
    ${AdvisorProfileFieldsFragmentDoc}`
export const useGetAdvisorProfileQuery = <TData = GetAdvisorProfileQuery, TError = any>(
  variables: GetAdvisorProfileQueryVariables,
  options?: UseQueryOptions<GetAdvisorProfileQuery, TError, TData>
) =>
  useQuery<GetAdvisorProfileQuery, TError, TData>(
    ['getAdvisorProfile', variables],
    fetcher<GetAdvisorProfileQuery, GetAdvisorProfileQueryVariables>(
      GetAdvisorProfileDocument,
      variables
    ),
    options
  )
export const GetGoalHistoryDocument = `
    query getGoalHistory($input: GetGoalHistoryInput!) {
  getGoalHistory(input: $input) {
    goalId
    sections {
      ...goalHistorySectionFields
    }
  }
}
    ${GoalHistorySectionFieldsFragmentDoc}`
export const useGetGoalHistoryQuery = <TData = GetGoalHistoryQuery, TError = any>(
  variables: GetGoalHistoryQueryVariables,
  options?: UseQueryOptions<GetGoalHistoryQuery, TError, TData>
) =>
  useQuery<GetGoalHistoryQuery, TError, TData>(
    ['getGoalHistory', variables],
    fetcher<GetGoalHistoryQuery, GetGoalHistoryQueryVariables>(GetGoalHistoryDocument, variables),
    options
  )
export const GetBusinessGoalsDocument = `
    query getBusinessGoals($input: GetBusinessGoalsInput!) {
  getBusinessGoals(input: $input) {
    ...goalsFields
  }
}
    ${GoalsFieldsFragmentDoc}`
export const useGetBusinessGoalsQuery = <TData = GetBusinessGoalsQuery, TError = any>(
  variables: GetBusinessGoalsQueryVariables,
  options?: UseQueryOptions<GetBusinessGoalsQuery, TError, TData>
) =>
  useQuery<GetBusinessGoalsQuery, TError, TData>(
    ['getBusinessGoals', variables],
    fetcher<GetBusinessGoalsQuery, GetBusinessGoalsQueryVariables>(
      GetBusinessGoalsDocument,
      variables
    ),
    options
  )
export const GetFilteredBusinessGoalsDocument = `
    query getFilteredBusinessGoals($input: GetBusinessGoalsInput!) {
  getBusinessGoals(input: $input) {
    ...goalResponse
  }
}
    ${GoalResponseFragmentDoc}`
export const useGetFilteredBusinessGoalsQuery = <
  TData = GetFilteredBusinessGoalsQuery,
  TError = any
>(
  variables: GetFilteredBusinessGoalsQueryVariables,
  options?: UseQueryOptions<GetFilteredBusinessGoalsQuery, TError, TData>
) =>
  useQuery<GetFilteredBusinessGoalsQuery, TError, TData>(
    ['getFilteredBusinessGoals', variables],
    fetcher<GetFilteredBusinessGoalsQuery, GetFilteredBusinessGoalsQueryVariables>(
      GetFilteredBusinessGoalsDocument,
      variables
    ),
    options
  )
export const GetBusinessGoalDocument = `
    query getBusinessGoal($input: GetBusinessGoalInput!) {
  getBusinessGoal(input: $input) {
    ...goalFields
  }
}
    ${GoalFieldsFragmentDoc}`
export const useGetBusinessGoalQuery = <TData = GetBusinessGoalQuery, TError = any>(
  variables: GetBusinessGoalQueryVariables,
  options?: UseQueryOptions<GetBusinessGoalQuery, TError, TData>
) =>
  useQuery<GetBusinessGoalQuery, TError, TData>(
    ['getBusinessGoal', variables],
    fetcher<GetBusinessGoalQuery, GetBusinessGoalQueryVariables>(
      GetBusinessGoalDocument,
      variables
    ),
    options
  )
export const GetUserTaskDocument = `
    query getUserTask($input: GetUserTaskInput!) {
  getUserTask(input: $input) {
    ...userTaskFields
  }
}
    ${UserTaskFieldsFragmentDoc}`
export const useGetUserTaskQuery = <TData = GetUserTaskQuery, TError = any>(
  variables: GetUserTaskQueryVariables,
  options?: UseQueryOptions<GetUserTaskQuery, TError, TData>
) =>
  useQuery<GetUserTaskQuery, TError, TData>(
    ['getUserTask', variables],
    fetcher<GetUserTaskQuery, GetUserTaskQueryVariables>(GetUserTaskDocument, variables),
    options
  )
export const GetUserTasksDocument = `
    query getUserTasks($input: GetUserTasksInput!) {
  getUserTasks(input: $input) {
    ...userTaskFields
  }
}
    ${UserTaskFieldsFragmentDoc}`
export const useGetUserTasksQuery = <TData = GetUserTasksQuery, TError = any>(
  variables: GetUserTasksQueryVariables,
  options?: UseQueryOptions<GetUserTasksQuery, TError, TData>
) =>
  useQuery<GetUserTasksQuery, TError, TData>(
    ['getUserTasks', variables],
    fetcher<GetUserTasksQuery, GetUserTasksQueryVariables>(GetUserTasksDocument, variables),
    options
  )
export const SearchUserTasksDocument = `
    query searchUserTasks($input: SearchUserTasksInput!) {
  searchUserTasks(input: $input) {
    ...userTaskFields
  }
}
    ${UserTaskFieldsFragmentDoc}`
export const useSearchUserTasksQuery = <TData = SearchUserTasksQuery, TError = any>(
  variables: SearchUserTasksQueryVariables,
  options?: UseQueryOptions<SearchUserTasksQuery, TError, TData>
) =>
  useQuery<SearchUserTasksQuery, TError, TData>(
    ['searchUserTasks', variables],
    fetcher<SearchUserTasksQuery, SearchUserTasksQueryVariables>(
      SearchUserTasksDocument,
      variables
    ),
    options
  )
export const GetAdvisorAssignedTasksDocument = `
    query getAdvisorAssignedTasks($input: GetAdvisorAssignedTasksInput!) {
  getAdvisorAssignedTasks(input: $input) {
    ...userTaskFields
  }
}
    ${UserTaskFieldsFragmentDoc}`
export const useGetAdvisorAssignedTasksQuery = <TData = GetAdvisorAssignedTasksQuery, TError = any>(
  variables: GetAdvisorAssignedTasksQueryVariables,
  options?: UseQueryOptions<GetAdvisorAssignedTasksQuery, TError, TData>
) =>
  useQuery<GetAdvisorAssignedTasksQuery, TError, TData>(
    ['getAdvisorAssignedTasks', variables],
    fetcher<GetAdvisorAssignedTasksQuery, GetAdvisorAssignedTasksQueryVariables>(
      GetAdvisorAssignedTasksDocument,
      variables
    ),
    options
  )
export const GetQuoteDocument = `
    query getQuote {
  getQuote {
    ...quoteField
  }
}
    ${QuoteFieldFragmentDoc}`
export const useGetQuoteQuery = <TData = GetQuoteQuery, TError = any>(
  variables?: GetQuoteQueryVariables,
  options?: UseQueryOptions<GetQuoteQuery, TError, TData>
) =>
  useQuery<GetQuoteQuery, TError, TData>(
    variables === undefined ? ['getQuote'] : ['getQuote', variables],
    fetcher<GetQuoteQuery, GetQuoteQueryVariables>(GetQuoteDocument, variables),
    options
  )
export const SaveBusinessGoalDocument = `
    mutation saveBusinessGoal($input: SaveBusinessGoalInput!) {
  saveBusinessGoal(input: $input)
}
    `
export const useSaveBusinessGoalMutation = <TError = any, TContext = unknown>(
  options?: UseMutationOptions<
    SaveBusinessGoalMutation,
    TError,
    SaveBusinessGoalMutationVariables,
    TContext
  >
) =>
  useMutation<SaveBusinessGoalMutation, TError, SaveBusinessGoalMutationVariables, TContext>(
    ['saveBusinessGoal'],
    (variables?: SaveBusinessGoalMutationVariables) =>
      fetcher<SaveBusinessGoalMutation, SaveBusinessGoalMutationVariables>(
        SaveBusinessGoalDocument,
        variables
      )(),
    options
  )
export const UpdateBusinessGoalDocument = `
    mutation updateBusinessGoal($input: UpdateBusinessGoalInput!) {
  updateBusinessGoal(input: $input)
}
    `
export const useUpdateBusinessGoalMutation = <TError = any, TContext = unknown>(
  options?: UseMutationOptions<
    UpdateBusinessGoalMutation,
    TError,
    UpdateBusinessGoalMutationVariables,
    TContext
  >
) =>
  useMutation<UpdateBusinessGoalMutation, TError, UpdateBusinessGoalMutationVariables, TContext>(
    ['updateBusinessGoal'],
    (variables?: UpdateBusinessGoalMutationVariables) =>
      fetcher<UpdateBusinessGoalMutation, UpdateBusinessGoalMutationVariables>(
        UpdateBusinessGoalDocument,
        variables
      )(),
    options
  )
export const UpdateBusinessGoalMilestoneDocument = `
    mutation updateBusinessGoalMilestone($input: UpdateBusinessGoalMilestoneInput!) {
  updateBusinessGoalMilestone(input: $input)
}
    `
export const useUpdateBusinessGoalMilestoneMutation = <TError = any, TContext = unknown>(
  options?: UseMutationOptions<
    UpdateBusinessGoalMilestoneMutation,
    TError,
    UpdateBusinessGoalMilestoneMutationVariables,
    TContext
  >
) =>
  useMutation<
    UpdateBusinessGoalMilestoneMutation,
    TError,
    UpdateBusinessGoalMilestoneMutationVariables,
    TContext
  >(
    ['updateBusinessGoalMilestone'],
    (variables?: UpdateBusinessGoalMilestoneMutationVariables) =>
      fetcher<UpdateBusinessGoalMilestoneMutation, UpdateBusinessGoalMilestoneMutationVariables>(
        UpdateBusinessGoalMilestoneDocument,
        variables
      )(),
    options
  )
export const CreateUserTaskDocument = `
    mutation createUserTask($input: CreateUserTaskInput!) {
  createUserTask(input: $input) {
    ...userTaskFields
  }
}
    ${UserTaskFieldsFragmentDoc}`
export const useCreateUserTaskMutation = <TError = any, TContext = unknown>(
  options?: UseMutationOptions<
    CreateUserTaskMutation,
    TError,
    CreateUserTaskMutationVariables,
    TContext
  >
) =>
  useMutation<CreateUserTaskMutation, TError, CreateUserTaskMutationVariables, TContext>(
    ['createUserTask'],
    (variables?: CreateUserTaskMutationVariables) =>
      fetcher<CreateUserTaskMutation, CreateUserTaskMutationVariables>(
        CreateUserTaskDocument,
        variables
      )(),
    options
  )
export const DeleteUserTaskDocument = `
    mutation deleteUserTask($input: DeleteUserTaskInput!) {
  deleteUserTask(input: $input)
}
    `
export const useDeleteUserTaskMutation = <TError = any, TContext = unknown>(
  options?: UseMutationOptions<
    DeleteUserTaskMutation,
    TError,
    DeleteUserTaskMutationVariables,
    TContext
  >
) =>
  useMutation<DeleteUserTaskMutation, TError, DeleteUserTaskMutationVariables, TContext>(
    ['deleteUserTask'],
    (variables?: DeleteUserTaskMutationVariables) =>
      fetcher<DeleteUserTaskMutation, DeleteUserTaskMutationVariables>(
        DeleteUserTaskDocument,
        variables
      )(),
    options
  )
export const UpdateUserTaskDocument = `
    mutation updateUserTask($input: UpdateUserTaskInput!) {
  updateUserTask(input: $input) {
    ...userTaskFields
  }
}
    ${UserTaskFieldsFragmentDoc}`
export const useUpdateUserTaskMutation = <TError = any, TContext = unknown>(
  options?: UseMutationOptions<
    UpdateUserTaskMutation,
    TError,
    UpdateUserTaskMutationVariables,
    TContext
  >
) =>
  useMutation<UpdateUserTaskMutation, TError, UpdateUserTaskMutationVariables, TContext>(
    ['updateUserTask'],
    (variables?: UpdateUserTaskMutationVariables) =>
      fetcher<UpdateUserTaskMutation, UpdateUserTaskMutationVariables>(
        UpdateUserTaskDocument,
        variables
      )(),
    options
  )
export const UpdateGoalPlanDocument = `
    mutation updateGoalPlan($input: UpdateGoalPlanInput!) {
  updateGoalPlan(input: $input)
}
    `
export const useUpdateGoalPlanMutation = <TError = any, TContext = unknown>(
  options?: UseMutationOptions<
    UpdateGoalPlanMutation,
    TError,
    UpdateGoalPlanMutationVariables,
    TContext
  >
) =>
  useMutation<UpdateGoalPlanMutation, TError, UpdateGoalPlanMutationVariables, TContext>(
    ['updateGoalPlan'],
    (variables?: UpdateGoalPlanMutationVariables) =>
      fetcher<UpdateGoalPlanMutation, UpdateGoalPlanMutationVariables>(
        UpdateGoalPlanDocument,
        variables
      )(),
    options
  )
export const RegeneratePlanDocument = `
    mutation regeneratePlan($input: RegeneratePlanInput!) {
  regeneratePlan(input: $input)
}
    `
export const useRegeneratePlanMutation = <TError = any, TContext = unknown>(
  options?: UseMutationOptions<
    RegeneratePlanMutation,
    TError,
    RegeneratePlanMutationVariables,
    TContext
  >
) =>
  useMutation<RegeneratePlanMutation, TError, RegeneratePlanMutationVariables, TContext>(
    ['regeneratePlan'],
    (variables?: RegeneratePlanMutationVariables) =>
      fetcher<RegeneratePlanMutation, RegeneratePlanMutationVariables>(
        RegeneratePlanDocument,
        variables
      )(),
    options
  )
export const PopulateTaskInformationDocument = `
    mutation populateTaskInformation($taskName: String!) {
  populateTaskInformation(taskName: $taskName) {
    ...populateTaskInformationFields
  }
}
    ${PopulateTaskInformationFieldsFragmentDoc}`
export const usePopulateTaskInformationMutation = <TError = any, TContext = unknown>(
  options?: UseMutationOptions<
    PopulateTaskInformationMutation,
    TError,
    PopulateTaskInformationMutationVariables,
    TContext
  >
) =>
  useMutation<
    PopulateTaskInformationMutation,
    TError,
    PopulateTaskInformationMutationVariables,
    TContext
  >(
    ['populateTaskInformation'],
    (variables?: PopulateTaskInformationMutationVariables) =>
      fetcher<PopulateTaskInformationMutation, PopulateTaskInformationMutationVariables>(
        PopulateTaskInformationDocument,
        variables
      )(),
    options
  )
export const AddTaskCommentDocument = `
    mutation addTaskComment($input: AddTaskCommentInput!) {
  addTaskComment(input: $input) {
    ...taskCommentFields
  }
}
    ${TaskCommentFieldsFragmentDoc}`
export const useAddTaskCommentMutation = <TError = any, TContext = unknown>(
  options?: UseMutationOptions<
    AddTaskCommentMutation,
    TError,
    AddTaskCommentMutationVariables,
    TContext
  >
) =>
  useMutation<AddTaskCommentMutation, TError, AddTaskCommentMutationVariables, TContext>(
    ['addTaskComment'],
    (variables?: AddTaskCommentMutationVariables) =>
      fetcher<AddTaskCommentMutation, AddTaskCommentMutationVariables>(
        AddTaskCommentDocument,
        variables
      )(),
    options
  )
export const DeleteTaskCommentDocument = `
    mutation deleteTaskComment($input: DeleteTaskCommentInput!) {
  deleteTaskComment(input: $input)
}
    `
export const useDeleteTaskCommentMutation = <TError = any, TContext = unknown>(
  options?: UseMutationOptions<
    DeleteTaskCommentMutation,
    TError,
    DeleteTaskCommentMutationVariables,
    TContext
  >
) =>
  useMutation<DeleteTaskCommentMutation, TError, DeleteTaskCommentMutationVariables, TContext>(
    ['deleteTaskComment'],
    (variables?: DeleteTaskCommentMutationVariables) =>
      fetcher<DeleteTaskCommentMutation, DeleteTaskCommentMutationVariables>(
        DeleteTaskCommentDocument,
        variables
      )(),
    options
  )
export const UpdateTaskCommentDocument = `
    mutation updateTaskComment($input: UpdateTaskCommentInput!) {
  updateTaskComment(input: $input) {
    ...taskCommentFields
  }
}
    ${TaskCommentFieldsFragmentDoc}`
export const useUpdateTaskCommentMutation = <TError = any, TContext = unknown>(
  options?: UseMutationOptions<
    UpdateTaskCommentMutation,
    TError,
    UpdateTaskCommentMutationVariables,
    TContext
  >
) =>
  useMutation<UpdateTaskCommentMutation, TError, UpdateTaskCommentMutationVariables, TContext>(
    ['updateTaskComment'],
    (variables?: UpdateTaskCommentMutationVariables) =>
      fetcher<UpdateTaskCommentMutation, UpdateTaskCommentMutationVariables>(
        UpdateTaskCommentDocument,
        variables
      )(),
    options
  )
export const UpdateTaskReactionDocument = `
    mutation updateTaskReaction($input: UpdateTaskReactionInput!) {
  updateTaskReaction(input: $input)
}
    `
export const useUpdateTaskReactionMutation = <TError = any, TContext = unknown>(
  options?: UseMutationOptions<
    UpdateTaskReactionMutation,
    TError,
    UpdateTaskReactionMutationVariables,
    TContext
  >
) =>
  useMutation<UpdateTaskReactionMutation, TError, UpdateTaskReactionMutationVariables, TContext>(
    ['updateTaskReaction'],
    (variables?: UpdateTaskReactionMutationVariables) =>
      fetcher<UpdateTaskReactionMutation, UpdateTaskReactionMutationVariables>(
        UpdateTaskReactionDocument,
        variables
      )(),
    options
  )
export const GetTaskCommentsDocument = `
    query getTaskComments($input: GetTaskCommentsInput!) {
  getTaskComments(input: $input) {
    ...taskCommentFields
  }
}
    ${TaskCommentFieldsFragmentDoc}`
export const useGetTaskCommentsQuery = <TData = GetTaskCommentsQuery, TError = any>(
  variables: GetTaskCommentsQueryVariables,
  options?: UseQueryOptions<GetTaskCommentsQuery, TError, TData>
) =>
  useQuery<GetTaskCommentsQuery, TError, TData>(
    ['getTaskComments', variables],
    fetcher<GetTaskCommentsQuery, GetTaskCommentsQueryVariables>(
      GetTaskCommentsDocument,
      variables
    ),
    options
  )
export const OnGoalPlanRegenerationErrorDocument = `
    subscription OnGoalPlanRegenerationError($userId: ID!) {
  onGoalPlanRegenerationError(userId: $userId) {
    goalId
    message
    timestamp
    userId
    isLastAttempt
  }
}
    `
export const GetOnboardingFlowStateDocument = `
    query getOnboardingFlowState($input: GetOnboardingFlowStateInput!) {
  getOnboardingFlowState(input: $input) {
    ...getOnboardingFlowStateFields
  }
}
    ${GetOnboardingFlowStateFieldsFragmentDoc}`
export const useGetOnboardingFlowStateQuery = <TData = GetOnboardingFlowStateQuery, TError = any>(
  variables: GetOnboardingFlowStateQueryVariables,
  options?: UseQueryOptions<GetOnboardingFlowStateQuery, TError, TData>
) =>
  useQuery<GetOnboardingFlowStateQuery, TError, TData>(
    ['getOnboardingFlowState', variables],
    fetcher<GetOnboardingFlowStateQuery, GetOnboardingFlowStateQueryVariables>(
      GetOnboardingFlowStateDocument,
      variables
    ),
    options
  )
